/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './schema';
const defaultOptions = {} as const;
export type AccountPersonalInformationFragmentFragment = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  title: string | null;
  birthDate: string | null;
  phoneNumber: string | null;
  timezone: string | null;
  address: {
    id: string;
    state: string | null;
    county: string | null;
    street: string | null;
    city: string | null;
    apartment: string | null;
    zipCode: string | null;
  } | null;
  employee: {
    id: string;
    workEmail: string | null;
    homeAddress: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
  } | null;
};

export type AccountPersonalInformationQueryVariables = Exact<{
  userId: string | number;
}>;

export type AccountPersonalInformationQuery = {
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    title: string | null;
    birthDate: string | null;
    phoneNumber: string | null;
    timezone: string | null;
    address: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    employee: {
      id: string;
      workEmail: string | null;
      homeAddress: {
        id: string;
        state: string | null;
        county: string | null;
        street: string | null;
        city: string | null;
        apartment: string | null;
        zipCode: string | null;
      } | null;
    } | null;
  } | null;
};

export type AccountPersonalInformationUpdateMutationVariables = Exact<{
  data: Types.UserUpdate;
  where: Types.UserWhereUnique;
}>;

export type AccountPersonalInformationUpdateMutation = {
  userUpdate: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    title: string | null;
    birthDate: string | null;
    phoneNumber: string | null;
    timezone: string | null;
    address: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    employee: {
      id: string;
      workEmail: string | null;
      homeAddress: {
        id: string;
        state: string | null;
        county: string | null;
        street: string | null;
        city: string | null;
        apartment: string | null;
        zipCode: string | null;
      } | null;
    } | null;
  };
};

export type ActivityLogItemFragment = {
  id: string;
  heading: string;
  companyDisplayName: string | null;
  authorDisplayName: string | null;
  comment: string | null;
  type: Types.ActivityLogType;
  createdAt: string;
  visibleFor: Array<Types.ActivityLogVisibleFor>;
  platformStaffId: string | null;
  file: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type GetActivityLogsListQueryVariables = Exact<{
  inboxItemId: string | number;
}>;

export type GetActivityLogsListQuery = {
  getActivityLogsList: Array<{
    id: string;
    heading: string;
    companyDisplayName: string | null;
    authorDisplayName: string | null;
    comment: string | null;
    type: Types.ActivityLogType;
    createdAt: string;
    visibleFor: Array<Types.ActivityLogVisibleFor>;
    platformStaffId: string | null;
    file: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  }>;
};

export type ActivityLogDeleteMutationVariables = Exact<{
  where: Types.ActivityLogWhereUnique;
}>;

export type ActivityLogDeleteMutation = { activityLogDelete: boolean };

export type AddressInfoFragment = {
  id: string;
  state: string | null;
  county: string | null;
  street: string | null;
  city: string | null;
  apartment: string | null;
  zipCode: string | null;
};

export type ApiVerificationRequestInfoFragment = {
  id: string;
  createdAt: string;
  type: Types.VerificationRequestType;
  employeeId: string;
};

export type ApiVerificationRequestQueryVariables = Exact<{
  where: Types.ApiVerificationRequestWhereUnique;
}>;

export type ApiVerificationRequestQuery = {
  apiVerificationRequest: {
    id: string;
    createdAt: string;
    type: Types.VerificationRequestType;
    employeeId: string;
  } | null;
};

export type GetVerifierInfoByApiVerificationRequestQueryVariables = Exact<{
  inboxItemId: string | number;
}>;

export type GetVerifierInfoByApiVerificationRequestQuery = {
  getVerifierInfoByApiVerificationRequest: {
    id: string;
    credentialStatus: Types.VerifierCredentialStatus;
    type: Types.VerifierType | null;
    displayName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    logo: { downloadUrl: string | null } | null;
  } | null;
};

export type AttestationsListQueryVariables = Exact<{
  filter?: Types.AttestationWhere | null | undefined;
}>;

export type AttestationsListQuery = {
  attestationList: Array<{
    id: string;
    name: string;
    text: string;
    purpose: any;
    pdf: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  }>;
};

export type InitialBillingRulesInfoFragment = {
  id: string;
  voI: number;
  voE: number;
  reverification: number;
  revenueShareType: Types.RevenueShareType;
  revenueSharePercents: number;
  revenueShareFlat: number;
};

export type VerifierBillingListQueryVariables = Exact<{
  filter?: Types.VerifierBillingWhere | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
  orderBy?: Array<Types.VerifierBillingOrderBy> | Types.VerifierBillingOrderBy | null | undefined;
}>;

export type VerifierBillingListQuery = {
  verifierBillingCount: number;
  verifierBillingList: Array<{
    id: string;
    voI: number;
    voE: number;
    reverification: number;
    verifier: {
      id: string;
      displayName: string | null;
      contactEmail: string | null;
      contactPhone: string | null;
      legalBusinessName: string | null;
      type: Types.VerifierType | null;
      credentialStatus: Types.VerifierCredentialStatus;
      fEIN: string | null;
      industry: string | null;
      websiteURL: string | null;
      governmentEntityName: string | null;
      typeOfGovernment: Types.VerifierTypeOfGovernment | null;
      department: string | null;
      commercialName: string | null;
      stripeCustomerId: string | null;
      denialReason: string | null;
      logo: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
      address: {
        id: string;
        county: string | null;
        city: string | null;
        state: string | null;
        apartment: string | null;
        street: string | null;
        zipCode: string | null;
      } | null;
    };
  }>;
};

export type VerifierBillingUpdateMutationVariables = Exact<{
  data: Types.VerifierBillingUpdate;
  where: Types.VerifierBillingWhereUnique;
}>;

export type VerifierBillingUpdateMutation = { verifierBillingUpdate: { id: string } };

export type VerifierBillingBulkUpdateMutationVariables = Exact<{
  data: Types.VerifierBillingUpdateMany;
  filter: Types.VerifierBillingWhere;
}>;

export type VerifierBillingBulkUpdateMutation = { verifierBillingUpdateMany: number };

export type GetRevenueShareSettingsListWithStripeStatusesQueryVariables = Exact<{
  filter?: Types.RevenueShareSettingWhere | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
  orderBy?:
    | Array<Types.RevenueShareSettingOrderBy>
    | Types.RevenueShareSettingOrderBy
    | null
    | undefined;
}>;

export type GetRevenueShareSettingsListWithStripeStatusesQuery = {
  getRevenueShareSettingsListWithStripeStatuses: {
    count: number;
    items: Array<{
      stripeStatus: Types.StripeAccountStatus | null;
      revenueShareSetting: {
        id: string;
        createdAt: string;
        updatedAt: string;
        revenueShareType: Types.RevenueShareType;
        revenueSharePercents: number | null;
        revenueShareFlat: number | null;
        revenueShareRecipient: Types.CompanyType;
        employer: {
          id: string;
          createdAt: string;
          displayName: string | null;
          contactEmail: string | null;
          legalBusinessName: string | null;
          numberOfEmployees: number | null;
          corporateStructure: string | null;
          industry: string | null;
          contactPhoneNumber: string | null;
          taxYearEndDate: string | null;
          withdrawalSettings: Types.EmployerWithdrawalSetting | null;
          stripeAccountId: string | null;
          requestAutoAccept: boolean;
          signUpMethod: Types.SignUpMethod;
          disclaimer: string | null;
          setLiveAt: string | null;
          controlledBy: Types.CompanyType;
          keepOwnRevenueShare: boolean;
          pinHint: string | null;
          revenueShareSetting: {
            id: string;
            revenueShareType: Types.RevenueShareType;
            revenueShareFlat: number | null;
            revenueSharePercents: number | null;
          } | null;
          logo: {
            id: string;
            key: string;
            filename: string;
            downloadUrl: string | null;
            updatedAt: string;
            createdAt: string;
            mime: string;
            size: number;
          } | null;
          headquarters: {
            id: string;
            state: string | null;
            county: string | null;
            street: string | null;
            city: string | null;
            apartment: string | null;
            zipCode: string | null;
          } | null;
          peo: {
            id: string;
            displayName: string | null;
            companyType: Types.PeoCompanyType;
            peoPayrollProvider: {
              id: string;
              companyType: Types.PeoPayrollProviderCompanyType;
            } | null;
          } | null;
          peoPayrollProvider: {
            id: string;
            displayName: string | null;
            companyType: Types.PeoPayrollProviderCompanyType;
          } | null;
        } | null;
      };
    }>;
  };
};

export type RevenueShareSettingUpdateMutationVariables = Exact<{
  data: Types.RevenueShareSettingUpdate;
  where: Types.RevenueShareSettingWhereUnique;
}>;

export type RevenueShareSettingUpdateMutation = { revenueShareSettingUpdate: { id: string } };

export type RevenueShareSettingBulkUpdateMutationVariables = Exact<{
  data: Types.RevenueShareSettingUpdateMany;
  filter: Types.RevenueShareSettingWhere;
}>;

export type RevenueShareSettingBulkUpdateMutation = { revenueShareSettingUpdateMany: number };

export type RevenueShareSettingDeleteMutationMutationVariables = Exact<{
  filter: Types.RevenueShareSettingWhereUnique;
}>;

export type RevenueShareSettingDeleteMutationMutation = { revenueShareSettingDelete: boolean };

export type InitialBillingRulesUpdateMutationVariables = Exact<{
  data: Types.InitialBillingUpdate;
}>;

export type InitialBillingRulesUpdateMutation = {
  updateInitialBillingRules: {
    id: string;
    voI: number;
    voE: number;
    reverification: number;
    revenueShareType: Types.RevenueShareType;
    revenueSharePercents: number;
    revenueShareFlat: number;
  };
};

export type InitialBillingRulesQueryVariables = Exact<{ [key: string]: never }>;

export type InitialBillingRulesQuery = {
  initialBillingList: Array<{
    id: string;
    voI: number;
    voE: number;
    reverification: number;
    revenueShareType: Types.RevenueShareType;
    revenueSharePercents: number;
    revenueShareFlat: number;
  }>;
};

export type ServerBuildVersionQueryVariables = Exact<{ [key: string]: never }>;

export type ServerBuildVersionQuery = { buildVersion: string | null };

export type CognitoGetSsoUrlQueryVariables = Exact<{ [key: string]: never }>;

export type CognitoGetSsoUrlQuery = { cognitoGetSsoUrl: string };

export type CognitoGetUserMfaStatusQueryVariables = Exact<{
  userId: string | number;
}>;

export type CognitoGetUserMfaStatusQuery = { cognitoGetUserMfaStatus: { mfaEnabled: boolean } };

export type CognitoGetCurrentUserAuthStatusQueryVariables = Exact<{ [key: string]: never }>;

export type CognitoGetCurrentUserAuthStatusQuery = {
  cognitoGetCurrentUserAuthStatus: {
    mfaRequired: boolean;
    mfaEnabled: boolean;
    ssoEnabled: boolean;
  };
};

export type CognitoDisableUserMfaMutationVariables = Exact<{
  userId: string | number;
}>;

export type CognitoDisableUserMfaMutation = { cognitoDisableUserMfa: { success: boolean } };

export type EmployeeItemFragment = {
  id: string;
  ssn: string;
  workEmail: string | null;
  phoneNumber: string | null;
  role: Types.EmployeeRole;
  userId: string | null;
  freeze: Types.ActiveInactive | null;
  requestAutoApprove: Types.ActiveInactive | null;
  deleteRequestSentAt: string | null;
  dataDeletedAt: string | null;
};

export type ConsumerQueryVariables = Exact<{
  id: string | number;
}>;

export type ConsumerQuery = {
  employee: {
    id: string;
    ssn: string;
    workEmail: string | null;
    phoneNumber: string | null;
    role: Types.EmployeeRole;
    userId: string | null;
    freeze: Types.ActiveInactive | null;
    requestAutoApprove: Types.ActiveInactive | null;
    deleteRequestSentAt: string | null;
    dataDeletedAt: string | null;
  } | null;
};

export type EmployeeRegistrationMutationVariables = Exact<{
  employeeSignupToken: string;
  requestAutoApprove: boolean;
  user: Types.NewEmployeeUserData;
}>;

export type EmployeeRegistrationMutation = {
  userRegistrationEmployee: { idToken: string | null; accessToken: string | null };
};

export type ConsumerUpdateMutationVariables = Exact<{
  data: Types.EmployeeUpdate;
  where: Types.EmployeeWhereUnique;
}>;

export type ConsumerUpdateMutation = { employeeUpdate: { id: string } };

export type DashboardUsageReportItemInfoFragment = {
  month: string;
  type: Types.DashboardVerificationRequestGroup;
  count: string | number;
};

export type DashboardWorkLetterUsageItemInfoFragment = {
  month: string;
  type: Types.EmployeeWorkLetterType;
  count: string | number;
};

export type DashboardPlatformAdminRevenueDistributionItemInfoFragment = {
  month: string;
  type: Types.CompanyType;
  revenueSharePayedAmount: string | number;
};

export type DashboardCvRevenueByVerificationTypeItemInfoFragment = {
  month: string;
  type: Types.DashboardVerificationRequestGroup;
  chargeAmount: number;
};

export type GetDashboardReportAndRevenueQueryVariables = Exact<{
  employerIds: Array<string | number> | string | number;
}>;

export type GetDashboardReportAndRevenueQuery = {
  getDashboardReportAndRevenue: {
    dashboardReportData: {
      activeRecordAmount: number;
      inactiveRecordAmount: number;
      resolvedDataDisputeAmount: number;
      pendingDataDisputeAmount: number;
    };
    dashboardRevenueShareData: { revenueSharePayedAmount: number; revenueShareOwedAmount: number };
  };
};

export type DashboardVerificationRequestsCountGroupByStatusInfoFragment = {
  status: Types.VerificationRequestStatus;
  count: number;
};

export type DashboardVerificationRequestsCountGroupByIsManualInfoFragment = {
  isManual: boolean;
  count: number;
};

export type DashboardVerifiersCountGroupByCredentialStatusInfoFragment = {
  status: Types.VerifierCredentialStatus;
  count: number;
};

export type DashboardDataDisputeItemsCountGroupByStatusInfoFragment = {
  status: Types.DataDisputeItemStatus;
  count: number;
};

export type DashboardCvAdminVerifiersDataResponseInfoFragment = {
  averageCertificationHours: number;
  commercialVerifiersCount: string | number;
  governmentalVerifiersCount: string | number;
};

export type DashboardPlatformAdminTopVerifierDataInfoFragment = {
  id: string;
  type: Types.VerifierType;
  displayName: string | null;
  verificationRequestsCount: string | number;
};

export type GetDashboardUsageReportsQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  from: string;
  to: string;
}>;

export type GetDashboardUsageReportsQuery = {
  getDashboardUsageReports: Array<{
    month: string;
    type: Types.DashboardVerificationRequestGroup;
    count: string | number;
  }>;
};

export type GetDashboardWorkLetterUsageQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  from: string;
  to: string;
}>;

export type GetDashboardWorkLetterUsageQuery = {
  getDashboardWorkLetterUsage: Array<{
    month: string;
    type: Types.EmployeeWorkLetterType;
    count: string | number;
  }>;
};

export type GetDashboardRecordsActivityQueryVariables = Exact<{
  employerIds?: Array<string> | string | null | undefined;
  peoIds?: Array<string> | string | null | undefined;
}>;

export type GetDashboardRecordsActivityQuery = {
  getDashboardRecordsActivity: {
    active: { Active: number; FMLA: number; IFMLA: number; Intern: number; On_Leave: number };
    inactive: {
      Inactive: number;
      Deceased: number;
      Retired: number;
      Separated: number;
      Terminated: number;
      Temporarily_Inactive: number;
      Severed_With_Pay: number;
      Unknown: number;
    };
  };
};

export type GetDashboardLastUploadRolesQueryVariables = Exact<{
  employerId?: string | number | null | undefined;
  peoId?: string | number | null | undefined;
}>;

export type GetDashboardLastUploadRolesQuery = {
  getDashboardLastUploadRoles: { rolesCount: number; uploadedAt: string } | null;
};

export type GetDashboardCvRevenueByVerificationTypeQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  from: string;
  to: string;
}>;

export type GetDashboardCvRevenueByVerificationTypeQuery = {
  getDashboardCVRevenueByVerificationType: Array<{
    month: string;
    type: Types.DashboardVerificationRequestGroup;
    chargeAmount: number;
  }>;
};

export type GetDashboardPlatformAdminRevenueDistributionsQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  from: string;
  to: string;
}>;

export type GetDashboardPlatformAdminRevenueDistributionsQuery = {
  getDashboardPlatformAdminRevenueDistributions: Array<{
    month: string;
    type: Types.CompanyType;
    revenueSharePayedAmount: string | number;
  }>;
};

export type GetDashboardPlatformAdminFinancialDataQueryVariables = Exact<{
  asOfDate: string;
  employerIds?: Array<string> | string | null | undefined;
  peoIds?: Array<string> | string | null | undefined;
}>;

export type GetDashboardPlatformAdminFinancialDataQuery = {
  getDashboardPlatformAdminFinancialData: {
    voe: number;
    voi: number;
    reverification: number;
    commercialVerifications: number;
    valueOfRecord: number;
    platformRevenue: number;
    revenueSharePaid: number;
    revenueShareOwed: number;
  };
};

export type GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  asOfDate: string;
}>;

export type GetDashboardVerificationRequestsCountGroupedByStatusQuery = {
  getDashboardVerificationRequestsCountGroupedByStatus: Array<{
    status: Types.VerificationRequestStatus;
    count: number;
  }>;
};

export type GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  asOfDate: string;
}>;

export type GetDashboardVerificationRequestsCountGroupedByIsManualQuery = {
  getDashboardVerificationRequestsCountGroupedByIsManual: Array<{
    isManual: boolean;
    count: number;
  }>;
};

export type GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables = Exact<{
  where?: Types.VerifierWhere | null | undefined;
}>;

export type GetDashboardVerifiersCountGroupedByCredentialStatusQuery = {
  getDashboardVerifiersCountGroupedByCredentialStatus: Array<{
    status: Types.VerifierCredentialStatus;
    count: number;
  }>;
};

export type GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables = Exact<{
  employerIds?: Array<string | number> | string | number | null | undefined;
  peoIds?: Array<string | number> | string | number | null | undefined;
  asOfDate: string;
}>;

export type GetDashboardDataDisputeItemsCountGroupedByStatusQuery = {
  getDashboardDataDisputeItemsCountGroupedByStatus: Array<{
    status: Types.DataDisputeItemStatus;
    count: number;
  }>;
};

export type GetDashboardCvAdminVerifiersDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardCvAdminVerifiersDataQuery = {
  getDashboardCVAdminVerifiersData: {
    averageCertificationHours: number;
    commercialVerifiersCount: string | number;
    governmentalVerifiersCount: string | number;
  };
};

export type GetDashboardPlatformAdminTopVerifiersDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDashboardPlatformAdminTopVerifiersDataQuery = {
  getDashboardPlatformAdminTopVerifiersData: Array<{
    id: string;
    type: Types.VerifierType;
    displayName: string | null;
    verificationRequestsCount: string | number;
  }>;
};

export type GenerateYearToDateFinancialReportMutationVariables = Exact<{
  date: string;
}>;

export type GenerateYearToDateFinancialReportMutation = {
  generateYearToDateFinancialReport: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  };
};

export type GetDashboardEmployeeStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardEmployeeStatsQuery = {
  getDashboardEmployeeUserStats: {
    total: number;
    percentage: number;
    breakdown: { Inactive: number; Active: number; Pending: number };
  };
};

export type DataDisputeItemInfoFragment = {
  id: string;
  status: Types.DataDisputeItemStatus;
  employerId: string;
};

export type DataDisputeInfoFragment = {
  id: string;
  reason: string | null;
  verificationRequest: { id: string; createdAt: string; inboxItemId: string } | null;
  employee: { id: string; user: { id: string; fullName: string | null } | null };
};

export type DataDisputeReportInfoFragment = {
  id: string;
  createdAt: string;
  inboxItemId: string;
  employee: {
    id: string;
    last4OfSsn: string;
    user: {
      id: string;
      email: string;
      fullName: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    } | null;
  };
  dataDisputeItemsList: Array<{
    id: string;
    status: Types.DataDisputeItemStatus;
    employer: {
      id: string;
      displayName: string | null;
      peo: { id: string; displayName: string | null } | null;
    };
  }>;
};

export type CreateDataDisputeByEmployeeMutationVariables = Exact<{
  inboxItemId?: string | number | null | undefined;
  employerId: string | number;
  reason: string;
}>;

export type CreateDataDisputeByEmployeeMutation = {
  createDataDisputeByEmployee: { dataDisputeId: string };
};

export type CreateDataDisputeOnEmployeeSignupByInviteMutationVariables = Exact<{
  inviteId: string | number;
  companyId: string | number;
  reason: string;
}>;

export type CreateDataDisputeOnEmployeeSignupByInviteMutation = {
  createDataDisputeOnEmployeeSignupByInvite: { success: boolean };
};

export type CreateDataDisputeOnEmployeeSignupMutationVariables = Exact<{
  employeeSignupToken: string;
  userData: Types.UserDataShapeForNewEmployeeOnDataDisputeCreation;
  companyId: string | number;
  reason: string;
}>;

export type CreateDataDisputeOnEmployeeSignupMutation = {
  createDataDisputeOnEmployeeSignup: { success: boolean };
};

export type CreateDataDisputeForPositionMutationVariables = Exact<{
  employeeId: string | number;
  positionId: string | number;
  employeeFirstName?: string | null | undefined;
  employeeLastName?: string | null | undefined;
  reason?: string | null | undefined;
}>;

export type CreateDataDisputeForPositionMutation = {
  createDataDisputeForPosition: { success: boolean };
};

export type DataDisputeItemChangeStatusMutationVariables = Exact<{
  dataDisputeItemId: string | number;
  status: Types.DataDisputeItemStatus;
}>;

export type DataDisputeItemChangeStatusMutation = {
  changeDataDisputeItemStatus: { success: boolean };
};

export type DataDisputeByIdQueryVariables = Exact<{
  filter: Types.DataDisputeWhereUnique;
  dataDisputeItemsFilter?: Types.DataDisputeItemWhere | null | undefined;
}>;

export type DataDisputeByIdQuery = {
  dataDispute: {
    id: string;
    reason: string | null;
    dataDisputeItemsList: Array<{
      id: string;
      status: Types.DataDisputeItemStatus;
      employerId: string;
    }>;
    verificationRequest: { id: string; createdAt: string; inboxItemId: string } | null;
    employee: { id: string; user: { id: string; fullName: string | null } | null };
  } | null;
};

export type DataDisputeItemsListQueryVariables = Exact<{
  filter?: Types.DataDisputeItemWhere | null | undefined;
}>;

export type DataDisputeItemsListQuery = {
  dataDisputeItemList: Array<{
    id: string;
    createdAt: string;
    status: Types.DataDisputeItemStatus;
    employer: { id: string; displayName: string | null };
    dataDispute: {
      id: string;
      inboxItemId: string;
      employee: {
        id: string;
        user: { id: string; firstName: string | null; lastName: string | null } | null;
      };
    };
  }>;
};

export type DataDisputeReportListQueryVariables = Exact<{
  filter?: Types.DataDisputeWhere | null | undefined;
  orderBy?: Array<Types.DataDisputeOrderBy> | Types.DataDisputeOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type DataDisputeReportListQuery = {
  dataDisputeCount: number;
  dataDisputeList: Array<{
    id: string;
    createdAt: string;
    inboxItemId: string;
    employee: {
      id: string;
      last4OfSsn: string;
      user: {
        id: string;
        email: string;
        fullName: string | null;
        avatar: {
          id: string;
          key: string;
          filename: string;
          downloadUrl: string | null;
          updatedAt: string;
          createdAt: string;
          mime: string;
          size: number;
        } | null;
      } | null;
    };
    dataDisputeItemsList: Array<{
      id: string;
      status: Types.DataDisputeItemStatus;
      employer: {
        id: string;
        displayName: string | null;
        peo: { id: string; displayName: string | null } | null;
      };
    }>;
  }>;
};

export type DisclaimerInfoFragment = {
  id: string;
  name: string;
  disclaimer: string;
  titles: Array<string>;
};

export type DisclaimerCreateMutationVariables = Exact<{
  data: Types.DisclaimerCreate;
}>;

export type DisclaimerCreateMutation = {
  disclaimerCreate: { id: string; name: string; disclaimer: string; titles: Array<string> };
};

export type DisclaimerDeleteMutationVariables = Exact<{
  where: Types.DisclaimerWhereUnique;
}>;

export type DisclaimerDeleteMutation = { disclaimerDelete: boolean };

export type DisclaimerUpdateMutationVariables = Exact<{
  where: Types.DisclaimerWhereUnique;
  data: Types.DisclaimerUpdate;
}>;

export type DisclaimerUpdateMutation = {
  disclaimerUpdate: { id: string; name: string; disclaimer: string; titles: Array<string> };
};

export type DisclaimersListQueryVariables = Exact<{
  filter?: Types.DisclaimerWhere | null | undefined;
}>;

export type DisclaimersListQuery = {
  disclaimerCount: number;
  disclaimerList: Array<{ id: string; name: string; disclaimer: string; titles: Array<string> }>;
};

export type EmailActivityItemInfoFragment = {
  id: string;
  from_email: string;
  to_email: string;
  subject: string;
  status: Types.EmailDeliveryStatus;
  opens_count: number;
  clicks_count: number;
  last_event_time: string;
};

export type EmailActivityQueryVariables = Exact<{
  limit?: number | null | undefined;
  toEmailFilter?: string | null | undefined;
  statusFilter?: Types.EmailDeliveryStatus | null | undefined;
}>;

export type EmailActivityQuery = {
  getEmailActivity: {
    messages: Array<{
      id: string;
      from_email: string;
      to_email: string;
      subject: string;
      status: Types.EmailDeliveryStatus;
      opens_count: number;
      clicks_count: number;
      last_event_time: string;
    }>;
  };
};

export type GetIsEmailFreeQueryVariables = Exact<{
  email: string;
}>;

export type GetIsEmailFreeQuery = { getIsEmailFree: { isEmailFree: boolean } };

export type CheckEmailSuppressionsQueryVariables = Exact<{
  email: string;
}>;

export type CheckEmailSuppressionsQuery = { checkEmailSuppressions: { success: boolean } };

export type DeleteSuppressionFromEmailMutationVariables = Exact<{
  email: string;
}>;

export type DeleteSuppressionFromEmailMutation = {
  deleteSuppressionFromEmail: { success: boolean };
};

export type SendEmailConfirmationCodeMutationVariables = Exact<{
  email: string;
}>;

export type SendEmailConfirmationCodeMutation = {
  sendEmailConfirmationCode: { success: boolean; pendingInviteResent: boolean };
};

export type VerifyEmailConfirmationCodeQueryVariables = Exact<{
  email: string;
  code: string;
}>;

export type VerifyEmailConfirmationCodeQuery = {
  verifyEmailConfirmationCode: { success: boolean };
};

export type EmployeeInfoForVerificationRequestItemFragment = {
  id: string;
  freeze: Types.ActiveInactive | null;
  fullName: string | null;
  email: string | null;
  phoneNumber: string | null;
};

export type EmployeeForPeoAccessSearchInfoFragment = {
  id: string;
  fullName: string | null;
  last4OfSsn: string;
  token: string;
};

export type CheckEmployeeQueryVariables = Exact<{
  ssn: string;
  employeeBirthDate: string;
}>;

export type CheckEmployeeQuery = { checkEmployee: { isEmployeeFrozen: boolean } | null };

export type GetEmployeeInfoForVerificationRequestQueryVariables = Exact<{
  employeeId: string | number;
}>;

export type GetEmployeeInfoForVerificationRequestQuery = {
  getEmployeeInfoForVerificationRequest: {
    id: string;
    freeze: Types.ActiveInactive | null;
    fullName: string | null;
    email: string | null;
    phoneNumber: string | null;
  } | null;
};

export type GetEmployeeForPeoAccessSearchQueryVariables = Exact<{
  employeeSsn: string;
  peoId?: string | number | null | undefined;
}>;

export type GetEmployeeForPeoAccessSearchQuery = {
  getEmployeeForPeoAccessSearch: {
    id: string;
    fullName: string | null;
    last4OfSsn: string;
    token: string;
  } | null;
};

export type DeleteEmployeeAccountDataMutationVariables = Exact<{
  employeeId: string | number;
}>;

export type DeleteEmployeeAccountDataMutation = { deleteEmployeeAccountData: { success: boolean } };

export type ReactivateEmployeeAccountMutationVariables = Exact<{
  employeeId: string | number;
}>;

export type ReactivateEmployeeAccountMutation = { reactivateEmployeeAccount: { success: boolean } };

export type DeleteEmployeeUserMutationVariables = Exact<{
  employeeId: string | number;
}>;

export type DeleteEmployeeUserMutation = { deleteEmployeeUser: { success: boolean } };

export type CheckDeletionEmployeeUserQueryVariables = Exact<{
  employeeId: string | number;
}>;

export type CheckDeletionEmployeeUserQuery = {
  checkDeletionEmployeeUser: { valid: boolean; errors: Array<string> };
};

export type EmployeeDataEmploymentRecordInfoFragment = {
  employerId: string | null;
  peoId: string | null;
  employerDisplayName: string | null;
  peoDisplayName: string | null;
  employerRegisteredBusinessName: string | null;
  employerFein: string;
  employerEmployeeId: string | null;
  employerLocation: string | null;
  employerLocationAddress: string | null;
  employerLogoUrl: string | null;
  isEmployerLive: boolean;
  isEmploymentActive: boolean;
  employmentStatus: Types.PositionEmploymentStatus | null;
  employeeFirstName: string | null;
  employeeLastName: string | null;
  employeePositionTitle: string | null;
  employeeLast4OfSsn: string;
  employeeDateOfBirth: string | null;
  employmentOriginalHireDate: string | null;
  employmentMostRecentEmployment: string | null;
  employmentTotalTimeWithEmployer: string | null;
  employmentUpdatedAt: string | null;
  averageHoursPerPayPeriod: string | null;
  averageBasePay: string | null;
  companyId: string;
};

export type EmployeeDataUserInformationInfoFragment = {
  id: string;
  email: string;
  createdAt: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  status: Types.UserStatus;
};

export type EmployeeDataInfoFragment = {
  id: string | null;
  last4OfSsn: string;
  dataDeletedAt: string | null;
  dataDeleteRequestSent: boolean;
  user: {
    id: string;
    email: string;
    createdAt: string;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    status: Types.UserStatus;
  } | null;
  employmentRecords: Array<{
    employerId: string | null;
    peoId: string | null;
    employerDisplayName: string | null;
    peoDisplayName: string | null;
    employerRegisteredBusinessName: string | null;
    employerFein: string;
    employerEmployeeId: string | null;
    employerLocation: string | null;
    employerLocationAddress: string | null;
    employerLogoUrl: string | null;
    isEmployerLive: boolean;
    isEmploymentActive: boolean;
    employmentStatus: Types.PositionEmploymentStatus | null;
    employeeFirstName: string | null;
    employeeLastName: string | null;
    employeePositionTitle: string | null;
    employeeLast4OfSsn: string;
    employeeDateOfBirth: string | null;
    employmentOriginalHireDate: string | null;
    employmentMostRecentEmployment: string | null;
    employmentTotalTimeWithEmployer: string | null;
    employmentUpdatedAt: string | null;
    averageHoursPerPayPeriod: string | null;
    averageBasePay: string | null;
    companyId: string;
  }>;
};

export type GetEmployeeDataForMyDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmployeeDataForMyDataQuery = {
  getEmployeeDataForMyData: {
    id: string | null;
    last4OfSsn: string;
    dataDeletedAt: string | null;
    dataDeleteRequestSent: boolean;
    user: {
      id: string;
      email: string;
      createdAt: string;
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
    } | null;
    employmentRecords: Array<{
      employerId: string | null;
      peoId: string | null;
      employerDisplayName: string | null;
      peoDisplayName: string | null;
      employerRegisteredBusinessName: string | null;
      employerFein: string;
      employerEmployeeId: string | null;
      employerLocation: string | null;
      employerLocationAddress: string | null;
      employerLogoUrl: string | null;
      isEmployerLive: boolean;
      isEmploymentActive: boolean;
      employmentStatus: Types.PositionEmploymentStatus | null;
      employeeFirstName: string | null;
      employeeLastName: string | null;
      employeePositionTitle: string | null;
      employeeLast4OfSsn: string;
      employeeDateOfBirth: string | null;
      employmentOriginalHireDate: string | null;
      employmentMostRecentEmployment: string | null;
      employmentTotalTimeWithEmployer: string | null;
      employmentUpdatedAt: string | null;
      averageHoursPerPayPeriod: string | null;
      averageBasePay: string | null;
      companyId: string;
    }>;
  };
};

export type GetEmployeeDataOnEmployeeSignupQueryVariables = Exact<{
  employeeSignupToken: string;
}>;

export type GetEmployeeDataOnEmployeeSignupQuery = {
  getEmployeeDataOnEmployeeSignup: {
    id: string | null;
    last4OfSsn: string;
    dataDeletedAt: string | null;
    dataDeleteRequestSent: boolean;
    user: {
      id: string;
      email: string;
      createdAt: string;
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
    } | null;
    employmentRecords: Array<{
      employerId: string | null;
      peoId: string | null;
      employerDisplayName: string | null;
      peoDisplayName: string | null;
      employerRegisteredBusinessName: string | null;
      employerFein: string;
      employerEmployeeId: string | null;
      employerLocation: string | null;
      employerLocationAddress: string | null;
      employerLogoUrl: string | null;
      isEmployerLive: boolean;
      isEmploymentActive: boolean;
      employmentStatus: Types.PositionEmploymentStatus | null;
      employeeFirstName: string | null;
      employeeLastName: string | null;
      employeePositionTitle: string | null;
      employeeLast4OfSsn: string;
      employeeDateOfBirth: string | null;
      employmentOriginalHireDate: string | null;
      employmentMostRecentEmployment: string | null;
      employmentTotalTimeWithEmployer: string | null;
      employmentUpdatedAt: string | null;
      averageHoursPerPayPeriod: string | null;
      averageBasePay: string | null;
      companyId: string;
    }>;
  };
};

export type GetEmployeeDataOnEmployeeSignupByInviteQueryVariables = Exact<{
  inviteId: string | number;
}>;

export type GetEmployeeDataOnEmployeeSignupByInviteQuery = {
  getEmployeeDataOnEmployeeSignupByInvite: {
    id: string | null;
    last4OfSsn: string;
    dataDeletedAt: string | null;
    dataDeleteRequestSent: boolean;
    user: {
      id: string;
      email: string;
      createdAt: string;
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
    } | null;
    employmentRecords: Array<{
      employerId: string | null;
      peoId: string | null;
      employerDisplayName: string | null;
      peoDisplayName: string | null;
      employerRegisteredBusinessName: string | null;
      employerFein: string;
      employerEmployeeId: string | null;
      employerLocation: string | null;
      employerLocationAddress: string | null;
      employerLogoUrl: string | null;
      isEmployerLive: boolean;
      isEmploymentActive: boolean;
      employmentStatus: Types.PositionEmploymentStatus | null;
      employeeFirstName: string | null;
      employeeLastName: string | null;
      employeePositionTitle: string | null;
      employeeLast4OfSsn: string;
      employeeDateOfBirth: string | null;
      employmentOriginalHireDate: string | null;
      employmentMostRecentEmployment: string | null;
      employmentTotalTimeWithEmployer: string | null;
      employmentUpdatedAt: string | null;
      averageHoursPerPayPeriod: string | null;
      averageBasePay: string | null;
      companyId: string;
    }>;
  };
};

export type GetEmployeeDataOnEmployeeSearchForAdminQueryVariables = Exact<{
  employeeSsnEncrypted: string;
  limit: number;
  cursor?: string | number | null | undefined;
  companyFilter?: Types.EmployeeSearchCompanyFilterInput | null | undefined;
}>;

export type GetEmployeeDataOnEmployeeSearchForAdminQuery = {
  getEmployeeDataOnEmployeeSearchForAdmin: {
    employmentRecordsHasNextPage: boolean;
    employmentRecordsCursor: string | null;
    result: {
      id: string | null;
      last4OfSsn: string;
      dataDeletedAt: string | null;
      dataDeleteRequestSent: boolean;
      user: {
        id: string;
        email: string;
        createdAt: string;
        firstName: string | null;
        lastName: string | null;
        phoneNumber: string | null;
        status: Types.UserStatus;
      } | null;
      employmentRecords: Array<{
        employerId: string | null;
        peoId: string | null;
        employerDisplayName: string | null;
        peoDisplayName: string | null;
        employerRegisteredBusinessName: string | null;
        employerFein: string;
        employerEmployeeId: string | null;
        employerLocation: string | null;
        employerLocationAddress: string | null;
        employerLogoUrl: string | null;
        isEmployerLive: boolean;
        isEmploymentActive: boolean;
        employmentStatus: Types.PositionEmploymentStatus | null;
        employeeFirstName: string | null;
        employeeLastName: string | null;
        employeePositionTitle: string | null;
        employeeLast4OfSsn: string;
        employeeDateOfBirth: string | null;
        employmentOriginalHireDate: string | null;
        employmentMostRecentEmployment: string | null;
        employmentTotalTimeWithEmployer: string | null;
        employmentUpdatedAt: string | null;
        averageHoursPerPayPeriod: string | null;
        averageBasePay: string | null;
        companyId: string;
      }>;
    };
  };
};

export type GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables = Exact<{
  employeeSsnEncrypted: string;
  limit: number;
  cursor?: string | number | null | undefined;
  companyFilter?: Types.EmployeeSearchCompanyFilterInput | null | undefined;
}>;

export type GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery = {
  getEmployeeDataOnEmployeeSearchForEmployerScope: {
    employmentRecordsHasNextPage: boolean;
    employmentRecordsCursor: string | null;
    result: {
      id: string | null;
      last4OfSsn: string;
      dataDeletedAt: string | null;
      dataDeleteRequestSent: boolean;
      user: {
        id: string;
        email: string;
        createdAt: string;
        firstName: string | null;
        lastName: string | null;
        phoneNumber: string | null;
        status: Types.UserStatus;
      } | null;
      employmentRecords: Array<{
        employerId: string | null;
        peoId: string | null;
        employerDisplayName: string | null;
        peoDisplayName: string | null;
        employerRegisteredBusinessName: string | null;
        employerFein: string;
        employerEmployeeId: string | null;
        employerLocation: string | null;
        employerLocationAddress: string | null;
        employerLogoUrl: string | null;
        isEmployerLive: boolean;
        isEmploymentActive: boolean;
        employmentStatus: Types.PositionEmploymentStatus | null;
        employeeFirstName: string | null;
        employeeLastName: string | null;
        employeePositionTitle: string | null;
        employeeLast4OfSsn: string;
        employeeDateOfBirth: string | null;
        employmentOriginalHireDate: string | null;
        employmentMostRecentEmployment: string | null;
        employmentTotalTimeWithEmployer: string | null;
        employmentUpdatedAt: string | null;
        averageHoursPerPayPeriod: string | null;
        averageBasePay: string | null;
        companyId: string;
      }>;
    };
  };
};

export type EmployeeInviteEmailOptionInfoFragment = {
  email: string;
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  employerDisplayNames: Array<string>;
};

export type GetEmployeeInviteEmailOptionsForAdminQueryVariables = Exact<{
  employeeSsnEncrypted: string;
}>;

export type GetEmployeeInviteEmailOptionsForAdminQuery = {
  getEmployeeInviteEmailOptionsForAdmin: Array<{
    email: string;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    employerDisplayNames: Array<string>;
  }>;
};

export type GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables = Exact<{
  employeeSsnEncrypted: string;
}>;

export type GetEmployeeInviteEmailOptionsForEmployerScopeQuery = {
  getEmployeeInviteEmailOptionsForEmployerScope: Array<{
    email: string;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    employerDisplayNames: Array<string>;
  }>;
};

export type GetEmployeeInviteLinkScopeForAdminQueryVariables = Exact<{
  employeeSsnEncrypted: string;
}>;

export type GetEmployeeInviteLinkScopeForAdminQuery = {
  getEmployeeInviteLinkScopeForAdmin: {
    route: string;
    paramKey: string;
    entityId: string;
    entityDisplayName: string | null;
  } | null;
};

export type EmployeeNoteInfoFragment = {
  id: string;
  employeeId: string;
  createdAt: string;
  comment: string | null;
  createdBy: string;
};

export type EmployeeNotesQueryVariables = Exact<{
  where?: Types.EmployeeNoteWhere | null | undefined;
  orderBy?: Array<Types.EmployeeNoteOrderBy> | Types.EmployeeNoteOrderBy | null | undefined;
}>;

export type EmployeeNotesQuery = {
  employeeNoteList: Array<{
    id: string;
    employeeId: string;
    createdAt: string;
    comment: string | null;
    createdBy: string;
  }>;
};

export type CreateEmployeeNoteMutationVariables = Exact<{
  employeeSsnEncrypted: string;
  comment: string;
}>;

export type CreateEmployeeNoteMutation = {
  createEmployeeNote: {
    id: string;
    employeeId: string;
    createdAt: string;
    comment: string | null;
    createdBy: string;
  };
};

export type EmployeeSearchMatchInfoFragment = {
  last4OfSsn: string;
  ssnEncrypted: string;
  firstName: string | null;
  lastName: string | null;
  birthDate: string | null;
  isPlatformUserExists: boolean;
  isPlatformDataDeleted: boolean;
};

export type SearchEmployeesForAdminQueryVariables = Exact<{
  input: Types.EmployeeSearchInput;
  companyFilter?: Types.EmployeeSearchCompanyFilterInput | null | undefined;
}>;

export type SearchEmployeesForAdminQuery = {
  searchEmployeesForAdmin: Array<{
    last4OfSsn: string;
    ssnEncrypted: string;
    firstName: string | null;
    lastName: string | null;
    birthDate: string | null;
    isPlatformUserExists: boolean;
    isPlatformDataDeleted: boolean;
  }>;
};

export type SearchEmployeesForEmployerScopeQueryVariables = Exact<{
  input: Types.EmployeeSearchInput;
  companyFilter?: Types.EmployeeSearchCompanyFilterInput | null | undefined;
}>;

export type SearchEmployeesForEmployerScopeQuery = {
  searchEmployeesForEmployerScope: Array<{
    last4OfSsn: string;
    ssnEncrypted: string;
    firstName: string | null;
    lastName: string | null;
    birthDate: string | null;
    isPlatformUserExists: boolean;
    isPlatformDataDeleted: boolean;
  }>;
};

export type EmployerInfoFragment = {
  id: string;
  createdAt: string;
  displayName: string | null;
  contactEmail: string | null;
  legalBusinessName: string | null;
  numberOfEmployees: number | null;
  corporateStructure: string | null;
  industry: string | null;
  contactPhoneNumber: string | null;
  taxYearEndDate: string | null;
  withdrawalSettings: Types.EmployerWithdrawalSetting | null;
  stripeAccountId: string | null;
  requestAutoAccept: boolean;
  signUpMethod: Types.SignUpMethod;
  disclaimer: string | null;
  setLiveAt: string | null;
  controlledBy: Types.CompanyType;
  keepOwnRevenueShare: boolean;
  pinHint: string | null;
  revenueShareSetting: {
    id: string;
    revenueShareType: Types.RevenueShareType;
    revenueShareFlat: number | null;
    revenueSharePercents: number | null;
  } | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
  headquarters: {
    id: string;
    state: string | null;
    county: string | null;
    street: string | null;
    city: string | null;
    apartment: string | null;
    zipCode: string | null;
  } | null;
  peo: {
    id: string;
    displayName: string | null;
    companyType: Types.PeoCompanyType;
    peoPayrollProvider: { id: string; companyType: Types.PeoPayrollProviderCompanyType } | null;
  } | null;
  peoPayrollProvider: {
    id: string;
    displayName: string | null;
    companyType: Types.PeoPayrollProviderCompanyType;
  } | null;
};

export type EmployerTableItemFragment = {
  id: string;
  displayName: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  controlledBy: Types.CompanyType;
  setLiveAt: string | null;
  numberOfEmployees: number | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
  headquarters: {
    id: string;
    state: string | null;
    county: string | null;
    street: string | null;
    city: string | null;
    apartment: string | null;
    zipCode: string | null;
  } | null;
  employerStaffsList: Array<{
    id: string;
    role: Types.EmployerStaffRole;
    user: { id: string; status: Types.UserStatus };
  }>;
  peo: { id: string; displayName: string | null } | null;
  peoPayrollProvider: { id: string; displayName: string | null } | null;
};

export type EmployerSimpleInfoFragment = {
  id: string;
  displayName: string | null;
  setLiveAt: string | null;
  revenueShareSettingId: string | null;
};

export type EmployerRevenueShareInfoFragment = {
  id: string;
  withdrawalSettings: Types.EmployerWithdrawalSetting | null;
  revenueShareReportEnabled: boolean;
  revenueShareSetting: {
    id: string;
    revenueShareType: Types.RevenueShareType;
    revenueShareFlat: number | null;
    revenueSharePercents: number | null;
  } | null;
};

export type EmployerBasicInfoFragment = {
  id: string;
  displayName: string | null;
  signUpMethod: Types.SignUpMethod;
  pinHint: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type EmployerListItemForVerificationRequestInfoFragment = {
  id: string;
  topLevelCompanyId: string;
  employeeId: string;
  feinValue: string;
  displayName: string | null;
  isPayrollsAvailable: boolean;
  checksum: string;
};

export type EmployerQueryVariables = Exact<{
  id: string | number;
}>;

export type EmployerQuery = {
  employer: {
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    legalBusinessName: string | null;
    numberOfEmployees: number | null;
    corporateStructure: string | null;
    industry: string | null;
    contactPhoneNumber: string | null;
    taxYearEndDate: string | null;
    withdrawalSettings: Types.EmployerWithdrawalSetting | null;
    stripeAccountId: string | null;
    requestAutoAccept: boolean;
    signUpMethod: Types.SignUpMethod;
    disclaimer: string | null;
    setLiveAt: string | null;
    controlledBy: Types.CompanyType;
    keepOwnRevenueShare: boolean;
    pinHint: string | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    peo: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoCompanyType;
      peoPayrollProvider: { id: string; companyType: Types.PeoPayrollProviderCompanyType } | null;
    } | null;
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoPayrollProviderCompanyType;
    } | null;
  } | null;
};

export type EmployerUpdateMutationVariables = Exact<{
  data: Types.EmployerUpdate;
  where: Types.EmployerWhereUnique;
}>;

export type EmployerUpdateMutation = {
  employerUpdate: {
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    legalBusinessName: string | null;
    numberOfEmployees: number | null;
    corporateStructure: string | null;
    industry: string | null;
    contactPhoneNumber: string | null;
    taxYearEndDate: string | null;
    withdrawalSettings: Types.EmployerWithdrawalSetting | null;
    stripeAccountId: string | null;
    requestAutoAccept: boolean;
    signUpMethod: Types.SignUpMethod;
    disclaimer: string | null;
    setLiveAt: string | null;
    controlledBy: Types.CompanyType;
    keepOwnRevenueShare: boolean;
    pinHint: string | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    peo: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoCompanyType;
      peoPayrollProvider: { id: string; companyType: Types.PeoPayrollProviderCompanyType } | null;
    } | null;
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoPayrollProviderCompanyType;
    } | null;
  };
};

export type EmployerUpdateManyMutationVariables = Exact<{
  data: Types.EmployerUpdateMany;
  filter: Types.EmployerWhere;
}>;

export type EmployerUpdateManyMutation = { employerUpdateMany: number };

export type EmployersTableListQueryVariables = Exact<{
  filter?: Types.EmployerWhere | null | undefined;
  orderBy?: Array<Types.EmployerOrderBy> | Types.EmployerOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type EmployersTableListQuery = {
  employerCount: number;
  employerList: Array<{
    id: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    controlledBy: Types.CompanyType;
    setLiveAt: string | null;
    numberOfEmployees: number | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    employerStaffsList: Array<{
      id: string;
      role: Types.EmployerStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
    peo: { id: string; displayName: string | null } | null;
    peoPayrollProvider: { id: string; displayName: string | null } | null;
  }>;
};

export type EmployersSimpleListQueryVariables = Exact<{
  filter?: Types.EmployerWhere | null | undefined;
  orderBy?: Array<Types.EmployerOrderBy> | Types.EmployerOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type EmployersSimpleListQuery = {
  employerCount: number;
  employerList: Array<{
    id: string;
    displayName: string | null;
    setLiveAt: string | null;
    revenueShareSettingId: string | null;
  }>;
};

export type EmployerRevenueShareQueryVariables = Exact<{
  where: Types.EmployerWhereUnique;
}>;

export type EmployerRevenueShareQuery = {
  employer: {
    id: string;
    withdrawalSettings: Types.EmployerWithdrawalSetting | null;
    revenueShareReportEnabled: boolean;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  } | null;
};

export type EmployerRevenueShareUpdateMutationVariables = Exact<{
  where: Types.EmployerWhereUnique;
  data: Types.EmployerUpdate;
}>;

export type EmployerRevenueShareUpdateMutation = {
  employerUpdate: {
    id: string;
    withdrawalSettings: Types.EmployerWithdrawalSetting | null;
    revenueShareReportEnabled: boolean;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  };
};

export type GetEmployerBasicInfoQueryVariables = Exact<{
  id: string | number;
}>;

export type GetEmployerBasicInfoQuery = {
  getEmployerBasicInfo: {
    id: string;
    displayName: string | null;
    signUpMethod: Types.SignUpMethod;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type GetEmployersListForVerificationRequestQueryVariables = Exact<{
  inboxItemId: string | number;
}>;

export type GetEmployersListForVerificationRequestQuery = {
  getEmployersListForVerificationRequest: {
    isThereInactiveEmployers: boolean;
    employers: Array<{
      id: string;
      topLevelCompanyId: string;
      employeeId: string;
      feinValue: string;
      displayName: string | null;
      isPayrollsAvailable: boolean;
      checksum: string;
    }>;
  };
};

export type GetEmployersListForVerificationRequestByEmployeeDataQueryVariables = Exact<{
  employeeSsn: string;
  employeeBirthDate: string;
  showInactiveEmployers?: boolean | null | undefined;
}>;

export type GetEmployersListForVerificationRequestByEmployeeDataQuery = {
  getEmployersListForVerificationRequestByEmployeeData: {
    isThereInactiveEmployers: boolean;
    employers: Array<{
      id: string;
      topLevelCompanyId: string;
      employeeId: string;
      feinValue: string;
      displayName: string | null;
      isPayrollsAvailable: boolean;
      checksum: string;
    }>;
  };
};

export type GetEmployersListForVerificationRequestForMyVerifyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEmployersListForVerificationRequestForMyVerifyQuery = {
  getEmployersListForVerificationRequestForMyVerify: {
    employers: Array<{
      id: string;
      topLevelCompanyId: string;
      employeeId: string;
      feinValue: string;
      displayName: string | null;
      isPayrollsAvailable: boolean;
      checksum: string;
    }>;
  };
};

export type GetEmployersListForWorkLetterQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmployersListForWorkLetterQuery = {
  getEmployersListForWorkLetter: {
    employers: Array<{
      id: string;
      topLevelCompanyId: string;
      employeeId: string;
      feinValue: string;
      displayName: string | null;
      isPayrollsAvailable: boolean;
      checksum: string;
    }>;
  };
};

export type GetEmployersListForWorkLetterForAdminQueryVariables = Exact<{
  employeeSsnEncrypted: string;
}>;

export type GetEmployersListForWorkLetterForAdminQuery = {
  getEmployersListForWorkLetterForAdmin: {
    employers: Array<{
      id: string;
      topLevelCompanyId: string;
      employeeId: string;
      feinValue: string;
      displayName: string | null;
      isPayrollsAvailable: boolean;
      checksum: string;
    }>;
  };
};

export type SendInvitesToEmployersByPeoStaffMutationVariables = Exact<{
  input: Types.SendInvitesToEmployersByPeoStaffInput;
}>;

export type SendInvitesToEmployersByPeoStaffMutation = {
  sendInvitesToEmployersByPeoStaff: { success: boolean };
};

export type EmployerLogoQueryVariables = Exact<{
  id: string | number;
}>;

export type EmployerLogoQuery = {
  employer: {
    id: string;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type EmployersCountQueryVariables = Exact<{
  filter?: Types.EmployerWhere | null | undefined;
}>;

export type EmployersCountQuery = { employerCount: number };

export type EmployerStaffInfoFragment = {
  id: string;
  role: Types.EmployerStaffRole;
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    phoneNumber: string | null;
    status: Types.UserStatus;
    birthDate: string | null;
    avatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  };
  employer: {
    id: string;
    displayName: string | null;
    controlledBy: Types.CompanyType;
    peoPayrollProviderId: string | null;
    peo: { id: string; peoPayrollProviderId: string | null } | null;
  };
};

export type EmployerStaffsListQueryVariables = Exact<{
  filter?: Types.EmployerStaffWhere | null | undefined;
  orderBy?: Array<Types.EmployerStaffOrderBy> | Types.EmployerStaffOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type EmployerStaffsListQuery = {
  employerStaffCount: number;
  employerStaffList: Array<{
    id: string;
    role: Types.EmployerStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    employer: {
      id: string;
      displayName: string | null;
      controlledBy: Types.CompanyType;
      peoPayrollProviderId: string | null;
      peo: { id: string; peoPayrollProviderId: string | null } | null;
    };
  }>;
};

export type EmployerStaffQueryVariables = Exact<{
  id: string | number;
}>;

export type EmployerStaffQuery = {
  employerStaff: {
    id: string;
    role: Types.EmployerStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    employer: {
      id: string;
      displayName: string | null;
      controlledBy: Types.CompanyType;
      peoPayrollProviderId: string | null;
      peo: { id: string; peoPayrollProviderId: string | null } | null;
    };
  } | null;
};

export type EmployerStaffUpdateMutationVariables = Exact<{
  data: Types.EmployerStaffUpdate;
  where: Types.EmployerStaffWhereUnique;
}>;

export type EmployerStaffUpdateMutation = {
  employerStaffUpdate: {
    id: string;
    role: Types.EmployerStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    employer: {
      id: string;
      displayName: string | null;
      controlledBy: Types.CompanyType;
      peoPayrollProviderId: string | null;
      peo: { id: string; peoPayrollProviderId: string | null } | null;
    };
  };
};

export type EmployerStaffInviteMutationVariables = Exact<{
  employerStaffList: Array<Types.InvitedEmployerStaff> | Types.InvitedEmployerStaff;
  employerId: string | number;
}>;

export type EmployerStaffInviteMutation = { sendInvitesToEmployerStaffs: { success: boolean } };

export type EmployerStaffInviteByEmployerAdminMutationVariables = Exact<{
  employerStaffList: Array<Types.InvitedEmployerStaff> | Types.InvitedEmployerStaff;
}>;

export type EmployerStaffInviteByEmployerAdminMutation = {
  sendInvitesToEmployerStaffsByEmployerAdmin: { success: boolean };
};

export type EmployerStaffBillingInfoQueryVariables = Exact<{
  id: string | number;
}>;

export type EmployerStaffBillingInfoQuery = {
  employerStaff: {
    id: string;
    employer: {
      id: string;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  } | null;
};

export type DeleteEmployerStaffMutationVariables = Exact<{
  employerStaffId: string | number;
}>;

export type DeleteEmployerStaffMutation = { deleteEmployerStaff: { success: boolean } };

export type CheckDeletionEmployerStaffQueryVariables = Exact<{
  employerStaffId: string | number;
}>;

export type CheckDeletionEmployerStaffQuery = {
  checkDeletionEmployerStaff: { valid: boolean; errors: Array<string> };
};

export type EmploymentDataEmployeeInformationInfoFragment = {
  averageBaseWage: string | null;
  averageHoursPerPayPeriod: string | null;
  employmentStatus: Types.PositionEmploymentStatus;
  employmentType: string | null;
  firstName: string | null;
  fullName: string | null;
  lastName: string | null;
  mostRecentEmployment: string | null;
  originalHireDate: string | null;
  rateOfPay: string | null;
  payFrequency: string | null;
  ssn: string;
  totalTimeWithEmployer: string | null;
  employeeId: string | null;
};

export type EmploymentDataHeadquartersAddressInfoFragment = {
  city: string | null;
  state: string | null;
  street: string | null;
  zipCode: string | null;
};

export type EmploymentDataPositionInformationInfoFragment = {
  division: string | null;
  registeredBusinessName: string | null;
  statusPosition: Types.EmploymentDataPositionInformationStatus;
  title: string | null;
};

export type EmploymentDataMetaInfoFragment = {
  companyId: string;
  locationId: string | null;
  employerId: string;
  headquartersId: string | null;
  consumerId: string | null;
  positionId: string;
  userId: string | null;
  userStatus: Types.UserStatus | null;
  userEmail: string | null;
  updatedAt: string;
};

export type EmploymentDataCompanyInformationInfoFragment = {
  avatarUrl: string | null;
  locationAddress: string;
  fein: string | null;
  registeredBusinessName: string | null;
  locationName: string | null;
  extLocationId: string | null;
  displayName: string | null;
};

export type EmploymentDataSummaryIncomeInformationInfoFragment = {
  year: number;
  baseWage: number | null;
  overtimeWage: number | null;
  bonusesWage: number | null;
  commissionWage: number | null;
  holidayWage: number | null;
  pension: number | null;
  severance: number | null;
  sickWage: number | null;
  tips: number | null;
  totalWage: number | null;
  vacationWage: number | null;
  ptoPayoutWage: number | null;
  sickTimePayoutWage: number | null;
  vacationTimePayoutWage: number | null;
  miscWage: number | null;
  otherWage: number | null;
  ptoWage: number | null;
  incentiveWage: number | null;
};

export type EmploymentDataPayrollItemInfoFragment = {
  id: string;
  baseWage: number | null;
  paymentDate: string | null;
  paymentPeriodEnd: string | null;
  grossHours: number | null;
  overtimeHours: number | null;
  overtimeWage: number | null;
  commissionWage: number | null;
  vacationWage: number | null;
  sickWage: number | null;
  bonusesWage: number | null;
  holidayWage: number | null;
  pension: number | null;
  shiftDifferential: number | null;
  severance: number | null;
  tips: number | null;
  stock: number | null;
  mostRecentHireDate: string | null;
  originalHireDate: string | null;
  grossWage: number | null;
  miscWage: number | null;
  otherWage: number | null;
  ptoWage: number | null;
  incentiveWage: number | null;
  ptoPayoutWage: number | null;
  sickTimePayoutWage: number | null;
  vacationTimePayoutWage: number | null;
  rateOfPay: string | null;
};

export type EmploymentDataBenefitInfoFragment = {
  id: string;
  eligibleForDental: boolean | null;
  enrolledInDental: boolean | null;
  dentalInsuranceCarrier: string | null;
  eligibleForMedical: boolean | null;
  enrolledInMedical: boolean | null;
  medicalInsuranceCarrier: string | null;
};

export type EmploymentDataInfoFragment = {
  employeeInformation: {
    averageBaseWage: string | null;
    averageHoursPerPayPeriod: string | null;
    employmentStatus: Types.PositionEmploymentStatus;
    employmentType: string | null;
    firstName: string | null;
    fullName: string | null;
    lastName: string | null;
    mostRecentEmployment: string | null;
    originalHireDate: string | null;
    rateOfPay: string | null;
    payFrequency: string | null;
    ssn: string;
    totalTimeWithEmployer: string | null;
    employeeId: string | null;
  };
  headquartersAddress: {
    city: string | null;
    state: string | null;
    street: string | null;
    zipCode: string | null;
  } | null;
  positionInformation: {
    division: string | null;
    registeredBusinessName: string | null;
    statusPosition: Types.EmploymentDataPositionInformationStatus;
    title: string | null;
  };
  meta: {
    companyId: string;
    locationId: string | null;
    employerId: string;
    headquartersId: string | null;
    consumerId: string | null;
    positionId: string;
    userId: string | null;
    userStatus: Types.UserStatus | null;
    userEmail: string | null;
    updatedAt: string;
  };
  companyInformation: {
    avatarUrl: string | null;
    locationAddress: string;
    fein: string | null;
    registeredBusinessName: string | null;
    locationName: string | null;
    extLocationId: string | null;
    displayName: string | null;
  };
  summaryIncomeInformation: Array<{
    year: number;
    baseWage: number | null;
    overtimeWage: number | null;
    bonusesWage: number | null;
    commissionWage: number | null;
    holidayWage: number | null;
    pension: number | null;
    severance: number | null;
    sickWage: number | null;
    tips: number | null;
    totalWage: number | null;
    vacationWage: number | null;
    ptoPayoutWage: number | null;
    sickTimePayoutWage: number | null;
    vacationTimePayoutWage: number | null;
    miscWage: number | null;
    otherWage: number | null;
    ptoWage: number | null;
    incentiveWage: number | null;
  }>;
  historicalIncomeInformation: {
    count: number;
    items: Array<{
      id: string;
      baseWage: number | null;
      paymentDate: string | null;
      paymentPeriodEnd: string | null;
      grossHours: number | null;
      overtimeHours: number | null;
      overtimeWage: number | null;
      commissionWage: number | null;
      vacationWage: number | null;
      sickWage: number | null;
      bonusesWage: number | null;
      holidayWage: number | null;
      pension: number | null;
      shiftDifferential: number | null;
      severance: number | null;
      tips: number | null;
      stock: number | null;
      mostRecentHireDate: string | null;
      originalHireDate: string | null;
      grossWage: number | null;
      miscWage: number | null;
      otherWage: number | null;
      ptoWage: number | null;
      incentiveWage: number | null;
      ptoPayoutWage: number | null;
      sickTimePayoutWage: number | null;
      vacationTimePayoutWage: number | null;
      rateOfPay: string | null;
    }>;
  };
  benefitsInformation: {
    count: number;
    items: Array<{
      id: string;
      eligibleForDental: boolean | null;
      enrolledInDental: boolean | null;
      dentalInsuranceCarrier: string | null;
      eligibleForMedical: boolean | null;
      enrolledInMedical: boolean | null;
      medicalInsuranceCarrier: string | null;
    }>;
  };
};

export type GetEmploymentDataOnEmployeeSignupQueryVariables = Exact<{
  employeeSignupToken: string;
  companyId: string | number;
}>;

export type GetEmploymentDataOnEmployeeSignupQuery = {
  getEmploymentDataOnEmployeeSignup: {
    employeeInformation: {
      averageBaseWage: string | null;
      averageHoursPerPayPeriod: string | null;
      employmentStatus: Types.PositionEmploymentStatus;
      employmentType: string | null;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      mostRecentEmployment: string | null;
      originalHireDate: string | null;
      rateOfPay: string | null;
      payFrequency: string | null;
      ssn: string;
      totalTimeWithEmployer: string | null;
      employeeId: string | null;
    };
    headquartersAddress: {
      city: string | null;
      state: string | null;
      street: string | null;
      zipCode: string | null;
    } | null;
    positionInformation: {
      division: string | null;
      registeredBusinessName: string | null;
      statusPosition: Types.EmploymentDataPositionInformationStatus;
      title: string | null;
    };
    meta: {
      companyId: string;
      locationId: string | null;
      employerId: string;
      headquartersId: string | null;
      consumerId: string | null;
      positionId: string;
      userId: string | null;
      userStatus: Types.UserStatus | null;
      userEmail: string | null;
      updatedAt: string;
    };
    companyInformation: {
      avatarUrl: string | null;
      locationAddress: string;
      fein: string | null;
      registeredBusinessName: string | null;
      locationName: string | null;
      extLocationId: string | null;
      displayName: string | null;
    };
    summaryIncomeInformation: Array<{
      year: number;
      baseWage: number | null;
      overtimeWage: number | null;
      bonusesWage: number | null;
      commissionWage: number | null;
      holidayWage: number | null;
      pension: number | null;
      severance: number | null;
      sickWage: number | null;
      tips: number | null;
      totalWage: number | null;
      vacationWage: number | null;
      ptoPayoutWage: number | null;
      sickTimePayoutWage: number | null;
      vacationTimePayoutWage: number | null;
      miscWage: number | null;
      otherWage: number | null;
      ptoWage: number | null;
      incentiveWage: number | null;
    }>;
    historicalIncomeInformation: {
      count: number;
      items: Array<{
        id: string;
        baseWage: number | null;
        paymentDate: string | null;
        paymentPeriodEnd: string | null;
        grossHours: number | null;
        overtimeHours: number | null;
        overtimeWage: number | null;
        commissionWage: number | null;
        vacationWage: number | null;
        sickWage: number | null;
        bonusesWage: number | null;
        holidayWage: number | null;
        pension: number | null;
        shiftDifferential: number | null;
        severance: number | null;
        tips: number | null;
        stock: number | null;
        mostRecentHireDate: string | null;
        originalHireDate: string | null;
        grossWage: number | null;
        miscWage: number | null;
        otherWage: number | null;
        ptoWage: number | null;
        incentiveWage: number | null;
        ptoPayoutWage: number | null;
        sickTimePayoutWage: number | null;
        vacationTimePayoutWage: number | null;
        rateOfPay: string | null;
      }>;
    };
    benefitsInformation: {
      count: number;
      items: Array<{
        id: string;
        eligibleForDental: boolean | null;
        enrolledInDental: boolean | null;
        dentalInsuranceCarrier: string | null;
        eligibleForMedical: boolean | null;
        enrolledInMedical: boolean | null;
        medicalInsuranceCarrier: string | null;
      }>;
    };
  } | null;
};

export type GetEmploymentDataOnEmployeeSignupByInviteQueryVariables = Exact<{
  inviteId: string | number;
  companyId: string | number;
}>;

export type GetEmploymentDataOnEmployeeSignupByInviteQuery = {
  getEmploymentDataOnEmployeeSignupByInvite: {
    employeeInformation: {
      averageBaseWage: string | null;
      averageHoursPerPayPeriod: string | null;
      employmentStatus: Types.PositionEmploymentStatus;
      employmentType: string | null;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      mostRecentEmployment: string | null;
      originalHireDate: string | null;
      rateOfPay: string | null;
      payFrequency: string | null;
      ssn: string;
      totalTimeWithEmployer: string | null;
      employeeId: string | null;
    };
    headquartersAddress: {
      city: string | null;
      state: string | null;
      street: string | null;
      zipCode: string | null;
    } | null;
    positionInformation: {
      division: string | null;
      registeredBusinessName: string | null;
      statusPosition: Types.EmploymentDataPositionInformationStatus;
      title: string | null;
    };
    meta: {
      companyId: string;
      locationId: string | null;
      employerId: string;
      headquartersId: string | null;
      consumerId: string | null;
      positionId: string;
      userId: string | null;
      userStatus: Types.UserStatus | null;
      userEmail: string | null;
      updatedAt: string;
    };
    companyInformation: {
      avatarUrl: string | null;
      locationAddress: string;
      fein: string | null;
      registeredBusinessName: string | null;
      locationName: string | null;
      extLocationId: string | null;
      displayName: string | null;
    };
    summaryIncomeInformation: Array<{
      year: number;
      baseWage: number | null;
      overtimeWage: number | null;
      bonusesWage: number | null;
      commissionWage: number | null;
      holidayWage: number | null;
      pension: number | null;
      severance: number | null;
      sickWage: number | null;
      tips: number | null;
      totalWage: number | null;
      vacationWage: number | null;
      ptoPayoutWage: number | null;
      sickTimePayoutWage: number | null;
      vacationTimePayoutWage: number | null;
      miscWage: number | null;
      otherWage: number | null;
      ptoWage: number | null;
      incentiveWage: number | null;
    }>;
    historicalIncomeInformation: {
      count: number;
      items: Array<{
        id: string;
        baseWage: number | null;
        paymentDate: string | null;
        paymentPeriodEnd: string | null;
        grossHours: number | null;
        overtimeHours: number | null;
        overtimeWage: number | null;
        commissionWage: number | null;
        vacationWage: number | null;
        sickWage: number | null;
        bonusesWage: number | null;
        holidayWage: number | null;
        pension: number | null;
        shiftDifferential: number | null;
        severance: number | null;
        tips: number | null;
        stock: number | null;
        mostRecentHireDate: string | null;
        originalHireDate: string | null;
        grossWage: number | null;
        miscWage: number | null;
        otherWage: number | null;
        ptoWage: number | null;
        incentiveWage: number | null;
        ptoPayoutWage: number | null;
        sickTimePayoutWage: number | null;
        vacationTimePayoutWage: number | null;
        rateOfPay: string | null;
      }>;
    };
    benefitsInformation: {
      count: number;
      items: Array<{
        id: string;
        eligibleForDental: boolean | null;
        enrolledInDental: boolean | null;
        dentalInsuranceCarrier: string | null;
        eligibleForMedical: boolean | null;
        enrolledInMedical: boolean | null;
        medicalInsuranceCarrier: string | null;
      }>;
    };
  } | null;
};

export type GetEmploymentDataForEmployeeMyDataQueryVariables = Exact<{
  companyId: string | number;
}>;

export type GetEmploymentDataForEmployeeMyDataQuery = {
  getEmploymentDataForEmployeeMyData: {
    employeeInformation: {
      averageBaseWage: string | null;
      averageHoursPerPayPeriod: string | null;
      employmentStatus: Types.PositionEmploymentStatus;
      employmentType: string | null;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      mostRecentEmployment: string | null;
      originalHireDate: string | null;
      rateOfPay: string | null;
      payFrequency: string | null;
      ssn: string;
      totalTimeWithEmployer: string | null;
      employeeId: string | null;
    };
    headquartersAddress: {
      city: string | null;
      state: string | null;
      street: string | null;
      zipCode: string | null;
    } | null;
    positionInformation: {
      division: string | null;
      registeredBusinessName: string | null;
      statusPosition: Types.EmploymentDataPositionInformationStatus;
      title: string | null;
    };
    meta: {
      companyId: string;
      locationId: string | null;
      employerId: string;
      headquartersId: string | null;
      consumerId: string | null;
      positionId: string;
      userId: string | null;
      userStatus: Types.UserStatus | null;
      userEmail: string | null;
      updatedAt: string;
    };
    companyInformation: {
      avatarUrl: string | null;
      locationAddress: string;
      fein: string | null;
      registeredBusinessName: string | null;
      locationName: string | null;
      extLocationId: string | null;
      displayName: string | null;
    };
    summaryIncomeInformation: Array<{
      year: number;
      baseWage: number | null;
      overtimeWage: number | null;
      bonusesWage: number | null;
      commissionWage: number | null;
      holidayWage: number | null;
      pension: number | null;
      severance: number | null;
      sickWage: number | null;
      tips: number | null;
      totalWage: number | null;
      vacationWage: number | null;
      ptoPayoutWage: number | null;
      sickTimePayoutWage: number | null;
      vacationTimePayoutWage: number | null;
      miscWage: number | null;
      otherWage: number | null;
      ptoWage: number | null;
      incentiveWage: number | null;
    }>;
    historicalIncomeInformation: {
      count: number;
      items: Array<{
        id: string;
        baseWage: number | null;
        paymentDate: string | null;
        paymentPeriodEnd: string | null;
        grossHours: number | null;
        overtimeHours: number | null;
        overtimeWage: number | null;
        commissionWage: number | null;
        vacationWage: number | null;
        sickWage: number | null;
        bonusesWage: number | null;
        holidayWage: number | null;
        pension: number | null;
        shiftDifferential: number | null;
        severance: number | null;
        tips: number | null;
        stock: number | null;
        mostRecentHireDate: string | null;
        originalHireDate: string | null;
        grossWage: number | null;
        miscWage: number | null;
        otherWage: number | null;
        ptoWage: number | null;
        incentiveWage: number | null;
        ptoPayoutWage: number | null;
        sickTimePayoutWage: number | null;
        vacationTimePayoutWage: number | null;
        rateOfPay: string | null;
      }>;
    };
    benefitsInformation: {
      count: number;
      items: Array<{
        id: string;
        eligibleForDental: boolean | null;
        enrolledInDental: boolean | null;
        dentalInsuranceCarrier: string | null;
        eligibleForMedical: boolean | null;
        enrolledInMedical: boolean | null;
        medicalInsuranceCarrier: string | null;
      }>;
    };
  } | null;
};

export type GetEmploymentDataForSearchedEmployeeQueryVariables = Exact<{
  employeeSsnEncrypted: string;
  companyId: string | number;
}>;

export type GetEmploymentDataForSearchedEmployeeQuery = {
  getEmploymentDataForSearchedEmployee: {
    employeeInformation: {
      averageBaseWage: string | null;
      averageHoursPerPayPeriod: string | null;
      employmentStatus: Types.PositionEmploymentStatus;
      employmentType: string | null;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      mostRecentEmployment: string | null;
      originalHireDate: string | null;
      rateOfPay: string | null;
      payFrequency: string | null;
      ssn: string;
      totalTimeWithEmployer: string | null;
      employeeId: string | null;
    };
    headquartersAddress: {
      city: string | null;
      state: string | null;
      street: string | null;
      zipCode: string | null;
    } | null;
    positionInformation: {
      division: string | null;
      registeredBusinessName: string | null;
      statusPosition: Types.EmploymentDataPositionInformationStatus;
      title: string | null;
    };
    meta: {
      companyId: string;
      locationId: string | null;
      employerId: string;
      headquartersId: string | null;
      consumerId: string | null;
      positionId: string;
      userId: string | null;
      userStatus: Types.UserStatus | null;
      userEmail: string | null;
      updatedAt: string;
    };
    companyInformation: {
      avatarUrl: string | null;
      locationAddress: string;
      fein: string | null;
      registeredBusinessName: string | null;
      locationName: string | null;
      extLocationId: string | null;
      displayName: string | null;
    };
    summaryIncomeInformation: Array<{
      year: number;
      baseWage: number | null;
      overtimeWage: number | null;
      bonusesWage: number | null;
      commissionWage: number | null;
      holidayWage: number | null;
      pension: number | null;
      severance: number | null;
      sickWage: number | null;
      tips: number | null;
      totalWage: number | null;
      vacationWage: number | null;
      ptoPayoutWage: number | null;
      sickTimePayoutWage: number | null;
      vacationTimePayoutWage: number | null;
      miscWage: number | null;
      otherWage: number | null;
      ptoWage: number | null;
      incentiveWage: number | null;
    }>;
    historicalIncomeInformation: {
      count: number;
      items: Array<{
        id: string;
        baseWage: number | null;
        paymentDate: string | null;
        paymentPeriodEnd: string | null;
        grossHours: number | null;
        overtimeHours: number | null;
        overtimeWage: number | null;
        commissionWage: number | null;
        vacationWage: number | null;
        sickWage: number | null;
        bonusesWage: number | null;
        holidayWage: number | null;
        pension: number | null;
        shiftDifferential: number | null;
        severance: number | null;
        tips: number | null;
        stock: number | null;
        mostRecentHireDate: string | null;
        originalHireDate: string | null;
        grossWage: number | null;
        miscWage: number | null;
        otherWage: number | null;
        ptoWage: number | null;
        incentiveWage: number | null;
        ptoPayoutWage: number | null;
        sickTimePayoutWage: number | null;
        vacationTimePayoutWage: number | null;
        rateOfPay: string | null;
      }>;
    };
    benefitsInformation: {
      count: number;
      items: Array<{
        id: string;
        eligibleForDental: boolean | null;
        enrolledInDental: boolean | null;
        dentalInsuranceCarrier: string | null;
        eligibleForMedical: boolean | null;
        enrolledInMedical: boolean | null;
        medicalInsuranceCarrier: string | null;
      }>;
    };
  } | null;
};

export type FileInfoFragment = {
  id: string;
  key: string;
  filename: string;
  downloadUrl: string | null;
  updatedAt: string;
  createdAt: string;
  mime: string;
  size: number;
};

export type FileResponseInfoFragment = {
  id: string;
  key: string;
  filename: string;
  downloadUrl: string | null;
  updatedAt: string;
  createdAt: string;
  mime: string;
  size: number;
};

export type FileMetaResponseInfoFragment = {
  id: string;
  updatedAt: string;
  createdAt: string;
  filename: string;
  size: number;
  mime: string;
};

export type UploadFileMutationVariables = Exact<{
  file: globalThis.File;
  public: boolean;
}>;

export type UploadFileMutation = {
  uploadFile: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  };
};

export type GeneratedReportMetaInfoFragment = {
  id: string;
  createdAt: string;
  employerId: string | null;
  employerDisplayName: string | null;
  feinValue: string | null;
  file: {
    id: string;
    updatedAt: string;
    createdAt: string;
    filename: string;
    size: number;
    mime: string;
  };
};

export type GeneratedReportsMetaQueryVariables = Exact<{
  inboxItemId: string | number;
}>;

export type GeneratedReportsMetaQuery = {
  getGeneratedReportsMeta: Array<{
    id: string;
    createdAt: string;
    employerId: string | null;
    employerDisplayName: string | null;
    feinValue: string | null;
    file: {
      id: string;
      updatedAt: string;
      createdAt: string;
      filename: string;
      size: number;
      mime: string;
    };
  }>;
};

export type DownloadGeneratedReportFilesMutationVariables = Exact<{
  inboxItemId: string | number;
  fileIdList: Array<string | number> | string | number;
  action: Types.PiiDataAccessActionType;
}>;

export type DownloadGeneratedReportFilesMutation = {
  downloadGeneratedReportFiles: Array<{
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  }>;
};

export type DownloadGeneratedReportFilesArchiveMutationVariables = Exact<{
  inboxItemId: string | number;
  fileIdList: Array<string | number> | string | number;
}>;

export type DownloadGeneratedReportFilesArchiveMutation = {
  downloadGeneratedReportFilesArchive: { downloadUrl: string; filename: string } | null;
};

export type SendGetHelpToClearVerifyStaffMutationVariables = Exact<{
  data: Types.GetHelpToClearVerifyStaffData;
}>;

export type SendGetHelpToClearVerifyStaffMutation = {
  sendGetHelpToClearVerifyStaff: { success: boolean };
};

export type InboxItemInfoFragment = { id: string; type: Types.InboxItemType };

export type InboxListItemInfoFragment = {
  id: string;
  type: Types.InboxItemType;
  createdAt: string;
  updatedAt: string;
  isUnread: boolean;
  lastActivityDate: string | null;
  lastActivityHeading: string | null;
  subEntityType: string | null;
  subEntityStatus: string | null;
  employeeFullName: string | null;
  employeeAvatarUrl: string | null;
  verifierCompanyName: string | null;
  verifierLogoUrl: string | null;
  contributorCompanyName: string | null;
  contributorLogoUrl: string | null;
  permissiblePurposeId: string | null;
  stripePaymentStatus: Types.VerificationRequestStripePaymentStatus | null;
};

export type InboxItemRequestItemFragment = {
  id: string;
  type: Types.InboxItemType;
  createdAt: string;
  companyName: string | null;
  contactName: string | null;
  contactEmail: string | null;
  verificationRequestType: Types.VerificationRequestType | null;
  verificationRequestStatus: Types.VerificationRequestStatus | null;
  dataDisputeStatus: Types.DataDisputeItemStatus | null;
};

export type InboxItemsScrollableListQueryVariables = Exact<{
  where?: Types.InboxItemsListWhere | null | undefined;
  skip?: number | null | undefined;
  take?: number | null | undefined;
  cursorId?: string | number | null | undefined;
}>;

export type InboxItemsScrollableListQuery = {
  getInboxListItemsCount: number;
  getInboxItemsList: Array<{
    id: string;
    type: Types.InboxItemType;
    createdAt: string;
    updatedAt: string;
    isUnread: boolean;
    lastActivityDate: string | null;
    lastActivityHeading: string | null;
    subEntityType: string | null;
    subEntityStatus: string | null;
    employeeFullName: string | null;
    employeeAvatarUrl: string | null;
    verifierCompanyName: string | null;
    verifierLogoUrl: string | null;
    contributorCompanyName: string | null;
    contributorLogoUrl: string | null;
    permissiblePurposeId: string | null;
    stripePaymentStatus: Types.VerificationRequestStripePaymentStatus | null;
  }>;
};

export type InboxItemQueryVariables = Exact<{
  id: string | number;
}>;

export type InboxItemQuery = { inboxItem: { id: string; type: Types.InboxItemType } | null };

export type InboxItemsRequestsListQueryVariables = Exact<{
  searchValue?: string | null | undefined;
  orderBy?: Array<Types.InboxItemOrderBy> | Types.InboxItemOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type InboxItemsRequestsListQuery = {
  getInboxItemsRequests: {
    count: number;
    items: Array<{
      id: string;
      type: Types.InboxItemType;
      createdAt: string;
      companyName: string | null;
      contactName: string | null;
      contactEmail: string | null;
      verificationRequestType: Types.VerificationRequestType | null;
      verificationRequestStatus: Types.VerificationRequestStatus | null;
      dataDisputeStatus: Types.DataDisputeItemStatus | null;
    }>;
  };
};

export type InboxItemUnreadStatusesUpdateMutationVariables = Exact<{
  input: Types.UpdateInboxItemUnreadStatusesInput;
}>;

export type InboxItemUnreadStatusesUpdateMutation = {
  updateInboxItemUnreadStatuses: { success: boolean };
};

export type UpdateInboxItemUnreadStatusMutationVariables = Exact<{
  inboxItemId: string | number;
}>;

export type UpdateInboxItemUnreadStatusMutation = {
  updateInboxItemUnreadStatus: { success: boolean };
};

export type LeaveCommentForInboxItemMutationVariables = Exact<{
  inboxItemId: string | number;
  comment: string;
  file?: globalThis.File | null | undefined;
  visibleFor?: Array<Types.ActivityLogVisibleFor> | Types.ActivityLogVisibleFor | null | undefined;
}>;

export type LeaveCommentForInboxItemMutation = { leaveCommentForInboxItem: { success: boolean } };

export type IntegrationInfoFragment = {
  id: string;
  name: string;
  scope: Array<Types.IntegrationScope>;
  status: Types.ActiveInactive;
  clientId: string;
  createdAt: string;
  updatedAt: string;
  ipLimitAttempts: number;
  ipLimitWindow: number;
  credentialsLimitAttempts: number;
  credentialsLimitWindow: number;
  verifierLimitAttempts: number;
  verifierLimitWindow: number;
  verifier: { id: string; displayName: string | null } | null;
};

export type IntegrationsListQueryVariables = Exact<{
  filter?: Types.IntegrationWhere | null | undefined;
  orderBy?: Array<Types.IntegrationOrderBy> | Types.IntegrationOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type IntegrationsListQuery = {
  integrationCount: number;
  integrationList: Array<{
    id: string;
    name: string;
    scope: Array<Types.IntegrationScope>;
    status: Types.ActiveInactive;
    clientId: string;
    createdAt: string;
    updatedAt: string;
    ipLimitAttempts: number;
    ipLimitWindow: number;
    credentialsLimitAttempts: number;
    credentialsLimitWindow: number;
    verifierLimitAttempts: number;
    verifierLimitWindow: number;
    verifier: { id: string; displayName: string | null } | null;
  }>;
};

export type IntegrationCreateMutationVariables = Exact<{
  name: string;
  scope: Array<Types.IntegrationScope> | Types.IntegrationScope;
  ipLimitAttempts: number;
  ipLimitWindow: number;
  credentialsLimitAttempts: number;
  credentialsLimitWindow: number;
  verifierLimitAttempts: number;
  verifierLimitWindow: number;
  verifierId?: string | number | null | undefined;
}>;

export type IntegrationCreateMutation = {
  integrationCreateCustom: { clientId: string; clientSecret: string };
};

export type IntegrationUpdateMutationVariables = Exact<{
  id: string | number;
  name: string;
  scope: Array<Types.IntegrationScope> | Types.IntegrationScope;
  status: Types.ActiveInactive;
  ipLimitAttempts: number;
  ipLimitWindow: number;
  credentialsLimitAttempts: number;
  credentialsLimitWindow: number;
  verifierLimitAttempts: number;
  verifierLimitWindow: number;
}>;

export type IntegrationUpdateMutation = {
  integrationUpdateCustom: {
    id: string;
    name: string;
    scope: Array<Types.IntegrationScope>;
    status: Types.ActiveInactive;
    clientId: string;
    createdAt: string;
    updatedAt: string;
    ipLimitAttempts: number;
    ipLimitWindow: number;
    credentialsLimitAttempts: number;
    credentialsLimitWindow: number;
    verifierLimitAttempts: number;
    verifierLimitWindow: number;
    verifier: { id: string; displayName: string | null } | null;
  };
};

export type IntegrationRegenerateCredentialsMutationVariables = Exact<{
  id: string | number;
}>;

export type IntegrationRegenerateCredentialsMutation = {
  integrationRegenerateCredentials: { clientId: string; clientSecret: string };
};

export type IntegrationUsageLogInfoFragment = {
  id: string;
  createdAt: string;
  finishedAt: string | null;
  duration: number | null;
  endpoint: string;
  requestId: string;
  requesterId: string | null;
  status: Types.IntegrationUsageLogStatus;
  statusCode: number | null;
  last4Ssn: string | null;
  dateOfBirth: string | null;
  errorMessage: string | null;
  verified: number;
  ambiguous: number;
  noMatch: number;
};

export type IntegrationUsageLogsListQueryVariables = Exact<{
  filter?: Types.IntegrationUsageLogWhere | null | undefined;
  orderBy?:
    | Array<Types.IntegrationUsageLogOrderBy>
    | Types.IntegrationUsageLogOrderBy
    | null
    | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type IntegrationUsageLogsListQuery = {
  integrationUsageLogCount: number;
  integrationUsageLogList: Array<{
    id: string;
    createdAt: string;
    finishedAt: string | null;
    duration: number | null;
    endpoint: string;
    requestId: string;
    requesterId: string | null;
    status: Types.IntegrationUsageLogStatus;
    statusCode: number | null;
    last4Ssn: string | null;
    dateOfBirth: string | null;
    errorMessage: string | null;
    verified: number;
    ambiguous: number;
    noMatch: number;
  }>;
};

export type IntegrationUsageLogStatsQueryVariables = Exact<{
  filter?: Types.IntegrationUsageLogWhere | null | undefined;
}>;

export type IntegrationUsageLogStatsQuery = {
  getIntegrationUsageLogStats: { total: number; matched: number; noMatch: number; failed: number };
};

export type IntegrationDetailQueryVariables = Exact<{
  id: string | number;
}>;

export type IntegrationDetailQuery = {
  integration: {
    id: string;
    name: string;
    scope: Array<Types.IntegrationScope>;
    status: Types.ActiveInactive;
    clientId: string;
    createdAt: string;
    updatedAt: string;
    ipLimitAttempts: number;
    ipLimitWindow: number;
    credentialsLimitAttempts: number;
    credentialsLimitWindow: number;
    verifierLimitAttempts: number;
    verifierLimitWindow: number;
    verifier: { id: string; displayName: string | null } | null;
  } | null;
};

export type ExportIntegrationUsageLogsQueryVariables = Exact<{
  input: Types.ExportIntegrationUsageLogInput;
}>;

export type ExportIntegrationUsageLogsQuery = { exportIntegrationUsageLogs: string };

export type InviteQueryVariables = Exact<{
  id: string | number;
}>;

export type InviteQuery = {
  getInvite: {
    id: string;
    email: string;
    role: Types.UserRole | null;
    isAdditionalStaff: boolean;
    isEmployerUnderPeo: boolean;
    isPeoUnderPeoPayrollProvider: boolean;
    predefinedSignUpMethod: Types.SignUpMethod | null;
    isBulkUploaded: boolean;
    from: Types.InviteFrom | null;
  };
};

export type SendInvitesToEmployersAdminsByCvAdminMutationVariables = Exact<{
  employers:
    | Array<Types.InvitedEmployerAdminByCvAdminData>
    | Types.InvitedEmployerAdminByCvAdminData;
  peoId?: string | number | null | undefined;
  peoPayrollProviderId?: string | number | null | undefined;
}>;

export type SendInvitesToEmployersAdminsByCvAdminMutation = {
  sendInvitesToEmployersAdminsByCVAdmin: { success: boolean };
};

export type SendInvitesToVerifiersAdminsByCvAdminMutationVariables = Exact<{
  verifierAdmin: Types.InvitedVerifierAdminByCvAdminData;
}>;

export type SendInvitesToVerifiersAdminsByCvAdminMutation = {
  sendInvitesToVerifiersAdminsByCVAdmin: { success: boolean };
};

export type SendInvitesToPeoStaffByPeoAdminMutationVariables = Exact<{
  staff: Array<Types.InvitedPeoStaffData> | Types.InvitedPeoStaffData;
}>;

export type SendInvitesToPeoStaffByPeoAdminMutation = {
  sendInvitesToPeoStaffByPeoAdmin: { success: boolean };
};

export type SendInvitesToVerifiersStaffMutationVariables = Exact<{
  verifierId?: string | number | null | undefined;
  verifierStaff: Array<Types.InvitedVerifierStaffData> | Types.InvitedVerifierStaffData;
}>;

export type SendInvitesToVerifiersStaffMutation = {
  sendInvitesToVerifiersStaff: { success: boolean };
};

export type SendInvitesToClearVerifyStaffMutationVariables = Exact<{
  managers: Array<Types.PlatformStaffInviteItem> | Types.PlatformStaffInviteItem;
}>;

export type SendInvitesToClearVerifyStaffMutation = {
  sendInvitesToClearVerifyStaff: { success: boolean };
};

export type UserRegistrationByInviteMutationVariables = Exact<{
  inviteId: string | number;
  user: Types.InvitedSignedUserData;
  verifier?: Types.InvitedSignedVerifierData | null | undefined;
  employer?: Types.InvitedSignedEmployerData | null | undefined;
  peo?: Types.InvitedSignedPeoData | null | undefined;
  consumer?: Types.InvitedSignedConsumerData | null | undefined;
  peoPayrollProvider?: Types.InvitedSignedPeoPayrollProviderData | null | undefined;
}>;

export type UserRegistrationByInviteMutation = {
  userRegistrationByInvite: { idToken: string | null; accessToken: string | null };
};

export type SendInvitesToVerifiersAdminsByVerifierAdminMutationVariables = Exact<{
  verifiersAdmins:
    | Array<Types.InvitedVerifierAdminByVerifierAdminData>
    | Types.InvitedVerifierAdminByVerifierAdminData;
}>;

export type SendInvitesToVerifiersAdminsByVerifierAdminMutation = {
  sendInvitesToVerifiersAdminsByVerifierAdmin: { success: boolean };
};

export type SendInvitesToConsumersByEmployerMutationVariables = Exact<{
  employeeIds: Array<string | number> | string | number;
  inviteEmail?: string | null | undefined;
}>;

export type SendInvitesToConsumersByEmployerMutation = {
  sendInvitesToConsumersByEmployer: { success: boolean };
};

export type SendInvitesToConsumersByPeoMutationVariables = Exact<{
  employeeIds: Array<string | number> | string | number;
  inviteEmail?: string | null | undefined;
}>;

export type SendInvitesToConsumersByPeoMutation = {
  sendInvitesToConsumersByPeo: { success: boolean };
};

export type CreateEmployeeInviteLinkByCvStaffMutationVariables = Exact<{
  employeeId: string | number;
}>;

export type CreateEmployeeInviteLinkByCvStaffMutation = {
  createEmployeeInviteLinkByCVStaff: { success: boolean; inviteLinkUrl: string | null };
};

export type SendInvitesToConsumersByCvStaffMutationVariables = Exact<{
  employeeIds: Array<string | number> | string | number;
  inviteScopeEntityId?: string | number | null | undefined;
  inviteScopeParamKey?: string | null | undefined;
  inviteEmail?: string | null | undefined;
}>;

export type SendInvitesToConsumersByCvStaffMutation = {
  sendInvitesToConsumersByCVStaff: { success: boolean };
};

export type SendInvitesToPeoByCvStaffMutationVariables = Exact<{
  peos: Array<Types.InvitedByCvStaffPeoData> | Types.InvitedByCvStaffPeoData;
  peoPayrollProviderId?: string | number | null | undefined;
}>;

export type SendInvitesToPeoByCvStaffMutation = { sendInvitesToPeoByCVStaff: { success: boolean } };

export type SendInvitesToPeoPayrollProviderByCvStaffMutationVariables = Exact<{
  peoPayrollProviders:
    | Array<Types.InvitedByCvStaffPeoPayrollProviderData>
    | Types.InvitedByCvStaffPeoPayrollProviderData;
}>;

export type SendInvitesToPeoPayrollProviderByCvStaffMutation = {
  sendInvitesToPeoPayrollProviderByCVStaff: { success: boolean };
};

export type SendInvitesToPeoStaffByCvStaffMutationVariables = Exact<{
  peoId: string;
  staff: Array<Types.InvitedPeoStaffData> | Types.InvitedPeoStaffData;
}>;

export type SendInvitesToPeoStaffByCvStaffMutation = {
  sendInvitesToPeoStaffByCVStaff: { success: boolean };
};

export type SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationVariables = Exact<{
  peoId: string;
  staff: Array<Types.InvitedPeoStaffData> | Types.InvitedPeoStaffData;
}>;

export type SendInvitesToPeoStaffByPeoPayrollProviderStaffMutation = {
  sendInvitesToPeoStaffByPeoPayrollProviderStaff: { success: boolean };
};

export type SendInvitesToEmployersUnderPeoMutationVariables = Exact<{
  input: Types.SendInvitesToEmployersUnderPeoInput;
}>;

export type SendInvitesToEmployersUnderPeoMutation = {
  sendInvitesToEmployersUnderPeo: { success: boolean };
};

export type SendInvitesToPeoByPeoPpMutationVariables = Exact<{
  input: Types.SendInvitesToPeoByPeoPpInput;
}>;

export type SendInvitesToPeoByPeoPpMutation = { sendInvitesToPeoByPeoPp: { success: boolean } };

export type SendInvitesToEmployersByPeoPpMutationVariables = Exact<{
  input: Types.SendInvitesToEmployersByPeoPpInput;
}>;

export type SendInvitesToEmployersByPeoPpMutation = {
  sendInvitesToEmployersByPeoPp: { success: boolean };
};

export type SendInvitesToConsumersByPeoPayrollProviderMutationVariables = Exact<{
  employeeIds: Array<string | number> | string | number;
  inviteEmail?: string | null | undefined;
}>;

export type SendInvitesToConsumersByPeoPayrollProviderMutation = {
  sendInvitesToConsumersByPeoPayrollProvider: { success: boolean };
};

export type ResendInviteToEmployerStaffMutationVariables = Exact<{
  employerStaffId: string | number;
}>;

export type ResendInviteToEmployerStaffMutation = {
  resendInviteToEmployerStaff: { success: boolean; inviteLinkUrl: string | null };
};

export type ResendInviteToPeoStaffMutationVariables = Exact<{
  peoStaffId: string | number;
}>;

export type ResendInviteToPeoStaffMutation = {
  resendInviteToPeoStaff: { success: boolean; inviteLinkUrl: string | null };
};

export type ResendInviteToPlatformStaffMutationVariables = Exact<{
  platformStaffId: string | number;
}>;

export type ResendInviteToPlatformStaffMutation = {
  resendInviteToPlatformStaff: { success: boolean; inviteLinkUrl: string | null };
};

export type ResendInviteToVerifierStaffMutationVariables = Exact<{
  verifierStaffId: string | number;
}>;

export type ResendInviteToVerifierStaffMutation = {
  resendInviteToVerifierStaff: { success: boolean; inviteLinkUrl: string | null };
};

export type GetMaintenanceStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetMaintenanceStatusQuery = { getMaintenanceStatus: { isMaintenanceEnabled: boolean } };

export type MiddeskCreateBusinessForVerifierMutationVariables = Exact<{
  verifierId: string | number;
  businessFields: Types.BusinessFields;
}>;

export type MiddeskCreateBusinessForVerifierMutation = {
  middeskCreateBusinessForVerifier: { middeskBusinessId: string | null };
};

export type GetMiddeskStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetMiddeskStatusQuery = { getMiddeskStatus: { isMiddeskEnabled: boolean } };

export type PartnershipInfoFragment = {
  id: string;
  createdAt: string;
  companyType: Types.CompanyType;
  displayName: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  employerCount: number;
  status: Types.UserStatus;
};

export type GetPartnershipsQueryVariables = Exact<{
  where?: Types.GetPartnershipsWhere | null | undefined;
  take?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type GetPartnershipsQuery = {
  getPartnerships: {
    count: number;
    items: Array<{
      id: string;
      createdAt: string;
      companyType: Types.CompanyType;
      displayName: string | null;
      contactEmail: string | null;
      contactPhoneNumber: string | null;
      employerCount: number;
      status: Types.UserStatus;
    }>;
  };
};

export type SendInviteToPartnershipMutationVariables = Exact<{
  companyType: Types.CompanyType;
  staffEmail: string;
}>;

export type SendInviteToPartnershipMutation = { sendInviteToPartnership: { success: boolean } };

export type GenerateWorkLetterMutationVariables = Exact<{
  company: Types.VerificationRequestCompanyData;
  letterType: Types.EmployeeWorkLetterType;
}>;

export type GenerateWorkLetterMutation = {
  generateWorkLetterPdf: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type GenerateWorkLetterForAdminMutationVariables = Exact<{
  employeeSsnEncrypted: string;
  company: Types.VerificationRequestCompanyData;
  letterType: Types.EmployeeWorkLetterType;
}>;

export type GenerateWorkLetterForAdminMutation = {
  generateWorkLetterPdfForAdmin: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type GenerateMyDataPdfMutationVariables = Exact<{ [key: string]: never }>;

export type GenerateMyDataPdfMutation = {
  generateMyDataPdf: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  };
};

export type PeoInfoFragment = {
  id: string;
  createdAt: string;
  displayName: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  fein: string | null;
  numberOfEmployees: number | null;
  corporateStructure: string | null;
  taxYearEndDate: string | null;
  defaultRequestAutoAccept: Types.ActiveInactive | null;
  defaultDisclaimer: string | null;
  stripeAccountId: string | null;
  employersLiveByDefaultSetAt: string | null;
  industry: string | null;
  disclaimer: string | null;
  companyType: Types.PeoCompanyType;
  keepOwnRevenueShare: boolean;
  requestAutoAccept: boolean;
  signUpMethod: Types.SignUpMethod;
  pinLength: Types.PinLength | null;
  firstPinDigits: Types.PinDigit | null;
  lastPinDigits: Types.PinDigit | null;
  pinHint: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
  headquarters: {
    id: string;
    state: string | null;
    county: string | null;
    street: string | null;
    city: string | null;
    apartment: string | null;
    zipCode: string | null;
  } | null;
  revenueShareSetting: {
    id: string;
    revenueShareType: Types.RevenueShareType;
    revenueShareFlat: number | null;
    revenueSharePercents: number | null;
  } | null;
  peoStaffsList: Array<{
    id: string;
    role: Types.PeoStaffRole;
    user: { id: string; status: Types.UserStatus };
  }>;
  peoPayrollProvider: {
    id: string;
    displayName: string | null;
    companyType: Types.PeoPayrollProviderCompanyType;
  } | null;
};

export type PeoSimpleInfoFragment = { id: string; displayName: string | null };

export type PeoRevenueShareInfoFragment = {
  id: string;
  revenueShareReportEnabled: boolean;
  revenueShareSetting: {
    id: string;
    revenueShareType: Types.RevenueShareType;
    revenueShareFlat: number | null;
    revenueSharePercents: number | null;
  } | null;
};

export type PeoBasicInfoFragment = {
  id: string;
  displayName: string | null;
  signUpMethod: Types.SignUpMethod;
  pinHint: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type PeoQueryVariables = Exact<{
  id: string | number;
}>;

export type PeoQuery = {
  peo: {
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    fein: string | null;
    numberOfEmployees: number | null;
    corporateStructure: string | null;
    taxYearEndDate: string | null;
    defaultRequestAutoAccept: Types.ActiveInactive | null;
    defaultDisclaimer: string | null;
    stripeAccountId: string | null;
    employersLiveByDefaultSetAt: string | null;
    industry: string | null;
    disclaimer: string | null;
    companyType: Types.PeoCompanyType;
    keepOwnRevenueShare: boolean;
    requestAutoAccept: boolean;
    signUpMethod: Types.SignUpMethod;
    pinLength: Types.PinLength | null;
    firstPinDigits: Types.PinDigit | null;
    lastPinDigits: Types.PinDigit | null;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    peoStaffsList: Array<{
      id: string;
      role: Types.PeoStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoPayrollProviderCompanyType;
    } | null;
  } | null;
};

export type PeosListQueryVariables = Exact<{
  filter?: Types.PeoWhere | null | undefined;
  orderBy?: Array<Types.PeoOrderBy> | Types.PeoOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeosListQuery = {
  peoCount: number;
  peoList: Array<{
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    fein: string | null;
    numberOfEmployees: number | null;
    corporateStructure: string | null;
    taxYearEndDate: string | null;
    defaultRequestAutoAccept: Types.ActiveInactive | null;
    defaultDisclaimer: string | null;
    stripeAccountId: string | null;
    employersLiveByDefaultSetAt: string | null;
    industry: string | null;
    disclaimer: string | null;
    companyType: Types.PeoCompanyType;
    keepOwnRevenueShare: boolean;
    requestAutoAccept: boolean;
    signUpMethod: Types.SignUpMethod;
    pinLength: Types.PinLength | null;
    firstPinDigits: Types.PinDigit | null;
    lastPinDigits: Types.PinDigit | null;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    peoStaffsList: Array<{
      id: string;
      role: Types.PeoStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoPayrollProviderCompanyType;
    } | null;
  }>;
};

export type PeosSimpleListQueryVariables = Exact<{
  filter?: Types.PeoWhere | null | undefined;
  orderBy?: Array<Types.PeoOrderBy> | Types.PeoOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeosSimpleListQuery = {
  peoCount: number;
  peoList: Array<{ id: string; displayName: string | null }>;
};

export type PeoUpdateMutationVariables = Exact<{
  data: Types.PeoUpdate;
  where: Types.PeoWhereUnique;
}>;

export type PeoUpdateMutation = {
  peoUpdate: {
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    fein: string | null;
    numberOfEmployees: number | null;
    corporateStructure: string | null;
    taxYearEndDate: string | null;
    defaultRequestAutoAccept: Types.ActiveInactive | null;
    defaultDisclaimer: string | null;
    stripeAccountId: string | null;
    employersLiveByDefaultSetAt: string | null;
    industry: string | null;
    disclaimer: string | null;
    companyType: Types.PeoCompanyType;
    keepOwnRevenueShare: boolean;
    requestAutoAccept: boolean;
    signUpMethod: Types.SignUpMethod;
    pinLength: Types.PinLength | null;
    firstPinDigits: Types.PinDigit | null;
    lastPinDigits: Types.PinDigit | null;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    peoStaffsList: Array<{
      id: string;
      role: Types.PeoStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      companyType: Types.PeoPayrollProviderCompanyType;
    } | null;
  };
};

export type PeoUpdateWithEmployersMutationVariables = Exact<{
  id: string | number;
  data?: Types.PeoUpdate | null | undefined;
  employersUpdateManyData?:
    | Array<Types.EmployerUpdateMany>
    | Types.EmployerUpdateMany
    | null
    | undefined;
  employersUpdateManyWhere?: Array<Types.EmployerWhere> | Types.EmployerWhere | null | undefined;
}>;

export type PeoUpdateWithEmployersMutation = { updatePeoWithEmployers: { success: boolean } };

export type PeoRevenueShareQueryVariables = Exact<{
  where: Types.PeoWhereUnique;
}>;

export type PeoRevenueShareQuery = {
  peo: {
    id: string;
    revenueShareReportEnabled: boolean;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  } | null;
};

export type PeoRevenueShareUpdateMutationVariables = Exact<{
  where: Types.PeoWhereUnique;
  data: Types.PeoUpdate;
}>;

export type PeoRevenueShareUpdateMutation = {
  peoUpdate: {
    id: string;
    revenueShareReportEnabled: boolean;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  };
};

export type GetPeoBasicInfoQueryVariables = Exact<{
  id: string | number;
}>;

export type GetPeoBasicInfoQuery = {
  getPeoBasicInfo: {
    id: string;
    displayName: string | null;
    signUpMethod: Types.SignUpMethod;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type PeoPayrollProviderInfoFragment = {
  id: string;
  createdAt: string;
  displayName: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  fein: string | null;
  numberOfEmployees: number | null;
  industry: string | null;
  corporateStructure: string | null;
  taxYearEndDate: string | null;
  defaultRequestAutoAccept: Types.ActiveInactive | null;
  defaultDisclaimer: string | null;
  stripeAccountId: string | null;
  signUpMethod: Types.SignUpMethod;
  companyType: Types.PeoPayrollProviderCompanyType;
  pinLength: Types.PinLength | null;
  firstPinDigits: Types.PinDigit | null;
  lastPinDigits: Types.PinDigit | null;
  pinHint: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
  headquarters: {
    id: string;
    state: string | null;
    county: string | null;
    street: string | null;
    city: string | null;
    apartment: string | null;
    zipCode: string | null;
  } | null;
  revenueShareSetting: {
    id: string;
    revenueShareType: Types.RevenueShareType;
    revenueShareFlat: number | null;
    revenueSharePercents: number | null;
  } | null;
  peoPayrollProviderStaffsList: Array<{
    id: string;
    role: Types.PeoPayrollProviderStaffRole;
    user: { id: string; status: Types.UserStatus };
  }>;
};

export type PeoPayrollProviderMinimalInfoFragment = { id: string; displayName: string | null };

export type PeoPayrollProviderRevenueShareInfoFragment = {
  id: string;
  revenueShareReportEnabled: boolean;
  revenueShareSetting: {
    id: string;
    revenueShareType: Types.RevenueShareType;
    revenueShareFlat: number | null;
    revenueSharePercents: number | null;
  } | null;
};

export type PeoPayrollProviderBasicInfoFragment = {
  id: string;
  displayName: string | null;
  signUpMethod: Types.SignUpMethod;
  pinHint: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type PeoPayrollProvidersListQueryVariables = Exact<{
  filter?: Types.PeoPayrollProviderWhere | null | undefined;
  orderBy?:
    | Array<Types.PeoPayrollProviderOrderBy>
    | Types.PeoPayrollProviderOrderBy
    | null
    | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeoPayrollProvidersListQuery = {
  peoPayrollProviderCount: number;
  peoPayrollProviderList: Array<{
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    fein: string | null;
    numberOfEmployees: number | null;
    industry: string | null;
    corporateStructure: string | null;
    taxYearEndDate: string | null;
    defaultRequestAutoAccept: Types.ActiveInactive | null;
    defaultDisclaimer: string | null;
    stripeAccountId: string | null;
    signUpMethod: Types.SignUpMethod;
    companyType: Types.PeoPayrollProviderCompanyType;
    pinLength: Types.PinLength | null;
    firstPinDigits: Types.PinDigit | null;
    lastPinDigits: Types.PinDigit | null;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    peoPayrollProviderStaffsList: Array<{
      id: string;
      role: Types.PeoPayrollProviderStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
  }>;
};

export type PeoPayrollProvidersSimpleListQueryVariables = Exact<{
  filter?: Types.PeoPayrollProviderWhere | null | undefined;
  orderBy?:
    | Array<Types.PeoPayrollProviderOrderBy>
    | Types.PeoPayrollProviderOrderBy
    | null
    | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeoPayrollProvidersSimpleListQuery = {
  peoPayrollProviderList: Array<{ id: string; displayName: string | null }>;
};

export type PeoPayrollProviderByIdQueryVariables = Exact<{
  id: string | number;
}>;

export type PeoPayrollProviderByIdQuery = {
  peoPayrollProvider: {
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    fein: string | null;
    numberOfEmployees: number | null;
    industry: string | null;
    corporateStructure: string | null;
    taxYearEndDate: string | null;
    defaultRequestAutoAccept: Types.ActiveInactive | null;
    defaultDisclaimer: string | null;
    stripeAccountId: string | null;
    signUpMethod: Types.SignUpMethod;
    companyType: Types.PeoPayrollProviderCompanyType;
    pinLength: Types.PinLength | null;
    firstPinDigits: Types.PinDigit | null;
    lastPinDigits: Types.PinDigit | null;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    peoPayrollProviderStaffsList: Array<{
      id: string;
      role: Types.PeoPayrollProviderStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
  } | null;
};

export type PeoPayrollProviderEmployersByIdQueryVariables = Exact<{
  id: string | number;
}>;

export type PeoPayrollProviderEmployersByIdQuery = {
  peoPayrollProvider: {
    id: string;
    peosList: Array<{
      id: string;
      displayName: string | null;
      logo: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
      employersList: Array<{
        id: string;
        displayName: string | null;
        setLiveAt: string | null;
        logo: {
          id: string;
          key: string;
          filename: string;
          downloadUrl: string | null;
          updatedAt: string;
          createdAt: string;
          mime: string;
          size: number;
        } | null;
      }>;
    }>;
    employersList: Array<{
      id: string;
      displayName: string | null;
      setLiveAt: string | null;
      logo: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    }>;
  } | null;
};

export type PeoPayrollProviderUpdateMutationVariables = Exact<{
  data: Types.PeoPayrollProviderUpdate;
  where: Types.PeoPayrollProviderWhereUnique;
}>;

export type PeoPayrollProviderUpdateMutation = {
  peoPayrollProviderUpdate: {
    id: string;
    createdAt: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhoneNumber: string | null;
    fein: string | null;
    numberOfEmployees: number | null;
    industry: string | null;
    corporateStructure: string | null;
    taxYearEndDate: string | null;
    defaultRequestAutoAccept: Types.ActiveInactive | null;
    defaultDisclaimer: string | null;
    stripeAccountId: string | null;
    signUpMethod: Types.SignUpMethod;
    companyType: Types.PeoPayrollProviderCompanyType;
    pinLength: Types.PinLength | null;
    firstPinDigits: Types.PinDigit | null;
    lastPinDigits: Types.PinDigit | null;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    headquarters: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      city: string | null;
      apartment: string | null;
      zipCode: string | null;
    } | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
    peoPayrollProviderStaffsList: Array<{
      id: string;
      role: Types.PeoPayrollProviderStaffRole;
      user: { id: string; status: Types.UserStatus };
    }>;
  };
};

export type PeoPayrollProviderRevenueShareQueryVariables = Exact<{
  where: Types.PeoPayrollProviderWhereUnique;
}>;

export type PeoPayrollProviderRevenueShareQuery = {
  peoPayrollProvider: {
    id: string;
    revenueShareReportEnabled: boolean;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  } | null;
};

export type PeoPayrollProviderRevenueShareUpdateMutationVariables = Exact<{
  where: Types.PeoPayrollProviderWhereUnique;
  data: Types.PeoPayrollProviderUpdate;
}>;

export type PeoPayrollProviderRevenueShareUpdateMutation = {
  peoPayrollProviderUpdate: {
    id: string;
    revenueShareReportEnabled: boolean;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  };
};

export type GetPeoPayrollProviderBasicInfoQueryVariables = Exact<{
  id: string | number;
}>;

export type GetPeoPayrollProviderBasicInfoQuery = {
  getPeoPayrollProviderBasicInfo: {
    id: string;
    displayName: string | null;
    signUpMethod: Types.SignUpMethod;
    pinHint: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type PeoPayrollProviderStaffInfoFragment = {
  id: string;
  role: Types.PeoPayrollProviderStaffRole;
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    phoneNumber: string | null;
    status: Types.UserStatus;
    birthDate: string | null;
    avatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  };
  peoPayrollProvider: {
    id: string;
    displayName: string | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  };
};

export type PeoPayrollProviderStaffQueryVariables = Exact<{
  id: string | number;
}>;

export type PeoPayrollProviderStaffQuery = {
  peoPayrollProviderStaff: {
    id: string;
    role: Types.PeoPayrollProviderStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  } | null;
};

export type PeoPayrollProviderStaffsListQueryVariables = Exact<{
  filter?: Types.PeoPayrollProviderStaffWhere | null | undefined;
  orderBy?:
    | Array<Types.PeoPayrollProviderStaffOrderBy>
    | Types.PeoPayrollProviderStaffOrderBy
    | null
    | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeoPayrollProviderStaffsListQuery = {
  peoPayrollProviderStaffCount: number;
  peoPayrollProviderStaffList: Array<{
    id: string;
    role: Types.PeoPayrollProviderStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  }>;
};

export type PeoPayrollProviderStaffUpdateMutationVariables = Exact<{
  data: Types.PeoPayrollProviderStaffUpdate;
  where: Types.PeoPayrollProviderStaffWhereUnique;
}>;

export type PeoPayrollProviderStaffUpdateMutation = {
  peoPayrollProviderStaffUpdate: {
    id: string;
    role: Types.PeoPayrollProviderStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    peoPayrollProvider: {
      id: string;
      displayName: string | null;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  };
};

export type SendInvitesToPeoPayrollProviderStaffsMutationVariables = Exact<{
  staff: Array<Types.InvitedPeoPayrollProviderStaff> | Types.InvitedPeoPayrollProviderStaff;
}>;

export type SendInvitesToPeoPayrollProviderStaffsMutation = {
  sendInvitesToPeoPayrollProviderStaffs: { success: boolean };
};

export type SendInvitesToPeoPayrollProviderStaffByCvStaffMutationVariables = Exact<{
  peoPayrollProviderId: string;
  staff: Array<Types.InvitedPeoPayrollProviderStaff> | Types.InvitedPeoPayrollProviderStaff;
}>;

export type SendInvitesToPeoPayrollProviderStaffByCvStaffMutation = {
  sendInvitesToPeoPayrollProviderStaffByCVStaff: { success: boolean };
};

export type PeoStaffInfoFragment = {
  id: string;
  role: Types.PeoStaffRole;
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    phoneNumber: string | null;
    status: Types.UserStatus;
    birthDate: string | null;
    avatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  };
  peo: {
    id: string;
    displayName: string | null;
    peoPayrollProviderId: string | null;
    revenueShareSetting: {
      id: string;
      revenueShareType: Types.RevenueShareType;
      revenueShareFlat: number | null;
      revenueSharePercents: number | null;
    } | null;
  };
};

export type PeoStaffMinimalInfoFragment = {
  id: string;
  role: Types.PeoStaffRole;
  peoId: string;
  user: { id: string; email: string; status: Types.UserStatus };
};

export type PeoStaffAccessInfoItemFragment = {
  id: string;
  accessRestrictionMode: Types.AccessRestrictionMode;
  blacklistedEmployeesList: Array<{ id: string; last4OfSsn: string; fullName: string | null }>;
  blacklistedEmployersList: Array<{ id: string; displayName: string | null }>;
  whitelistedEmployersList: Array<{ id: string; displayName: string | null }>;
};

export type PeoStaffQueryVariables = Exact<{
  id: string | number;
}>;

export type PeoStaffQuery = {
  peoStaff: {
    id: string;
    role: Types.PeoStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    peo: {
      id: string;
      displayName: string | null;
      peoPayrollProviderId: string | null;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  } | null;
};

export type PeoStaffListQueryVariables = Exact<{
  filter?: Types.PeoStaffWhere | null | undefined;
  orderBy?: Array<Types.PeoStaffOrderBy> | Types.PeoStaffOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeoStaffListQuery = {
  peoStaffCount: number;
  peoStaffList: Array<{
    id: string;
    role: Types.PeoStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    peo: {
      id: string;
      displayName: string | null;
      peoPayrollProviderId: string | null;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  }>;
};

export type PeoStaffMinimalListQueryVariables = Exact<{
  filter?: Types.PeoStaffWhere | null | undefined;
  orderBy?: Array<Types.PeoStaffOrderBy> | Types.PeoStaffOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PeoStaffMinimalListQuery = {
  peoStaffCount: number;
  peoStaffList: Array<{
    id: string;
    role: Types.PeoStaffRole;
    peoId: string;
    user: { id: string; email: string; status: Types.UserStatus };
  }>;
};

export type GetPeoStaffAccessInfoQueryVariables = Exact<{
  id: string | number;
}>;

export type GetPeoStaffAccessInfoQuery = {
  getPeoStaffAccessInfo: {
    id: string;
    accessRestrictionMode: Types.AccessRestrictionMode;
    blacklistedEmployeesList: Array<{ id: string; last4OfSsn: string; fullName: string | null }>;
    blacklistedEmployersList: Array<{ id: string; displayName: string | null }>;
    whitelistedEmployersList: Array<{ id: string; displayName: string | null }>;
  } | null;
};

export type PeoStaffUpdateMutationVariables = Exact<{
  data: Types.PeoStaffUpdate;
  where: Types.PeoStaffWhereUnique;
}>;

export type PeoStaffUpdateMutation = {
  peoStaffUpdate: {
    id: string;
    role: Types.PeoStaffRole;
    user: {
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      fullName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    peo: {
      id: string;
      displayName: string | null;
      peoPayrollProviderId: string | null;
      revenueShareSetting: {
        id: string;
        revenueShareType: Types.RevenueShareType;
        revenueShareFlat: number | null;
        revenueSharePercents: number | null;
      } | null;
    };
  };
};

export type UpdatePeoStaffDetailsMutationVariables = Exact<{
  peoStaffId: string | number;
  data: Types.UpdatePeoStaffDetailsInput;
}>;

export type UpdatePeoStaffDetailsMutation = { updatePeoStaffDetails: { success: boolean } };

export type DeletePeoStaffMutationVariables = Exact<{
  peoStaffId: string | number;
}>;

export type DeletePeoStaffMutation = { deletePeoStaff: { success: boolean } };

export type CheckDeletionPeoStaffQueryVariables = Exact<{
  peoStaffId: string | number;
}>;

export type CheckDeletionPeoStaffQuery = {
  checkDeletionPeoStaff: { valid: boolean; errors: Array<string> };
};

export type PermissiblePurposeReferenceItemFragment = {
  id: string;
  label: string | null;
  verifierType: Types.VerifierType;
};

export type PermissiblePurposeByReferenceItemFragment = {
  id: string;
  purposeValue: number | null;
  createdAt: string;
  status: Types.PermissiblePurposeStatus | null;
  denialReason: string | null;
};

export type PermissiblePurposeReferencesListQueryVariables = Exact<{
  filter?: Types.PermissiblePurposeReferenceWhere | null | undefined;
}>;

export type PermissiblePurposeReferencesListQuery = {
  permissiblePurposeReferenceCount: number;
  permissiblePurposeReferenceList: Array<{
    id: string;
    label: string | null;
    verifierType: Types.VerifierType;
  }>;
};

export type PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables = Exact<{
  filter?: Types.PermissiblePurposeReferenceWhere | null | undefined;
  permissiblePurposeFilter?: Types.PermissiblePurposeWhere | null | undefined;
}>;

export type PermissiblePurposeReferencesListWithPermissiblePurposesQuery = {
  permissiblePurposeReferenceCount: number;
  permissiblePurposeReferenceList: Array<{
    permissiblePurposesCount: number;
    id: string;
    label: string | null;
    verifierType: Types.VerifierType;
    permissiblePurposesList: Array<{
      id: string;
      purposeValue: number | null;
      createdAt: string;
      status: Types.PermissiblePurposeStatus | null;
      denialReason: string | null;
    }>;
  }>;
};

export type PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables = Exact<{
  permissiblePurposeFilter?: Types.PermissiblePurposeWhere | null | undefined;
}>;

export type PermissiblePurposeReferencesListDashboardVerifiersTabQuery = {
  permissiblePurposeReferenceList: Array<{
    id: string;
    label: string | null;
    verifierType: Types.VerifierType;
    permissiblePurposesCount: number;
  }>;
};

export type PermissiblePurposesItemFragment = {
  id: string;
  purposeValue: number | null;
  createdAt: string;
  status: Types.PermissiblePurposeStatus | null;
  denialReason: string | null;
  permissiblePurposeReference: {
    id: string;
    label: string | null;
    verifierType: Types.VerifierType;
  };
};

export type PermissiblePurposeQueryVariables = Exact<{
  filter: Types.PermissiblePurposeWhereUnique;
}>;

export type PermissiblePurposeQuery = {
  permissiblePurpose: {
    id: string;
    purposeValue: number | null;
    createdAt: string;
    status: Types.PermissiblePurposeStatus | null;
    denialReason: string | null;
    permissiblePurposeReference: {
      id: string;
      label: string | null;
      verifierType: Types.VerifierType;
    };
  } | null;
};

export type PermissiblePurposesListQueryVariables = Exact<{
  filter?: Types.PermissiblePurposeWhere | null | undefined;
  orderBy?:
    | Array<Types.PermissiblePurposeOrderBy>
    | Types.PermissiblePurposeOrderBy
    | null
    | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PermissiblePurposesListQuery = {
  permissiblePurposeCount: number;
  permissiblePurposeList: Array<{
    id: string;
    purposeValue: number | null;
    createdAt: string;
    status: Types.PermissiblePurposeStatus | null;
    denialReason: string | null;
    permissiblePurposeReference: {
      id: string;
      label: string | null;
      verifierType: Types.VerifierType;
    };
  }>;
};

export type PermissiblePurposeCreateMutationVariables = Exact<{
  data: Types.PermissiblePurposeCreate;
}>;

export type PermissiblePurposeCreateMutation = { createPermissiblePurpose: { id: string } };

export type PermissiblePurposeUpdateMutationVariables = Exact<{
  id: string | number;
  data: Types.PermissiblePurposeUpdate;
}>;

export type PermissiblePurposeUpdateMutation = {
  updatePermissiblePurpose: {
    id: string;
    purposeValue: number | null;
    createdAt: string;
    status: Types.PermissiblePurposeStatus | null;
    denialReason: string | null;
    permissiblePurposeReference: {
      id: string;
      label: string | null;
      verifierType: Types.VerifierType;
    };
  };
};

export type PlatformStaffItemFragment = {
  id: string;
  role: Types.PlatformStaffRole;
  isFinancialReportAvailable: boolean;
  isAbleToManagePlatformStaff: boolean;
  user: {
    id: string;
    email: string;
    fullName: string | null;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    status: Types.UserStatus;
    birthDate: string | null;
    avatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  };
  employersVisibleList: Array<{ id: string }>;
  employersHiddenList: Array<{ id: string }>;
};

export type PlatformStaffListQueryVariables = Exact<{
  filter?: Types.PlatformStaffWhere | null | undefined;
  orderBy?: Array<Types.PlatformStaffOrderBy> | Types.PlatformStaffOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type PlatformStaffListQuery = {
  platformStaffCount: number;
  platformStaffList: Array<{
    id: string;
    role: Types.PlatformStaffRole;
    isFinancialReportAvailable: boolean;
    isAbleToManagePlatformStaff: boolean;
    user: {
      id: string;
      email: string;
      fullName: string | null;
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    employersVisibleList: Array<{ id: string }>;
    employersHiddenList: Array<{ id: string }>;
  }>;
};

export type PlatformStaffQueryVariables = Exact<{
  where: Types.PlatformStaffWhereUnique;
}>;

export type PlatformStaffQuery = {
  platformStaff: {
    id: string;
    role: Types.PlatformStaffRole;
    isFinancialReportAvailable: boolean;
    isAbleToManagePlatformStaff: boolean;
    user: {
      id: string;
      email: string;
      fullName: string | null;
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    employersVisibleList: Array<{ id: string }>;
    employersHiddenList: Array<{ id: string }>;
  } | null;
};

export type CheckDeletionClearVerifyStaffQueryVariables = Exact<{
  platformStaffId: string | number;
}>;

export type CheckDeletionClearVerifyStaffQuery = {
  checkDeletionClearVerifyStaff: { valid: boolean; errors: Array<string> };
};

export type DeleteClearVerifyStaffMutationVariables = Exact<{
  platformStaffId: string | number;
}>;

export type DeleteClearVerifyStaffMutation = { deleteClearVerifyStaff: { success: boolean } };

export type UpdatePlatformStaffMutationVariables = Exact<{
  where: Types.PlatformStaffWhereUnique;
  data: Types.PlatformStaffUpdate;
}>;

export type UpdatePlatformStaffMutation = {
  platformStaffUpdate: {
    id: string;
    role: Types.PlatformStaffRole;
    isFinancialReportAvailable: boolean;
    isAbleToManagePlatformStaff: boolean;
    user: {
      id: string;
      email: string;
      fullName: string | null;
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      status: Types.UserStatus;
      birthDate: string | null;
      avatar: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
    };
    employersVisibleList: Array<{ id: string }>;
    employersHiddenList: Array<{ id: string }>;
  };
};

export type ResourceInfoFragment = {
  id: string;
  userRoleCategory: Array<Types.ResourceUserRoleCategory>;
  iconName: Types.ResourceIconName;
  title: string;
  description: string;
  originType: Types.ResourceOriginType | null;
  url: string | null;
  file: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type ResourceListQueryVariables = Exact<{
  filter?: Types.ResourceWhere | null | undefined;
  orderBy?: Array<Types.ResourceOrderBy> | Types.ResourceOrderBy | null | undefined;
}>;

export type ResourceListQuery = {
  resourceCount: number;
  resourceList: Array<{
    id: string;
    userRoleCategory: Array<Types.ResourceUserRoleCategory>;
    iconName: Types.ResourceIconName;
    title: string;
    description: string;
    originType: Types.ResourceOriginType | null;
    url: string | null;
    file: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  }>;
};

export type RevenueShareSettingFragment = {
  id: string;
  revenueShareType: Types.RevenueShareType;
  revenueShareFlat: number | null;
  revenueSharePercents: number | null;
};

export type GenerateRevenueShareReportMutationVariables = Exact<{
  startDate: string;
  endDate: string;
  companyId?: string | number | null | undefined;
  companyType?: Types.CompanyType | null | undefined;
}>;

export type GenerateRevenueShareReportMutation = {
  generateRevenueShareReport: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  };
};

export type GetDashboardRevenueShareAccountsCountQueryVariables = Exact<{
  asOfDate: string;
}>;

export type GetDashboardRevenueShareAccountsCountQuery = {
  getDashboardRevenueShareAccountsCount: number;
};

export type ValidateSignupEmployeeDataQueryVariables = Exact<{
  inviteId?: string | number | null | undefined;
  employeeSignupToken?: string | null | undefined;
  employeeSsn: string;
  email: string;
}>;

export type ValidateSignupEmployeeDataQuery = {
  validateSignupEmployeeData: { employeeSignupToken: string };
};

export type ValidateSignupEmployeePinOrSsnQueryVariables = Exact<{
  pinOrSsn: string;
  companyType: Types.CompanyType;
  companyId: string | number;
}>;

export type ValidateSignupEmployeePinOrSsnQuery = {
  validateSignupEmployeePinOrSsn: { employeeSignupToken: string };
};

export type StatesItemFragment = {
  name: string | null;
  abbreviation: string | null;
  privacySetting: Types.ActiveInactive | null;
  deleteRequest: Types.ActiveInactive | null;
  createdAt: string;
};

export type StatesListQueryVariables = Exact<{
  filter?: Types.StateWhere | null | undefined;
}>;

export type StatesListQuery = {
  stateList: Array<{
    name: string | null;
    abbreviation: string | null;
    privacySetting: Types.ActiveInactive | null;
    deleteRequest: Types.ActiveInactive | null;
    createdAt: string;
  }>;
};

export type StripeBillingTransactionInfoFragment = {
  id: string;
  createdAt: string;
  amount: number;
  verifierDisplayName: string | null;
  verifierEmail: string | null;
  description: string | null;
  cardBrand: string | null;
  cardLast4: string | null;
  status: Types.StripeBillingTransactionStatus;
  receiptUrl: string | null;
  isRefunded: boolean;
};

export type StripeGetAccountInfoQueryVariables = Exact<{
  stripeAccountId?: string | null | undefined;
}>;

export type StripeGetAccountInfoQuery = {
  stripeGetAccountInfo: { status: Types.StripeAccountStatus };
};

export type StripeCreatePaymentIntentForVerifierMutationVariables = Exact<{
  verifierId: string | number;
  amount: number;
  metadata?: any;
}>;

export type StripeCreatePaymentIntentForVerifierMutation = {
  stripeCreatePaymentIntentForVerifier: { customerId: string; paymentIntent: any };
};

export type StripeCreatePaymentIntentForVerifierStaffMutationVariables = Exact<{
  verifierStaffId: string | number;
  amount: number;
  metadata?: any;
}>;

export type StripeCreatePaymentIntentForVerifierStaffMutation = {
  stripeCreatePaymentIntentForVerifierStaff: { customerId: string; paymentIntent: any };
};

export type StripeGetCustomerPaymentMethodsQueryVariables = Exact<{
  stripeCustomerId?: string | null | undefined;
  stripeAccountId?: string | null | undefined;
}>;

export type StripeGetCustomerPaymentMethodsQuery = {
  stripeGetCustomerPaymentMethods: {
    defaultPaymentMethodId: string | null;
    cardPaymentMethods: any;
    achPaymentMethods: any;
  } | null;
};

export type StripeCreateSetupIntentMutationVariables = Exact<{ [key: string]: never }>;

export type StripeCreateSetupIntentMutation = { stripeCreateSetupIntent: { clientSecret: string } };

export type StripeUpdateCustomerDefaultPaymentMethodMutationVariables = Exact<{
  customerId: string;
  defaultPaymentMethodId: string;
  connectedStripeAccountId?: string | null | undefined;
}>;

export type StripeUpdateCustomerDefaultPaymentMethodMutation = {
  stripeUpdateCustomerDefaultPaymentMethod: {
    defaultPaymentMethodId: string | null;
    success: boolean;
  };
};

export type StripeDetachPaymentMethodMutationVariables = Exact<{
  paymentMethodId: string;
  connectedStripeAccountId?: string | null | undefined;
}>;

export type StripeDetachPaymentMethodMutation = { stripeDetachPaymentMethod: { success: boolean } };

export type StripeGetPaymentHistoryQueryVariables = Exact<{
  verifierId?: string | number | null | undefined;
  limit?: number | null | undefined;
  pageId?: string | null | undefined;
}>;

export type StripeGetPaymentHistoryQuery = {
  stripeGetPaymentHistory: {
    nextPageId: string | null;
    paymentHistoryCharges: Array<{
      id: string;
      createdAt: string;
      amount: number;
      verifierDisplayName: string | null;
      verifierEmail: string | null;
      description: string | null;
      cardBrand: string | null;
      cardLast4: string | null;
      status: Types.StripeBillingTransactionStatus;
      receiptUrl: string | null;
      isRefunded: boolean;
    }>;
  };
};

export type StripeGetPaymentIntentForVerificationRequestQueryVariables = Exact<{
  inboxItemId: string | number;
}>;

export type StripeGetPaymentIntentForVerificationRequestQuery = {
  stripeGetPaymentIntentForVerificationRequest: { paymentIntentId: string; paymentMethod: string };
};

export type StripeUpdatePaymentMethodForVerificationRequestMutationVariables = Exact<{
  inboxItemId: string | number;
  paymentMethodId: string;
}>;

export type StripeUpdatePaymentMethodForVerificationRequestMutation = {
  stripeUpdatePaymentMethodForVerificationRequest: { success: boolean; redirectUrl: string | null };
};

export type StripeRefundChargeMutationVariables = Exact<{
  stripeChargeId: string;
}>;

export type StripeRefundChargeMutation = { stripeRefundCharge: { success: boolean } };

export type StripeRefundVerificationRequestChargeMutationVariables = Exact<{
  inboxItemId: string | number;
}>;

export type StripeRefundVerificationRequestChargeMutation = {
  stripeRefundVerificationRequestCharge: { success: boolean };
};

export type TestVerificationRequestInfoFragment = {
  id: string;
  createdAt: string;
  type: Array<Types.VerificationRequestType>;
  employeeId: string;
  platformStaff: { id: string; user: { id: string; fullName: string | null } };
};

export type CreateTestVerificationRequestMutationVariables = Exact<{
  ssn: string;
  employeeFirstName?: string | null | undefined;
  employeeLastName?: string | null | undefined;
  employeeBirthDate: string;
  requestType: Array<Types.VerificationRequestType> | Types.VerificationRequestType;
  companies: Array<Types.VerificationRequestCompanyData> | Types.VerificationRequestCompanyData;
}>;

export type CreateTestVerificationRequestMutation = {
  createTestVerificationRequest: { success: boolean; inboxItemId: string | null };
};

export type TestVerificationRequestQueryVariables = Exact<{
  inboxItemId: string | number;
}>;

export type TestVerificationRequestQuery = {
  testVerificationRequest: {
    id: string;
    createdAt: string;
    type: Array<Types.VerificationRequestType>;
    employeeId: string;
    platformStaff: { id: string; user: { id: string; fullName: string | null } };
  } | null;
};

export type UserItemFragment = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  phoneNumber: string | null;
  status: Types.UserStatus;
  birthDate: string | null;
  avatar: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type CurrentUserAddressInfoFragment = {
  id: string;
  state: string | null;
  county: string | null;
  street: string | null;
  apartment: string | null;
  zipCode: string | null;
  city: string | null;
};

export type CurrentUserBaseInfoFragment = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  timezone: string | null;
  title: string | null;
  createdAt: string;
  lastPasswordChangeAt: string | null;
  platformStaff: { id: string; role: Types.PlatformStaffRole } | null;
  verifierStaff: { id: string; role: Types.VerifierStaffRole; verifierId: string } | null;
  peoPayrollProviderStaff: {
    id: string;
    role: Types.PeoPayrollProviderStaffRole;
    isPartnershipCompany: boolean;
    peoPayrollProviderId: string;
  } | null;
  peoStaff: {
    id: string;
    role: Types.PeoStaffRole;
    isPartnershipCompany: boolean;
    peoId: string;
  } | null;
  employerStaff: { id: string; role: Types.EmployerStaffRole; employerId: string } | null;
  employee: { id: string; role: Types.EmployeeRole } | null;
  address: {
    id: string;
    state: string | null;
    county: string | null;
    street: string | null;
    apartment: string | null;
    zipCode: string | null;
    city: string | null;
  } | null;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  currentUser: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    timezone: string | null;
    title: string | null;
    createdAt: string;
    lastPasswordChangeAt: string | null;
    platformStaff: { id: string; role: Types.PlatformStaffRole } | null;
    verifierStaff: { id: string; role: Types.VerifierStaffRole; verifierId: string } | null;
    peoPayrollProviderStaff: {
      id: string;
      role: Types.PeoPayrollProviderStaffRole;
      isPartnershipCompany: boolean;
      peoPayrollProviderId: string;
    } | null;
    peoStaff: {
      id: string;
      role: Types.PeoStaffRole;
      isPartnershipCompany: boolean;
      peoId: string;
    } | null;
    employerStaff: { id: string; role: Types.EmployerStaffRole; employerId: string } | null;
    employee: { id: string; role: Types.EmployeeRole } | null;
    address: {
      id: string;
      state: string | null;
      county: string | null;
      street: string | null;
      apartment: string | null;
      zipCode: string | null;
      city: string | null;
    } | null;
  } | null;
};

export type UserByIdQueryVariables = Exact<{
  id: string | number;
}>;

export type UserByIdQuery = {
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    phoneNumber: string | null;
    status: Types.UserStatus;
    birthDate: string | null;
    avatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type EmployeeInviteIdQueryVariables = Exact<{
  userId: string | number;
}>;

export type EmployeeInviteIdQuery = { getEmployeeInviteId: string | null };

export type UserAvatarQueryVariables = Exact<{
  id: string | number;
}>;

export type UserAvatarQuery = {
  user: {
    id: string;
    avatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type UserNotificationSettingsQueryVariables = Exact<{
  where: Types.UserWhereUnique;
}>;

export type UserNotificationSettingsQuery = {
  user: { id: string; notificationSettings: Array<Types.UsersNotificationSetting> } | null;
};

export type UpdateUserMutationVariables = Exact<{
  data: Types.UserUpdate;
  where: Types.UserWhereUnique;
}>;

export type UpdateUserMutation = { userUpdate: { id: string; status: Types.UserStatus } };

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  data: Types.UserUpdate;
  where: Types.UserWhereUnique;
}>;

export type UpdateUserNotificationSettingsMutation = {
  userUpdate: { id: string; notificationSettings: Array<Types.UsersNotificationSetting> };
};

export type CreateUserPasswordChangeRequestMutationVariables = Exact<{ [key: string]: never }>;

export type CreateUserPasswordChangeRequestMutation = {
  createUserPasswordChangeRequest: { success: boolean };
};

export type ChangeUserPasswordMutationVariables = Exact<{
  currentPassword: string;
  newPassword: string;
  mfaSession?: string | null | undefined;
  mfaCode?: string | null | undefined;
  userPasswordChangeRequestId: string | number;
}>;

export type ChangeUserPasswordMutation = {
  changeUserPassword: { success: boolean; mfaSession: string | null };
};

export type CreateUserPasswordResetRequestMutationVariables = Exact<{
  email: string;
}>;

export type CreateUserPasswordResetRequestMutation = {
  createUserPasswordResetRequest: { success: boolean };
};

export type ResetUserPasswordMutationVariables = Exact<{
  newPassword: string;
  userPasswordResetRequestId: string | number;
}>;

export type ResetUserPasswordMutation = { resetUserPassword: { success: boolean } };

export type CheckPasswordRequestExistQueryVariables = Exact<{
  requestId: string | number;
  requestType: Types.PasswordRequestType;
}>;

export type CheckPasswordRequestExistQuery = { checkPasswordRequestExist: { success: boolean } };

export type UserRegistrationVerifierAdminMutationVariables = Exact<{
  user: Types.VerifierAdminUserData;
  verifier: Types.VerifierAdminVerifierData;
  emailConfirmationCode: string;
}>;

export type UserRegistrationVerifierAdminMutation = {
  userRegistrationVerifierAdmin: { idToken: string | null; accessToken: string | null };
};

export type UserRegistrationVerifierManagerMutationVariables = Exact<{
  verifierId: string | number;
  user: Types.VerifierManagerUserData;
  emailConfirmationCode: string;
}>;

export type UserRegistrationVerifierManagerMutation = {
  userRegistrationVerifierManager: { idToken: string | null; accessToken: string | null };
};

export type SendRequestAccountIsFrozenMutationVariables = Exact<{
  employeeId: string | number;
}>;

export type SendRequestAccountIsFrozenMutation = {
  sendRequestAccountIsFrozen: { success: boolean };
};

export type SendDeleteMyDataRequestMutationVariables = Exact<{ [key: string]: never }>;

export type SendDeleteMyDataRequestMutation = { sendDeleteMyDataRequest: { success: boolean } };

export type ChangeUserStatusMutationVariables = Exact<{
  userId: string | number;
  newStatus: Types.UserStatus;
}>;

export type ChangeUserStatusMutation = {
  changeUserStatus: { id: string; status: Types.UserStatus };
};

export type ChangeEmployeeUserEmailByPlatformAdminMutationVariables = Exact<{
  userId: string | number;
  newEmail: string;
}>;

export type ChangeEmployeeUserEmailByPlatformAdminMutation = {
  changeEmployeeUserEmailByPlatformAdmin: { success: boolean };
};

export type UpdateUserRoleMutationVariables = Exact<{
  userId: string | number;
  data: Types.UpdateUserRoleInput;
}>;

export type UpdateUserRoleMutation = { updateUserRole: { success: boolean } };

export type CreateUserEmailChangeRequestMutationVariables = Exact<{
  newEmail: string;
}>;

export type CreateUserEmailChangeRequestMutation = {
  createUserEmailChangeRequest: { success: boolean };
};

export type ConfirmUserEmailMutationVariables = Exact<{
  userEmailChangeRequestId: string | number;
}>;

export type ConfirmUserEmailMutation = { confirmUserEmail: { success: boolean } };

export type CheckIfUserEmailChangeExistQueryVariables = Exact<{ [key: string]: never }>;

export type CheckIfUserEmailChangeExistQuery = {
  checkIfUserEmailChangeExist: { success: boolean };
};

export type VerificationRequestListItemFragment = {
  id: string;
  createdAt: string;
  type: Types.VerificationRequestType | null;
  status: Types.VerificationRequestStatus;
  isMyVerifyRequest: boolean;
  permissiblePurposeId: string | null;
  verifierStaffId: string;
  employeeId: string;
};

export type VerificationRequestForReportItemFragment = {
  id: string;
  createdAt: string;
  type: Types.VerificationRequestType | null;
  status: Types.VerificationRequestStatus;
  inboxItemId: string;
  employeeFullName: string | null;
  employers: string | null;
  peos: string | null;
  verifierDisplayName: string | null;
  verifierStaffFullName: string | null;
  permissiblePurposeLabel: string | null;
  employeeAvatar: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
};

export type VerificationRequestPaymentInfoFragment = {
  id: string;
  stripePaymentStatus: Types.VerificationRequestStripePaymentStatus | null;
  stripeFailedPaymentMessage: string | null;
};

export type VerificationRequestTotalChargeQueryVariables = Exact<{
  employeeId?: string | number | null | undefined;
  employeeSsn?: string | null | undefined;
  requestType: Types.VerificationRequestType;
  permissiblePurposeId: string | number;
  companies: Array<Types.VerificationRequestCompanyData> | Types.VerificationRequestCompanyData;
}>;

export type VerificationRequestTotalChargeQuery = {
  getVerificationRequestTotalCharge: {
    totalCharge: number;
    isReverification: boolean;
    isOutstandingRequest: boolean;
  };
};

export type GetMyVerifyRequestTotalChargeQueryVariables = Exact<{
  inboxItemId: string | number;
  permissiblePurposeId: string | number;
  verificationReportType?: Types.VerificationRequestType | null | undefined;
}>;

export type GetMyVerifyRequestTotalChargeQuery = {
  getMyVerifyRequestTotalCharge: {
    totalCharge: number;
    isReverification: boolean;
    isOutstandingRequest: boolean;
  };
};

export type GetExistingVerificationRequestTotalChargeQueryVariables = Exact<{
  inboxItemId: string | number;
  reason: Types.ExistingVerificationRequestTotalChargeReason;
}>;

export type GetExistingVerificationRequestTotalChargeQuery = {
  getExistingVerificationRequestTotalCharge: { totalCharge: number };
};

export type CreateVerificationRequestMutationVariables = Exact<{
  employeeFirstName?: string | null | undefined;
  employeeLastName?: string | null | undefined;
  employeeBirthDate: string;
  noteToEmployee?: string | null | undefined;
  paymentMethodId?: string | null | undefined;
  permissiblePurposeId: string | number;
  requestType: Types.VerificationRequestType;
  ssn: string;
  companies: Array<Types.VerificationRequestCompanyData> | Types.VerificationRequestCompanyData;
  verifierId?: string | number | null | undefined;
}>;

export type CreateVerificationRequestMutation = {
  createVerificationRequest: {
    success: boolean;
    redirectUrl: string | null;
    inboxItemId: string | null;
  };
};

export type CreateVerificationRequestByEmployeeMutationVariables = Exact<{
  companyName: string;
  firstName: string;
  lastName: string;
  contactEmail: string;
  companies: Array<Types.VerificationRequestCompanyData> | Types.VerificationRequestCompanyData;
  noteToRecipient?: string | null | undefined;
}>;

export type CreateVerificationRequestByEmployeeMutation = {
  createVerificationRequestByEmployee: { success: boolean };
};

export type CreateReverificationRequestMutationVariables = Exact<{
  inboxItemId: string | number;
  paymentMethodId?: string | null | undefined;
}>;

export type CreateReverificationRequestMutation = {
  createReverificationRequest: {
    success: boolean;
    redirectUrl: string | null;
    inboxItemId: string | null;
  };
};

export type VerificationRequestQueryVariables = Exact<{
  filter: Types.VerificationRequestWhereUnique;
}>;

export type VerificationRequestQuery = {
  verificationRequest: {
    id: string;
    createdAt: string;
    type: Types.VerificationRequestType | null;
    status: Types.VerificationRequestStatus;
    isMyVerifyRequest: boolean;
    permissiblePurposeId: string | null;
    verifierStaffId: string;
    employeeId: string;
  } | null;
};

export type VerificationRequestPaymentInfoQueryVariables = Exact<{
  where: Types.VerificationRequestWhereUnique;
}>;

export type VerificationRequestPaymentInfoQuery = {
  verificationRequest: {
    id: string;
    stripePaymentStatus: Types.VerificationRequestStripePaymentStatus | null;
    stripeFailedPaymentMessage: string | null;
  } | null;
};

export type VerificationRequestsListQueryVariables = Exact<{
  filter?: Types.VerificationRequestWhere | null | undefined;
}>;

export type VerificationRequestsListQuery = {
  verificationRequestList: Array<{
    id: string;
    createdAt: string;
    inboxItemId: string;
    employee: {
      id: string;
      user: { id: string; firstName: string | null; lastName: string | null } | null;
    };
    verifierStaff: { id: string; verifier: { id: string; displayName: string | null } };
  }>;
};

export type VerificationRequestsReportListQueryVariables = Exact<{
  filter?: Types.VerificationRequestWhere | null | undefined;
  orderBy?:
    | Array<Types.VerificationRequestOrderBy>
    | Types.VerificationRequestOrderBy
    | null
    | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type VerificationRequestsReportListQuery = {
  verificationRequestCount: number;
  getVerificationRequestsListForReport: Array<{
    id: string;
    createdAt: string;
    type: Types.VerificationRequestType | null;
    status: Types.VerificationRequestStatus;
    inboxItemId: string;
    employeeFullName: string | null;
    employers: string | null;
    peos: string | null;
    verifierDisplayName: string | null;
    verifierStaffFullName: string | null;
    permissiblePurposeLabel: string | null;
    employeeAvatar: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  }>;
};

export type VerificationRequestsCountQueryVariables = Exact<{
  where?: Types.VerificationRequestWhere | null | undefined;
}>;

export type VerificationRequestsCountQuery = { verificationRequestCount: number };

export type GetAnnualFreeReportDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetAnnualFreeReportDataQuery = {
  getAnnualFreeReportData: {
    createdAt: string;
    file: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    };
  } | null;
};

export type GenerateVerificationRequestsReportMutationVariables = Exact<{
  where?: Types.VerificationRequestWhere | null | undefined;
  orderBy?:
    | Array<Types.VerificationRequestOrderBy>
    | Types.VerificationRequestOrderBy
    | null
    | undefined;
  format: Types.VerificationRequestsReportFormat;
}>;

export type GenerateVerificationRequestsReportMutation = {
  generateVerificationRequestsReport: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  };
};

export type ApproveVerificationRequestByVerifierMutationVariables = Exact<{
  inboxItemId: string | number;
  verificationRequestType?: Types.VerificationRequestType | null | undefined;
  permissiblePurposeId: string | number;
  paymentMethodId?: string | null | undefined;
}>;

export type ApproveVerificationRequestByVerifierMutation = {
  approveVerificationRequestByVerifier: { success: boolean; redirectUrl: string | null };
};

export type ApproveVerificationRequestByEmployeeMutationVariables = Exact<{
  inboxItemId: string | number;
}>;

export type ApproveVerificationRequestByEmployeeMutation = {
  approveVerificationRequestByEmployee: { success: boolean };
};

export type DeclineVerificationRequestByVerifierMutationVariables = Exact<{
  inboxItemId: string | number;
}>;

export type DeclineVerificationRequestByVerifierMutation = {
  declineVerificationRequestByVerifier: { success: boolean };
};

export type DeclineVerificationRequestByEmployeeMutationVariables = Exact<{
  inboxItemId: string | number;
}>;

export type DeclineVerificationRequestByEmployeeMutation = {
  declineVerificationRequestByEmployee: { success: boolean };
};

export type GenerateAnnualFreeReportMutationVariables = Exact<{ [key: string]: never }>;

export type GenerateAnnualFreeReportMutation = {
  generateAnnualFreeReport: {
    status: Types.AnnualFreeReportStatus;
    file: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    };
  };
};

export type VerifierInfoFragment = {
  id: string;
  displayName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  legalBusinessName: string | null;
  type: Types.VerifierType | null;
  credentialStatus: Types.VerifierCredentialStatus;
  denialReason: string | null;
  fEIN: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
  verifierStaffsList: Array<{
    id: string;
    role: Types.VerifierStaffRole;
    user: {
      id: string;
      email: string;
      lastName: string | null;
      firstName: string | null;
      status: Types.UserStatus;
    };
  }>;
  permissiblePurposesList: Array<{
    id: string;
    purposeValue: number | null;
    createdAt: string;
    status: Types.PermissiblePurposeStatus | null;
    denialReason: string | null;
    permissiblePurposeReference: {
      id: string;
      label: string | null;
      verifierType: Types.VerifierType;
    };
  }>;
};

export type VerifierDetailInfoFragment = {
  id: string;
  displayName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  legalBusinessName: string | null;
  type: Types.VerifierType | null;
  credentialStatus: Types.VerifierCredentialStatus;
  fEIN: string | null;
  industry: string | null;
  websiteURL: string | null;
  governmentEntityName: string | null;
  typeOfGovernment: Types.VerifierTypeOfGovernment | null;
  department: string | null;
  commercialName: string | null;
  stripeCustomerId: string | null;
  denialReason: string | null;
  logo: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  } | null;
  address: {
    id: string;
    county: string | null;
    city: string | null;
    state: string | null;
    apartment: string | null;
    street: string | null;
    zipCode: string | null;
  } | null;
};

export type VerifierCredentialInfoFragment = {
  id: string;
  createdAt: string;
  credentialedAt: string | null;
};

export type VerifierBillingRulesInfoFragment = {
  id: string;
  verifierBilling: { id: string; voI: number; voE: number; reverification: number } | null;
};

export type VerifierBasicItemInfoFragment = { id: string; displayName: string | null };

export type VerifiersListQueryVariables = Exact<{
  filter?: Types.VerifierWhere | null | undefined;
  orderBy?: Array<Types.VerifierOrderBy> | Types.VerifierOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type VerifiersListQuery = {
  verifierCount: number;
  verifierList: Array<{
    id: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    legalBusinessName: string | null;
    type: Types.VerifierType | null;
    credentialStatus: Types.VerifierCredentialStatus;
    denialReason: string | null;
    fEIN: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    verifierStaffsList: Array<{
      id: string;
      role: Types.VerifierStaffRole;
      user: {
        id: string;
        email: string;
        lastName: string | null;
        firstName: string | null;
        status: Types.UserStatus;
      };
    }>;
    permissiblePurposesList: Array<{
      id: string;
      purposeValue: number | null;
      createdAt: string;
      status: Types.PermissiblePurposeStatus | null;
      denialReason: string | null;
      permissiblePurposeReference: {
        id: string;
        label: string | null;
        verifierType: Types.VerifierType;
      };
    }>;
  }>;
};

export type VerifierQueryVariables = Exact<{
  id: string | number;
}>;

export type VerifierQuery = {
  verifier: {
    id: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    legalBusinessName: string | null;
    type: Types.VerifierType | null;
    credentialStatus: Types.VerifierCredentialStatus;
    fEIN: string | null;
    industry: string | null;
    websiteURL: string | null;
    governmentEntityName: string | null;
    typeOfGovernment: Types.VerifierTypeOfGovernment | null;
    department: string | null;
    commercialName: string | null;
    stripeCustomerId: string | null;
    denialReason: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    address: {
      id: string;
      county: string | null;
      city: string | null;
      state: string | null;
      apartment: string | null;
      street: string | null;
      zipCode: string | null;
    } | null;
  } | null;
};

export type CheckIsAdditionalVerifierAdminQueryVariables = Exact<{
  verifierId: string | number;
}>;

export type CheckIsAdditionalVerifierAdminQuery = {
  checkIsAdditionalVerifierAdmin: { isAdditionalVerifierAdmin: boolean };
};

export type VerifierUpdateMutationVariables = Exact<{
  id: string | number;
  data: Types.VerifierUpdate;
}>;

export type VerifierUpdateMutation = {
  updateVerifier: {
    id: string;
    displayName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    legalBusinessName: string | null;
    type: Types.VerifierType | null;
    credentialStatus: Types.VerifierCredentialStatus;
    fEIN: string | null;
    industry: string | null;
    websiteURL: string | null;
    governmentEntityName: string | null;
    typeOfGovernment: Types.VerifierTypeOfGovernment | null;
    department: string | null;
    commercialName: string | null;
    stripeCustomerId: string | null;
    denialReason: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
    address: {
      id: string;
      county: string | null;
      city: string | null;
      state: string | null;
      apartment: string | null;
      street: string | null;
      zipCode: string | null;
    } | null;
  };
};

export type VerifierBillingRulesQueryVariables = Exact<{
  id: string | number;
}>;

export type VerifierBillingRulesQuery = {
  verifier: {
    id: string;
    verifierBilling: { id: string; voI: number; voE: number; reverification: number } | null;
  } | null;
};

export type VerifierBillingRulesUpdateMutationVariables = Exact<{
  id: string | number;
  data: Types.VerifierUpdate;
}>;

export type VerifierBillingRulesUpdateMutation = {
  updateVerifier: {
    id: string;
    verifierBilling: { id: string; voI: number; voE: number; reverification: number } | null;
  };
};

export type GetVerifierByEmailDomainQueryVariables = Exact<{
  email: string;
  emailConfirmationCode: string;
}>;

export type GetVerifierByEmailDomainQuery = {
  getVerifierByEmailDomain: {
    verifiers: Array<{
      id: string;
      createdAt: string;
      displayName: string | null;
      type: Types.VerifierType | null;
      logo: {
        id: string;
        key: string;
        filename: string;
        downloadUrl: string | null;
        updatedAt: string;
        createdAt: string;
        mime: string;
        size: number;
      } | null;
      address: { state: string | null; street: string | null } | null;
    }> | null;
  };
};

export type GetVerifierInfoByVerificationRequestQueryVariables = Exact<{
  verificationRequestId: string | number;
}>;

export type GetVerifierInfoByVerificationRequestQuery = {
  getVerifierInfoByVerificationRequest: {
    id: string;
    credentialStatus: Types.VerifierCredentialStatus;
    type: Types.VerifierType | null;
    displayName: string | null;
    contactName: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  };
};

export type VerifierLogoQueryVariables = Exact<{
  id: string | number;
}>;

export type VerifierLogoQuery = {
  verifier: {
    id: string;
    logo: {
      id: string;
      key: string;
      filename: string;
      downloadUrl: string | null;
      updatedAt: string;
      createdAt: string;
      mime: string;
      size: number;
    } | null;
  } | null;
};

export type VerifierCredentialInfoQueryVariables = Exact<{
  where: Types.VerifierWhereUnique;
}>;

export type VerifierCredentialInfoQuery = {
  verifier: { id: string; createdAt: string; credentialedAt: string | null } | null;
};

export type VerifiersBasicListQueryVariables = Exact<{
  displayName?: string | null | undefined;
  first?: number | null | undefined;
}>;

export type VerifiersBasicListQuery = {
  getVerifiersBasicList: Array<{ id: string; displayName: string | null }>;
};

export type DeleteVerifierMutationVariables = Exact<{
  verifierId: string | number;
}>;

export type DeleteVerifierMutation = { deleteVerifier: { success: boolean } };

export type CheckDeletionVerifierQueryVariables = Exact<{
  verifierId: string | number;
}>;

export type CheckDeletionVerifierQuery = {
  checkDeletionVerifier: { valid: boolean; errors: Array<string> };
};

export type GenerateRankedVerifiersReportMutationVariables = Exact<{
  verifierType: Types.VerifierType;
}>;

export type GenerateRankedVerifiersReportMutation = {
  generateRankedVerifiersReport: {
    id: string;
    key: string;
    filename: string;
    downloadUrl: string | null;
    updatedAt: string;
    createdAt: string;
    mime: string;
    size: number;
  };
};

export type VerifierStaffItemFragment = {
  id: string;
  role: Types.VerifierStaffRole;
  stripeCustomerId: string | null;
  verifier: {
    id: string;
    legalBusinessName: string | null;
    type: Types.VerifierType | null;
    stripeCustomerId: string | null;
  };
  user: {
    id: string;
    email: string;
    lastName: string | null;
    firstName: string | null;
    phoneNumber: string | null;
    birthDate: string | null;
    status: Types.UserStatus;
  };
};

export type VerifierStaffWithBillingInfoFragment = {
  id: string;
  verifier: {
    id: string;
    verifierBilling: { id: string; voI: number; voE: number; reverification: number } | null;
  };
};

export type VerifierStaffListQueryVariables = Exact<{
  filter?: Types.VerifierStaffWhere | null | undefined;
  orderBy?: Array<Types.VerifierStaffOrderBy> | Types.VerifierStaffOrderBy | null | undefined;
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export type VerifierStaffListQuery = {
  verifierStaffCount: number;
  verifierStaffList: Array<{
    id: string;
    role: Types.VerifierStaffRole;
    stripeCustomerId: string | null;
    verifier: {
      id: string;
      legalBusinessName: string | null;
      type: Types.VerifierType | null;
      stripeCustomerId: string | null;
    };
    user: {
      id: string;
      email: string;
      lastName: string | null;
      firstName: string | null;
      phoneNumber: string | null;
      birthDate: string | null;
      status: Types.UserStatus;
    };
  }>;
};

export type VerifierStaffUpdateMutationVariables = Exact<{
  data: Types.VerifierStaffUpdate;
  where: Types.VerifierStaffWhereUnique;
}>;

export type VerifierStaffUpdateMutation = {
  verifierStaffUpdate: {
    id: string;
    role: Types.VerifierStaffRole;
    stripeCustomerId: string | null;
    verifier: {
      id: string;
      legalBusinessName: string | null;
      type: Types.VerifierType | null;
      stripeCustomerId: string | null;
    };
    user: {
      id: string;
      email: string;
      lastName: string | null;
      firstName: string | null;
      phoneNumber: string | null;
      birthDate: string | null;
      status: Types.UserStatus;
    };
  };
};

export type VerifierStaffQueryVariables = Exact<{
  id: string | number;
}>;

export type VerifierStaffQuery = {
  verifierStaff: {
    id: string;
    role: Types.VerifierStaffRole;
    stripeCustomerId: string | null;
    verifier: {
      id: string;
      legalBusinessName: string | null;
      type: Types.VerifierType | null;
      stripeCustomerId: string | null;
    };
    user: {
      id: string;
      email: string;
      lastName: string | null;
      firstName: string | null;
      phoneNumber: string | null;
      birthDate: string | null;
      status: Types.UserStatus;
    };
  } | null;
};

export type VerifierStaffBillingAccessQueryVariables = Exact<{
  id: string | number;
}>;

export type VerifierStaffBillingAccessQuery = {
  verifierStaff: { verifier: { type: Types.VerifierType | null } } | null;
};

export type VerifierStaffBillingInfoQueryVariables = Exact<{
  id: string | number;
}>;

export type VerifierStaffBillingInfoQuery = {
  verifierStaff: {
    id: string;
    verifier: {
      id: string;
      verifierBilling: { id: string; voI: number; voE: number; reverification: number } | null;
    };
  } | null;
};

export type DeleteVerifierStaffMutationVariables = Exact<{
  verifierStaffId: string | number;
}>;

export type DeleteVerifierStaffMutation = { deleteVerifierStaff: { success: boolean } };

export type CheckDeletionVerifierStaffQueryVariables = Exact<{
  verifierStaffId: string | number;
}>;

export type CheckDeletionVerifierStaffQuery = {
  checkDeletionVerifierStaff: { valid: boolean; errors: Array<string> };
};

export const AddressInfoFragmentDoc = gql`
    fragment AddressInfo on Address {
  id
  state
  county
  street
  city
  apartment
  zipCode
}
    `;
export const AccountPersonalInformationFragmentFragmentDoc = gql`
    fragment AccountPersonalInformationFragment on User {
  id
  email
  firstName
  lastName
  title
  birthDate
  phoneNumber
  timezone
  address {
    ...AddressInfo
  }
  employee {
    id
    workEmail
    homeAddress {
      ...AddressInfo
    }
  }
}
    ${AddressInfoFragmentDoc}`;
export const FileResponseInfoFragmentDoc = gql`
    fragment FileResponseInfo on FileResponse {
  id
  key
  filename
  downloadUrl
  updatedAt
  createdAt
  mime
  size
}
    `;
export const ActivityLogItemFragmentDoc = gql`
    fragment ActivityLogItem on ActivityLogsListItem {
  id
  heading
  companyDisplayName
  authorDisplayName
  comment
  file {
    ...FileResponseInfo
  }
  type
  createdAt
  visibleFor
  platformStaffId
}
    ${FileResponseInfoFragmentDoc}`;
export const ApiVerificationRequestInfoFragmentDoc = gql`
    fragment ApiVerificationRequestInfo on ApiVerificationRequest {
  id
  createdAt
  type
  employeeId
}
    `;
export const InitialBillingRulesInfoFragmentDoc = gql`
    fragment InitialBillingRulesInfo on InitialBilling {
  id
  voI
  voE
  reverification
  revenueShareType
  revenueSharePercents
  revenueShareFlat
}
    `;
export const EmployeeItemFragmentDoc = gql`
    fragment EmployeeItem on Employee {
  id
  ssn
  workEmail
  phoneNumber
  role
  userId
  freeze
  requestAutoApprove
  deleteRequestSentAt
  dataDeletedAt
}
    `;
export const DashboardUsageReportItemInfoFragmentDoc = gql`
    fragment DashboardUsageReportItemInfo on DashboardUsageReportItem {
  month
  type
  count
}
    `;
export const DashboardWorkLetterUsageItemInfoFragmentDoc = gql`
    fragment DashboardWorkLetterUsageItemInfo on DashboardWorkLetterUsageItem {
  month
  type
  count
}
    `;
export const DashboardPlatformAdminRevenueDistributionItemInfoFragmentDoc = gql`
    fragment DashboardPlatformAdminRevenueDistributionItemInfo on DashboardPlatformAdminRevenueDistributionItem {
  month
  type
  revenueSharePayedAmount
}
    `;
export const DashboardCvRevenueByVerificationTypeItemInfoFragmentDoc = gql`
    fragment DashboardCvRevenueByVerificationTypeItemInfo on DashboardCvRevenueByVerificationTypeItem {
  month
  type
  chargeAmount
}
    `;
export const DashboardVerificationRequestsCountGroupByStatusInfoFragmentDoc = gql`
    fragment DashboardVerificationRequestsCountGroupByStatusInfo on DashboardVerificationRequestsCountGroupByStatus {
  status
  count
}
    `;
export const DashboardVerificationRequestsCountGroupByIsManualInfoFragmentDoc = gql`
    fragment DashboardVerificationRequestsCountGroupByIsManualInfo on DashboardVerificationRequestsCountGroupByIsManual {
  isManual
  count
}
    `;
export const DashboardVerifiersCountGroupByCredentialStatusInfoFragmentDoc = gql`
    fragment DashboardVerifiersCountGroupByCredentialStatusInfo on DashboardVerifiersCountGroupByCredentialStatus {
  status
  count
}
    `;
export const DashboardDataDisputeItemsCountGroupByStatusInfoFragmentDoc = gql`
    fragment DashboardDataDisputeItemsCountGroupByStatusInfo on DashboardDataDisputeItemsCountGroupByStatus {
  status
  count
}
    `;
export const DashboardCvAdminVerifiersDataResponseInfoFragmentDoc = gql`
    fragment DashboardCVAdminVerifiersDataResponseInfo on DashboardCVAdminVerifiersDataResponse {
  averageCertificationHours
  commercialVerifiersCount
  governmentalVerifiersCount
}
    `;
export const DashboardPlatformAdminTopVerifierDataInfoFragmentDoc = gql`
    fragment DashboardPlatformAdminTopVerifierDataInfo on DashboardPlatformAdminTopVerifierData {
  id
  type
  displayName
  verificationRequestsCount
}
    `;
export const DataDisputeItemInfoFragmentDoc = gql`
    fragment DataDisputeItemInfo on DataDisputeItem {
  id
  status
  employerId
}
    `;
export const DataDisputeInfoFragmentDoc = gql`
    fragment DataDisputeInfo on DataDispute {
  id
  reason
  verificationRequest {
    id
    createdAt
    inboxItemId
  }
  employee {
    id
    user {
      id
      fullName
    }
  }
}
    `;
export const FileInfoFragmentDoc = gql`
    fragment FileInfo on File {
  id
  key
  filename
  downloadUrl
  updatedAt
  createdAt
  mime
  size
}
    `;
export const DataDisputeReportInfoFragmentDoc = gql`
    fragment DataDisputeReportInfo on DataDispute {
  id
  createdAt
  inboxItemId
  employee {
    id
    last4OfSsn
    user {
      id
      email
      fullName
      avatar {
        ...FileInfo
      }
    }
  }
  dataDisputeItemsList {
    id
    status
    employer {
      id
      displayName
      peo {
        id
        displayName
      }
    }
  }
}
    ${FileInfoFragmentDoc}`;
export const DisclaimerInfoFragmentDoc = gql`
    fragment DisclaimerInfo on Disclaimer {
  id
  name
  disclaimer
  titles
}
    `;
export const EmailActivityItemInfoFragmentDoc = gql`
    fragment EmailActivityItemInfo on EmailActivityItem {
  id
  from_email
  to_email
  subject
  status
  opens_count
  clicks_count
  last_event_time
}
    `;
export const EmployeeInfoForVerificationRequestItemFragmentDoc = gql`
    fragment EmployeeInfoForVerificationRequestItem on EmployeeInfoForVerificationRequest {
  id
  freeze
  fullName
  email
  phoneNumber
}
    `;
export const EmployeeForPeoAccessSearchInfoFragmentDoc = gql`
    fragment EmployeeForPeoAccessSearchInfo on EmployeeForPeoAccessSearch {
  id
  fullName
  last4OfSsn
  token
}
    `;
export const EmployeeDataUserInformationInfoFragmentDoc = gql`
    fragment EmployeeDataUserInformationInfo on EmployeeDataUserInformation {
  id
  email
  createdAt
  firstName
  lastName
  phoneNumber
  status
}
    `;
export const EmployeeDataEmploymentRecordInfoFragmentDoc = gql`
    fragment EmployeeDataEmploymentRecordInfo on EmployeeDataEmploymentRecord {
  employerId
  peoId
  employerDisplayName
  peoDisplayName
  employerRegisteredBusinessName
  employerFein
  employerEmployeeId
  employerLocation
  employerLocationAddress
  employerLogoUrl
  isEmployerLive
  isEmploymentActive
  employmentStatus
  employeeFirstName
  employeeLastName
  employeePositionTitle
  employeeLast4OfSsn
  employeeDateOfBirth
  employmentOriginalHireDate
  employmentMostRecentEmployment
  employmentTotalTimeWithEmployer
  employmentUpdatedAt
  averageHoursPerPayPeriod
  averageBasePay
  companyId
}
    `;
export const EmployeeDataInfoFragmentDoc = gql`
    fragment EmployeeDataInfo on EmployeeData {
  id
  last4OfSsn
  dataDeletedAt
  dataDeleteRequestSent
  user {
    ...EmployeeDataUserInformationInfo
  }
  employmentRecords {
    ...EmployeeDataEmploymentRecordInfo
  }
}
    ${EmployeeDataUserInformationInfoFragmentDoc}
${EmployeeDataEmploymentRecordInfoFragmentDoc}`;
export const EmployeeInviteEmailOptionInfoFragmentDoc = gql`
    fragment EmployeeInviteEmailOptionInfo on EmployeeInviteEmailOption {
  email
  firstName
  lastName
  middleName
  employerDisplayNames
}
    `;
export const EmployeeNoteInfoFragmentDoc = gql`
    fragment EmployeeNoteInfo on EmployeeNote {
  id
  employeeId
  createdAt
  comment
  createdBy
}
    `;
export const EmployeeSearchMatchInfoFragmentDoc = gql`
    fragment EmployeeSearchMatchInfo on EmployeeSearchMatch {
  last4OfSsn
  ssnEncrypted
  firstName
  lastName
  birthDate
  isPlatformUserExists
  isPlatformDataDeleted
}
    `;
export const RevenueShareSettingFragmentDoc = gql`
    fragment RevenueShareSetting on RevenueShareSetting {
  id
  revenueShareType
  revenueShareFlat
  revenueSharePercents
}
    `;
export const EmployerInfoFragmentDoc = gql`
    fragment EmployerInfo on Employer {
  id
  createdAt
  displayName
  contactEmail
  legalBusinessName
  numberOfEmployees
  corporateStructure
  industry
  contactPhoneNumber
  taxYearEndDate
  withdrawalSettings
  stripeAccountId
  requestAutoAccept
  signUpMethod
  disclaimer
  setLiveAt
  controlledBy
  keepOwnRevenueShare
  pinHint
  revenueShareSetting {
    ...RevenueShareSetting
  }
  logo {
    ...FileInfo
  }
  headquarters {
    ...AddressInfo
  }
  peo {
    id
    displayName
    companyType
    peoPayrollProvider {
      id
      companyType
    }
  }
  peoPayrollProvider {
    id
    displayName
    companyType
  }
}
    ${RevenueShareSettingFragmentDoc}
${FileInfoFragmentDoc}
${AddressInfoFragmentDoc}`;
export const EmployerTableItemFragmentDoc = gql`
    fragment EmployerTableItem on Employer {
  id
  displayName
  contactEmail
  contactPhoneNumber
  controlledBy
  setLiveAt
  numberOfEmployees
  logo {
    ...FileInfo
  }
  headquarters {
    ...AddressInfo
  }
  employerStaffsList {
    id
    role
    user {
      id
      status
    }
  }
  peo {
    id
    displayName
  }
  peoPayrollProvider {
    id
    displayName
  }
}
    ${FileInfoFragmentDoc}
${AddressInfoFragmentDoc}`;
export const EmployerSimpleInfoFragmentDoc = gql`
    fragment EmployerSimpleInfo on Employer {
  id
  displayName
  setLiveAt
  revenueShareSettingId
}
    `;
export const EmployerRevenueShareInfoFragmentDoc = gql`
    fragment EmployerRevenueShareInfo on Employer {
  id
  withdrawalSettings
  revenueShareReportEnabled
  revenueShareSetting {
    ...RevenueShareSetting
  }
}
    ${RevenueShareSettingFragmentDoc}`;
export const EmployerBasicInfoFragmentDoc = gql`
    fragment EmployerBasicInfo on GetEmployerBasicInfoResponse {
  id
  displayName
  signUpMethod
  pinHint
  logo {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export const EmployerListItemForVerificationRequestInfoFragmentDoc = gql`
    fragment EmployerListItemForVerificationRequestInfo on EmployerListItemForVerificationRequest {
  id
  topLevelCompanyId
  employeeId
  feinValue
  displayName
  isPayrollsAvailable
  checksum
}
    `;
export const UserItemFragmentDoc = gql`
    fragment UserItem on User {
  id
  email
  firstName
  lastName
  fullName
  phoneNumber
  status
  birthDate
  avatar {
    ...FileInfo
  }
}
    ${FileInfoFragmentDoc}`;
export const EmployerStaffInfoFragmentDoc = gql`
    fragment EmployerStaffInfo on EmployerStaff {
  id
  role
  user {
    ...UserItem
  }
  employer {
    id
    displayName
    controlledBy
    peo {
      id
      peoPayrollProviderId
    }
    peoPayrollProviderId
  }
}
    ${UserItemFragmentDoc}`;
export const EmploymentDataEmployeeInformationInfoFragmentDoc = gql`
    fragment EmploymentDataEmployeeInformationInfo on EmploymentDataEmployeeInformation {
  averageBaseWage
  averageHoursPerPayPeriod
  employmentStatus
  employmentType
  firstName
  fullName
  lastName
  mostRecentEmployment
  originalHireDate
  rateOfPay
  payFrequency
  ssn
  totalTimeWithEmployer
  employeeId
}
    `;
export const EmploymentDataHeadquartersAddressInfoFragmentDoc = gql`
    fragment EmploymentDataHeadquartersAddressInfo on EmploymentDataHeadquartersAddress {
  city
  state
  street
  zipCode
}
    `;
export const EmploymentDataPositionInformationInfoFragmentDoc = gql`
    fragment EmploymentDataPositionInformationInfo on EmploymentDataPositionInformation {
  division
  registeredBusinessName
  statusPosition
  title
}
    `;
export const EmploymentDataMetaInfoFragmentDoc = gql`
    fragment EmploymentDataMetaInfo on EmploymentDataMeta {
  companyId
  locationId
  employerId
  headquartersId
  consumerId
  positionId
  userId
  userStatus
  userEmail
  updatedAt
}
    `;
export const EmploymentDataCompanyInformationInfoFragmentDoc = gql`
    fragment EmploymentDataCompanyInformationInfo on EmploymentDataCompanyInformation {
  avatarUrl
  locationAddress
  fein
  registeredBusinessName
  locationName
  extLocationId
  displayName
}
    `;
export const EmploymentDataSummaryIncomeInformationInfoFragmentDoc = gql`
    fragment EmploymentDataSummaryIncomeInformationInfo on EmploymentDataSummaryIncomeInformation {
  year
  baseWage
  overtimeWage
  bonusesWage
  commissionWage
  holidayWage
  pension
  severance
  sickWage
  tips
  totalWage
  vacationWage
  ptoPayoutWage
  sickTimePayoutWage
  vacationTimePayoutWage
  miscWage
  otherWage
  ptoWage
  incentiveWage
}
    `;
export const EmploymentDataPayrollItemInfoFragmentDoc = gql`
    fragment EmploymentDataPayrollItemInfo on EmploymentDataPayrollItemsPayrollItem {
  id
  baseWage
  paymentDate
  paymentPeriodEnd
  grossHours
  overtimeHours
  overtimeWage
  commissionWage
  vacationWage
  sickWage
  bonusesWage
  holidayWage
  pension
  shiftDifferential
  severance
  tips
  stock
  mostRecentHireDate
  originalHireDate
  grossWage
  miscWage
  otherWage
  ptoWage
  incentiveWage
  ptoPayoutWage
  sickTimePayoutWage
  vacationTimePayoutWage
  rateOfPay
}
    `;
export const EmploymentDataBenefitInfoFragmentDoc = gql`
    fragment EmploymentDataBenefitInfo on EmploymentDataBenefitsInformationBenefitItem {
  id
  eligibleForDental
  enrolledInDental
  dentalInsuranceCarrier
  eligibleForMedical
  enrolledInMedical
  medicalInsuranceCarrier
}
    `;
export const EmploymentDataInfoFragmentDoc = gql`
    fragment EmploymentDataInfo on EmploymentData {
  employeeInformation {
    ...EmploymentDataEmployeeInformationInfo
  }
  headquartersAddress {
    ...EmploymentDataHeadquartersAddressInfo
  }
  positionInformation {
    ...EmploymentDataPositionInformationInfo
  }
  meta {
    ...EmploymentDataMetaInfo
  }
  companyInformation {
    ...EmploymentDataCompanyInformationInfo
  }
  summaryIncomeInformation {
    ...EmploymentDataSummaryIncomeInformationInfo
  }
  historicalIncomeInformation {
    count
    items {
      ...EmploymentDataPayrollItemInfo
    }
  }
  benefitsInformation {
    count
    items {
      ...EmploymentDataBenefitInfo
    }
  }
}
    ${EmploymentDataEmployeeInformationInfoFragmentDoc}
${EmploymentDataHeadquartersAddressInfoFragmentDoc}
${EmploymentDataPositionInformationInfoFragmentDoc}
${EmploymentDataMetaInfoFragmentDoc}
${EmploymentDataCompanyInformationInfoFragmentDoc}
${EmploymentDataSummaryIncomeInformationInfoFragmentDoc}
${EmploymentDataPayrollItemInfoFragmentDoc}
${EmploymentDataBenefitInfoFragmentDoc}`;
export const FileMetaResponseInfoFragmentDoc = gql`
    fragment FileMetaResponseInfo on FileMetaResponse {
  id
  updatedAt
  createdAt
  filename
  size
  mime
}
    `;
export const GeneratedReportMetaInfoFragmentDoc = gql`
    fragment GeneratedReportMetaInfo on GeneratedReportMeta {
  id
  createdAt
  employerId
  employerDisplayName
  feinValue
  file {
    ...FileMetaResponseInfo
  }
}
    ${FileMetaResponseInfoFragmentDoc}`;
export const InboxItemInfoFragmentDoc = gql`
    fragment InboxItemInfo on InboxItem {
  id
  type
}
    `;
export const InboxListItemInfoFragmentDoc = gql`
    fragment InboxListItemInfo on InboxListItem {
  id
  type
  createdAt
  updatedAt
  isUnread
  lastActivityDate
  lastActivityHeading
  subEntityType
  subEntityStatus
  employeeFullName
  employeeAvatarUrl
  verifierCompanyName
  verifierLogoUrl
  contributorCompanyName
  contributorLogoUrl
  permissiblePurposeId
  stripePaymentStatus
}
    `;
export const InboxItemRequestItemFragmentDoc = gql`
    fragment InboxItemRequestItem on InboxItemRequest {
  id
  type
  createdAt
  companyName
  contactName
  contactEmail
  verificationRequestType
  verificationRequestStatus
  dataDisputeStatus
}
    `;
export const IntegrationInfoFragmentDoc = gql`
    fragment IntegrationInfo on Integration {
  id
  name
  scope
  status
  clientId
  createdAt
  updatedAt
  ipLimitAttempts
  ipLimitWindow
  credentialsLimitAttempts
  credentialsLimitWindow
  verifierLimitAttempts
  verifierLimitWindow
  verifier {
    id
    displayName
  }
}
    `;
export const IntegrationUsageLogInfoFragmentDoc = gql`
    fragment IntegrationUsageLogInfo on IntegrationUsageLog {
  id
  createdAt
  finishedAt
  duration
  endpoint
  requestId
  requesterId
  status
  statusCode
  last4Ssn
  dateOfBirth
  errorMessage
  verified
  ambiguous
  noMatch
}
    `;
export const PartnershipInfoFragmentDoc = gql`
    fragment PartnershipInfo on PartnershipItem {
  id
  createdAt
  companyType
  displayName
  contactEmail
  contactPhoneNumber
  employerCount
  status
}
    `;
export const PeoInfoFragmentDoc = gql`
    fragment PeoInfo on Peo {
  id
  createdAt
  displayName
  contactEmail
  contactPhoneNumber
  fein
  numberOfEmployees
  corporateStructure
  taxYearEndDate
  defaultRequestAutoAccept
  defaultDisclaimer
  stripeAccountId
  employersLiveByDefaultSetAt
  industry
  disclaimer
  companyType
  logo {
    ...FileInfo
  }
  headquarters {
    ...AddressInfo
  }
  keepOwnRevenueShare
  revenueShareSetting {
    ...RevenueShareSetting
  }
  peoStaffsList {
    id
    role
    user {
      id
      status
    }
  }
  requestAutoAccept
  signUpMethod
  pinLength
  firstPinDigits
  lastPinDigits
  pinHint
  peoPayrollProvider {
    id
    displayName
    companyType
  }
}
    ${FileInfoFragmentDoc}
${AddressInfoFragmentDoc}
${RevenueShareSettingFragmentDoc}`;
export const PeoSimpleInfoFragmentDoc = gql`
    fragment PeoSimpleInfo on Peo {
  id
  displayName
}
    `;
export const PeoRevenueShareInfoFragmentDoc = gql`
    fragment PeoRevenueShareInfo on Peo {
  id
  revenueShareReportEnabled
  revenueShareSetting {
    ...RevenueShareSetting
  }
}
    ${RevenueShareSettingFragmentDoc}`;
export const PeoBasicInfoFragmentDoc = gql`
    fragment PeoBasicInfo on GetPeoBasicInfoResponse {
  id
  displayName
  signUpMethod
  pinHint
  logo {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export const PeoPayrollProviderInfoFragmentDoc = gql`
    fragment PeoPayrollProviderInfo on PeoPayrollProvider {
  id
  createdAt
  displayName
  contactEmail
  contactPhoneNumber
  fein
  numberOfEmployees
  industry
  corporateStructure
  taxYearEndDate
  defaultRequestAutoAccept
  defaultDisclaimer
  stripeAccountId
  signUpMethod
  companyType
  pinLength
  firstPinDigits
  lastPinDigits
  pinHint
  logo {
    ...FileInfo
  }
  headquarters {
    ...AddressInfo
  }
  revenueShareSetting {
    ...RevenueShareSetting
  }
  peoPayrollProviderStaffsList {
    id
    role
    user {
      id
      status
    }
  }
}
    ${FileInfoFragmentDoc}
${AddressInfoFragmentDoc}
${RevenueShareSettingFragmentDoc}`;
export const PeoPayrollProviderMinimalInfoFragmentDoc = gql`
    fragment PeoPayrollProviderMinimalInfo on PeoPayrollProvider {
  id
  displayName
}
    `;
export const PeoPayrollProviderRevenueShareInfoFragmentDoc = gql`
    fragment PeoPayrollProviderRevenueShareInfo on PeoPayrollProvider {
  id
  revenueShareReportEnabled
  revenueShareSetting {
    ...RevenueShareSetting
  }
}
    ${RevenueShareSettingFragmentDoc}`;
export const PeoPayrollProviderBasicInfoFragmentDoc = gql`
    fragment PeoPayrollProviderBasicInfo on GetPeoPayrollProviderBasicInfoResponse {
  id
  displayName
  signUpMethod
  pinHint
  logo {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export const PeoPayrollProviderStaffInfoFragmentDoc = gql`
    fragment PeoPayrollProviderStaffInfo on PeoPayrollProviderStaff {
  id
  role
  user {
    ...UserItem
  }
  peoPayrollProvider {
    id
    displayName
    revenueShareSetting {
      id
      revenueShareType
      revenueShareFlat
      revenueSharePercents
    }
  }
}
    ${UserItemFragmentDoc}`;
export const PeoStaffInfoFragmentDoc = gql`
    fragment PeoStaffInfo on PeoStaff {
  id
  role
  user {
    ...UserItem
  }
  peo {
    id
    displayName
    revenueShareSetting {
      id
      revenueShareType
      revenueShareFlat
      revenueSharePercents
    }
    peoPayrollProviderId
  }
}
    ${UserItemFragmentDoc}`;
export const PeoStaffMinimalInfoFragmentDoc = gql`
    fragment PeoStaffMinimalInfo on PeoStaff {
  id
  role
  peoId
  user {
    id
    email
    status
  }
}
    `;
export const PeoStaffAccessInfoItemFragmentDoc = gql`
    fragment PeoStaffAccessInfoItem on PeoStaffAccessInfo {
  id
  accessRestrictionMode
  blacklistedEmployeesList {
    id
    last4OfSsn
    fullName
  }
  blacklistedEmployersList {
    id
    displayName
  }
  whitelistedEmployersList {
    id
    displayName
  }
}
    `;
export const PermissiblePurposeByReferenceItemFragmentDoc = gql`
    fragment PermissiblePurposeByReferenceItem on PermissiblePurpose {
  id
  purposeValue
  createdAt
  status
  denialReason
}
    `;
export const PlatformStaffItemFragmentDoc = gql`
    fragment PlatformStaffItem on PlatformStaff {
  id
  role
  user {
    id
    email
    fullName
    firstName
    lastName
    phoneNumber
    status
    birthDate
    avatar {
      ...FileInfo
    }
  }
  isFinancialReportAvailable
  isAbleToManagePlatformStaff
  employersVisibleList {
    id
  }
  employersHiddenList {
    id
  }
}
    ${FileInfoFragmentDoc}`;
export const ResourceInfoFragmentDoc = gql`
    fragment ResourceInfo on Resource {
  id
  userRoleCategory
  iconName
  title
  description
  originType
  url
  file {
    ...FileInfo
  }
}
    ${FileInfoFragmentDoc}`;
export const StatesItemFragmentDoc = gql`
    fragment StatesItem on State {
  name
  abbreviation
  privacySetting
  deleteRequest
  createdAt
}
    `;
export const StripeBillingTransactionInfoFragmentDoc = gql`
    fragment StripeBillingTransactionInfo on StripeBillingTransaction {
  id
  createdAt
  amount
  verifierDisplayName
  verifierEmail
  description
  cardBrand
  cardLast4
  status
  receiptUrl
  isRefunded
}
    `;
export const TestVerificationRequestInfoFragmentDoc = gql`
    fragment TestVerificationRequestInfo on TestVerificationRequest {
  id
  createdAt
  type
  employeeId
  platformStaff {
    id
    user {
      id
      fullName
    }
  }
}
    `;
export const CurrentUserAddressInfoFragmentDoc = gql`
    fragment CurrentUserAddressInfo on CurrentUserAddress {
  id
  state
  county
  street
  apartment
  zipCode
  city
}
    `;
export const CurrentUserBaseInfoFragmentDoc = gql`
    fragment CurrentUserBaseInfo on CurrentUserResponse {
  id
  email
  firstName
  lastName
  timezone
  title
  createdAt
  lastPasswordChangeAt
  platformStaff {
    id
    role
  }
  verifierStaff {
    id
    role
    verifierId
  }
  peoPayrollProviderStaff {
    id
    role
    isPartnershipCompany
    peoPayrollProviderId
  }
  peoStaff {
    id
    role
    isPartnershipCompany
    peoId
  }
  employerStaff {
    id
    role
    employerId
  }
  employee {
    id
    role
  }
  address {
    ...CurrentUserAddressInfo
  }
}
    ${CurrentUserAddressInfoFragmentDoc}`;
export const VerificationRequestListItemFragmentDoc = gql`
    fragment VerificationRequestListItem on VerificationRequest {
  id
  createdAt
  type
  status
  isMyVerifyRequest
  permissiblePurposeId
  verifierStaffId
  employeeId
}
    `;
export const VerificationRequestForReportItemFragmentDoc = gql`
    fragment VerificationRequestForReportItem on VerificationRequestForReport {
  id
  createdAt
  type
  status
  inboxItemId
  employeeFullName
  employeeAvatar {
    ...FileResponseInfo
  }
  employers
  peos
  verifierDisplayName
  verifierStaffFullName
  permissiblePurposeLabel
}
    ${FileResponseInfoFragmentDoc}`;
export const VerificationRequestPaymentInfoFragmentDoc = gql`
    fragment VerificationRequestPaymentInfo on VerificationRequest {
  id
  stripePaymentStatus
  stripeFailedPaymentMessage
}
    `;
export const PermissiblePurposeReferenceItemFragmentDoc = gql`
    fragment PermissiblePurposeReferenceItem on PermissiblePurposeReference {
  id
  label
  verifierType
}
    `;
export const PermissiblePurposesItemFragmentDoc = gql`
    fragment PermissiblePurposesItem on PermissiblePurpose {
  id
  purposeValue
  createdAt
  status
  denialReason
  permissiblePurposeReference {
    ...PermissiblePurposeReferenceItem
  }
}
    ${PermissiblePurposeReferenceItemFragmentDoc}`;
export const VerifierInfoFragmentDoc = gql`
    fragment VerifierInfo on Verifier {
  id
  displayName
  contactEmail
  contactPhone
  logo {
    ...FileInfo
  }
  legalBusinessName
  type
  credentialStatus
  denialReason
  verifierStaffsList {
    id
    role
    user {
      id
      email
      lastName
      firstName
      status
    }
  }
  permissiblePurposesList {
    ...PermissiblePurposesItem
  }
  fEIN
}
    ${FileInfoFragmentDoc}
${PermissiblePurposesItemFragmentDoc}`;
export const VerifierDetailInfoFragmentDoc = gql`
    fragment VerifierDetailInfo on Verifier {
  id
  displayName
  contactEmail
  contactPhone
  logo {
    ...FileInfo
  }
  legalBusinessName
  type
  credentialStatus
  fEIN
  industry
  address {
    id
    county
    city
    state
    apartment
    street
    zipCode
  }
  websiteURL
  governmentEntityName
  typeOfGovernment
  department
  commercialName
  stripeCustomerId
  denialReason
}
    ${FileInfoFragmentDoc}`;
export const VerifierCredentialInfoFragmentDoc = gql`
    fragment VerifierCredentialInfo on Verifier {
  id
  createdAt
  credentialedAt
}
    `;
export const VerifierBillingRulesInfoFragmentDoc = gql`
    fragment VerifierBillingRulesInfo on Verifier {
  id
  verifierBilling {
    id
    voI
    voE
    reverification
  }
}
    `;
export const VerifierBasicItemInfoFragmentDoc = gql`
    fragment VerifierBasicItemInfo on VerifierBasicItem {
  id
  displayName
}
    `;
export const VerifierStaffItemFragmentDoc = gql`
    fragment VerifierStaffItem on VerifierStaff {
  id
  role
  stripeCustomerId
  verifier {
    id
    legalBusinessName
    type
    stripeCustomerId
  }
  user {
    id
    email
    lastName
    firstName
    phoneNumber
    birthDate
    status
  }
}
    `;
export const VerifierStaffWithBillingInfoFragmentDoc = gql`
    fragment VerifierStaffWithBillingInfo on VerifierStaff {
  id
  verifier {
    id
    verifierBilling {
      id
      voI
      voE
      reverification
    }
  }
}
    `;
export const AccountPersonalInformationDocument = gql`
    query AccountPersonalInformation($userId: ID!) {
  user(where: {id: $userId}) {
    ...AccountPersonalInformationFragment
  }
}
    ${AccountPersonalInformationFragmentFragmentDoc}`;

/**
 * __useAccountPersonalInformationQuery__
 *
 * To run a query within a React component, call `useAccountPersonalInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPersonalInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPersonalInformationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountPersonalInformationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AccountPersonalInformationQuery,
    AccountPersonalInformationQueryVariables
  > &
    ({ variables: AccountPersonalInformationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountPersonalInformationQuery, AccountPersonalInformationQueryVariables>(
    AccountPersonalInformationDocument,
    options,
  );
}
export function useAccountPersonalInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountPersonalInformationQuery,
    AccountPersonalInformationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountPersonalInformationQuery,
    AccountPersonalInformationQueryVariables
  >(AccountPersonalInformationDocument, options);
}
// @ts-ignore
export function useAccountPersonalInformationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountPersonalInformationQuery,
    AccountPersonalInformationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AccountPersonalInformationQuery,
  AccountPersonalInformationQueryVariables
>;
export function useAccountPersonalInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountPersonalInformationQuery,
        AccountPersonalInformationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountPersonalInformationQuery | undefined,
  AccountPersonalInformationQueryVariables
>;
export function useAccountPersonalInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountPersonalInformationQuery,
        AccountPersonalInformationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AccountPersonalInformationQuery,
    AccountPersonalInformationQueryVariables
  >(AccountPersonalInformationDocument, options);
}
export type AccountPersonalInformationQueryHookResult = ReturnType<
  typeof useAccountPersonalInformationQuery
>;
export type AccountPersonalInformationLazyQueryHookResult = ReturnType<
  typeof useAccountPersonalInformationLazyQuery
>;
export type AccountPersonalInformationSuspenseQueryHookResult = ReturnType<
  typeof useAccountPersonalInformationSuspenseQuery
>;
export type AccountPersonalInformationQueryResult = Apollo.QueryResult<
  AccountPersonalInformationQuery,
  AccountPersonalInformationQueryVariables
>;
export const AccountPersonalInformationUpdateDocument = gql`
    mutation AccountPersonalInformationUpdate($data: UserUpdate!, $where: UserWhereUnique!) {
  userUpdate(data: $data, where: $where) {
    ...AccountPersonalInformationFragment
  }
}
    ${AccountPersonalInformationFragmentFragmentDoc}`;
export type AccountPersonalInformationUpdateMutationFn = Apollo.MutationFunction<
  AccountPersonalInformationUpdateMutation,
  AccountPersonalInformationUpdateMutationVariables
>;

/**
 * __useAccountPersonalInformationUpdateMutation__
 *
 * To run a mutation, you first call `useAccountPersonalInformationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPersonalInformationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPersonalInformationUpdateMutation, { data, loading, error }] = useAccountPersonalInformationUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAccountPersonalInformationUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccountPersonalInformationUpdateMutation,
    AccountPersonalInformationUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AccountPersonalInformationUpdateMutation,
    AccountPersonalInformationUpdateMutationVariables
  >(AccountPersonalInformationUpdateDocument, options);
}
export type AccountPersonalInformationUpdateMutationHookResult = ReturnType<
  typeof useAccountPersonalInformationUpdateMutation
>;
export type AccountPersonalInformationUpdateMutationResult =
  Apollo.MutationResult<AccountPersonalInformationUpdateMutation>;
export type AccountPersonalInformationUpdateMutationOptions = Apollo.BaseMutationOptions<
  AccountPersonalInformationUpdateMutation,
  AccountPersonalInformationUpdateMutationVariables
>;
export const GetActivityLogsListDocument = gql`
    query GetActivityLogsList($inboxItemId: ID!) {
  getActivityLogsList(inboxItemId: $inboxItemId) {
    ...ActivityLogItem
  }
}
    ${ActivityLogItemFragmentDoc}`;

/**
 * __useGetActivityLogsListQuery__
 *
 * To run a query within a React component, call `useGetActivityLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogsListQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useGetActivityLogsListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivityLogsListQuery,
    GetActivityLogsListQueryVariables
  > &
    ({ variables: GetActivityLogsListQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActivityLogsListQuery, GetActivityLogsListQueryVariables>(
    GetActivityLogsListDocument,
    options,
  );
}
export function useGetActivityLogsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivityLogsListQuery,
    GetActivityLogsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActivityLogsListQuery, GetActivityLogsListQueryVariables>(
    GetActivityLogsListDocument,
    options,
  );
}
// @ts-ignore
export function useGetActivityLogsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActivityLogsListQuery,
    GetActivityLogsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActivityLogsListQuery, GetActivityLogsListQueryVariables>;
export function useGetActivityLogsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActivityLogsListQuery, GetActivityLogsListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetActivityLogsListQuery | undefined,
  GetActivityLogsListQueryVariables
>;
export function useGetActivityLogsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActivityLogsListQuery, GetActivityLogsListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActivityLogsListQuery, GetActivityLogsListQueryVariables>(
    GetActivityLogsListDocument,
    options,
  );
}
export type GetActivityLogsListQueryHookResult = ReturnType<typeof useGetActivityLogsListQuery>;
export type GetActivityLogsListLazyQueryHookResult = ReturnType<
  typeof useGetActivityLogsListLazyQuery
>;
export type GetActivityLogsListSuspenseQueryHookResult = ReturnType<
  typeof useGetActivityLogsListSuspenseQuery
>;
export type GetActivityLogsListQueryResult = Apollo.QueryResult<
  GetActivityLogsListQuery,
  GetActivityLogsListQueryVariables
>;
export const ActivityLogDeleteDocument = gql`
    mutation ActivityLogDelete($where: ActivityLogWhereUnique!) {
  activityLogDelete(where: $where)
}
    `;
export type ActivityLogDeleteMutationFn = Apollo.MutationFunction<
  ActivityLogDeleteMutation,
  ActivityLogDeleteMutationVariables
>;

/**
 * __useActivityLogDeleteMutation__
 *
 * To run a mutation, you first call `useActivityLogDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityLogDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityLogDeleteMutation, { data, loading, error }] = useActivityLogDeleteMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useActivityLogDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivityLogDeleteMutation,
    ActivityLogDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivityLogDeleteMutation, ActivityLogDeleteMutationVariables>(
    ActivityLogDeleteDocument,
    options,
  );
}
export type ActivityLogDeleteMutationHookResult = ReturnType<typeof useActivityLogDeleteMutation>;
export type ActivityLogDeleteMutationResult = Apollo.MutationResult<ActivityLogDeleteMutation>;
export type ActivityLogDeleteMutationOptions = Apollo.BaseMutationOptions<
  ActivityLogDeleteMutation,
  ActivityLogDeleteMutationVariables
>;
export const ApiVerificationRequestDocument = gql`
    query ApiVerificationRequest($where: ApiVerificationRequestWhereUnique!) {
  apiVerificationRequest(where: $where) {
    ...ApiVerificationRequestInfo
  }
}
    ${ApiVerificationRequestInfoFragmentDoc}`;

/**
 * __useApiVerificationRequestQuery__
 *
 * To run a query within a React component, call `useApiVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiVerificationRequestQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useApiVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApiVerificationRequestQuery,
    ApiVerificationRequestQueryVariables
  > &
    ({ variables: ApiVerificationRequestQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApiVerificationRequestQuery, ApiVerificationRequestQueryVariables>(
    ApiVerificationRequestDocument,
    options,
  );
}
export function useApiVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApiVerificationRequestQuery,
    ApiVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ApiVerificationRequestQuery, ApiVerificationRequestQueryVariables>(
    ApiVerificationRequestDocument,
    options,
  );
}
// @ts-ignore
export function useApiVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApiVerificationRequestQuery,
    ApiVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ApiVerificationRequestQuery, ApiVerificationRequestQueryVariables>;
export function useApiVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiVerificationRequestQuery,
        ApiVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ApiVerificationRequestQuery | undefined,
  ApiVerificationRequestQueryVariables
>;
export function useApiVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiVerificationRequestQuery,
        ApiVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ApiVerificationRequestQuery, ApiVerificationRequestQueryVariables>(
    ApiVerificationRequestDocument,
    options,
  );
}
export type ApiVerificationRequestQueryHookResult = ReturnType<
  typeof useApiVerificationRequestQuery
>;
export type ApiVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useApiVerificationRequestLazyQuery
>;
export type ApiVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useApiVerificationRequestSuspenseQuery
>;
export type ApiVerificationRequestQueryResult = Apollo.QueryResult<
  ApiVerificationRequestQuery,
  ApiVerificationRequestQueryVariables
>;
export const GetVerifierInfoByApiVerificationRequestDocument = gql`
    query GetVerifierInfoByApiVerificationRequest($inboxItemId: ID!) {
  getVerifierInfoByApiVerificationRequest(inboxItemId: $inboxItemId) {
    id
    credentialStatus
    type
    logo {
      downloadUrl
    }
    displayName
    contactEmail
    contactPhone
  }
}
    `;

/**
 * __useGetVerifierInfoByApiVerificationRequestQuery__
 *
 * To run a query within a React component, call `useGetVerifierInfoByApiVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifierInfoByApiVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifierInfoByApiVerificationRequestQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useGetVerifierInfoByApiVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVerifierInfoByApiVerificationRequestQuery,
    GetVerifierInfoByApiVerificationRequestQueryVariables
  > &
    (
      | { variables: GetVerifierInfoByApiVerificationRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVerifierInfoByApiVerificationRequestQuery,
    GetVerifierInfoByApiVerificationRequestQueryVariables
  >(GetVerifierInfoByApiVerificationRequestDocument, options);
}
export function useGetVerifierInfoByApiVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVerifierInfoByApiVerificationRequestQuery,
    GetVerifierInfoByApiVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVerifierInfoByApiVerificationRequestQuery,
    GetVerifierInfoByApiVerificationRequestQueryVariables
  >(GetVerifierInfoByApiVerificationRequestDocument, options);
}
// @ts-ignore
export function useGetVerifierInfoByApiVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVerifierInfoByApiVerificationRequestQuery,
    GetVerifierInfoByApiVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetVerifierInfoByApiVerificationRequestQuery,
  GetVerifierInfoByApiVerificationRequestQueryVariables
>;
export function useGetVerifierInfoByApiVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVerifierInfoByApiVerificationRequestQuery,
        GetVerifierInfoByApiVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetVerifierInfoByApiVerificationRequestQuery | undefined,
  GetVerifierInfoByApiVerificationRequestQueryVariables
>;
export function useGetVerifierInfoByApiVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVerifierInfoByApiVerificationRequestQuery,
        GetVerifierInfoByApiVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetVerifierInfoByApiVerificationRequestQuery,
    GetVerifierInfoByApiVerificationRequestQueryVariables
  >(GetVerifierInfoByApiVerificationRequestDocument, options);
}
export type GetVerifierInfoByApiVerificationRequestQueryHookResult = ReturnType<
  typeof useGetVerifierInfoByApiVerificationRequestQuery
>;
export type GetVerifierInfoByApiVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useGetVerifierInfoByApiVerificationRequestLazyQuery
>;
export type GetVerifierInfoByApiVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useGetVerifierInfoByApiVerificationRequestSuspenseQuery
>;
export type GetVerifierInfoByApiVerificationRequestQueryResult = Apollo.QueryResult<
  GetVerifierInfoByApiVerificationRequestQuery,
  GetVerifierInfoByApiVerificationRequestQueryVariables
>;
export const AttestationsListDocument = gql`
    query AttestationsList($filter: AttestationWhere) {
  attestationList(where: $filter) {
    id
    name
    text
    purpose
    pdf {
      ...FileInfo
    }
  }
}
    ${FileInfoFragmentDoc}`;

/**
 * __useAttestationsListQuery__
 *
 * To run a query within a React component, call `useAttestationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttestationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttestationsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttestationsListQuery(
  baseOptions?: Apollo.QueryHookOptions<AttestationsListQuery, AttestationsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttestationsListQuery, AttestationsListQueryVariables>(
    AttestationsListDocument,
    options,
  );
}
export function useAttestationsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AttestationsListQuery, AttestationsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttestationsListQuery, AttestationsListQueryVariables>(
    AttestationsListDocument,
    options,
  );
}
// @ts-ignore
export function useAttestationsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttestationsListQuery,
    AttestationsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AttestationsListQuery, AttestationsListQueryVariables>;
export function useAttestationsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttestationsListQuery, AttestationsListQueryVariables>,
): Apollo.UseSuspenseQueryResult<AttestationsListQuery | undefined, AttestationsListQueryVariables>;
export function useAttestationsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttestationsListQuery, AttestationsListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttestationsListQuery, AttestationsListQueryVariables>(
    AttestationsListDocument,
    options,
  );
}
export type AttestationsListQueryHookResult = ReturnType<typeof useAttestationsListQuery>;
export type AttestationsListLazyQueryHookResult = ReturnType<typeof useAttestationsListLazyQuery>;
export type AttestationsListSuspenseQueryHookResult = ReturnType<
  typeof useAttestationsListSuspenseQuery
>;
export type AttestationsListQueryResult = Apollo.QueryResult<
  AttestationsListQuery,
  AttestationsListQueryVariables
>;
export const VerifierBillingListDocument = gql`
    query VerifierBillingList($filter: VerifierBillingWhere, $first: Int, $skip: Int, $orderBy: [VerifierBillingOrderBy!]) {
  verifierBillingList(
    where: $filter
    take: $first
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    voI
    voE
    reverification
    verifier {
      ...VerifierDetailInfo
    }
  }
  verifierBillingCount(where: $filter)
}
    ${VerifierDetailInfoFragmentDoc}`;

/**
 * __useVerifierBillingListQuery__
 *
 * To run a query within a React component, call `useVerifierBillingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierBillingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierBillingListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useVerifierBillingListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VerifierBillingListQuery,
    VerifierBillingListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierBillingListQuery, VerifierBillingListQueryVariables>(
    VerifierBillingListDocument,
    options,
  );
}
export function useVerifierBillingListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifierBillingListQuery,
    VerifierBillingListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierBillingListQuery, VerifierBillingListQueryVariables>(
    VerifierBillingListDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierBillingListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifierBillingListQuery,
    VerifierBillingListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerifierBillingListQuery, VerifierBillingListQueryVariables>;
export function useVerifierBillingListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierBillingListQuery, VerifierBillingListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VerifierBillingListQuery | undefined,
  VerifierBillingListQueryVariables
>;
export function useVerifierBillingListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierBillingListQuery, VerifierBillingListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierBillingListQuery, VerifierBillingListQueryVariables>(
    VerifierBillingListDocument,
    options,
  );
}
export type VerifierBillingListQueryHookResult = ReturnType<typeof useVerifierBillingListQuery>;
export type VerifierBillingListLazyQueryHookResult = ReturnType<
  typeof useVerifierBillingListLazyQuery
>;
export type VerifierBillingListSuspenseQueryHookResult = ReturnType<
  typeof useVerifierBillingListSuspenseQuery
>;
export type VerifierBillingListQueryResult = Apollo.QueryResult<
  VerifierBillingListQuery,
  VerifierBillingListQueryVariables
>;
export const VerifierBillingUpdateDocument = gql`
    mutation VerifierBillingUpdate($data: VerifierBillingUpdate!, $where: VerifierBillingWhereUnique!) {
  verifierBillingUpdate(data: $data, where: $where) {
    id
  }
}
    `;
export type VerifierBillingUpdateMutationFn = Apollo.MutationFunction<
  VerifierBillingUpdateMutation,
  VerifierBillingUpdateMutationVariables
>;

/**
 * __useVerifierBillingUpdateMutation__
 *
 * To run a mutation, you first call `useVerifierBillingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifierBillingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifierBillingUpdateMutation, { data, loading, error }] = useVerifierBillingUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVerifierBillingUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifierBillingUpdateMutation,
    VerifierBillingUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifierBillingUpdateMutation, VerifierBillingUpdateMutationVariables>(
    VerifierBillingUpdateDocument,
    options,
  );
}
export type VerifierBillingUpdateMutationHookResult = ReturnType<
  typeof useVerifierBillingUpdateMutation
>;
export type VerifierBillingUpdateMutationResult =
  Apollo.MutationResult<VerifierBillingUpdateMutation>;
export type VerifierBillingUpdateMutationOptions = Apollo.BaseMutationOptions<
  VerifierBillingUpdateMutation,
  VerifierBillingUpdateMutationVariables
>;
export const VerifierBillingBulkUpdateDocument = gql`
    mutation VerifierBillingBulkUpdate($data: VerifierBillingUpdateMany!, $filter: VerifierBillingWhere!) {
  verifierBillingUpdateMany(data: $data, where: $filter)
}
    `;
export type VerifierBillingBulkUpdateMutationFn = Apollo.MutationFunction<
  VerifierBillingBulkUpdateMutation,
  VerifierBillingBulkUpdateMutationVariables
>;

/**
 * __useVerifierBillingBulkUpdateMutation__
 *
 * To run a mutation, you first call `useVerifierBillingBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifierBillingBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifierBillingBulkUpdateMutation, { data, loading, error }] = useVerifierBillingBulkUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVerifierBillingBulkUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifierBillingBulkUpdateMutation,
    VerifierBillingBulkUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifierBillingBulkUpdateMutation,
    VerifierBillingBulkUpdateMutationVariables
  >(VerifierBillingBulkUpdateDocument, options);
}
export type VerifierBillingBulkUpdateMutationHookResult = ReturnType<
  typeof useVerifierBillingBulkUpdateMutation
>;
export type VerifierBillingBulkUpdateMutationResult =
  Apollo.MutationResult<VerifierBillingBulkUpdateMutation>;
export type VerifierBillingBulkUpdateMutationOptions = Apollo.BaseMutationOptions<
  VerifierBillingBulkUpdateMutation,
  VerifierBillingBulkUpdateMutationVariables
>;
export const GetRevenueShareSettingsListWithStripeStatusesDocument = gql`
    query getRevenueShareSettingsListWithStripeStatuses($filter: RevenueShareSettingWhere, $first: Int, $skip: Int, $orderBy: [RevenueShareSettingOrderBy!]) {
  getRevenueShareSettingsListWithStripeStatuses(
    where: $filter
    take: $first
    skip: $skip
    orderBy: $orderBy
  ) {
    count
    items {
      stripeStatus
      revenueShareSetting {
        id
        createdAt
        updatedAt
        revenueShareType
        revenueSharePercents
        revenueShareFlat
        revenueShareRecipient
        employer {
          ...EmployerInfo
        }
      }
    }
  }
}
    ${EmployerInfoFragmentDoc}`;

/**
 * __useGetRevenueShareSettingsListWithStripeStatusesQuery__
 *
 * To run a query within a React component, call `useGetRevenueShareSettingsListWithStripeStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueShareSettingsListWithStripeStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueShareSettingsListWithStripeStatusesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetRevenueShareSettingsListWithStripeStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRevenueShareSettingsListWithStripeStatusesQuery,
    GetRevenueShareSettingsListWithStripeStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRevenueShareSettingsListWithStripeStatusesQuery,
    GetRevenueShareSettingsListWithStripeStatusesQueryVariables
  >(GetRevenueShareSettingsListWithStripeStatusesDocument, options);
}
export function useGetRevenueShareSettingsListWithStripeStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRevenueShareSettingsListWithStripeStatusesQuery,
    GetRevenueShareSettingsListWithStripeStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRevenueShareSettingsListWithStripeStatusesQuery,
    GetRevenueShareSettingsListWithStripeStatusesQueryVariables
  >(GetRevenueShareSettingsListWithStripeStatusesDocument, options);
}
// @ts-ignore
export function useGetRevenueShareSettingsListWithStripeStatusesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRevenueShareSettingsListWithStripeStatusesQuery,
    GetRevenueShareSettingsListWithStripeStatusesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRevenueShareSettingsListWithStripeStatusesQuery,
  GetRevenueShareSettingsListWithStripeStatusesQueryVariables
>;
export function useGetRevenueShareSettingsListWithStripeStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRevenueShareSettingsListWithStripeStatusesQuery,
        GetRevenueShareSettingsListWithStripeStatusesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRevenueShareSettingsListWithStripeStatusesQuery | undefined,
  GetRevenueShareSettingsListWithStripeStatusesQueryVariables
>;
export function useGetRevenueShareSettingsListWithStripeStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRevenueShareSettingsListWithStripeStatusesQuery,
        GetRevenueShareSettingsListWithStripeStatusesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRevenueShareSettingsListWithStripeStatusesQuery,
    GetRevenueShareSettingsListWithStripeStatusesQueryVariables
  >(GetRevenueShareSettingsListWithStripeStatusesDocument, options);
}
export type GetRevenueShareSettingsListWithStripeStatusesQueryHookResult = ReturnType<
  typeof useGetRevenueShareSettingsListWithStripeStatusesQuery
>;
export type GetRevenueShareSettingsListWithStripeStatusesLazyQueryHookResult = ReturnType<
  typeof useGetRevenueShareSettingsListWithStripeStatusesLazyQuery
>;
export type GetRevenueShareSettingsListWithStripeStatusesSuspenseQueryHookResult = ReturnType<
  typeof useGetRevenueShareSettingsListWithStripeStatusesSuspenseQuery
>;
export type GetRevenueShareSettingsListWithStripeStatusesQueryResult = Apollo.QueryResult<
  GetRevenueShareSettingsListWithStripeStatusesQuery,
  GetRevenueShareSettingsListWithStripeStatusesQueryVariables
>;
export const RevenueShareSettingUpdateDocument = gql`
    mutation RevenueShareSettingUpdate($data: RevenueShareSettingUpdate!, $where: RevenueShareSettingWhereUnique!) {
  revenueShareSettingUpdate(data: $data, where: $where) {
    id
  }
}
    `;
export type RevenueShareSettingUpdateMutationFn = Apollo.MutationFunction<
  RevenueShareSettingUpdateMutation,
  RevenueShareSettingUpdateMutationVariables
>;

/**
 * __useRevenueShareSettingUpdateMutation__
 *
 * To run a mutation, you first call `useRevenueShareSettingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevenueShareSettingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revenueShareSettingUpdateMutation, { data, loading, error }] = useRevenueShareSettingUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRevenueShareSettingUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevenueShareSettingUpdateMutation,
    RevenueShareSettingUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevenueShareSettingUpdateMutation,
    RevenueShareSettingUpdateMutationVariables
  >(RevenueShareSettingUpdateDocument, options);
}
export type RevenueShareSettingUpdateMutationHookResult = ReturnType<
  typeof useRevenueShareSettingUpdateMutation
>;
export type RevenueShareSettingUpdateMutationResult =
  Apollo.MutationResult<RevenueShareSettingUpdateMutation>;
export type RevenueShareSettingUpdateMutationOptions = Apollo.BaseMutationOptions<
  RevenueShareSettingUpdateMutation,
  RevenueShareSettingUpdateMutationVariables
>;
export const RevenueShareSettingBulkUpdateDocument = gql`
    mutation RevenueShareSettingBulkUpdate($data: RevenueShareSettingUpdateMany!, $filter: RevenueShareSettingWhere!) {
  revenueShareSettingUpdateMany(data: $data, where: $filter)
}
    `;
export type RevenueShareSettingBulkUpdateMutationFn = Apollo.MutationFunction<
  RevenueShareSettingBulkUpdateMutation,
  RevenueShareSettingBulkUpdateMutationVariables
>;

/**
 * __useRevenueShareSettingBulkUpdateMutation__
 *
 * To run a mutation, you first call `useRevenueShareSettingBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevenueShareSettingBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revenueShareSettingBulkUpdateMutation, { data, loading, error }] = useRevenueShareSettingBulkUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRevenueShareSettingBulkUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevenueShareSettingBulkUpdateMutation,
    RevenueShareSettingBulkUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevenueShareSettingBulkUpdateMutation,
    RevenueShareSettingBulkUpdateMutationVariables
  >(RevenueShareSettingBulkUpdateDocument, options);
}
export type RevenueShareSettingBulkUpdateMutationHookResult = ReturnType<
  typeof useRevenueShareSettingBulkUpdateMutation
>;
export type RevenueShareSettingBulkUpdateMutationResult =
  Apollo.MutationResult<RevenueShareSettingBulkUpdateMutation>;
export type RevenueShareSettingBulkUpdateMutationOptions = Apollo.BaseMutationOptions<
  RevenueShareSettingBulkUpdateMutation,
  RevenueShareSettingBulkUpdateMutationVariables
>;
export const RevenueShareSettingDeleteMutationDocument = gql`
    mutation RevenueShareSettingDeleteMutation($filter: RevenueShareSettingWhereUnique!) {
  revenueShareSettingDelete(where: $filter)
}
    `;
export type RevenueShareSettingDeleteMutationMutationFn = Apollo.MutationFunction<
  RevenueShareSettingDeleteMutationMutation,
  RevenueShareSettingDeleteMutationMutationVariables
>;

/**
 * __useRevenueShareSettingDeleteMutationMutation__
 *
 * To run a mutation, you first call `useRevenueShareSettingDeleteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevenueShareSettingDeleteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revenueShareSettingDeleteMutationMutation, { data, loading, error }] = useRevenueShareSettingDeleteMutationMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRevenueShareSettingDeleteMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevenueShareSettingDeleteMutationMutation,
    RevenueShareSettingDeleteMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevenueShareSettingDeleteMutationMutation,
    RevenueShareSettingDeleteMutationMutationVariables
  >(RevenueShareSettingDeleteMutationDocument, options);
}
export type RevenueShareSettingDeleteMutationMutationHookResult = ReturnType<
  typeof useRevenueShareSettingDeleteMutationMutation
>;
export type RevenueShareSettingDeleteMutationMutationResult =
  Apollo.MutationResult<RevenueShareSettingDeleteMutationMutation>;
export type RevenueShareSettingDeleteMutationMutationOptions = Apollo.BaseMutationOptions<
  RevenueShareSettingDeleteMutationMutation,
  RevenueShareSettingDeleteMutationMutationVariables
>;
export const InitialBillingRulesUpdateDocument = gql`
    mutation InitialBillingRulesUpdate($data: InitialBillingUpdate!) {
  updateInitialBillingRules(initialBilling: $data) {
    ...InitialBillingRulesInfo
  }
}
    ${InitialBillingRulesInfoFragmentDoc}`;
export type InitialBillingRulesUpdateMutationFn = Apollo.MutationFunction<
  InitialBillingRulesUpdateMutation,
  InitialBillingRulesUpdateMutationVariables
>;

/**
 * __useInitialBillingRulesUpdateMutation__
 *
 * To run a mutation, you first call `useInitialBillingRulesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitialBillingRulesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initialBillingRulesUpdateMutation, { data, loading, error }] = useInitialBillingRulesUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInitialBillingRulesUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitialBillingRulesUpdateMutation,
    InitialBillingRulesUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitialBillingRulesUpdateMutation,
    InitialBillingRulesUpdateMutationVariables
  >(InitialBillingRulesUpdateDocument, options);
}
export type InitialBillingRulesUpdateMutationHookResult = ReturnType<
  typeof useInitialBillingRulesUpdateMutation
>;
export type InitialBillingRulesUpdateMutationResult =
  Apollo.MutationResult<InitialBillingRulesUpdateMutation>;
export type InitialBillingRulesUpdateMutationOptions = Apollo.BaseMutationOptions<
  InitialBillingRulesUpdateMutation,
  InitialBillingRulesUpdateMutationVariables
>;
export const InitialBillingRulesDocument = gql`
    query InitialBillingRules {
  initialBillingList {
    ...InitialBillingRulesInfo
  }
}
    ${InitialBillingRulesInfoFragmentDoc}`;

/**
 * __useInitialBillingRulesQuery__
 *
 * To run a query within a React component, call `useInitialBillingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialBillingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialBillingRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitialBillingRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InitialBillingRulesQuery,
    InitialBillingRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InitialBillingRulesQuery, InitialBillingRulesQueryVariables>(
    InitialBillingRulesDocument,
    options,
  );
}
export function useInitialBillingRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InitialBillingRulesQuery,
    InitialBillingRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InitialBillingRulesQuery, InitialBillingRulesQueryVariables>(
    InitialBillingRulesDocument,
    options,
  );
}
// @ts-ignore
export function useInitialBillingRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InitialBillingRulesQuery,
    InitialBillingRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InitialBillingRulesQuery, InitialBillingRulesQueryVariables>;
export function useInitialBillingRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InitialBillingRulesQuery, InitialBillingRulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  InitialBillingRulesQuery | undefined,
  InitialBillingRulesQueryVariables
>;
export function useInitialBillingRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InitialBillingRulesQuery, InitialBillingRulesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InitialBillingRulesQuery, InitialBillingRulesQueryVariables>(
    InitialBillingRulesDocument,
    options,
  );
}
export type InitialBillingRulesQueryHookResult = ReturnType<typeof useInitialBillingRulesQuery>;
export type InitialBillingRulesLazyQueryHookResult = ReturnType<
  typeof useInitialBillingRulesLazyQuery
>;
export type InitialBillingRulesSuspenseQueryHookResult = ReturnType<
  typeof useInitialBillingRulesSuspenseQuery
>;
export type InitialBillingRulesQueryResult = Apollo.QueryResult<
  InitialBillingRulesQuery,
  InitialBillingRulesQueryVariables
>;
export const ServerBuildVersionDocument = gql`
    query ServerBuildVersion {
  buildVersion
}
    `;

/**
 * __useServerBuildVersionQuery__
 *
 * To run a query within a React component, call `useServerBuildVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerBuildVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerBuildVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerBuildVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>(
    ServerBuildVersionDocument,
    options,
  );
}
export function useServerBuildVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerBuildVersionQuery,
    ServerBuildVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>(
    ServerBuildVersionDocument,
    options,
  );
}
// @ts-ignore
export function useServerBuildVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerBuildVersionQuery,
    ServerBuildVersionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>;
export function useServerBuildVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ServerBuildVersionQuery | undefined,
  ServerBuildVersionQueryVariables
>;
export function useServerBuildVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ServerBuildVersionQuery, ServerBuildVersionQueryVariables>(
    ServerBuildVersionDocument,
    options,
  );
}
export type ServerBuildVersionQueryHookResult = ReturnType<typeof useServerBuildVersionQuery>;
export type ServerBuildVersionLazyQueryHookResult = ReturnType<
  typeof useServerBuildVersionLazyQuery
>;
export type ServerBuildVersionSuspenseQueryHookResult = ReturnType<
  typeof useServerBuildVersionSuspenseQuery
>;
export type ServerBuildVersionQueryResult = Apollo.QueryResult<
  ServerBuildVersionQuery,
  ServerBuildVersionQueryVariables
>;
export const CognitoGetSsoUrlDocument = gql`
    query cognitoGetSsoUrl {
  cognitoGetSsoUrl
}
    `;

/**
 * __useCognitoGetSsoUrlQuery__
 *
 * To run a query within a React component, call `useCognitoGetSsoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCognitoGetSsoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCognitoGetSsoUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCognitoGetSsoUrlQuery(
  baseOptions?: Apollo.QueryHookOptions<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>(
    CognitoGetSsoUrlDocument,
    options,
  );
}
export function useCognitoGetSsoUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>(
    CognitoGetSsoUrlDocument,
    options,
  );
}
// @ts-ignore
export function useCognitoGetSsoUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CognitoGetSsoUrlQuery,
    CognitoGetSsoUrlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>;
export function useCognitoGetSsoUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>,
): Apollo.UseSuspenseQueryResult<CognitoGetSsoUrlQuery | undefined, CognitoGetSsoUrlQueryVariables>;
export function useCognitoGetSsoUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CognitoGetSsoUrlQuery, CognitoGetSsoUrlQueryVariables>(
    CognitoGetSsoUrlDocument,
    options,
  );
}
export type CognitoGetSsoUrlQueryHookResult = ReturnType<typeof useCognitoGetSsoUrlQuery>;
export type CognitoGetSsoUrlLazyQueryHookResult = ReturnType<typeof useCognitoGetSsoUrlLazyQuery>;
export type CognitoGetSsoUrlSuspenseQueryHookResult = ReturnType<
  typeof useCognitoGetSsoUrlSuspenseQuery
>;
export type CognitoGetSsoUrlQueryResult = Apollo.QueryResult<
  CognitoGetSsoUrlQuery,
  CognitoGetSsoUrlQueryVariables
>;
export const CognitoGetUserMfaStatusDocument = gql`
    query cognitoGetUserMfaStatus($userId: ID!) {
  cognitoGetUserMfaStatus(userId: $userId) {
    mfaEnabled
  }
}
    `;

/**
 * __useCognitoGetUserMfaStatusQuery__
 *
 * To run a query within a React component, call `useCognitoGetUserMfaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCognitoGetUserMfaStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCognitoGetUserMfaStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCognitoGetUserMfaStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    CognitoGetUserMfaStatusQuery,
    CognitoGetUserMfaStatusQueryVariables
  > &
    ({ variables: CognitoGetUserMfaStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CognitoGetUserMfaStatusQuery, CognitoGetUserMfaStatusQueryVariables>(
    CognitoGetUserMfaStatusDocument,
    options,
  );
}
export function useCognitoGetUserMfaStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CognitoGetUserMfaStatusQuery,
    CognitoGetUserMfaStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CognitoGetUserMfaStatusQuery, CognitoGetUserMfaStatusQueryVariables>(
    CognitoGetUserMfaStatusDocument,
    options,
  );
}
// @ts-ignore
export function useCognitoGetUserMfaStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CognitoGetUserMfaStatusQuery,
    CognitoGetUserMfaStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CognitoGetUserMfaStatusQuery,
  CognitoGetUserMfaStatusQueryVariables
>;
export function useCognitoGetUserMfaStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CognitoGetUserMfaStatusQuery,
        CognitoGetUserMfaStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CognitoGetUserMfaStatusQuery | undefined,
  CognitoGetUserMfaStatusQueryVariables
>;
export function useCognitoGetUserMfaStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CognitoGetUserMfaStatusQuery,
        CognitoGetUserMfaStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CognitoGetUserMfaStatusQuery,
    CognitoGetUserMfaStatusQueryVariables
  >(CognitoGetUserMfaStatusDocument, options);
}
export type CognitoGetUserMfaStatusQueryHookResult = ReturnType<
  typeof useCognitoGetUserMfaStatusQuery
>;
export type CognitoGetUserMfaStatusLazyQueryHookResult = ReturnType<
  typeof useCognitoGetUserMfaStatusLazyQuery
>;
export type CognitoGetUserMfaStatusSuspenseQueryHookResult = ReturnType<
  typeof useCognitoGetUserMfaStatusSuspenseQuery
>;
export type CognitoGetUserMfaStatusQueryResult = Apollo.QueryResult<
  CognitoGetUserMfaStatusQuery,
  CognitoGetUserMfaStatusQueryVariables
>;
export const CognitoGetCurrentUserAuthStatusDocument = gql`
    query cognitoGetCurrentUserAuthStatus {
  cognitoGetCurrentUserAuthStatus {
    mfaRequired
    mfaEnabled
    ssoEnabled
  }
}
    `;

/**
 * __useCognitoGetCurrentUserAuthStatusQuery__
 *
 * To run a query within a React component, call `useCognitoGetCurrentUserAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCognitoGetCurrentUserAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCognitoGetCurrentUserAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCognitoGetCurrentUserAuthStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CognitoGetCurrentUserAuthStatusQuery,
    CognitoGetCurrentUserAuthStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CognitoGetCurrentUserAuthStatusQuery,
    CognitoGetCurrentUserAuthStatusQueryVariables
  >(CognitoGetCurrentUserAuthStatusDocument, options);
}
export function useCognitoGetCurrentUserAuthStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CognitoGetCurrentUserAuthStatusQuery,
    CognitoGetCurrentUserAuthStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CognitoGetCurrentUserAuthStatusQuery,
    CognitoGetCurrentUserAuthStatusQueryVariables
  >(CognitoGetCurrentUserAuthStatusDocument, options);
}
// @ts-ignore
export function useCognitoGetCurrentUserAuthStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CognitoGetCurrentUserAuthStatusQuery,
    CognitoGetCurrentUserAuthStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CognitoGetCurrentUserAuthStatusQuery,
  CognitoGetCurrentUserAuthStatusQueryVariables
>;
export function useCognitoGetCurrentUserAuthStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CognitoGetCurrentUserAuthStatusQuery,
        CognitoGetCurrentUserAuthStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CognitoGetCurrentUserAuthStatusQuery | undefined,
  CognitoGetCurrentUserAuthStatusQueryVariables
>;
export function useCognitoGetCurrentUserAuthStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CognitoGetCurrentUserAuthStatusQuery,
        CognitoGetCurrentUserAuthStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CognitoGetCurrentUserAuthStatusQuery,
    CognitoGetCurrentUserAuthStatusQueryVariables
  >(CognitoGetCurrentUserAuthStatusDocument, options);
}
export type CognitoGetCurrentUserAuthStatusQueryHookResult = ReturnType<
  typeof useCognitoGetCurrentUserAuthStatusQuery
>;
export type CognitoGetCurrentUserAuthStatusLazyQueryHookResult = ReturnType<
  typeof useCognitoGetCurrentUserAuthStatusLazyQuery
>;
export type CognitoGetCurrentUserAuthStatusSuspenseQueryHookResult = ReturnType<
  typeof useCognitoGetCurrentUserAuthStatusSuspenseQuery
>;
export type CognitoGetCurrentUserAuthStatusQueryResult = Apollo.QueryResult<
  CognitoGetCurrentUserAuthStatusQuery,
  CognitoGetCurrentUserAuthStatusQueryVariables
>;
export const CognitoDisableUserMfaDocument = gql`
    mutation cognitoDisableUserMfa($userId: ID!) {
  cognitoDisableUserMfa(userId: $userId) {
    success
  }
}
    `;
export type CognitoDisableUserMfaMutationFn = Apollo.MutationFunction<
  CognitoDisableUserMfaMutation,
  CognitoDisableUserMfaMutationVariables
>;

/**
 * __useCognitoDisableUserMfaMutation__
 *
 * To run a mutation, you first call `useCognitoDisableUserMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCognitoDisableUserMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cognitoDisableUserMfaMutation, { data, loading, error }] = useCognitoDisableUserMfaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCognitoDisableUserMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CognitoDisableUserMfaMutation,
    CognitoDisableUserMfaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CognitoDisableUserMfaMutation, CognitoDisableUserMfaMutationVariables>(
    CognitoDisableUserMfaDocument,
    options,
  );
}
export type CognitoDisableUserMfaMutationHookResult = ReturnType<
  typeof useCognitoDisableUserMfaMutation
>;
export type CognitoDisableUserMfaMutationResult =
  Apollo.MutationResult<CognitoDisableUserMfaMutation>;
export type CognitoDisableUserMfaMutationOptions = Apollo.BaseMutationOptions<
  CognitoDisableUserMfaMutation,
  CognitoDisableUserMfaMutationVariables
>;
export const ConsumerDocument = gql`
    query Consumer($id: ID!) {
  employee(where: {id: $id}) {
    ...EmployeeItem
  }
}
    ${EmployeeItemFragmentDoc}`;

/**
 * __useConsumerQuery__
 *
 * To run a query within a React component, call `useConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsumerQuery(
  baseOptions: Apollo.QueryHookOptions<ConsumerQuery, ConsumerQueryVariables> &
    ({ variables: ConsumerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConsumerQuery, ConsumerQueryVariables>(ConsumerDocument, options);
}
export function useConsumerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConsumerQuery, ConsumerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConsumerQuery, ConsumerQueryVariables>(ConsumerDocument, options);
}
// @ts-ignore
export function useConsumerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ConsumerQuery, ConsumerQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConsumerQuery, ConsumerQueryVariables>;
export function useConsumerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConsumerQuery, ConsumerQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConsumerQuery | undefined, ConsumerQueryVariables>;
export function useConsumerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConsumerQuery, ConsumerQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConsumerQuery, ConsumerQueryVariables>(ConsumerDocument, options);
}
export type ConsumerQueryHookResult = ReturnType<typeof useConsumerQuery>;
export type ConsumerLazyQueryHookResult = ReturnType<typeof useConsumerLazyQuery>;
export type ConsumerSuspenseQueryHookResult = ReturnType<typeof useConsumerSuspenseQuery>;
export type ConsumerQueryResult = Apollo.QueryResult<ConsumerQuery, ConsumerQueryVariables>;
export const EmployeeRegistrationDocument = gql`
    mutation EmployeeRegistration($employeeSignupToken: String!, $requestAutoApprove: Boolean!, $user: NewEmployeeUserData!) {
  userRegistrationEmployee(
    employeeSignupToken: $employeeSignupToken
    requestAutoApprove: $requestAutoApprove
    user: $user
  ) {
    idToken
    accessToken
  }
}
    `;
export type EmployeeRegistrationMutationFn = Apollo.MutationFunction<
  EmployeeRegistrationMutation,
  EmployeeRegistrationMutationVariables
>;

/**
 * __useEmployeeRegistrationMutation__
 *
 * To run a mutation, you first call `useEmployeeRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeRegistrationMutation, { data, loading, error }] = useEmployeeRegistrationMutation({
 *   variables: {
 *      employeeSignupToken: // value for 'employeeSignupToken'
 *      requestAutoApprove: // value for 'requestAutoApprove'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useEmployeeRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployeeRegistrationMutation,
    EmployeeRegistrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmployeeRegistrationMutation, EmployeeRegistrationMutationVariables>(
    EmployeeRegistrationDocument,
    options,
  );
}
export type EmployeeRegistrationMutationHookResult = ReturnType<
  typeof useEmployeeRegistrationMutation
>;
export type EmployeeRegistrationMutationResult =
  Apollo.MutationResult<EmployeeRegistrationMutation>;
export type EmployeeRegistrationMutationOptions = Apollo.BaseMutationOptions<
  EmployeeRegistrationMutation,
  EmployeeRegistrationMutationVariables
>;
export const ConsumerUpdateDocument = gql`
    mutation ConsumerUpdate($data: EmployeeUpdate!, $where: EmployeeWhereUnique!) {
  employeeUpdate(data: $data, where: $where) {
    id
  }
}
    `;
export type ConsumerUpdateMutationFn = Apollo.MutationFunction<
  ConsumerUpdateMutation,
  ConsumerUpdateMutationVariables
>;

/**
 * __useConsumerUpdateMutation__
 *
 * To run a mutation, you first call `useConsumerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerUpdateMutation, { data, loading, error }] = useConsumerUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useConsumerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>(
    ConsumerUpdateDocument,
    options,
  );
}
export type ConsumerUpdateMutationHookResult = ReturnType<typeof useConsumerUpdateMutation>;
export type ConsumerUpdateMutationResult = Apollo.MutationResult<ConsumerUpdateMutation>;
export type ConsumerUpdateMutationOptions = Apollo.BaseMutationOptions<
  ConsumerUpdateMutation,
  ConsumerUpdateMutationVariables
>;
export const GetDashboardReportAndRevenueDocument = gql`
    query GetDashboardReportAndRevenue($employerIds: [ID!]!) {
  getDashboardReportAndRevenue(employerIds: $employerIds) {
    dashboardReportData {
      activeRecordAmount
      inactiveRecordAmount
      resolvedDataDisputeAmount
      pendingDataDisputeAmount
    }
    dashboardRevenueShareData {
      revenueSharePayedAmount
      revenueShareOwedAmount
    }
  }
}
    `;

/**
 * __useGetDashboardReportAndRevenueQuery__
 *
 * To run a query within a React component, call `useGetDashboardReportAndRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardReportAndRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardReportAndRevenueQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *   },
 * });
 */
export function useGetDashboardReportAndRevenueQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardReportAndRevenueQuery,
    GetDashboardReportAndRevenueQueryVariables
  > &
    ({ variables: GetDashboardReportAndRevenueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardReportAndRevenueQuery,
    GetDashboardReportAndRevenueQueryVariables
  >(GetDashboardReportAndRevenueDocument, options);
}
export function useGetDashboardReportAndRevenueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardReportAndRevenueQuery,
    GetDashboardReportAndRevenueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardReportAndRevenueQuery,
    GetDashboardReportAndRevenueQueryVariables
  >(GetDashboardReportAndRevenueDocument, options);
}
// @ts-ignore
export function useGetDashboardReportAndRevenueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardReportAndRevenueQuery,
    GetDashboardReportAndRevenueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardReportAndRevenueQuery,
  GetDashboardReportAndRevenueQueryVariables
>;
export function useGetDashboardReportAndRevenueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardReportAndRevenueQuery,
        GetDashboardReportAndRevenueQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardReportAndRevenueQuery | undefined,
  GetDashboardReportAndRevenueQueryVariables
>;
export function useGetDashboardReportAndRevenueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardReportAndRevenueQuery,
        GetDashboardReportAndRevenueQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardReportAndRevenueQuery,
    GetDashboardReportAndRevenueQueryVariables
  >(GetDashboardReportAndRevenueDocument, options);
}
export type GetDashboardReportAndRevenueQueryHookResult = ReturnType<
  typeof useGetDashboardReportAndRevenueQuery
>;
export type GetDashboardReportAndRevenueLazyQueryHookResult = ReturnType<
  typeof useGetDashboardReportAndRevenueLazyQuery
>;
export type GetDashboardReportAndRevenueSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardReportAndRevenueSuspenseQuery
>;
export type GetDashboardReportAndRevenueQueryResult = Apollo.QueryResult<
  GetDashboardReportAndRevenueQuery,
  GetDashboardReportAndRevenueQueryVariables
>;
export const GetDashboardUsageReportsDocument = gql`
    query GetDashboardUsageReports($employerIds: [ID!], $peoIds: [ID!], $from: DateTime!, $to: DateTime!) {
  getDashboardUsageReports(
    employerIds: $employerIds
    peoIds: $peoIds
    from: $from
    to: $to
  ) {
    ...DashboardUsageReportItemInfo
  }
}
    ${DashboardUsageReportItemInfoFragmentDoc}`;

/**
 * __useGetDashboardUsageReportsQuery__
 *
 * To run a query within a React component, call `useGetDashboardUsageReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardUsageReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardUsageReportsQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetDashboardUsageReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardUsageReportsQuery,
    GetDashboardUsageReportsQueryVariables
  > &
    ({ variables: GetDashboardUsageReportsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDashboardUsageReportsQuery, GetDashboardUsageReportsQueryVariables>(
    GetDashboardUsageReportsDocument,
    options,
  );
}
export function useGetDashboardUsageReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardUsageReportsQuery,
    GetDashboardUsageReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDashboardUsageReportsQuery, GetDashboardUsageReportsQueryVariables>(
    GetDashboardUsageReportsDocument,
    options,
  );
}
// @ts-ignore
export function useGetDashboardUsageReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardUsageReportsQuery,
    GetDashboardUsageReportsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardUsageReportsQuery,
  GetDashboardUsageReportsQueryVariables
>;
export function useGetDashboardUsageReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardUsageReportsQuery,
        GetDashboardUsageReportsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardUsageReportsQuery | undefined,
  GetDashboardUsageReportsQueryVariables
>;
export function useGetDashboardUsageReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardUsageReportsQuery,
        GetDashboardUsageReportsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardUsageReportsQuery,
    GetDashboardUsageReportsQueryVariables
  >(GetDashboardUsageReportsDocument, options);
}
export type GetDashboardUsageReportsQueryHookResult = ReturnType<
  typeof useGetDashboardUsageReportsQuery
>;
export type GetDashboardUsageReportsLazyQueryHookResult = ReturnType<
  typeof useGetDashboardUsageReportsLazyQuery
>;
export type GetDashboardUsageReportsSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardUsageReportsSuspenseQuery
>;
export type GetDashboardUsageReportsQueryResult = Apollo.QueryResult<
  GetDashboardUsageReportsQuery,
  GetDashboardUsageReportsQueryVariables
>;
export const GetDashboardWorkLetterUsageDocument = gql`
    query GetDashboardWorkLetterUsage($employerIds: [ID!], $peoIds: [ID!], $from: DateTime!, $to: DateTime!) {
  getDashboardWorkLetterUsage(
    employerIds: $employerIds
    peoIds: $peoIds
    from: $from
    to: $to
  ) {
    ...DashboardWorkLetterUsageItemInfo
  }
}
    ${DashboardWorkLetterUsageItemInfoFragmentDoc}`;

/**
 * __useGetDashboardWorkLetterUsageQuery__
 *
 * To run a query within a React component, call `useGetDashboardWorkLetterUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardWorkLetterUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardWorkLetterUsageQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetDashboardWorkLetterUsageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardWorkLetterUsageQuery,
    GetDashboardWorkLetterUsageQueryVariables
  > &
    ({ variables: GetDashboardWorkLetterUsageQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardWorkLetterUsageQuery,
    GetDashboardWorkLetterUsageQueryVariables
  >(GetDashboardWorkLetterUsageDocument, options);
}
export function useGetDashboardWorkLetterUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardWorkLetterUsageQuery,
    GetDashboardWorkLetterUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardWorkLetterUsageQuery,
    GetDashboardWorkLetterUsageQueryVariables
  >(GetDashboardWorkLetterUsageDocument, options);
}
// @ts-ignore
export function useGetDashboardWorkLetterUsageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardWorkLetterUsageQuery,
    GetDashboardWorkLetterUsageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardWorkLetterUsageQuery,
  GetDashboardWorkLetterUsageQueryVariables
>;
export function useGetDashboardWorkLetterUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardWorkLetterUsageQuery,
        GetDashboardWorkLetterUsageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardWorkLetterUsageQuery | undefined,
  GetDashboardWorkLetterUsageQueryVariables
>;
export function useGetDashboardWorkLetterUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardWorkLetterUsageQuery,
        GetDashboardWorkLetterUsageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardWorkLetterUsageQuery,
    GetDashboardWorkLetterUsageQueryVariables
  >(GetDashboardWorkLetterUsageDocument, options);
}
export type GetDashboardWorkLetterUsageQueryHookResult = ReturnType<
  typeof useGetDashboardWorkLetterUsageQuery
>;
export type GetDashboardWorkLetterUsageLazyQueryHookResult = ReturnType<
  typeof useGetDashboardWorkLetterUsageLazyQuery
>;
export type GetDashboardWorkLetterUsageSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardWorkLetterUsageSuspenseQuery
>;
export type GetDashboardWorkLetterUsageQueryResult = Apollo.QueryResult<
  GetDashboardWorkLetterUsageQuery,
  GetDashboardWorkLetterUsageQueryVariables
>;
export const GetDashboardRecordsActivityDocument = gql`
    query GetDashboardRecordsActivity($employerIds: [String!], $peoIds: [String!]) {
  getDashboardRecordsActivity(employerIds: $employerIds, peoIds: $peoIds) {
    active {
      Active
      FMLA
      IFMLA
      Intern
      On_Leave
    }
    inactive {
      Inactive
      Deceased
      Retired
      Separated
      Terminated
      Temporarily_Inactive
      Severed_With_Pay
      Unknown
    }
  }
}
    `;

/**
 * __useGetDashboardRecordsActivityQuery__
 *
 * To run a query within a React component, call `useGetDashboardRecordsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardRecordsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardRecordsActivityQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *   },
 * });
 */
export function useGetDashboardRecordsActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardRecordsActivityQuery,
    GetDashboardRecordsActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardRecordsActivityQuery,
    GetDashboardRecordsActivityQueryVariables
  >(GetDashboardRecordsActivityDocument, options);
}
export function useGetDashboardRecordsActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardRecordsActivityQuery,
    GetDashboardRecordsActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardRecordsActivityQuery,
    GetDashboardRecordsActivityQueryVariables
  >(GetDashboardRecordsActivityDocument, options);
}
// @ts-ignore
export function useGetDashboardRecordsActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardRecordsActivityQuery,
    GetDashboardRecordsActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardRecordsActivityQuery,
  GetDashboardRecordsActivityQueryVariables
>;
export function useGetDashboardRecordsActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardRecordsActivityQuery,
        GetDashboardRecordsActivityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardRecordsActivityQuery | undefined,
  GetDashboardRecordsActivityQueryVariables
>;
export function useGetDashboardRecordsActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardRecordsActivityQuery,
        GetDashboardRecordsActivityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardRecordsActivityQuery,
    GetDashboardRecordsActivityQueryVariables
  >(GetDashboardRecordsActivityDocument, options);
}
export type GetDashboardRecordsActivityQueryHookResult = ReturnType<
  typeof useGetDashboardRecordsActivityQuery
>;
export type GetDashboardRecordsActivityLazyQueryHookResult = ReturnType<
  typeof useGetDashboardRecordsActivityLazyQuery
>;
export type GetDashboardRecordsActivitySuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardRecordsActivitySuspenseQuery
>;
export type GetDashboardRecordsActivityQueryResult = Apollo.QueryResult<
  GetDashboardRecordsActivityQuery,
  GetDashboardRecordsActivityQueryVariables
>;
export const GetDashboardLastUploadRolesDocument = gql`
    query GetDashboardLastUploadRoles($employerId: ID, $peoId: ID) {
  getDashboardLastUploadRoles(employerId: $employerId, peoId: $peoId) {
    rolesCount
    uploadedAt
  }
}
    `;

/**
 * __useGetDashboardLastUploadRolesQuery__
 *
 * To run a query within a React component, call `useGetDashboardLastUploadRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardLastUploadRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardLastUploadRolesQuery({
 *   variables: {
 *      employerId: // value for 'employerId'
 *      peoId: // value for 'peoId'
 *   },
 * });
 */
export function useGetDashboardLastUploadRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardLastUploadRolesQuery,
    GetDashboardLastUploadRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardLastUploadRolesQuery,
    GetDashboardLastUploadRolesQueryVariables
  >(GetDashboardLastUploadRolesDocument, options);
}
export function useGetDashboardLastUploadRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardLastUploadRolesQuery,
    GetDashboardLastUploadRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardLastUploadRolesQuery,
    GetDashboardLastUploadRolesQueryVariables
  >(GetDashboardLastUploadRolesDocument, options);
}
// @ts-ignore
export function useGetDashboardLastUploadRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardLastUploadRolesQuery,
    GetDashboardLastUploadRolesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardLastUploadRolesQuery,
  GetDashboardLastUploadRolesQueryVariables
>;
export function useGetDashboardLastUploadRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardLastUploadRolesQuery,
        GetDashboardLastUploadRolesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardLastUploadRolesQuery | undefined,
  GetDashboardLastUploadRolesQueryVariables
>;
export function useGetDashboardLastUploadRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardLastUploadRolesQuery,
        GetDashboardLastUploadRolesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardLastUploadRolesQuery,
    GetDashboardLastUploadRolesQueryVariables
  >(GetDashboardLastUploadRolesDocument, options);
}
export type GetDashboardLastUploadRolesQueryHookResult = ReturnType<
  typeof useGetDashboardLastUploadRolesQuery
>;
export type GetDashboardLastUploadRolesLazyQueryHookResult = ReturnType<
  typeof useGetDashboardLastUploadRolesLazyQuery
>;
export type GetDashboardLastUploadRolesSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardLastUploadRolesSuspenseQuery
>;
export type GetDashboardLastUploadRolesQueryResult = Apollo.QueryResult<
  GetDashboardLastUploadRolesQuery,
  GetDashboardLastUploadRolesQueryVariables
>;
export const GetDashboardCvRevenueByVerificationTypeDocument = gql`
    query GetDashboardCVRevenueByVerificationType($employerIds: [ID!], $peoIds: [ID!], $from: Date!, $to: Date!) {
  getDashboardCVRevenueByVerificationType(
    employerIds: $employerIds
    peoIds: $peoIds
    from: $from
    to: $to
  ) {
    ...DashboardCvRevenueByVerificationTypeItemInfo
  }
}
    ${DashboardCvRevenueByVerificationTypeItemInfoFragmentDoc}`;

/**
 * __useGetDashboardCvRevenueByVerificationTypeQuery__
 *
 * To run a query within a React component, call `useGetDashboardCvRevenueByVerificationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCvRevenueByVerificationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCvRevenueByVerificationTypeQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetDashboardCvRevenueByVerificationTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardCvRevenueByVerificationTypeQuery,
    GetDashboardCvRevenueByVerificationTypeQueryVariables
  > &
    (
      | { variables: GetDashboardCvRevenueByVerificationTypeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardCvRevenueByVerificationTypeQuery,
    GetDashboardCvRevenueByVerificationTypeQueryVariables
  >(GetDashboardCvRevenueByVerificationTypeDocument, options);
}
export function useGetDashboardCvRevenueByVerificationTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardCvRevenueByVerificationTypeQuery,
    GetDashboardCvRevenueByVerificationTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardCvRevenueByVerificationTypeQuery,
    GetDashboardCvRevenueByVerificationTypeQueryVariables
  >(GetDashboardCvRevenueByVerificationTypeDocument, options);
}
// @ts-ignore
export function useGetDashboardCvRevenueByVerificationTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardCvRevenueByVerificationTypeQuery,
    GetDashboardCvRevenueByVerificationTypeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardCvRevenueByVerificationTypeQuery,
  GetDashboardCvRevenueByVerificationTypeQueryVariables
>;
export function useGetDashboardCvRevenueByVerificationTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardCvRevenueByVerificationTypeQuery,
        GetDashboardCvRevenueByVerificationTypeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardCvRevenueByVerificationTypeQuery | undefined,
  GetDashboardCvRevenueByVerificationTypeQueryVariables
>;
export function useGetDashboardCvRevenueByVerificationTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardCvRevenueByVerificationTypeQuery,
        GetDashboardCvRevenueByVerificationTypeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardCvRevenueByVerificationTypeQuery,
    GetDashboardCvRevenueByVerificationTypeQueryVariables
  >(GetDashboardCvRevenueByVerificationTypeDocument, options);
}
export type GetDashboardCvRevenueByVerificationTypeQueryHookResult = ReturnType<
  typeof useGetDashboardCvRevenueByVerificationTypeQuery
>;
export type GetDashboardCvRevenueByVerificationTypeLazyQueryHookResult = ReturnType<
  typeof useGetDashboardCvRevenueByVerificationTypeLazyQuery
>;
export type GetDashboardCvRevenueByVerificationTypeSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardCvRevenueByVerificationTypeSuspenseQuery
>;
export type GetDashboardCvRevenueByVerificationTypeQueryResult = Apollo.QueryResult<
  GetDashboardCvRevenueByVerificationTypeQuery,
  GetDashboardCvRevenueByVerificationTypeQueryVariables
>;
export const GetDashboardPlatformAdminRevenueDistributionsDocument = gql`
    query GetDashboardPlatformAdminRevenueDistributions($employerIds: [ID!], $peoIds: [ID!], $from: DateTime!, $to: DateTime!) {
  getDashboardPlatformAdminRevenueDistributions(
    peoIds: $peoIds
    employerIds: $employerIds
    from: $from
    to: $to
  ) {
    ...DashboardPlatformAdminRevenueDistributionItemInfo
  }
}
    ${DashboardPlatformAdminRevenueDistributionItemInfoFragmentDoc}`;

/**
 * __useGetDashboardPlatformAdminRevenueDistributionsQuery__
 *
 * To run a query within a React component, call `useGetDashboardPlatformAdminRevenueDistributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardPlatformAdminRevenueDistributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardPlatformAdminRevenueDistributionsQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetDashboardPlatformAdminRevenueDistributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardPlatformAdminRevenueDistributionsQuery,
    GetDashboardPlatformAdminRevenueDistributionsQueryVariables
  > &
    (
      | { variables: GetDashboardPlatformAdminRevenueDistributionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardPlatformAdminRevenueDistributionsQuery,
    GetDashboardPlatformAdminRevenueDistributionsQueryVariables
  >(GetDashboardPlatformAdminRevenueDistributionsDocument, options);
}
export function useGetDashboardPlatformAdminRevenueDistributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardPlatformAdminRevenueDistributionsQuery,
    GetDashboardPlatformAdminRevenueDistributionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardPlatformAdminRevenueDistributionsQuery,
    GetDashboardPlatformAdminRevenueDistributionsQueryVariables
  >(GetDashboardPlatformAdminRevenueDistributionsDocument, options);
}
// @ts-ignore
export function useGetDashboardPlatformAdminRevenueDistributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardPlatformAdminRevenueDistributionsQuery,
    GetDashboardPlatformAdminRevenueDistributionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardPlatformAdminRevenueDistributionsQuery,
  GetDashboardPlatformAdminRevenueDistributionsQueryVariables
>;
export function useGetDashboardPlatformAdminRevenueDistributionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardPlatformAdminRevenueDistributionsQuery,
        GetDashboardPlatformAdminRevenueDistributionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardPlatformAdminRevenueDistributionsQuery | undefined,
  GetDashboardPlatformAdminRevenueDistributionsQueryVariables
>;
export function useGetDashboardPlatformAdminRevenueDistributionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardPlatformAdminRevenueDistributionsQuery,
        GetDashboardPlatformAdminRevenueDistributionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardPlatformAdminRevenueDistributionsQuery,
    GetDashboardPlatformAdminRevenueDistributionsQueryVariables
  >(GetDashboardPlatformAdminRevenueDistributionsDocument, options);
}
export type GetDashboardPlatformAdminRevenueDistributionsQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminRevenueDistributionsQuery
>;
export type GetDashboardPlatformAdminRevenueDistributionsLazyQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminRevenueDistributionsLazyQuery
>;
export type GetDashboardPlatformAdminRevenueDistributionsSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminRevenueDistributionsSuspenseQuery
>;
export type GetDashboardPlatformAdminRevenueDistributionsQueryResult = Apollo.QueryResult<
  GetDashboardPlatformAdminRevenueDistributionsQuery,
  GetDashboardPlatformAdminRevenueDistributionsQueryVariables
>;
export const GetDashboardPlatformAdminFinancialDataDocument = gql`
    query GetDashboardPlatformAdminFinancialData($asOfDate: DateTime!, $employerIds: [String!], $peoIds: [String!]) {
  getDashboardPlatformAdminFinancialData(
    asOfDate: $asOfDate
    employerIds: $employerIds
    peoIds: $peoIds
  ) {
    voe
    voi
    reverification
    commercialVerifications
    valueOfRecord
    platformRevenue
    revenueSharePaid
    revenueShareOwed
  }
}
    `;

/**
 * __useGetDashboardPlatformAdminFinancialDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardPlatformAdminFinancialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardPlatformAdminFinancialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardPlatformAdminFinancialDataQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *   },
 * });
 */
export function useGetDashboardPlatformAdminFinancialDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardPlatformAdminFinancialDataQuery,
    GetDashboardPlatformAdminFinancialDataQueryVariables
  > &
    (
      | { variables: GetDashboardPlatformAdminFinancialDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardPlatformAdminFinancialDataQuery,
    GetDashboardPlatformAdminFinancialDataQueryVariables
  >(GetDashboardPlatformAdminFinancialDataDocument, options);
}
export function useGetDashboardPlatformAdminFinancialDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardPlatformAdminFinancialDataQuery,
    GetDashboardPlatformAdminFinancialDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardPlatformAdminFinancialDataQuery,
    GetDashboardPlatformAdminFinancialDataQueryVariables
  >(GetDashboardPlatformAdminFinancialDataDocument, options);
}
// @ts-ignore
export function useGetDashboardPlatformAdminFinancialDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardPlatformAdminFinancialDataQuery,
    GetDashboardPlatformAdminFinancialDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardPlatformAdminFinancialDataQuery,
  GetDashboardPlatformAdminFinancialDataQueryVariables
>;
export function useGetDashboardPlatformAdminFinancialDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardPlatformAdminFinancialDataQuery,
        GetDashboardPlatformAdminFinancialDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardPlatformAdminFinancialDataQuery | undefined,
  GetDashboardPlatformAdminFinancialDataQueryVariables
>;
export function useGetDashboardPlatformAdminFinancialDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardPlatformAdminFinancialDataQuery,
        GetDashboardPlatformAdminFinancialDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardPlatformAdminFinancialDataQuery,
    GetDashboardPlatformAdminFinancialDataQueryVariables
  >(GetDashboardPlatformAdminFinancialDataDocument, options);
}
export type GetDashboardPlatformAdminFinancialDataQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminFinancialDataQuery
>;
export type GetDashboardPlatformAdminFinancialDataLazyQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminFinancialDataLazyQuery
>;
export type GetDashboardPlatformAdminFinancialDataSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminFinancialDataSuspenseQuery
>;
export type GetDashboardPlatformAdminFinancialDataQueryResult = Apollo.QueryResult<
  GetDashboardPlatformAdminFinancialDataQuery,
  GetDashboardPlatformAdminFinancialDataQueryVariables
>;
export const GetDashboardVerificationRequestsCountGroupedByStatusDocument = gql`
    query GetDashboardVerificationRequestsCountGroupedByStatus($employerIds: [ID!], $peoIds: [ID!], $asOfDate: DateTime!) {
  getDashboardVerificationRequestsCountGroupedByStatus(
    employerIds: $employerIds
    peoIds: $peoIds
    asOfDate: $asOfDate
  ) {
    ...DashboardVerificationRequestsCountGroupByStatusInfo
  }
}
    ${DashboardVerificationRequestsCountGroupByStatusInfoFragmentDoc}`;

/**
 * __useGetDashboardVerificationRequestsCountGroupedByStatusQuery__
 *
 * To run a query within a React component, call `useGetDashboardVerificationRequestsCountGroupedByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardVerificationRequestsCountGroupedByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardVerificationRequestsCountGroupedByStatusQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetDashboardVerificationRequestsCountGroupedByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardVerificationRequestsCountGroupedByStatusQuery,
    GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
  > &
    (
      | {
          variables: GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardVerificationRequestsCountGroupedByStatusQuery,
    GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
  >(GetDashboardVerificationRequestsCountGroupedByStatusDocument, options);
}
export function useGetDashboardVerificationRequestsCountGroupedByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardVerificationRequestsCountGroupedByStatusQuery,
    GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardVerificationRequestsCountGroupedByStatusQuery,
    GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
  >(GetDashboardVerificationRequestsCountGroupedByStatusDocument, options);
}
// @ts-ignore
export function useGetDashboardVerificationRequestsCountGroupedByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardVerificationRequestsCountGroupedByStatusQuery,
    GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardVerificationRequestsCountGroupedByStatusQuery,
  GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
>;
export function useGetDashboardVerificationRequestsCountGroupedByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardVerificationRequestsCountGroupedByStatusQuery,
        GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardVerificationRequestsCountGroupedByStatusQuery | undefined,
  GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
>;
export function useGetDashboardVerificationRequestsCountGroupedByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardVerificationRequestsCountGroupedByStatusQuery,
        GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardVerificationRequestsCountGroupedByStatusQuery,
    GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
  >(GetDashboardVerificationRequestsCountGroupedByStatusDocument, options);
}
export type GetDashboardVerificationRequestsCountGroupedByStatusQueryHookResult = ReturnType<
  typeof useGetDashboardVerificationRequestsCountGroupedByStatusQuery
>;
export type GetDashboardVerificationRequestsCountGroupedByStatusLazyQueryHookResult = ReturnType<
  typeof useGetDashboardVerificationRequestsCountGroupedByStatusLazyQuery
>;
export type GetDashboardVerificationRequestsCountGroupedByStatusSuspenseQueryHookResult =
  ReturnType<typeof useGetDashboardVerificationRequestsCountGroupedByStatusSuspenseQuery>;
export type GetDashboardVerificationRequestsCountGroupedByStatusQueryResult = Apollo.QueryResult<
  GetDashboardVerificationRequestsCountGroupedByStatusQuery,
  GetDashboardVerificationRequestsCountGroupedByStatusQueryVariables
>;
export const GetDashboardVerificationRequestsCountGroupedByIsManualDocument = gql`
    query GetDashboardVerificationRequestsCountGroupedByIsManual($employerIds: [ID!], $peoIds: [ID!], $asOfDate: DateTime!) {
  getDashboardVerificationRequestsCountGroupedByIsManual(
    employerIds: $employerIds
    peoIds: $peoIds
    asOfDate: $asOfDate
  ) {
    ...DashboardVerificationRequestsCountGroupByIsManualInfo
  }
}
    ${DashboardVerificationRequestsCountGroupByIsManualInfoFragmentDoc}`;

/**
 * __useGetDashboardVerificationRequestsCountGroupedByIsManualQuery__
 *
 * To run a query within a React component, call `useGetDashboardVerificationRequestsCountGroupedByIsManualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardVerificationRequestsCountGroupedByIsManualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardVerificationRequestsCountGroupedByIsManualQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetDashboardVerificationRequestsCountGroupedByIsManualQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
    GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
  > &
    (
      | {
          variables: GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
    GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
  >(GetDashboardVerificationRequestsCountGroupedByIsManualDocument, options);
}
export function useGetDashboardVerificationRequestsCountGroupedByIsManualLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
    GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
    GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
  >(GetDashboardVerificationRequestsCountGroupedByIsManualDocument, options);
}
// @ts-ignore
export function useGetDashboardVerificationRequestsCountGroupedByIsManualSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
    GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
  GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
>;
export function useGetDashboardVerificationRequestsCountGroupedByIsManualSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
        GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardVerificationRequestsCountGroupedByIsManualQuery | undefined,
  GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
>;
export function useGetDashboardVerificationRequestsCountGroupedByIsManualSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
        GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
    GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
  >(GetDashboardVerificationRequestsCountGroupedByIsManualDocument, options);
}
export type GetDashboardVerificationRequestsCountGroupedByIsManualQueryHookResult = ReturnType<
  typeof useGetDashboardVerificationRequestsCountGroupedByIsManualQuery
>;
export type GetDashboardVerificationRequestsCountGroupedByIsManualLazyQueryHookResult = ReturnType<
  typeof useGetDashboardVerificationRequestsCountGroupedByIsManualLazyQuery
>;
export type GetDashboardVerificationRequestsCountGroupedByIsManualSuspenseQueryHookResult =
  ReturnType<typeof useGetDashboardVerificationRequestsCountGroupedByIsManualSuspenseQuery>;
export type GetDashboardVerificationRequestsCountGroupedByIsManualQueryResult = Apollo.QueryResult<
  GetDashboardVerificationRequestsCountGroupedByIsManualQuery,
  GetDashboardVerificationRequestsCountGroupedByIsManualQueryVariables
>;
export const GetDashboardVerifiersCountGroupedByCredentialStatusDocument = gql`
    query GetDashboardVerifiersCountGroupedByCredentialStatus($where: VerifierWhere) {
  getDashboardVerifiersCountGroupedByCredentialStatus(verifierWhere: $where) {
    ...DashboardVerifiersCountGroupByCredentialStatusInfo
  }
}
    ${DashboardVerifiersCountGroupByCredentialStatusInfoFragmentDoc}`;

/**
 * __useGetDashboardVerifiersCountGroupedByCredentialStatusQuery__
 *
 * To run a query within a React component, call `useGetDashboardVerifiersCountGroupedByCredentialStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardVerifiersCountGroupedByCredentialStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardVerifiersCountGroupedByCredentialStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDashboardVerifiersCountGroupedByCredentialStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
    GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
    GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
  >(GetDashboardVerifiersCountGroupedByCredentialStatusDocument, options);
}
export function useGetDashboardVerifiersCountGroupedByCredentialStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
    GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
    GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
  >(GetDashboardVerifiersCountGroupedByCredentialStatusDocument, options);
}
// @ts-ignore
export function useGetDashboardVerifiersCountGroupedByCredentialStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
    GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
  GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
>;
export function useGetDashboardVerifiersCountGroupedByCredentialStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
        GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardVerifiersCountGroupedByCredentialStatusQuery | undefined,
  GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
>;
export function useGetDashboardVerifiersCountGroupedByCredentialStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
        GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
    GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
  >(GetDashboardVerifiersCountGroupedByCredentialStatusDocument, options);
}
export type GetDashboardVerifiersCountGroupedByCredentialStatusQueryHookResult = ReturnType<
  typeof useGetDashboardVerifiersCountGroupedByCredentialStatusQuery
>;
export type GetDashboardVerifiersCountGroupedByCredentialStatusLazyQueryHookResult = ReturnType<
  typeof useGetDashboardVerifiersCountGroupedByCredentialStatusLazyQuery
>;
export type GetDashboardVerifiersCountGroupedByCredentialStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardVerifiersCountGroupedByCredentialStatusSuspenseQuery
>;
export type GetDashboardVerifiersCountGroupedByCredentialStatusQueryResult = Apollo.QueryResult<
  GetDashboardVerifiersCountGroupedByCredentialStatusQuery,
  GetDashboardVerifiersCountGroupedByCredentialStatusQueryVariables
>;
export const GetDashboardDataDisputeItemsCountGroupedByStatusDocument = gql`
    query GetDashboardDataDisputeItemsCountGroupedByStatus($employerIds: [ID!], $peoIds: [ID!], $asOfDate: DateTime!) {
  getDashboardDataDisputeItemsCountGroupedByStatus(
    employerIds: $employerIds
    peoIds: $peoIds
    asOfDate: $asOfDate
  ) {
    ...DashboardDataDisputeItemsCountGroupByStatusInfo
  }
}
    ${DashboardDataDisputeItemsCountGroupByStatusInfoFragmentDoc}`;

/**
 * __useGetDashboardDataDisputeItemsCountGroupedByStatusQuery__
 *
 * To run a query within a React component, call `useGetDashboardDataDisputeItemsCountGroupedByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardDataDisputeItemsCountGroupedByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardDataDisputeItemsCountGroupedByStatusQuery({
 *   variables: {
 *      employerIds: // value for 'employerIds'
 *      peoIds: // value for 'peoIds'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetDashboardDataDisputeItemsCountGroupedByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
    GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
  > &
    (
      | {
          variables: GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
    GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
  >(GetDashboardDataDisputeItemsCountGroupedByStatusDocument, options);
}
export function useGetDashboardDataDisputeItemsCountGroupedByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
    GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
    GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
  >(GetDashboardDataDisputeItemsCountGroupedByStatusDocument, options);
}
// @ts-ignore
export function useGetDashboardDataDisputeItemsCountGroupedByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
    GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
  GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
>;
export function useGetDashboardDataDisputeItemsCountGroupedByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
        GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardDataDisputeItemsCountGroupedByStatusQuery | undefined,
  GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
>;
export function useGetDashboardDataDisputeItemsCountGroupedByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
        GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
    GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
  >(GetDashboardDataDisputeItemsCountGroupedByStatusDocument, options);
}
export type GetDashboardDataDisputeItemsCountGroupedByStatusQueryHookResult = ReturnType<
  typeof useGetDashboardDataDisputeItemsCountGroupedByStatusQuery
>;
export type GetDashboardDataDisputeItemsCountGroupedByStatusLazyQueryHookResult = ReturnType<
  typeof useGetDashboardDataDisputeItemsCountGroupedByStatusLazyQuery
>;
export type GetDashboardDataDisputeItemsCountGroupedByStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardDataDisputeItemsCountGroupedByStatusSuspenseQuery
>;
export type GetDashboardDataDisputeItemsCountGroupedByStatusQueryResult = Apollo.QueryResult<
  GetDashboardDataDisputeItemsCountGroupedByStatusQuery,
  GetDashboardDataDisputeItemsCountGroupedByStatusQueryVariables
>;
export const GetDashboardCvAdminVerifiersDataDocument = gql`
    query GetDashboardCVAdminVerifiersData {
  getDashboardCVAdminVerifiersData {
    ...DashboardCVAdminVerifiersDataResponseInfo
  }
}
    ${DashboardCvAdminVerifiersDataResponseInfoFragmentDoc}`;

/**
 * __useGetDashboardCvAdminVerifiersDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardCvAdminVerifiersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCvAdminVerifiersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCvAdminVerifiersDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardCvAdminVerifiersDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardCvAdminVerifiersDataQuery,
    GetDashboardCvAdminVerifiersDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardCvAdminVerifiersDataQuery,
    GetDashboardCvAdminVerifiersDataQueryVariables
  >(GetDashboardCvAdminVerifiersDataDocument, options);
}
export function useGetDashboardCvAdminVerifiersDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardCvAdminVerifiersDataQuery,
    GetDashboardCvAdminVerifiersDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardCvAdminVerifiersDataQuery,
    GetDashboardCvAdminVerifiersDataQueryVariables
  >(GetDashboardCvAdminVerifiersDataDocument, options);
}
// @ts-ignore
export function useGetDashboardCvAdminVerifiersDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardCvAdminVerifiersDataQuery,
    GetDashboardCvAdminVerifiersDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardCvAdminVerifiersDataQuery,
  GetDashboardCvAdminVerifiersDataQueryVariables
>;
export function useGetDashboardCvAdminVerifiersDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardCvAdminVerifiersDataQuery,
        GetDashboardCvAdminVerifiersDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardCvAdminVerifiersDataQuery | undefined,
  GetDashboardCvAdminVerifiersDataQueryVariables
>;
export function useGetDashboardCvAdminVerifiersDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardCvAdminVerifiersDataQuery,
        GetDashboardCvAdminVerifiersDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardCvAdminVerifiersDataQuery,
    GetDashboardCvAdminVerifiersDataQueryVariables
  >(GetDashboardCvAdminVerifiersDataDocument, options);
}
export type GetDashboardCvAdminVerifiersDataQueryHookResult = ReturnType<
  typeof useGetDashboardCvAdminVerifiersDataQuery
>;
export type GetDashboardCvAdminVerifiersDataLazyQueryHookResult = ReturnType<
  typeof useGetDashboardCvAdminVerifiersDataLazyQuery
>;
export type GetDashboardCvAdminVerifiersDataSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardCvAdminVerifiersDataSuspenseQuery
>;
export type GetDashboardCvAdminVerifiersDataQueryResult = Apollo.QueryResult<
  GetDashboardCvAdminVerifiersDataQuery,
  GetDashboardCvAdminVerifiersDataQueryVariables
>;
export const GetDashboardPlatformAdminTopVerifiersDataDocument = gql`
    query GetDashboardPlatformAdminTopVerifiersData {
  getDashboardPlatformAdminTopVerifiersData {
    ...DashboardPlatformAdminTopVerifierDataInfo
  }
}
    ${DashboardPlatformAdminTopVerifierDataInfoFragmentDoc}`;

/**
 * __useGetDashboardPlatformAdminTopVerifiersDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardPlatformAdminTopVerifiersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardPlatformAdminTopVerifiersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardPlatformAdminTopVerifiersDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardPlatformAdminTopVerifiersDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardPlatformAdminTopVerifiersDataQuery,
    GetDashboardPlatformAdminTopVerifiersDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardPlatformAdminTopVerifiersDataQuery,
    GetDashboardPlatformAdminTopVerifiersDataQueryVariables
  >(GetDashboardPlatformAdminTopVerifiersDataDocument, options);
}
export function useGetDashboardPlatformAdminTopVerifiersDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardPlatformAdminTopVerifiersDataQuery,
    GetDashboardPlatformAdminTopVerifiersDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardPlatformAdminTopVerifiersDataQuery,
    GetDashboardPlatformAdminTopVerifiersDataQueryVariables
  >(GetDashboardPlatformAdminTopVerifiersDataDocument, options);
}
// @ts-ignore
export function useGetDashboardPlatformAdminTopVerifiersDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardPlatformAdminTopVerifiersDataQuery,
    GetDashboardPlatformAdminTopVerifiersDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardPlatformAdminTopVerifiersDataQuery,
  GetDashboardPlatformAdminTopVerifiersDataQueryVariables
>;
export function useGetDashboardPlatformAdminTopVerifiersDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardPlatformAdminTopVerifiersDataQuery,
        GetDashboardPlatformAdminTopVerifiersDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardPlatformAdminTopVerifiersDataQuery | undefined,
  GetDashboardPlatformAdminTopVerifiersDataQueryVariables
>;
export function useGetDashboardPlatformAdminTopVerifiersDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardPlatformAdminTopVerifiersDataQuery,
        GetDashboardPlatformAdminTopVerifiersDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardPlatformAdminTopVerifiersDataQuery,
    GetDashboardPlatformAdminTopVerifiersDataQueryVariables
  >(GetDashboardPlatformAdminTopVerifiersDataDocument, options);
}
export type GetDashboardPlatformAdminTopVerifiersDataQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminTopVerifiersDataQuery
>;
export type GetDashboardPlatformAdminTopVerifiersDataLazyQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminTopVerifiersDataLazyQuery
>;
export type GetDashboardPlatformAdminTopVerifiersDataSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardPlatformAdminTopVerifiersDataSuspenseQuery
>;
export type GetDashboardPlatformAdminTopVerifiersDataQueryResult = Apollo.QueryResult<
  GetDashboardPlatformAdminTopVerifiersDataQuery,
  GetDashboardPlatformAdminTopVerifiersDataQueryVariables
>;
export const GenerateYearToDateFinancialReportDocument = gql`
    mutation GenerateYearToDateFinancialReport($date: Date!) {
  generateYearToDateFinancialReport(date: $date) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateYearToDateFinancialReportMutationFn = Apollo.MutationFunction<
  GenerateYearToDateFinancialReportMutation,
  GenerateYearToDateFinancialReportMutationVariables
>;

/**
 * __useGenerateYearToDateFinancialReportMutation__
 *
 * To run a mutation, you first call `useGenerateYearToDateFinancialReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateYearToDateFinancialReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateYearToDateFinancialReportMutation, { data, loading, error }] = useGenerateYearToDateFinancialReportMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGenerateYearToDateFinancialReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateYearToDateFinancialReportMutation,
    GenerateYearToDateFinancialReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateYearToDateFinancialReportMutation,
    GenerateYearToDateFinancialReportMutationVariables
  >(GenerateYearToDateFinancialReportDocument, options);
}
export type GenerateYearToDateFinancialReportMutationHookResult = ReturnType<
  typeof useGenerateYearToDateFinancialReportMutation
>;
export type GenerateYearToDateFinancialReportMutationResult =
  Apollo.MutationResult<GenerateYearToDateFinancialReportMutation>;
export type GenerateYearToDateFinancialReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateYearToDateFinancialReportMutation,
  GenerateYearToDateFinancialReportMutationVariables
>;
export const GetDashboardEmployeeStatsDocument = gql`
    query GetDashboardEmployeeStats {
  getDashboardEmployeeUserStats {
    total
    percentage
    breakdown {
      Inactive
      Active
      Pending
    }
  }
}
    `;

/**
 * __useGetDashboardEmployeeStatsQuery__
 *
 * To run a query within a React component, call `useGetDashboardEmployeeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardEmployeeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardEmployeeStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardEmployeeStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardEmployeeStatsQuery,
    GetDashboardEmployeeStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDashboardEmployeeStatsQuery, GetDashboardEmployeeStatsQueryVariables>(
    GetDashboardEmployeeStatsDocument,
    options,
  );
}
export function useGetDashboardEmployeeStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardEmployeeStatsQuery,
    GetDashboardEmployeeStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardEmployeeStatsQuery,
    GetDashboardEmployeeStatsQueryVariables
  >(GetDashboardEmployeeStatsDocument, options);
}
// @ts-ignore
export function useGetDashboardEmployeeStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardEmployeeStatsQuery,
    GetDashboardEmployeeStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardEmployeeStatsQuery,
  GetDashboardEmployeeStatsQueryVariables
>;
export function useGetDashboardEmployeeStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardEmployeeStatsQuery,
        GetDashboardEmployeeStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardEmployeeStatsQuery | undefined,
  GetDashboardEmployeeStatsQueryVariables
>;
export function useGetDashboardEmployeeStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardEmployeeStatsQuery,
        GetDashboardEmployeeStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardEmployeeStatsQuery,
    GetDashboardEmployeeStatsQueryVariables
  >(GetDashboardEmployeeStatsDocument, options);
}
export type GetDashboardEmployeeStatsQueryHookResult = ReturnType<
  typeof useGetDashboardEmployeeStatsQuery
>;
export type GetDashboardEmployeeStatsLazyQueryHookResult = ReturnType<
  typeof useGetDashboardEmployeeStatsLazyQuery
>;
export type GetDashboardEmployeeStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardEmployeeStatsSuspenseQuery
>;
export type GetDashboardEmployeeStatsQueryResult = Apollo.QueryResult<
  GetDashboardEmployeeStatsQuery,
  GetDashboardEmployeeStatsQueryVariables
>;
export const CreateDataDisputeByEmployeeDocument = gql`
    mutation CreateDataDisputeByEmployee($inboxItemId: ID, $employerId: ID!, $reason: String!) {
  createDataDisputeByEmployee(
    inboxItemId: $inboxItemId
    employerId: $employerId
    reason: $reason
  ) {
    dataDisputeId
  }
}
    `;
export type CreateDataDisputeByEmployeeMutationFn = Apollo.MutationFunction<
  CreateDataDisputeByEmployeeMutation,
  CreateDataDisputeByEmployeeMutationVariables
>;

/**
 * __useCreateDataDisputeByEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateDataDisputeByEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataDisputeByEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataDisputeByEmployeeMutation, { data, loading, error }] = useCreateDataDisputeByEmployeeMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      employerId: // value for 'employerId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateDataDisputeByEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDataDisputeByEmployeeMutation,
    CreateDataDisputeByEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDataDisputeByEmployeeMutation,
    CreateDataDisputeByEmployeeMutationVariables
  >(CreateDataDisputeByEmployeeDocument, options);
}
export type CreateDataDisputeByEmployeeMutationHookResult = ReturnType<
  typeof useCreateDataDisputeByEmployeeMutation
>;
export type CreateDataDisputeByEmployeeMutationResult =
  Apollo.MutationResult<CreateDataDisputeByEmployeeMutation>;
export type CreateDataDisputeByEmployeeMutationOptions = Apollo.BaseMutationOptions<
  CreateDataDisputeByEmployeeMutation,
  CreateDataDisputeByEmployeeMutationVariables
>;
export const CreateDataDisputeOnEmployeeSignupByInviteDocument = gql`
    mutation CreateDataDisputeOnEmployeeSignupByInvite($inviteId: ID!, $companyId: ID!, $reason: String!) {
  createDataDisputeOnEmployeeSignupByInvite(
    inviteId: $inviteId
    companyId: $companyId
    reason: $reason
  ) {
    success
  }
}
    `;
export type CreateDataDisputeOnEmployeeSignupByInviteMutationFn = Apollo.MutationFunction<
  CreateDataDisputeOnEmployeeSignupByInviteMutation,
  CreateDataDisputeOnEmployeeSignupByInviteMutationVariables
>;

/**
 * __useCreateDataDisputeOnEmployeeSignupByInviteMutation__
 *
 * To run a mutation, you first call `useCreateDataDisputeOnEmployeeSignupByInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataDisputeOnEmployeeSignupByInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataDisputeOnEmployeeSignupByInviteMutation, { data, loading, error }] = useCreateDataDisputeOnEmployeeSignupByInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      companyId: // value for 'companyId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateDataDisputeOnEmployeeSignupByInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDataDisputeOnEmployeeSignupByInviteMutation,
    CreateDataDisputeOnEmployeeSignupByInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDataDisputeOnEmployeeSignupByInviteMutation,
    CreateDataDisputeOnEmployeeSignupByInviteMutationVariables
  >(CreateDataDisputeOnEmployeeSignupByInviteDocument, options);
}
export type CreateDataDisputeOnEmployeeSignupByInviteMutationHookResult = ReturnType<
  typeof useCreateDataDisputeOnEmployeeSignupByInviteMutation
>;
export type CreateDataDisputeOnEmployeeSignupByInviteMutationResult =
  Apollo.MutationResult<CreateDataDisputeOnEmployeeSignupByInviteMutation>;
export type CreateDataDisputeOnEmployeeSignupByInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateDataDisputeOnEmployeeSignupByInviteMutation,
  CreateDataDisputeOnEmployeeSignupByInviteMutationVariables
>;
export const CreateDataDisputeOnEmployeeSignupDocument = gql`
    mutation createDataDisputeOnEmployeeSignup($employeeSignupToken: String!, $userData: UserDataShapeForNewEmployeeOnDataDisputeCreation!, $companyId: ID!, $reason: String!) {
  createDataDisputeOnEmployeeSignup(
    employeeSignupToken: $employeeSignupToken
    userData: $userData
    companyId: $companyId
    reason: $reason
  ) {
    success
  }
}
    `;
export type CreateDataDisputeOnEmployeeSignupMutationFn = Apollo.MutationFunction<
  CreateDataDisputeOnEmployeeSignupMutation,
  CreateDataDisputeOnEmployeeSignupMutationVariables
>;

/**
 * __useCreateDataDisputeOnEmployeeSignupMutation__
 *
 * To run a mutation, you first call `useCreateDataDisputeOnEmployeeSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataDisputeOnEmployeeSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataDisputeOnEmployeeSignupMutation, { data, loading, error }] = useCreateDataDisputeOnEmployeeSignupMutation({
 *   variables: {
 *      employeeSignupToken: // value for 'employeeSignupToken'
 *      userData: // value for 'userData'
 *      companyId: // value for 'companyId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateDataDisputeOnEmployeeSignupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDataDisputeOnEmployeeSignupMutation,
    CreateDataDisputeOnEmployeeSignupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDataDisputeOnEmployeeSignupMutation,
    CreateDataDisputeOnEmployeeSignupMutationVariables
  >(CreateDataDisputeOnEmployeeSignupDocument, options);
}
export type CreateDataDisputeOnEmployeeSignupMutationHookResult = ReturnType<
  typeof useCreateDataDisputeOnEmployeeSignupMutation
>;
export type CreateDataDisputeOnEmployeeSignupMutationResult =
  Apollo.MutationResult<CreateDataDisputeOnEmployeeSignupMutation>;
export type CreateDataDisputeOnEmployeeSignupMutationOptions = Apollo.BaseMutationOptions<
  CreateDataDisputeOnEmployeeSignupMutation,
  CreateDataDisputeOnEmployeeSignupMutationVariables
>;
export const CreateDataDisputeForPositionDocument = gql`
    mutation CreateDataDisputeForPosition($employeeId: ID!, $positionId: ID!, $employeeFirstName: String, $employeeLastName: String, $reason: String) {
  createDataDisputeForPosition(
    employeeId: $employeeId
    positionId: $positionId
    employeeFirstName: $employeeFirstName
    employeeLastName: $employeeLastName
    reason: $reason
  ) {
    success
  }
}
    `;
export type CreateDataDisputeForPositionMutationFn = Apollo.MutationFunction<
  CreateDataDisputeForPositionMutation,
  CreateDataDisputeForPositionMutationVariables
>;

/**
 * __useCreateDataDisputeForPositionMutation__
 *
 * To run a mutation, you first call `useCreateDataDisputeForPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataDisputeForPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataDisputeForPositionMutation, { data, loading, error }] = useCreateDataDisputeForPositionMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      positionId: // value for 'positionId'
 *      employeeFirstName: // value for 'employeeFirstName'
 *      employeeLastName: // value for 'employeeLastName'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateDataDisputeForPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDataDisputeForPositionMutation,
    CreateDataDisputeForPositionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDataDisputeForPositionMutation,
    CreateDataDisputeForPositionMutationVariables
  >(CreateDataDisputeForPositionDocument, options);
}
export type CreateDataDisputeForPositionMutationHookResult = ReturnType<
  typeof useCreateDataDisputeForPositionMutation
>;
export type CreateDataDisputeForPositionMutationResult =
  Apollo.MutationResult<CreateDataDisputeForPositionMutation>;
export type CreateDataDisputeForPositionMutationOptions = Apollo.BaseMutationOptions<
  CreateDataDisputeForPositionMutation,
  CreateDataDisputeForPositionMutationVariables
>;
export const DataDisputeItemChangeStatusDocument = gql`
    mutation DataDisputeItemChangeStatus($dataDisputeItemId: ID!, $status: DataDisputeItemStatus!) {
  changeDataDisputeItemStatus(
    dataDisputeItemId: $dataDisputeItemId
    status: $status
  ) {
    success
  }
}
    `;
export type DataDisputeItemChangeStatusMutationFn = Apollo.MutationFunction<
  DataDisputeItemChangeStatusMutation,
  DataDisputeItemChangeStatusMutationVariables
>;

/**
 * __useDataDisputeItemChangeStatusMutation__
 *
 * To run a mutation, you first call `useDataDisputeItemChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataDisputeItemChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataDisputeItemChangeStatusMutation, { data, loading, error }] = useDataDisputeItemChangeStatusMutation({
 *   variables: {
 *      dataDisputeItemId: // value for 'dataDisputeItemId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useDataDisputeItemChangeStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DataDisputeItemChangeStatusMutation,
    DataDisputeItemChangeStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DataDisputeItemChangeStatusMutation,
    DataDisputeItemChangeStatusMutationVariables
  >(DataDisputeItemChangeStatusDocument, options);
}
export type DataDisputeItemChangeStatusMutationHookResult = ReturnType<
  typeof useDataDisputeItemChangeStatusMutation
>;
export type DataDisputeItemChangeStatusMutationResult =
  Apollo.MutationResult<DataDisputeItemChangeStatusMutation>;
export type DataDisputeItemChangeStatusMutationOptions = Apollo.BaseMutationOptions<
  DataDisputeItemChangeStatusMutation,
  DataDisputeItemChangeStatusMutationVariables
>;
export const DataDisputeByIdDocument = gql`
    query DataDisputeById($filter: DataDisputeWhereUnique!, $dataDisputeItemsFilter: DataDisputeItemWhere) {
  dataDispute(where: $filter) {
    ...DataDisputeInfo
    dataDisputeItemsList(where: $dataDisputeItemsFilter) {
      ...DataDisputeItemInfo
    }
  }
}
    ${DataDisputeInfoFragmentDoc}
${DataDisputeItemInfoFragmentDoc}`;

/**
 * __useDataDisputeByIdQuery__
 *
 * To run a query within a React component, call `useDataDisputeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataDisputeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataDisputeByIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      dataDisputeItemsFilter: // value for 'dataDisputeItemsFilter'
 *   },
 * });
 */
export function useDataDisputeByIdQuery(
  baseOptions: Apollo.QueryHookOptions<DataDisputeByIdQuery, DataDisputeByIdQueryVariables> &
    ({ variables: DataDisputeByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>(
    DataDisputeByIdDocument,
    options,
  );
}
export function useDataDisputeByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>(
    DataDisputeByIdDocument,
    options,
  );
}
// @ts-ignore
export function useDataDisputeByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataDisputeByIdQuery,
    DataDisputeByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>;
export function useDataDisputeByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<DataDisputeByIdQuery | undefined, DataDisputeByIdQueryVariables>;
export function useDataDisputeByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DataDisputeByIdQuery, DataDisputeByIdQueryVariables>(
    DataDisputeByIdDocument,
    options,
  );
}
export type DataDisputeByIdQueryHookResult = ReturnType<typeof useDataDisputeByIdQuery>;
export type DataDisputeByIdLazyQueryHookResult = ReturnType<typeof useDataDisputeByIdLazyQuery>;
export type DataDisputeByIdSuspenseQueryHookResult = ReturnType<
  typeof useDataDisputeByIdSuspenseQuery
>;
export type DataDisputeByIdQueryResult = Apollo.QueryResult<
  DataDisputeByIdQuery,
  DataDisputeByIdQueryVariables
>;
export const DataDisputeItemsListDocument = gql`
    query DataDisputeItemsList($filter: DataDisputeItemWhere) {
  dataDisputeItemList(where: $filter) {
    id
    createdAt
    status
    employer {
      id
      displayName
    }
    dataDispute {
      id
      inboxItemId
      employee {
        id
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useDataDisputeItemsListQuery__
 *
 * To run a query within a React component, call `useDataDisputeItemsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataDisputeItemsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataDisputeItemsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDataDisputeItemsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DataDisputeItemsListQuery,
    DataDisputeItemsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DataDisputeItemsListQuery, DataDisputeItemsListQueryVariables>(
    DataDisputeItemsListDocument,
    options,
  );
}
export function useDataDisputeItemsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataDisputeItemsListQuery,
    DataDisputeItemsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DataDisputeItemsListQuery, DataDisputeItemsListQueryVariables>(
    DataDisputeItemsListDocument,
    options,
  );
}
// @ts-ignore
export function useDataDisputeItemsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataDisputeItemsListQuery,
    DataDisputeItemsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DataDisputeItemsListQuery, DataDisputeItemsListQueryVariables>;
export function useDataDisputeItemsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataDisputeItemsListQuery,
        DataDisputeItemsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataDisputeItemsListQuery | undefined,
  DataDisputeItemsListQueryVariables
>;
export function useDataDisputeItemsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataDisputeItemsListQuery,
        DataDisputeItemsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DataDisputeItemsListQuery, DataDisputeItemsListQueryVariables>(
    DataDisputeItemsListDocument,
    options,
  );
}
export type DataDisputeItemsListQueryHookResult = ReturnType<typeof useDataDisputeItemsListQuery>;
export type DataDisputeItemsListLazyQueryHookResult = ReturnType<
  typeof useDataDisputeItemsListLazyQuery
>;
export type DataDisputeItemsListSuspenseQueryHookResult = ReturnType<
  typeof useDataDisputeItemsListSuspenseQuery
>;
export type DataDisputeItemsListQueryResult = Apollo.QueryResult<
  DataDisputeItemsListQuery,
  DataDisputeItemsListQueryVariables
>;
export const DataDisputeReportListDocument = gql`
    query DataDisputeReportList($filter: DataDisputeWhere, $orderBy: [DataDisputeOrderBy!], $first: Int, $skip: Int) {
  dataDisputeCount(where: $filter)
  dataDisputeList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...DataDisputeReportInfo
  }
}
    ${DataDisputeReportInfoFragmentDoc}`;

/**
 * __useDataDisputeReportListQuery__
 *
 * To run a query within a React component, call `useDataDisputeReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataDisputeReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataDisputeReportListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useDataDisputeReportListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DataDisputeReportListQuery,
    DataDisputeReportListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DataDisputeReportListQuery, DataDisputeReportListQueryVariables>(
    DataDisputeReportListDocument,
    options,
  );
}
export function useDataDisputeReportListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataDisputeReportListQuery,
    DataDisputeReportListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DataDisputeReportListQuery, DataDisputeReportListQueryVariables>(
    DataDisputeReportListDocument,
    options,
  );
}
// @ts-ignore
export function useDataDisputeReportListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataDisputeReportListQuery,
    DataDisputeReportListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DataDisputeReportListQuery, DataDisputeReportListQueryVariables>;
export function useDataDisputeReportListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataDisputeReportListQuery,
        DataDisputeReportListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataDisputeReportListQuery | undefined,
  DataDisputeReportListQueryVariables
>;
export function useDataDisputeReportListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataDisputeReportListQuery,
        DataDisputeReportListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DataDisputeReportListQuery, DataDisputeReportListQueryVariables>(
    DataDisputeReportListDocument,
    options,
  );
}
export type DataDisputeReportListQueryHookResult = ReturnType<typeof useDataDisputeReportListQuery>;
export type DataDisputeReportListLazyQueryHookResult = ReturnType<
  typeof useDataDisputeReportListLazyQuery
>;
export type DataDisputeReportListSuspenseQueryHookResult = ReturnType<
  typeof useDataDisputeReportListSuspenseQuery
>;
export type DataDisputeReportListQueryResult = Apollo.QueryResult<
  DataDisputeReportListQuery,
  DataDisputeReportListQueryVariables
>;
export const DisclaimerCreateDocument = gql`
    mutation DisclaimerCreate($data: DisclaimerCreate!) {
  disclaimerCreate(data: $data) {
    ...DisclaimerInfo
  }
}
    ${DisclaimerInfoFragmentDoc}`;
export type DisclaimerCreateMutationFn = Apollo.MutationFunction<
  DisclaimerCreateMutation,
  DisclaimerCreateMutationVariables
>;

/**
 * __useDisclaimerCreateMutation__
 *
 * To run a mutation, you first call `useDisclaimerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisclaimerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disclaimerCreateMutation, { data, loading, error }] = useDisclaimerCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDisclaimerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisclaimerCreateMutation,
    DisclaimerCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisclaimerCreateMutation, DisclaimerCreateMutationVariables>(
    DisclaimerCreateDocument,
    options,
  );
}
export type DisclaimerCreateMutationHookResult = ReturnType<typeof useDisclaimerCreateMutation>;
export type DisclaimerCreateMutationResult = Apollo.MutationResult<DisclaimerCreateMutation>;
export type DisclaimerCreateMutationOptions = Apollo.BaseMutationOptions<
  DisclaimerCreateMutation,
  DisclaimerCreateMutationVariables
>;
export const DisclaimerDeleteDocument = gql`
    mutation DisclaimerDelete($where: DisclaimerWhereUnique!) {
  disclaimerDelete(where: $where)
}
    `;
export type DisclaimerDeleteMutationFn = Apollo.MutationFunction<
  DisclaimerDeleteMutation,
  DisclaimerDeleteMutationVariables
>;

/**
 * __useDisclaimerDeleteMutation__
 *
 * To run a mutation, you first call `useDisclaimerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisclaimerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disclaimerDeleteMutation, { data, loading, error }] = useDisclaimerDeleteMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDisclaimerDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisclaimerDeleteMutation,
    DisclaimerDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisclaimerDeleteMutation, DisclaimerDeleteMutationVariables>(
    DisclaimerDeleteDocument,
    options,
  );
}
export type DisclaimerDeleteMutationHookResult = ReturnType<typeof useDisclaimerDeleteMutation>;
export type DisclaimerDeleteMutationResult = Apollo.MutationResult<DisclaimerDeleteMutation>;
export type DisclaimerDeleteMutationOptions = Apollo.BaseMutationOptions<
  DisclaimerDeleteMutation,
  DisclaimerDeleteMutationVariables
>;
export const DisclaimerUpdateDocument = gql`
    mutation DisclaimerUpdate($where: DisclaimerWhereUnique!, $data: DisclaimerUpdate!) {
  disclaimerUpdate(where: $where, data: $data) {
    ...DisclaimerInfo
  }
}
    ${DisclaimerInfoFragmentDoc}`;
export type DisclaimerUpdateMutationFn = Apollo.MutationFunction<
  DisclaimerUpdateMutation,
  DisclaimerUpdateMutationVariables
>;

/**
 * __useDisclaimerUpdateMutation__
 *
 * To run a mutation, you first call `useDisclaimerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisclaimerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disclaimerUpdateMutation, { data, loading, error }] = useDisclaimerUpdateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDisclaimerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisclaimerUpdateMutation,
    DisclaimerUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisclaimerUpdateMutation, DisclaimerUpdateMutationVariables>(
    DisclaimerUpdateDocument,
    options,
  );
}
export type DisclaimerUpdateMutationHookResult = ReturnType<typeof useDisclaimerUpdateMutation>;
export type DisclaimerUpdateMutationResult = Apollo.MutationResult<DisclaimerUpdateMutation>;
export type DisclaimerUpdateMutationOptions = Apollo.BaseMutationOptions<
  DisclaimerUpdateMutation,
  DisclaimerUpdateMutationVariables
>;
export const DisclaimersListDocument = gql`
    query DisclaimersList($filter: DisclaimerWhere) {
  disclaimerCount(where: $filter)
  disclaimerList(where: $filter) {
    ...DisclaimerInfo
  }
}
    ${DisclaimerInfoFragmentDoc}`;

/**
 * __useDisclaimersListQuery__
 *
 * To run a query within a React component, call `useDisclaimersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisclaimersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisclaimersListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDisclaimersListQuery(
  baseOptions?: Apollo.QueryHookOptions<DisclaimersListQuery, DisclaimersListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DisclaimersListQuery, DisclaimersListQueryVariables>(
    DisclaimersListDocument,
    options,
  );
}
export function useDisclaimersListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DisclaimersListQuery, DisclaimersListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DisclaimersListQuery, DisclaimersListQueryVariables>(
    DisclaimersListDocument,
    options,
  );
}
// @ts-ignore
export function useDisclaimersListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DisclaimersListQuery,
    DisclaimersListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DisclaimersListQuery, DisclaimersListQueryVariables>;
export function useDisclaimersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DisclaimersListQuery, DisclaimersListQueryVariables>,
): Apollo.UseSuspenseQueryResult<DisclaimersListQuery | undefined, DisclaimersListQueryVariables>;
export function useDisclaimersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DisclaimersListQuery, DisclaimersListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DisclaimersListQuery, DisclaimersListQueryVariables>(
    DisclaimersListDocument,
    options,
  );
}
export type DisclaimersListQueryHookResult = ReturnType<typeof useDisclaimersListQuery>;
export type DisclaimersListLazyQueryHookResult = ReturnType<typeof useDisclaimersListLazyQuery>;
export type DisclaimersListSuspenseQueryHookResult = ReturnType<
  typeof useDisclaimersListSuspenseQuery
>;
export type DisclaimersListQueryResult = Apollo.QueryResult<
  DisclaimersListQuery,
  DisclaimersListQueryVariables
>;
export const EmailActivityDocument = gql`
    query EmailActivity($limit: Int, $toEmailFilter: String, $statusFilter: EmailDeliveryStatus) {
  getEmailActivity(
    limit: $limit
    toEmailFilter: $toEmailFilter
    statusFilter: $statusFilter
  ) {
    messages {
      ...EmailActivityItemInfo
    }
  }
}
    ${EmailActivityItemInfoFragmentDoc}`;

/**
 * __useEmailActivityQuery__
 *
 * To run a query within a React component, call `useEmailActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailActivityQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      toEmailFilter: // value for 'toEmailFilter'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useEmailActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmailActivityQuery, EmailActivityQueryVariables>(
    EmailActivityDocument,
    options,
  );
}
export function useEmailActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmailActivityQuery, EmailActivityQueryVariables>(
    EmailActivityDocument,
    options,
  );
}
// @ts-ignore
export function useEmailActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmailActivityQuery, EmailActivityQueryVariables>;
export function useEmailActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmailActivityQuery | undefined, EmailActivityQueryVariables>;
export function useEmailActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmailActivityQuery, EmailActivityQueryVariables>(
    EmailActivityDocument,
    options,
  );
}
export type EmailActivityQueryHookResult = ReturnType<typeof useEmailActivityQuery>;
export type EmailActivityLazyQueryHookResult = ReturnType<typeof useEmailActivityLazyQuery>;
export type EmailActivitySuspenseQueryHookResult = ReturnType<typeof useEmailActivitySuspenseQuery>;
export type EmailActivityQueryResult = Apollo.QueryResult<
  EmailActivityQuery,
  EmailActivityQueryVariables
>;
export const GetIsEmailFreeDocument = gql`
    query GetIsEmailFree($email: String!) {
  getIsEmailFree(email: $email) {
    isEmailFree
  }
}
    `;

/**
 * __useGetIsEmailFreeQuery__
 *
 * To run a query within a React component, call `useGetIsEmailFreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsEmailFreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsEmailFreeQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetIsEmailFreeQuery(
  baseOptions: Apollo.QueryHookOptions<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables> &
    ({ variables: GetIsEmailFreeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>(
    GetIsEmailFreeDocument,
    options,
  );
}
export function useGetIsEmailFreeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>(
    GetIsEmailFreeDocument,
    options,
  );
}
// @ts-ignore
export function useGetIsEmailFreeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>;
export function useGetIsEmailFreeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetIsEmailFreeQuery | undefined, GetIsEmailFreeQueryVariables>;
export function useGetIsEmailFreeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIsEmailFreeQuery, GetIsEmailFreeQueryVariables>(
    GetIsEmailFreeDocument,
    options,
  );
}
export type GetIsEmailFreeQueryHookResult = ReturnType<typeof useGetIsEmailFreeQuery>;
export type GetIsEmailFreeLazyQueryHookResult = ReturnType<typeof useGetIsEmailFreeLazyQuery>;
export type GetIsEmailFreeSuspenseQueryHookResult = ReturnType<
  typeof useGetIsEmailFreeSuspenseQuery
>;
export type GetIsEmailFreeQueryResult = Apollo.QueryResult<
  GetIsEmailFreeQuery,
  GetIsEmailFreeQueryVariables
>;
export const CheckEmailSuppressionsDocument = gql`
    query CheckEmailSuppressions($email: String!) {
  checkEmailSuppressions(email: $email) {
    success
  }
}
    `;

/**
 * __useCheckEmailSuppressionsQuery__
 *
 * To run a query within a React component, call `useCheckEmailSuppressionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailSuppressionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailSuppressionsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckEmailSuppressionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckEmailSuppressionsQuery,
    CheckEmailSuppressionsQueryVariables
  > &
    ({ variables: CheckEmailSuppressionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckEmailSuppressionsQuery, CheckEmailSuppressionsQueryVariables>(
    CheckEmailSuppressionsDocument,
    options,
  );
}
export function useCheckEmailSuppressionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckEmailSuppressionsQuery,
    CheckEmailSuppressionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckEmailSuppressionsQuery, CheckEmailSuppressionsQueryVariables>(
    CheckEmailSuppressionsDocument,
    options,
  );
}
// @ts-ignore
export function useCheckEmailSuppressionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckEmailSuppressionsQuery,
    CheckEmailSuppressionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckEmailSuppressionsQuery, CheckEmailSuppressionsQueryVariables>;
export function useCheckEmailSuppressionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckEmailSuppressionsQuery,
        CheckEmailSuppressionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckEmailSuppressionsQuery | undefined,
  CheckEmailSuppressionsQueryVariables
>;
export function useCheckEmailSuppressionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckEmailSuppressionsQuery,
        CheckEmailSuppressionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckEmailSuppressionsQuery, CheckEmailSuppressionsQueryVariables>(
    CheckEmailSuppressionsDocument,
    options,
  );
}
export type CheckEmailSuppressionsQueryHookResult = ReturnType<
  typeof useCheckEmailSuppressionsQuery
>;
export type CheckEmailSuppressionsLazyQueryHookResult = ReturnType<
  typeof useCheckEmailSuppressionsLazyQuery
>;
export type CheckEmailSuppressionsSuspenseQueryHookResult = ReturnType<
  typeof useCheckEmailSuppressionsSuspenseQuery
>;
export type CheckEmailSuppressionsQueryResult = Apollo.QueryResult<
  CheckEmailSuppressionsQuery,
  CheckEmailSuppressionsQueryVariables
>;
export const DeleteSuppressionFromEmailDocument = gql`
    mutation DeleteSuppressionFromEmail($email: String!) {
  deleteSuppressionFromEmail(email: $email) {
    success
  }
}
    `;
export type DeleteSuppressionFromEmailMutationFn = Apollo.MutationFunction<
  DeleteSuppressionFromEmailMutation,
  DeleteSuppressionFromEmailMutationVariables
>;

/**
 * __useDeleteSuppressionFromEmailMutation__
 *
 * To run a mutation, you first call `useDeleteSuppressionFromEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSuppressionFromEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSuppressionFromEmailMutation, { data, loading, error }] = useDeleteSuppressionFromEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteSuppressionFromEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSuppressionFromEmailMutation,
    DeleteSuppressionFromEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSuppressionFromEmailMutation,
    DeleteSuppressionFromEmailMutationVariables
  >(DeleteSuppressionFromEmailDocument, options);
}
export type DeleteSuppressionFromEmailMutationHookResult = ReturnType<
  typeof useDeleteSuppressionFromEmailMutation
>;
export type DeleteSuppressionFromEmailMutationResult =
  Apollo.MutationResult<DeleteSuppressionFromEmailMutation>;
export type DeleteSuppressionFromEmailMutationOptions = Apollo.BaseMutationOptions<
  DeleteSuppressionFromEmailMutation,
  DeleteSuppressionFromEmailMutationVariables
>;
export const SendEmailConfirmationCodeDocument = gql`
    mutation SendEmailConfirmationCode($email: String!) {
  sendEmailConfirmationCode(email: $email) {
    success
    pendingInviteResent
  }
}
    `;
export type SendEmailConfirmationCodeMutationFn = Apollo.MutationFunction<
  SendEmailConfirmationCodeMutation,
  SendEmailConfirmationCodeMutationVariables
>;

/**
 * __useSendEmailConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useSendEmailConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailConfirmationCodeMutation, { data, loading, error }] = useSendEmailConfirmationCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendEmailConfirmationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendEmailConfirmationCodeMutation,
    SendEmailConfirmationCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendEmailConfirmationCodeMutation,
    SendEmailConfirmationCodeMutationVariables
  >(SendEmailConfirmationCodeDocument, options);
}
export type SendEmailConfirmationCodeMutationHookResult = ReturnType<
  typeof useSendEmailConfirmationCodeMutation
>;
export type SendEmailConfirmationCodeMutationResult =
  Apollo.MutationResult<SendEmailConfirmationCodeMutation>;
export type SendEmailConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<
  SendEmailConfirmationCodeMutation,
  SendEmailConfirmationCodeMutationVariables
>;
export const VerifyEmailConfirmationCodeDocument = gql`
    query VerifyEmailConfirmationCode($email: String!, $code: String!) {
  verifyEmailConfirmationCode(email: $email, code: $code) {
    success
  }
}
    `;

/**
 * __useVerifyEmailConfirmationCodeQuery__
 *
 * To run a query within a React component, call `useVerifyEmailConfirmationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailConfirmationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyEmailConfirmationCodeQuery({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyEmailConfirmationCodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifyEmailConfirmationCodeQuery,
    VerifyEmailConfirmationCodeQueryVariables
  > &
    ({ variables: VerifyEmailConfirmationCodeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VerifyEmailConfirmationCodeQuery,
    VerifyEmailConfirmationCodeQueryVariables
  >(VerifyEmailConfirmationCodeDocument, options);
}
export function useVerifyEmailConfirmationCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifyEmailConfirmationCodeQuery,
    VerifyEmailConfirmationCodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VerifyEmailConfirmationCodeQuery,
    VerifyEmailConfirmationCodeQueryVariables
  >(VerifyEmailConfirmationCodeDocument, options);
}
// @ts-ignore
export function useVerifyEmailConfirmationCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifyEmailConfirmationCodeQuery,
    VerifyEmailConfirmationCodeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerifyEmailConfirmationCodeQuery,
  VerifyEmailConfirmationCodeQueryVariables
>;
export function useVerifyEmailConfirmationCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifyEmailConfirmationCodeQuery,
        VerifyEmailConfirmationCodeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerifyEmailConfirmationCodeQuery | undefined,
  VerifyEmailConfirmationCodeQueryVariables
>;
export function useVerifyEmailConfirmationCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifyEmailConfirmationCodeQuery,
        VerifyEmailConfirmationCodeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerifyEmailConfirmationCodeQuery,
    VerifyEmailConfirmationCodeQueryVariables
  >(VerifyEmailConfirmationCodeDocument, options);
}
export type VerifyEmailConfirmationCodeQueryHookResult = ReturnType<
  typeof useVerifyEmailConfirmationCodeQuery
>;
export type VerifyEmailConfirmationCodeLazyQueryHookResult = ReturnType<
  typeof useVerifyEmailConfirmationCodeLazyQuery
>;
export type VerifyEmailConfirmationCodeSuspenseQueryHookResult = ReturnType<
  typeof useVerifyEmailConfirmationCodeSuspenseQuery
>;
export type VerifyEmailConfirmationCodeQueryResult = Apollo.QueryResult<
  VerifyEmailConfirmationCodeQuery,
  VerifyEmailConfirmationCodeQueryVariables
>;
export const CheckEmployeeDocument = gql`
    query CheckEmployee($ssn: String!, $employeeBirthDate: Date!) {
  checkEmployee(ssn: $ssn, employeeBirthDate: $employeeBirthDate) {
    isEmployeeFrozen
  }
}
    `;

/**
 * __useCheckEmployeeQuery__
 *
 * To run a query within a React component, call `useCheckEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmployeeQuery({
 *   variables: {
 *      ssn: // value for 'ssn'
 *      employeeBirthDate: // value for 'employeeBirthDate'
 *   },
 * });
 */
export function useCheckEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<CheckEmployeeQuery, CheckEmployeeQueryVariables> &
    ({ variables: CheckEmployeeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckEmployeeQuery, CheckEmployeeQueryVariables>(
    CheckEmployeeDocument,
    options,
  );
}
export function useCheckEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckEmployeeQuery, CheckEmployeeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckEmployeeQuery, CheckEmployeeQueryVariables>(
    CheckEmployeeDocument,
    options,
  );
}
// @ts-ignore
export function useCheckEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CheckEmployeeQuery, CheckEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<CheckEmployeeQuery, CheckEmployeeQueryVariables>;
export function useCheckEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckEmployeeQuery, CheckEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<CheckEmployeeQuery | undefined, CheckEmployeeQueryVariables>;
export function useCheckEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckEmployeeQuery, CheckEmployeeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckEmployeeQuery, CheckEmployeeQueryVariables>(
    CheckEmployeeDocument,
    options,
  );
}
export type CheckEmployeeQueryHookResult = ReturnType<typeof useCheckEmployeeQuery>;
export type CheckEmployeeLazyQueryHookResult = ReturnType<typeof useCheckEmployeeLazyQuery>;
export type CheckEmployeeSuspenseQueryHookResult = ReturnType<typeof useCheckEmployeeSuspenseQuery>;
export type CheckEmployeeQueryResult = Apollo.QueryResult<
  CheckEmployeeQuery,
  CheckEmployeeQueryVariables
>;
export const GetEmployeeInfoForVerificationRequestDocument = gql`
    query GetEmployeeInfoForVerificationRequest($employeeId: ID!) {
  getEmployeeInfoForVerificationRequest(employeeId: $employeeId) {
    ...EmployeeInfoForVerificationRequestItem
  }
}
    ${EmployeeInfoForVerificationRequestItemFragmentDoc}`;

/**
 * __useGetEmployeeInfoForVerificationRequestQuery__
 *
 * To run a query within a React component, call `useGetEmployeeInfoForVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeInfoForVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeInfoForVerificationRequestQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetEmployeeInfoForVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeInfoForVerificationRequestQuery,
    GetEmployeeInfoForVerificationRequestQueryVariables
  > &
    (
      | { variables: GetEmployeeInfoForVerificationRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeInfoForVerificationRequestQuery,
    GetEmployeeInfoForVerificationRequestQueryVariables
  >(GetEmployeeInfoForVerificationRequestDocument, options);
}
export function useGetEmployeeInfoForVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeInfoForVerificationRequestQuery,
    GetEmployeeInfoForVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeInfoForVerificationRequestQuery,
    GetEmployeeInfoForVerificationRequestQueryVariables
  >(GetEmployeeInfoForVerificationRequestDocument, options);
}
// @ts-ignore
export function useGetEmployeeInfoForVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeInfoForVerificationRequestQuery,
    GetEmployeeInfoForVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInfoForVerificationRequestQuery,
  GetEmployeeInfoForVerificationRequestQueryVariables
>;
export function useGetEmployeeInfoForVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInfoForVerificationRequestQuery,
        GetEmployeeInfoForVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInfoForVerificationRequestQuery | undefined,
  GetEmployeeInfoForVerificationRequestQueryVariables
>;
export function useGetEmployeeInfoForVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInfoForVerificationRequestQuery,
        GetEmployeeInfoForVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeInfoForVerificationRequestQuery,
    GetEmployeeInfoForVerificationRequestQueryVariables
  >(GetEmployeeInfoForVerificationRequestDocument, options);
}
export type GetEmployeeInfoForVerificationRequestQueryHookResult = ReturnType<
  typeof useGetEmployeeInfoForVerificationRequestQuery
>;
export type GetEmployeeInfoForVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeInfoForVerificationRequestLazyQuery
>;
export type GetEmployeeInfoForVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeInfoForVerificationRequestSuspenseQuery
>;
export type GetEmployeeInfoForVerificationRequestQueryResult = Apollo.QueryResult<
  GetEmployeeInfoForVerificationRequestQuery,
  GetEmployeeInfoForVerificationRequestQueryVariables
>;
export const GetEmployeeForPeoAccessSearchDocument = gql`
    query GetEmployeeForPeoAccessSearch($employeeSsn: String!, $peoId: ID) {
  getEmployeeForPeoAccessSearch(employeeSsn: $employeeSsn, peoId: $peoId) {
    ...EmployeeForPeoAccessSearchInfo
  }
}
    ${EmployeeForPeoAccessSearchInfoFragmentDoc}`;

/**
 * __useGetEmployeeForPeoAccessSearchQuery__
 *
 * To run a query within a React component, call `useGetEmployeeForPeoAccessSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeForPeoAccessSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeForPeoAccessSearchQuery({
 *   variables: {
 *      employeeSsn: // value for 'employeeSsn'
 *      peoId: // value for 'peoId'
 *   },
 * });
 */
export function useGetEmployeeForPeoAccessSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeForPeoAccessSearchQuery,
    GetEmployeeForPeoAccessSearchQueryVariables
  > &
    (
      | { variables: GetEmployeeForPeoAccessSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeForPeoAccessSearchQuery,
    GetEmployeeForPeoAccessSearchQueryVariables
  >(GetEmployeeForPeoAccessSearchDocument, options);
}
export function useGetEmployeeForPeoAccessSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeForPeoAccessSearchQuery,
    GetEmployeeForPeoAccessSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeForPeoAccessSearchQuery,
    GetEmployeeForPeoAccessSearchQueryVariables
  >(GetEmployeeForPeoAccessSearchDocument, options);
}
// @ts-ignore
export function useGetEmployeeForPeoAccessSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeForPeoAccessSearchQuery,
    GetEmployeeForPeoAccessSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeForPeoAccessSearchQuery,
  GetEmployeeForPeoAccessSearchQueryVariables
>;
export function useGetEmployeeForPeoAccessSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeForPeoAccessSearchQuery,
        GetEmployeeForPeoAccessSearchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeForPeoAccessSearchQuery | undefined,
  GetEmployeeForPeoAccessSearchQueryVariables
>;
export function useGetEmployeeForPeoAccessSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeForPeoAccessSearchQuery,
        GetEmployeeForPeoAccessSearchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeForPeoAccessSearchQuery,
    GetEmployeeForPeoAccessSearchQueryVariables
  >(GetEmployeeForPeoAccessSearchDocument, options);
}
export type GetEmployeeForPeoAccessSearchQueryHookResult = ReturnType<
  typeof useGetEmployeeForPeoAccessSearchQuery
>;
export type GetEmployeeForPeoAccessSearchLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeForPeoAccessSearchLazyQuery
>;
export type GetEmployeeForPeoAccessSearchSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeForPeoAccessSearchSuspenseQuery
>;
export type GetEmployeeForPeoAccessSearchQueryResult = Apollo.QueryResult<
  GetEmployeeForPeoAccessSearchQuery,
  GetEmployeeForPeoAccessSearchQueryVariables
>;
export const DeleteEmployeeAccountDataDocument = gql`
    mutation DeleteEmployeeAccountData($employeeId: ID!) {
  deleteEmployeeAccountData(employeeId: $employeeId) {
    success
  }
}
    `;
export type DeleteEmployeeAccountDataMutationFn = Apollo.MutationFunction<
  DeleteEmployeeAccountDataMutation,
  DeleteEmployeeAccountDataMutationVariables
>;

/**
 * __useDeleteEmployeeAccountDataMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeAccountDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeAccountDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeAccountDataMutation, { data, loading, error }] = useDeleteEmployeeAccountDataMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteEmployeeAccountDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEmployeeAccountDataMutation,
    DeleteEmployeeAccountDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEmployeeAccountDataMutation,
    DeleteEmployeeAccountDataMutationVariables
  >(DeleteEmployeeAccountDataDocument, options);
}
export type DeleteEmployeeAccountDataMutationHookResult = ReturnType<
  typeof useDeleteEmployeeAccountDataMutation
>;
export type DeleteEmployeeAccountDataMutationResult =
  Apollo.MutationResult<DeleteEmployeeAccountDataMutation>;
export type DeleteEmployeeAccountDataMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeAccountDataMutation,
  DeleteEmployeeAccountDataMutationVariables
>;
export const ReactivateEmployeeAccountDocument = gql`
    mutation ReactivateEmployeeAccount($employeeId: ID!) {
  reactivateEmployeeAccount(employeeId: $employeeId) {
    success
  }
}
    `;
export type ReactivateEmployeeAccountMutationFn = Apollo.MutationFunction<
  ReactivateEmployeeAccountMutation,
  ReactivateEmployeeAccountMutationVariables
>;

/**
 * __useReactivateEmployeeAccountMutation__
 *
 * To run a mutation, you first call `useReactivateEmployeeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateEmployeeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateEmployeeAccountMutation, { data, loading, error }] = useReactivateEmployeeAccountMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useReactivateEmployeeAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReactivateEmployeeAccountMutation,
    ReactivateEmployeeAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReactivateEmployeeAccountMutation,
    ReactivateEmployeeAccountMutationVariables
  >(ReactivateEmployeeAccountDocument, options);
}
export type ReactivateEmployeeAccountMutationHookResult = ReturnType<
  typeof useReactivateEmployeeAccountMutation
>;
export type ReactivateEmployeeAccountMutationResult =
  Apollo.MutationResult<ReactivateEmployeeAccountMutation>;
export type ReactivateEmployeeAccountMutationOptions = Apollo.BaseMutationOptions<
  ReactivateEmployeeAccountMutation,
  ReactivateEmployeeAccountMutationVariables
>;
export const DeleteEmployeeUserDocument = gql`
    mutation DeleteEmployeeUser($employeeId: ID!) {
  deleteEmployeeUser(employeeId: $employeeId) {
    success
  }
}
    `;
export type DeleteEmployeeUserMutationFn = Apollo.MutationFunction<
  DeleteEmployeeUserMutation,
  DeleteEmployeeUserMutationVariables
>;

/**
 * __useDeleteEmployeeUserMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeUserMutation, { data, loading, error }] = useDeleteEmployeeUserMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteEmployeeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEmployeeUserMutation,
    DeleteEmployeeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeUserMutation, DeleteEmployeeUserMutationVariables>(
    DeleteEmployeeUserDocument,
    options,
  );
}
export type DeleteEmployeeUserMutationHookResult = ReturnType<typeof useDeleteEmployeeUserMutation>;
export type DeleteEmployeeUserMutationResult = Apollo.MutationResult<DeleteEmployeeUserMutation>;
export type DeleteEmployeeUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeUserMutation,
  DeleteEmployeeUserMutationVariables
>;
export const CheckDeletionEmployeeUserDocument = gql`
    query CheckDeletionEmployeeUser($employeeId: ID!) {
  checkDeletionEmployeeUser(employeeId: $employeeId) {
    valid
    errors
  }
}
    `;

/**
 * __useCheckDeletionEmployeeUserQuery__
 *
 * To run a query within a React component, call `useCheckDeletionEmployeeUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDeletionEmployeeUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDeletionEmployeeUserQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useCheckDeletionEmployeeUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckDeletionEmployeeUserQuery,
    CheckDeletionEmployeeUserQueryVariables
  > &
    ({ variables: CheckDeletionEmployeeUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckDeletionEmployeeUserQuery, CheckDeletionEmployeeUserQueryVariables>(
    CheckDeletionEmployeeUserDocument,
    options,
  );
}
export function useCheckDeletionEmployeeUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckDeletionEmployeeUserQuery,
    CheckDeletionEmployeeUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckDeletionEmployeeUserQuery,
    CheckDeletionEmployeeUserQueryVariables
  >(CheckDeletionEmployeeUserDocument, options);
}
// @ts-ignore
export function useCheckDeletionEmployeeUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckDeletionEmployeeUserQuery,
    CheckDeletionEmployeeUserQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionEmployeeUserQuery,
  CheckDeletionEmployeeUserQueryVariables
>;
export function useCheckDeletionEmployeeUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionEmployeeUserQuery,
        CheckDeletionEmployeeUserQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionEmployeeUserQuery | undefined,
  CheckDeletionEmployeeUserQueryVariables
>;
export function useCheckDeletionEmployeeUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionEmployeeUserQuery,
        CheckDeletionEmployeeUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckDeletionEmployeeUserQuery,
    CheckDeletionEmployeeUserQueryVariables
  >(CheckDeletionEmployeeUserDocument, options);
}
export type CheckDeletionEmployeeUserQueryHookResult = ReturnType<
  typeof useCheckDeletionEmployeeUserQuery
>;
export type CheckDeletionEmployeeUserLazyQueryHookResult = ReturnType<
  typeof useCheckDeletionEmployeeUserLazyQuery
>;
export type CheckDeletionEmployeeUserSuspenseQueryHookResult = ReturnType<
  typeof useCheckDeletionEmployeeUserSuspenseQuery
>;
export type CheckDeletionEmployeeUserQueryResult = Apollo.QueryResult<
  CheckDeletionEmployeeUserQuery,
  CheckDeletionEmployeeUserQueryVariables
>;
export const GetEmployeeDataForMyDataDocument = gql`
    query GetEmployeeDataForMyData {
  getEmployeeDataForMyData {
    ...EmployeeDataInfo
  }
}
    ${EmployeeDataInfoFragmentDoc}`;

/**
 * __useGetEmployeeDataForMyDataQuery__
 *
 * To run a query within a React component, call `useGetEmployeeDataForMyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeDataForMyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeDataForMyDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeDataForMyDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeeDataForMyDataQuery,
    GetEmployeeDataForMyDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeDataForMyDataQuery, GetEmployeeDataForMyDataQueryVariables>(
    GetEmployeeDataForMyDataDocument,
    options,
  );
}
export function useGetEmployeeDataForMyDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeDataForMyDataQuery,
    GetEmployeeDataForMyDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeDataForMyDataQuery, GetEmployeeDataForMyDataQueryVariables>(
    GetEmployeeDataForMyDataDocument,
    options,
  );
}
// @ts-ignore
export function useGetEmployeeDataForMyDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeDataForMyDataQuery,
    GetEmployeeDataForMyDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataForMyDataQuery,
  GetEmployeeDataForMyDataQueryVariables
>;
export function useGetEmployeeDataForMyDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataForMyDataQuery,
        GetEmployeeDataForMyDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataForMyDataQuery | undefined,
  GetEmployeeDataForMyDataQueryVariables
>;
export function useGetEmployeeDataForMyDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataForMyDataQuery,
        GetEmployeeDataForMyDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeDataForMyDataQuery,
    GetEmployeeDataForMyDataQueryVariables
  >(GetEmployeeDataForMyDataDocument, options);
}
export type GetEmployeeDataForMyDataQueryHookResult = ReturnType<
  typeof useGetEmployeeDataForMyDataQuery
>;
export type GetEmployeeDataForMyDataLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeDataForMyDataLazyQuery
>;
export type GetEmployeeDataForMyDataSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeDataForMyDataSuspenseQuery
>;
export type GetEmployeeDataForMyDataQueryResult = Apollo.QueryResult<
  GetEmployeeDataForMyDataQuery,
  GetEmployeeDataForMyDataQueryVariables
>;
export const GetEmployeeDataOnEmployeeSignupDocument = gql`
    query GetEmployeeDataOnEmployeeSignup($employeeSignupToken: String!) {
  getEmployeeDataOnEmployeeSignup(employeeSignupToken: $employeeSignupToken) {
    ...EmployeeDataInfo
  }
}
    ${EmployeeDataInfoFragmentDoc}`;

/**
 * __useGetEmployeeDataOnEmployeeSignupQuery__
 *
 * To run a query within a React component, call `useGetEmployeeDataOnEmployeeSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeDataOnEmployeeSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeDataOnEmployeeSignupQuery({
 *   variables: {
 *      employeeSignupToken: // value for 'employeeSignupToken'
 *   },
 * });
 */
export function useGetEmployeeDataOnEmployeeSignupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeDataOnEmployeeSignupQuery,
    GetEmployeeDataOnEmployeeSignupQueryVariables
  > &
    (
      | { variables: GetEmployeeDataOnEmployeeSignupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeDataOnEmployeeSignupQuery,
    GetEmployeeDataOnEmployeeSignupQueryVariables
  >(GetEmployeeDataOnEmployeeSignupDocument, options);
}
export function useGetEmployeeDataOnEmployeeSignupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeDataOnEmployeeSignupQuery,
    GetEmployeeDataOnEmployeeSignupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeDataOnEmployeeSignupQuery,
    GetEmployeeDataOnEmployeeSignupQueryVariables
  >(GetEmployeeDataOnEmployeeSignupDocument, options);
}
// @ts-ignore
export function useGetEmployeeDataOnEmployeeSignupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeDataOnEmployeeSignupQuery,
    GetEmployeeDataOnEmployeeSignupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSignupQuery,
  GetEmployeeDataOnEmployeeSignupQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSignupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSignupQuery,
        GetEmployeeDataOnEmployeeSignupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSignupQuery | undefined,
  GetEmployeeDataOnEmployeeSignupQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSignupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSignupQuery,
        GetEmployeeDataOnEmployeeSignupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeDataOnEmployeeSignupQuery,
    GetEmployeeDataOnEmployeeSignupQueryVariables
  >(GetEmployeeDataOnEmployeeSignupDocument, options);
}
export type GetEmployeeDataOnEmployeeSignupQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSignupQuery
>;
export type GetEmployeeDataOnEmployeeSignupLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSignupLazyQuery
>;
export type GetEmployeeDataOnEmployeeSignupSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSignupSuspenseQuery
>;
export type GetEmployeeDataOnEmployeeSignupQueryResult = Apollo.QueryResult<
  GetEmployeeDataOnEmployeeSignupQuery,
  GetEmployeeDataOnEmployeeSignupQueryVariables
>;
export const GetEmployeeDataOnEmployeeSignupByInviteDocument = gql`
    query GetEmployeeDataOnEmployeeSignupByInvite($inviteId: ID!) {
  getEmployeeDataOnEmployeeSignupByInvite(inviteId: $inviteId) {
    ...EmployeeDataInfo
  }
}
    ${EmployeeDataInfoFragmentDoc}`;

/**
 * __useGetEmployeeDataOnEmployeeSignupByInviteQuery__
 *
 * To run a query within a React component, call `useGetEmployeeDataOnEmployeeSignupByInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeDataOnEmployeeSignupByInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeDataOnEmployeeSignupByInviteQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useGetEmployeeDataOnEmployeeSignupByInviteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeDataOnEmployeeSignupByInviteQuery,
    GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
  > &
    (
      | { variables: GetEmployeeDataOnEmployeeSignupByInviteQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeDataOnEmployeeSignupByInviteQuery,
    GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
  >(GetEmployeeDataOnEmployeeSignupByInviteDocument, options);
}
export function useGetEmployeeDataOnEmployeeSignupByInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeDataOnEmployeeSignupByInviteQuery,
    GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeDataOnEmployeeSignupByInviteQuery,
    GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
  >(GetEmployeeDataOnEmployeeSignupByInviteDocument, options);
}
// @ts-ignore
export function useGetEmployeeDataOnEmployeeSignupByInviteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeDataOnEmployeeSignupByInviteQuery,
    GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSignupByInviteQuery,
  GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSignupByInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSignupByInviteQuery,
        GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSignupByInviteQuery | undefined,
  GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSignupByInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSignupByInviteQuery,
        GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeDataOnEmployeeSignupByInviteQuery,
    GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
  >(GetEmployeeDataOnEmployeeSignupByInviteDocument, options);
}
export type GetEmployeeDataOnEmployeeSignupByInviteQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSignupByInviteQuery
>;
export type GetEmployeeDataOnEmployeeSignupByInviteLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSignupByInviteLazyQuery
>;
export type GetEmployeeDataOnEmployeeSignupByInviteSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSignupByInviteSuspenseQuery
>;
export type GetEmployeeDataOnEmployeeSignupByInviteQueryResult = Apollo.QueryResult<
  GetEmployeeDataOnEmployeeSignupByInviteQuery,
  GetEmployeeDataOnEmployeeSignupByInviteQueryVariables
>;
export const GetEmployeeDataOnEmployeeSearchForAdminDocument = gql`
    query GetEmployeeDataOnEmployeeSearchForAdmin($employeeSsnEncrypted: String!, $limit: Int!, $cursor: ID, $companyFilter: EmployeeSearchCompanyFilterInput) {
  getEmployeeDataOnEmployeeSearchForAdmin(
    employeeSsnEncrypted: $employeeSsnEncrypted
    limit: $limit
    cursor: $cursor
    companyFilter: $companyFilter
  ) {
    result {
      ...EmployeeDataInfo
    }
    employmentRecordsHasNextPage
    employmentRecordsCursor
  }
}
    ${EmployeeDataInfoFragmentDoc}`;

/**
 * __useGetEmployeeDataOnEmployeeSearchForAdminQuery__
 *
 * To run a query within a React component, call `useGetEmployeeDataOnEmployeeSearchForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeDataOnEmployeeSearchForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeDataOnEmployeeSearchForAdminQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      companyFilter: // value for 'companyFilter'
 *   },
 * });
 */
export function useGetEmployeeDataOnEmployeeSearchForAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeDataOnEmployeeSearchForAdminQuery,
    GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
  > &
    (
      | { variables: GetEmployeeDataOnEmployeeSearchForAdminQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeDataOnEmployeeSearchForAdminQuery,
    GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
  >(GetEmployeeDataOnEmployeeSearchForAdminDocument, options);
}
export function useGetEmployeeDataOnEmployeeSearchForAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeDataOnEmployeeSearchForAdminQuery,
    GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeDataOnEmployeeSearchForAdminQuery,
    GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
  >(GetEmployeeDataOnEmployeeSearchForAdminDocument, options);
}
// @ts-ignore
export function useGetEmployeeDataOnEmployeeSearchForAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeDataOnEmployeeSearchForAdminQuery,
    GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSearchForAdminQuery,
  GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSearchForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSearchForAdminQuery,
        GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSearchForAdminQuery | undefined,
  GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSearchForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSearchForAdminQuery,
        GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeDataOnEmployeeSearchForAdminQuery,
    GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
  >(GetEmployeeDataOnEmployeeSearchForAdminDocument, options);
}
export type GetEmployeeDataOnEmployeeSearchForAdminQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSearchForAdminQuery
>;
export type GetEmployeeDataOnEmployeeSearchForAdminLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSearchForAdminLazyQuery
>;
export type GetEmployeeDataOnEmployeeSearchForAdminSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSearchForAdminSuspenseQuery
>;
export type GetEmployeeDataOnEmployeeSearchForAdminQueryResult = Apollo.QueryResult<
  GetEmployeeDataOnEmployeeSearchForAdminQuery,
  GetEmployeeDataOnEmployeeSearchForAdminQueryVariables
>;
export const GetEmployeeDataOnEmployeeSearchForEmployerScopeDocument = gql`
    query GetEmployeeDataOnEmployeeSearchForEmployerScope($employeeSsnEncrypted: String!, $limit: Int!, $cursor: ID, $companyFilter: EmployeeSearchCompanyFilterInput) {
  getEmployeeDataOnEmployeeSearchForEmployerScope(
    employeeSsnEncrypted: $employeeSsnEncrypted
    limit: $limit
    cursor: $cursor
    companyFilter: $companyFilter
  ) {
    result {
      ...EmployeeDataInfo
    }
    employmentRecordsHasNextPage
    employmentRecordsCursor
  }
}
    ${EmployeeDataInfoFragmentDoc}`;

/**
 * __useGetEmployeeDataOnEmployeeSearchForEmployerScopeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeDataOnEmployeeSearchForEmployerScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeDataOnEmployeeSearchForEmployerScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeDataOnEmployeeSearchForEmployerScopeQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      companyFilter: // value for 'companyFilter'
 *   },
 * });
 */
export function useGetEmployeeDataOnEmployeeSearchForEmployerScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
  > &
    (
      | { variables: GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
  >(GetEmployeeDataOnEmployeeSearchForEmployerScopeDocument, options);
}
export function useGetEmployeeDataOnEmployeeSearchForEmployerScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
  >(GetEmployeeDataOnEmployeeSearchForEmployerScopeDocument, options);
}
// @ts-ignore
export function useGetEmployeeDataOnEmployeeSearchForEmployerScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
  GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSearchForEmployerScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
        GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery | undefined,
  GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
>;
export function useGetEmployeeDataOnEmployeeSearchForEmployerScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
        GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
    GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
  >(GetEmployeeDataOnEmployeeSearchForEmployerScopeDocument, options);
}
export type GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSearchForEmployerScopeQuery
>;
export type GetEmployeeDataOnEmployeeSearchForEmployerScopeLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSearchForEmployerScopeLazyQuery
>;
export type GetEmployeeDataOnEmployeeSearchForEmployerScopeSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeDataOnEmployeeSearchForEmployerScopeSuspenseQuery
>;
export type GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryResult = Apollo.QueryResult<
  GetEmployeeDataOnEmployeeSearchForEmployerScopeQuery,
  GetEmployeeDataOnEmployeeSearchForEmployerScopeQueryVariables
>;
export const GetEmployeeInviteEmailOptionsForAdminDocument = gql`
    query GetEmployeeInviteEmailOptionsForAdmin($employeeSsnEncrypted: String!) {
  getEmployeeInviteEmailOptionsForAdmin(
    employeeSsnEncrypted: $employeeSsnEncrypted
  ) {
    ...EmployeeInviteEmailOptionInfo
  }
}
    ${EmployeeInviteEmailOptionInfoFragmentDoc}`;

/**
 * __useGetEmployeeInviteEmailOptionsForAdminQuery__
 *
 * To run a query within a React component, call `useGetEmployeeInviteEmailOptionsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeInviteEmailOptionsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeInviteEmailOptionsForAdminQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *   },
 * });
 */
export function useGetEmployeeInviteEmailOptionsForAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeInviteEmailOptionsForAdminQuery,
    GetEmployeeInviteEmailOptionsForAdminQueryVariables
  > &
    (
      | { variables: GetEmployeeInviteEmailOptionsForAdminQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeInviteEmailOptionsForAdminQuery,
    GetEmployeeInviteEmailOptionsForAdminQueryVariables
  >(GetEmployeeInviteEmailOptionsForAdminDocument, options);
}
export function useGetEmployeeInviteEmailOptionsForAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeInviteEmailOptionsForAdminQuery,
    GetEmployeeInviteEmailOptionsForAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeInviteEmailOptionsForAdminQuery,
    GetEmployeeInviteEmailOptionsForAdminQueryVariables
  >(GetEmployeeInviteEmailOptionsForAdminDocument, options);
}
// @ts-ignore
export function useGetEmployeeInviteEmailOptionsForAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeInviteEmailOptionsForAdminQuery,
    GetEmployeeInviteEmailOptionsForAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInviteEmailOptionsForAdminQuery,
  GetEmployeeInviteEmailOptionsForAdminQueryVariables
>;
export function useGetEmployeeInviteEmailOptionsForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInviteEmailOptionsForAdminQuery,
        GetEmployeeInviteEmailOptionsForAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInviteEmailOptionsForAdminQuery | undefined,
  GetEmployeeInviteEmailOptionsForAdminQueryVariables
>;
export function useGetEmployeeInviteEmailOptionsForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInviteEmailOptionsForAdminQuery,
        GetEmployeeInviteEmailOptionsForAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeInviteEmailOptionsForAdminQuery,
    GetEmployeeInviteEmailOptionsForAdminQueryVariables
  >(GetEmployeeInviteEmailOptionsForAdminDocument, options);
}
export type GetEmployeeInviteEmailOptionsForAdminQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteEmailOptionsForAdminQuery
>;
export type GetEmployeeInviteEmailOptionsForAdminLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteEmailOptionsForAdminLazyQuery
>;
export type GetEmployeeInviteEmailOptionsForAdminSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteEmailOptionsForAdminSuspenseQuery
>;
export type GetEmployeeInviteEmailOptionsForAdminQueryResult = Apollo.QueryResult<
  GetEmployeeInviteEmailOptionsForAdminQuery,
  GetEmployeeInviteEmailOptionsForAdminQueryVariables
>;
export const GetEmployeeInviteEmailOptionsForEmployerScopeDocument = gql`
    query GetEmployeeInviteEmailOptionsForEmployerScope($employeeSsnEncrypted: String!) {
  getEmployeeInviteEmailOptionsForEmployerScope(
    employeeSsnEncrypted: $employeeSsnEncrypted
  ) {
    ...EmployeeInviteEmailOptionInfo
  }
}
    ${EmployeeInviteEmailOptionInfoFragmentDoc}`;

/**
 * __useGetEmployeeInviteEmailOptionsForEmployerScopeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeInviteEmailOptionsForEmployerScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeInviteEmailOptionsForEmployerScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeInviteEmailOptionsForEmployerScopeQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *   },
 * });
 */
export function useGetEmployeeInviteEmailOptionsForEmployerScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
    GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
  > &
    (
      | { variables: GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
    GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
  >(GetEmployeeInviteEmailOptionsForEmployerScopeDocument, options);
}
export function useGetEmployeeInviteEmailOptionsForEmployerScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
    GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
    GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
  >(GetEmployeeInviteEmailOptionsForEmployerScopeDocument, options);
}
// @ts-ignore
export function useGetEmployeeInviteEmailOptionsForEmployerScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
    GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
  GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
>;
export function useGetEmployeeInviteEmailOptionsForEmployerScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
        GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInviteEmailOptionsForEmployerScopeQuery | undefined,
  GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
>;
export function useGetEmployeeInviteEmailOptionsForEmployerScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
        GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
    GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
  >(GetEmployeeInviteEmailOptionsForEmployerScopeDocument, options);
}
export type GetEmployeeInviteEmailOptionsForEmployerScopeQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteEmailOptionsForEmployerScopeQuery
>;
export type GetEmployeeInviteEmailOptionsForEmployerScopeLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteEmailOptionsForEmployerScopeLazyQuery
>;
export type GetEmployeeInviteEmailOptionsForEmployerScopeSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteEmailOptionsForEmployerScopeSuspenseQuery
>;
export type GetEmployeeInviteEmailOptionsForEmployerScopeQueryResult = Apollo.QueryResult<
  GetEmployeeInviteEmailOptionsForEmployerScopeQuery,
  GetEmployeeInviteEmailOptionsForEmployerScopeQueryVariables
>;
export const GetEmployeeInviteLinkScopeForAdminDocument = gql`
    query GetEmployeeInviteLinkScopeForAdmin($employeeSsnEncrypted: String!) {
  getEmployeeInviteLinkScopeForAdmin(employeeSsnEncrypted: $employeeSsnEncrypted) {
    route
    paramKey
    entityId
    entityDisplayName
  }
}
    `;

/**
 * __useGetEmployeeInviteLinkScopeForAdminQuery__
 *
 * To run a query within a React component, call `useGetEmployeeInviteLinkScopeForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeInviteLinkScopeForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeInviteLinkScopeForAdminQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *   },
 * });
 */
export function useGetEmployeeInviteLinkScopeForAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeInviteLinkScopeForAdminQuery,
    GetEmployeeInviteLinkScopeForAdminQueryVariables
  > &
    (
      | { variables: GetEmployeeInviteLinkScopeForAdminQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeInviteLinkScopeForAdminQuery,
    GetEmployeeInviteLinkScopeForAdminQueryVariables
  >(GetEmployeeInviteLinkScopeForAdminDocument, options);
}
export function useGetEmployeeInviteLinkScopeForAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeInviteLinkScopeForAdminQuery,
    GetEmployeeInviteLinkScopeForAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeInviteLinkScopeForAdminQuery,
    GetEmployeeInviteLinkScopeForAdminQueryVariables
  >(GetEmployeeInviteLinkScopeForAdminDocument, options);
}
// @ts-ignore
export function useGetEmployeeInviteLinkScopeForAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeInviteLinkScopeForAdminQuery,
    GetEmployeeInviteLinkScopeForAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInviteLinkScopeForAdminQuery,
  GetEmployeeInviteLinkScopeForAdminQueryVariables
>;
export function useGetEmployeeInviteLinkScopeForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInviteLinkScopeForAdminQuery,
        GetEmployeeInviteLinkScopeForAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeInviteLinkScopeForAdminQuery | undefined,
  GetEmployeeInviteLinkScopeForAdminQueryVariables
>;
export function useGetEmployeeInviteLinkScopeForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeInviteLinkScopeForAdminQuery,
        GetEmployeeInviteLinkScopeForAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeeInviteLinkScopeForAdminQuery,
    GetEmployeeInviteLinkScopeForAdminQueryVariables
  >(GetEmployeeInviteLinkScopeForAdminDocument, options);
}
export type GetEmployeeInviteLinkScopeForAdminQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteLinkScopeForAdminQuery
>;
export type GetEmployeeInviteLinkScopeForAdminLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteLinkScopeForAdminLazyQuery
>;
export type GetEmployeeInviteLinkScopeForAdminSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeInviteLinkScopeForAdminSuspenseQuery
>;
export type GetEmployeeInviteLinkScopeForAdminQueryResult = Apollo.QueryResult<
  GetEmployeeInviteLinkScopeForAdminQuery,
  GetEmployeeInviteLinkScopeForAdminQueryVariables
>;
export const EmployeeNotesDocument = gql`
    query EmployeeNotes($where: EmployeeNoteWhere, $orderBy: [EmployeeNoteOrderBy!]) {
  employeeNoteList(where: $where, orderBy: $orderBy) {
    ...EmployeeNoteInfo
  }
}
    ${EmployeeNoteInfoFragmentDoc}`;

/**
 * __useEmployeeNotesQuery__
 *
 * To run a query within a React component, call `useEmployeeNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNotesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useEmployeeNotesQuery(
  baseOptions?: Apollo.QueryHookOptions<EmployeeNotesQuery, EmployeeNotesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployeeNotesQuery, EmployeeNotesQueryVariables>(
    EmployeeNotesDocument,
    options,
  );
}
export function useEmployeeNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNotesQuery, EmployeeNotesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployeeNotesQuery, EmployeeNotesQueryVariables>(
    EmployeeNotesDocument,
    options,
  );
}
// @ts-ignore
export function useEmployeeNotesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNotesQuery, EmployeeNotesQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployeeNotesQuery, EmployeeNotesQueryVariables>;
export function useEmployeeNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployeeNotesQuery, EmployeeNotesQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployeeNotesQuery | undefined, EmployeeNotesQueryVariables>;
export function useEmployeeNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployeeNotesQuery, EmployeeNotesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployeeNotesQuery, EmployeeNotesQueryVariables>(
    EmployeeNotesDocument,
    options,
  );
}
export type EmployeeNotesQueryHookResult = ReturnType<typeof useEmployeeNotesQuery>;
export type EmployeeNotesLazyQueryHookResult = ReturnType<typeof useEmployeeNotesLazyQuery>;
export type EmployeeNotesSuspenseQueryHookResult = ReturnType<typeof useEmployeeNotesSuspenseQuery>;
export type EmployeeNotesQueryResult = Apollo.QueryResult<
  EmployeeNotesQuery,
  EmployeeNotesQueryVariables
>;
export const CreateEmployeeNoteDocument = gql`
    mutation CreateEmployeeNote($employeeSsnEncrypted: String!, $comment: String!) {
  createEmployeeNote(
    employeeSsnEncrypted: $employeeSsnEncrypted
    comment: $comment
  ) {
    ...EmployeeNoteInfo
  }
}
    ${EmployeeNoteInfoFragmentDoc}`;
export type CreateEmployeeNoteMutationFn = Apollo.MutationFunction<
  CreateEmployeeNoteMutation,
  CreateEmployeeNoteMutationVariables
>;

/**
 * __useCreateEmployeeNoteMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeNoteMutation, { data, loading, error }] = useCreateEmployeeNoteMutation({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateEmployeeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEmployeeNoteMutation,
    CreateEmployeeNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEmployeeNoteMutation, CreateEmployeeNoteMutationVariables>(
    CreateEmployeeNoteDocument,
    options,
  );
}
export type CreateEmployeeNoteMutationHookResult = ReturnType<typeof useCreateEmployeeNoteMutation>;
export type CreateEmployeeNoteMutationResult = Apollo.MutationResult<CreateEmployeeNoteMutation>;
export type CreateEmployeeNoteMutationOptions = Apollo.BaseMutationOptions<
  CreateEmployeeNoteMutation,
  CreateEmployeeNoteMutationVariables
>;
export const SearchEmployeesForAdminDocument = gql`
    query SearchEmployeesForAdmin($input: EmployeeSearchInput!, $companyFilter: EmployeeSearchCompanyFilterInput) {
  searchEmployeesForAdmin(input: $input, companyFilter: $companyFilter) {
    ...EmployeeSearchMatchInfo
  }
}
    ${EmployeeSearchMatchInfoFragmentDoc}`;

/**
 * __useSearchEmployeesForAdminQuery__
 *
 * To run a query within a React component, call `useSearchEmployeesForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmployeesForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmployeesForAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *      companyFilter: // value for 'companyFilter'
 *   },
 * });
 */
export function useSearchEmployeesForAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchEmployeesForAdminQuery,
    SearchEmployeesForAdminQueryVariables
  > &
    ({ variables: SearchEmployeesForAdminQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchEmployeesForAdminQuery, SearchEmployeesForAdminQueryVariables>(
    SearchEmployeesForAdminDocument,
    options,
  );
}
export function useSearchEmployeesForAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchEmployeesForAdminQuery,
    SearchEmployeesForAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchEmployeesForAdminQuery, SearchEmployeesForAdminQueryVariables>(
    SearchEmployeesForAdminDocument,
    options,
  );
}
// @ts-ignore
export function useSearchEmployeesForAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchEmployeesForAdminQuery,
    SearchEmployeesForAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchEmployeesForAdminQuery,
  SearchEmployeesForAdminQueryVariables
>;
export function useSearchEmployeesForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchEmployeesForAdminQuery,
        SearchEmployeesForAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchEmployeesForAdminQuery | undefined,
  SearchEmployeesForAdminQueryVariables
>;
export function useSearchEmployeesForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchEmployeesForAdminQuery,
        SearchEmployeesForAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchEmployeesForAdminQuery,
    SearchEmployeesForAdminQueryVariables
  >(SearchEmployeesForAdminDocument, options);
}
export type SearchEmployeesForAdminQueryHookResult = ReturnType<
  typeof useSearchEmployeesForAdminQuery
>;
export type SearchEmployeesForAdminLazyQueryHookResult = ReturnType<
  typeof useSearchEmployeesForAdminLazyQuery
>;
export type SearchEmployeesForAdminSuspenseQueryHookResult = ReturnType<
  typeof useSearchEmployeesForAdminSuspenseQuery
>;
export type SearchEmployeesForAdminQueryResult = Apollo.QueryResult<
  SearchEmployeesForAdminQuery,
  SearchEmployeesForAdminQueryVariables
>;
export const SearchEmployeesForEmployerScopeDocument = gql`
    query SearchEmployeesForEmployerScope($input: EmployeeSearchInput!, $companyFilter: EmployeeSearchCompanyFilterInput) {
  searchEmployeesForEmployerScope(input: $input, companyFilter: $companyFilter) {
    ...EmployeeSearchMatchInfo
  }
}
    ${EmployeeSearchMatchInfoFragmentDoc}`;

/**
 * __useSearchEmployeesForEmployerScopeQuery__
 *
 * To run a query within a React component, call `useSearchEmployeesForEmployerScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmployeesForEmployerScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmployeesForEmployerScopeQuery({
 *   variables: {
 *      input: // value for 'input'
 *      companyFilter: // value for 'companyFilter'
 *   },
 * });
 */
export function useSearchEmployeesForEmployerScopeQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchEmployeesForEmployerScopeQuery,
    SearchEmployeesForEmployerScopeQueryVariables
  > &
    (
      | { variables: SearchEmployeesForEmployerScopeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchEmployeesForEmployerScopeQuery,
    SearchEmployeesForEmployerScopeQueryVariables
  >(SearchEmployeesForEmployerScopeDocument, options);
}
export function useSearchEmployeesForEmployerScopeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchEmployeesForEmployerScopeQuery,
    SearchEmployeesForEmployerScopeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchEmployeesForEmployerScopeQuery,
    SearchEmployeesForEmployerScopeQueryVariables
  >(SearchEmployeesForEmployerScopeDocument, options);
}
// @ts-ignore
export function useSearchEmployeesForEmployerScopeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchEmployeesForEmployerScopeQuery,
    SearchEmployeesForEmployerScopeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchEmployeesForEmployerScopeQuery,
  SearchEmployeesForEmployerScopeQueryVariables
>;
export function useSearchEmployeesForEmployerScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchEmployeesForEmployerScopeQuery,
        SearchEmployeesForEmployerScopeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchEmployeesForEmployerScopeQuery | undefined,
  SearchEmployeesForEmployerScopeQueryVariables
>;
export function useSearchEmployeesForEmployerScopeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchEmployeesForEmployerScopeQuery,
        SearchEmployeesForEmployerScopeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchEmployeesForEmployerScopeQuery,
    SearchEmployeesForEmployerScopeQueryVariables
  >(SearchEmployeesForEmployerScopeDocument, options);
}
export type SearchEmployeesForEmployerScopeQueryHookResult = ReturnType<
  typeof useSearchEmployeesForEmployerScopeQuery
>;
export type SearchEmployeesForEmployerScopeLazyQueryHookResult = ReturnType<
  typeof useSearchEmployeesForEmployerScopeLazyQuery
>;
export type SearchEmployeesForEmployerScopeSuspenseQueryHookResult = ReturnType<
  typeof useSearchEmployeesForEmployerScopeSuspenseQuery
>;
export type SearchEmployeesForEmployerScopeQueryResult = Apollo.QueryResult<
  SearchEmployeesForEmployerScopeQuery,
  SearchEmployeesForEmployerScopeQueryVariables
>;
export const EmployerDocument = gql`
    query Employer($id: ID!) {
  employer(where: {id: $id}) {
    ...EmployerInfo
  }
}
    ${EmployerInfoFragmentDoc}`;

/**
 * __useEmployerQuery__
 *
 * To run a query within a React component, call `useEmployerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployerQuery(
  baseOptions: Apollo.QueryHookOptions<EmployerQuery, EmployerQueryVariables> &
    ({ variables: EmployerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployerQuery, EmployerQueryVariables>(EmployerDocument, options);
}
export function useEmployerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployerQuery, EmployerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployerQuery, EmployerQueryVariables>(EmployerDocument, options);
}
// @ts-ignore
export function useEmployerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EmployerQuery, EmployerQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployerQuery, EmployerQueryVariables>;
export function useEmployerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerQuery, EmployerQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployerQuery | undefined, EmployerQueryVariables>;
export function useEmployerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerQuery, EmployerQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployerQuery, EmployerQueryVariables>(EmployerDocument, options);
}
export type EmployerQueryHookResult = ReturnType<typeof useEmployerQuery>;
export type EmployerLazyQueryHookResult = ReturnType<typeof useEmployerLazyQuery>;
export type EmployerSuspenseQueryHookResult = ReturnType<typeof useEmployerSuspenseQuery>;
export type EmployerQueryResult = Apollo.QueryResult<EmployerQuery, EmployerQueryVariables>;
export const EmployerUpdateDocument = gql`
    mutation EmployerUpdate($data: EmployerUpdate!, $where: EmployerWhereUnique!) {
  employerUpdate(data: $data, where: $where) {
    ...EmployerInfo
  }
}
    ${EmployerInfoFragmentDoc}`;
export type EmployerUpdateMutationFn = Apollo.MutationFunction<
  EmployerUpdateMutation,
  EmployerUpdateMutationVariables
>;

/**
 * __useEmployerUpdateMutation__
 *
 * To run a mutation, you first call `useEmployerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerUpdateMutation, { data, loading, error }] = useEmployerUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEmployerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<EmployerUpdateMutation, EmployerUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmployerUpdateMutation, EmployerUpdateMutationVariables>(
    EmployerUpdateDocument,
    options,
  );
}
export type EmployerUpdateMutationHookResult = ReturnType<typeof useEmployerUpdateMutation>;
export type EmployerUpdateMutationResult = Apollo.MutationResult<EmployerUpdateMutation>;
export type EmployerUpdateMutationOptions = Apollo.BaseMutationOptions<
  EmployerUpdateMutation,
  EmployerUpdateMutationVariables
>;
export const EmployerUpdateManyDocument = gql`
    mutation EmployerUpdateMany($data: EmployerUpdateMany!, $filter: EmployerWhere!) {
  employerUpdateMany(data: $data, where: $filter)
}
    `;
export type EmployerUpdateManyMutationFn = Apollo.MutationFunction<
  EmployerUpdateManyMutation,
  EmployerUpdateManyMutationVariables
>;

/**
 * __useEmployerUpdateManyMutation__
 *
 * To run a mutation, you first call `useEmployerUpdateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerUpdateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerUpdateManyMutation, { data, loading, error }] = useEmployerUpdateManyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmployerUpdateManyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployerUpdateManyMutation,
    EmployerUpdateManyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmployerUpdateManyMutation, EmployerUpdateManyMutationVariables>(
    EmployerUpdateManyDocument,
    options,
  );
}
export type EmployerUpdateManyMutationHookResult = ReturnType<typeof useEmployerUpdateManyMutation>;
export type EmployerUpdateManyMutationResult = Apollo.MutationResult<EmployerUpdateManyMutation>;
export type EmployerUpdateManyMutationOptions = Apollo.BaseMutationOptions<
  EmployerUpdateManyMutation,
  EmployerUpdateManyMutationVariables
>;
export const EmployersTableListDocument = gql`
    query EmployersTableList($filter: EmployerWhere, $orderBy: [EmployerOrderBy!], $first: Int, $skip: Int) {
  employerCount(where: $filter)
  employerList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...EmployerTableItem
  }
}
    ${EmployerTableItemFragmentDoc}`;

/**
 * __useEmployersTableListQuery__
 *
 * To run a query within a React component, call `useEmployersTableListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployersTableListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployersTableListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useEmployersTableListQuery(
  baseOptions?: Apollo.QueryHookOptions<EmployersTableListQuery, EmployersTableListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployersTableListQuery, EmployersTableListQueryVariables>(
    EmployersTableListDocument,
    options,
  );
}
export function useEmployersTableListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployersTableListQuery,
    EmployersTableListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployersTableListQuery, EmployersTableListQueryVariables>(
    EmployersTableListDocument,
    options,
  );
}
// @ts-ignore
export function useEmployersTableListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployersTableListQuery,
    EmployersTableListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EmployersTableListQuery, EmployersTableListQueryVariables>;
export function useEmployersTableListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployersTableListQuery, EmployersTableListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EmployersTableListQuery | undefined,
  EmployersTableListQueryVariables
>;
export function useEmployersTableListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployersTableListQuery, EmployersTableListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployersTableListQuery, EmployersTableListQueryVariables>(
    EmployersTableListDocument,
    options,
  );
}
export type EmployersTableListQueryHookResult = ReturnType<typeof useEmployersTableListQuery>;
export type EmployersTableListLazyQueryHookResult = ReturnType<
  typeof useEmployersTableListLazyQuery
>;
export type EmployersTableListSuspenseQueryHookResult = ReturnType<
  typeof useEmployersTableListSuspenseQuery
>;
export type EmployersTableListQueryResult = Apollo.QueryResult<
  EmployersTableListQuery,
  EmployersTableListQueryVariables
>;
export const EmployersSimpleListDocument = gql`
    query EmployersSimpleList($filter: EmployerWhere, $orderBy: [EmployerOrderBy!], $first: Int, $skip: Int) {
  employerCount(where: $filter)
  employerList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...EmployerSimpleInfo
  }
}
    ${EmployerSimpleInfoFragmentDoc}`;

/**
 * __useEmployersSimpleListQuery__
 *
 * To run a query within a React component, call `useEmployersSimpleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployersSimpleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployersSimpleListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useEmployersSimpleListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EmployersSimpleListQuery,
    EmployersSimpleListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployersSimpleListQuery, EmployersSimpleListQueryVariables>(
    EmployersSimpleListDocument,
    options,
  );
}
export function useEmployersSimpleListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployersSimpleListQuery,
    EmployersSimpleListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployersSimpleListQuery, EmployersSimpleListQueryVariables>(
    EmployersSimpleListDocument,
    options,
  );
}
// @ts-ignore
export function useEmployersSimpleListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployersSimpleListQuery,
    EmployersSimpleListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EmployersSimpleListQuery, EmployersSimpleListQueryVariables>;
export function useEmployersSimpleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployersSimpleListQuery, EmployersSimpleListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EmployersSimpleListQuery | undefined,
  EmployersSimpleListQueryVariables
>;
export function useEmployersSimpleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployersSimpleListQuery, EmployersSimpleListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployersSimpleListQuery, EmployersSimpleListQueryVariables>(
    EmployersSimpleListDocument,
    options,
  );
}
export type EmployersSimpleListQueryHookResult = ReturnType<typeof useEmployersSimpleListQuery>;
export type EmployersSimpleListLazyQueryHookResult = ReturnType<
  typeof useEmployersSimpleListLazyQuery
>;
export type EmployersSimpleListSuspenseQueryHookResult = ReturnType<
  typeof useEmployersSimpleListSuspenseQuery
>;
export type EmployersSimpleListQueryResult = Apollo.QueryResult<
  EmployersSimpleListQuery,
  EmployersSimpleListQueryVariables
>;
export const EmployerRevenueShareDocument = gql`
    query EmployerRevenueShare($where: EmployerWhereUnique!) {
  employer(where: $where) {
    ...EmployerRevenueShareInfo
  }
}
    ${EmployerRevenueShareInfoFragmentDoc}`;

/**
 * __useEmployerRevenueShareQuery__
 *
 * To run a query within a React component, call `useEmployerRevenueShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerRevenueShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerRevenueShareQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEmployerRevenueShareQuery(
  baseOptions: Apollo.QueryHookOptions<
    EmployerRevenueShareQuery,
    EmployerRevenueShareQueryVariables
  > &
    ({ variables: EmployerRevenueShareQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployerRevenueShareQuery, EmployerRevenueShareQueryVariables>(
    EmployerRevenueShareDocument,
    options,
  );
}
export function useEmployerRevenueShareLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployerRevenueShareQuery,
    EmployerRevenueShareQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployerRevenueShareQuery, EmployerRevenueShareQueryVariables>(
    EmployerRevenueShareDocument,
    options,
  );
}
// @ts-ignore
export function useEmployerRevenueShareSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployerRevenueShareQuery,
    EmployerRevenueShareQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EmployerRevenueShareQuery, EmployerRevenueShareQueryVariables>;
export function useEmployerRevenueShareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EmployerRevenueShareQuery,
        EmployerRevenueShareQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EmployerRevenueShareQuery | undefined,
  EmployerRevenueShareQueryVariables
>;
export function useEmployerRevenueShareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EmployerRevenueShareQuery,
        EmployerRevenueShareQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployerRevenueShareQuery, EmployerRevenueShareQueryVariables>(
    EmployerRevenueShareDocument,
    options,
  );
}
export type EmployerRevenueShareQueryHookResult = ReturnType<typeof useEmployerRevenueShareQuery>;
export type EmployerRevenueShareLazyQueryHookResult = ReturnType<
  typeof useEmployerRevenueShareLazyQuery
>;
export type EmployerRevenueShareSuspenseQueryHookResult = ReturnType<
  typeof useEmployerRevenueShareSuspenseQuery
>;
export type EmployerRevenueShareQueryResult = Apollo.QueryResult<
  EmployerRevenueShareQuery,
  EmployerRevenueShareQueryVariables
>;
export const EmployerRevenueShareUpdateDocument = gql`
    mutation EmployerRevenueShareUpdate($where: EmployerWhereUnique!, $data: EmployerUpdate!) {
  employerUpdate(where: $where, data: $data) {
    ...EmployerRevenueShareInfo
  }
}
    ${EmployerRevenueShareInfoFragmentDoc}`;
export type EmployerRevenueShareUpdateMutationFn = Apollo.MutationFunction<
  EmployerRevenueShareUpdateMutation,
  EmployerRevenueShareUpdateMutationVariables
>;

/**
 * __useEmployerRevenueShareUpdateMutation__
 *
 * To run a mutation, you first call `useEmployerRevenueShareUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerRevenueShareUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerRevenueShareUpdateMutation, { data, loading, error }] = useEmployerRevenueShareUpdateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEmployerRevenueShareUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployerRevenueShareUpdateMutation,
    EmployerRevenueShareUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EmployerRevenueShareUpdateMutation,
    EmployerRevenueShareUpdateMutationVariables
  >(EmployerRevenueShareUpdateDocument, options);
}
export type EmployerRevenueShareUpdateMutationHookResult = ReturnType<
  typeof useEmployerRevenueShareUpdateMutation
>;
export type EmployerRevenueShareUpdateMutationResult =
  Apollo.MutationResult<EmployerRevenueShareUpdateMutation>;
export type EmployerRevenueShareUpdateMutationOptions = Apollo.BaseMutationOptions<
  EmployerRevenueShareUpdateMutation,
  EmployerRevenueShareUpdateMutationVariables
>;
export const GetEmployerBasicInfoDocument = gql`
    query GetEmployerBasicInfo($id: ID!) {
  getEmployerBasicInfo(id: $id) {
    ...EmployerBasicInfo
  }
}
    ${EmployerBasicInfoFragmentDoc}`;

/**
 * __useGetEmployerBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetEmployerBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployerBasicInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployerBasicInfoQuery,
    GetEmployerBasicInfoQueryVariables
  > &
    ({ variables: GetEmployerBasicInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployerBasicInfoQuery, GetEmployerBasicInfoQueryVariables>(
    GetEmployerBasicInfoDocument,
    options,
  );
}
export function useGetEmployerBasicInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployerBasicInfoQuery,
    GetEmployerBasicInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployerBasicInfoQuery, GetEmployerBasicInfoQueryVariables>(
    GetEmployerBasicInfoDocument,
    options,
  );
}
// @ts-ignore
export function useGetEmployerBasicInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployerBasicInfoQuery,
    GetEmployerBasicInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEmployerBasicInfoQuery, GetEmployerBasicInfoQueryVariables>;
export function useGetEmployerBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployerBasicInfoQuery,
        GetEmployerBasicInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployerBasicInfoQuery | undefined,
  GetEmployerBasicInfoQueryVariables
>;
export function useGetEmployerBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployerBasicInfoQuery,
        GetEmployerBasicInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployerBasicInfoQuery, GetEmployerBasicInfoQueryVariables>(
    GetEmployerBasicInfoDocument,
    options,
  );
}
export type GetEmployerBasicInfoQueryHookResult = ReturnType<typeof useGetEmployerBasicInfoQuery>;
export type GetEmployerBasicInfoLazyQueryHookResult = ReturnType<
  typeof useGetEmployerBasicInfoLazyQuery
>;
export type GetEmployerBasicInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployerBasicInfoSuspenseQuery
>;
export type GetEmployerBasicInfoQueryResult = Apollo.QueryResult<
  GetEmployerBasicInfoQuery,
  GetEmployerBasicInfoQueryVariables
>;
export const GetEmployersListForVerificationRequestDocument = gql`
    query GetEmployersListForVerificationRequest($inboxItemId: ID!) {
  getEmployersListForVerificationRequest(inboxItemId: $inboxItemId) {
    isThereInactiveEmployers
    employers {
      ...EmployerListItemForVerificationRequestInfo
    }
  }
}
    ${EmployerListItemForVerificationRequestInfoFragmentDoc}`;

/**
 * __useGetEmployersListForVerificationRequestQuery__
 *
 * To run a query within a React component, call `useGetEmployersListForVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersListForVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersListForVerificationRequestQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useGetEmployersListForVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployersListForVerificationRequestQuery,
    GetEmployersListForVerificationRequestQueryVariables
  > &
    (
      | { variables: GetEmployersListForVerificationRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployersListForVerificationRequestQuery,
    GetEmployersListForVerificationRequestQueryVariables
  >(GetEmployersListForVerificationRequestDocument, options);
}
export function useGetEmployersListForVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployersListForVerificationRequestQuery,
    GetEmployersListForVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployersListForVerificationRequestQuery,
    GetEmployersListForVerificationRequestQueryVariables
  >(GetEmployersListForVerificationRequestDocument, options);
}
// @ts-ignore
export function useGetEmployersListForVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployersListForVerificationRequestQuery,
    GetEmployersListForVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForVerificationRequestQuery,
  GetEmployersListForVerificationRequestQueryVariables
>;
export function useGetEmployersListForVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForVerificationRequestQuery,
        GetEmployersListForVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForVerificationRequestQuery | undefined,
  GetEmployersListForVerificationRequestQueryVariables
>;
export function useGetEmployersListForVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForVerificationRequestQuery,
        GetEmployersListForVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployersListForVerificationRequestQuery,
    GetEmployersListForVerificationRequestQueryVariables
  >(GetEmployersListForVerificationRequestDocument, options);
}
export type GetEmployersListForVerificationRequestQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestQuery
>;
export type GetEmployersListForVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestLazyQuery
>;
export type GetEmployersListForVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestSuspenseQuery
>;
export type GetEmployersListForVerificationRequestQueryResult = Apollo.QueryResult<
  GetEmployersListForVerificationRequestQuery,
  GetEmployersListForVerificationRequestQueryVariables
>;
export const GetEmployersListForVerificationRequestByEmployeeDataDocument = gql`
    query GetEmployersListForVerificationRequestByEmployeeData($employeeSsn: String!, $employeeBirthDate: Date!, $showInactiveEmployers: Boolean) {
  getEmployersListForVerificationRequestByEmployeeData(
    employeeSsn: $employeeSsn
    employeeBirthDate: $employeeBirthDate
    showInactiveEmployers: $showInactiveEmployers
  ) {
    isThereInactiveEmployers
    employers {
      ...EmployerListItemForVerificationRequestInfo
    }
  }
}
    ${EmployerListItemForVerificationRequestInfoFragmentDoc}`;

/**
 * __useGetEmployersListForVerificationRequestByEmployeeDataQuery__
 *
 * To run a query within a React component, call `useGetEmployersListForVerificationRequestByEmployeeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersListForVerificationRequestByEmployeeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersListForVerificationRequestByEmployeeDataQuery({
 *   variables: {
 *      employeeSsn: // value for 'employeeSsn'
 *      employeeBirthDate: // value for 'employeeBirthDate'
 *      showInactiveEmployers: // value for 'showInactiveEmployers'
 *   },
 * });
 */
export function useGetEmployersListForVerificationRequestByEmployeeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployersListForVerificationRequestByEmployeeDataQuery,
    GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
  > &
    (
      | {
          variables: GetEmployersListForVerificationRequestByEmployeeDataQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployersListForVerificationRequestByEmployeeDataQuery,
    GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
  >(GetEmployersListForVerificationRequestByEmployeeDataDocument, options);
}
export function useGetEmployersListForVerificationRequestByEmployeeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployersListForVerificationRequestByEmployeeDataQuery,
    GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployersListForVerificationRequestByEmployeeDataQuery,
    GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
  >(GetEmployersListForVerificationRequestByEmployeeDataDocument, options);
}
// @ts-ignore
export function useGetEmployersListForVerificationRequestByEmployeeDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployersListForVerificationRequestByEmployeeDataQuery,
    GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForVerificationRequestByEmployeeDataQuery,
  GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
>;
export function useGetEmployersListForVerificationRequestByEmployeeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForVerificationRequestByEmployeeDataQuery,
        GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForVerificationRequestByEmployeeDataQuery | undefined,
  GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
>;
export function useGetEmployersListForVerificationRequestByEmployeeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForVerificationRequestByEmployeeDataQuery,
        GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployersListForVerificationRequestByEmployeeDataQuery,
    GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
  >(GetEmployersListForVerificationRequestByEmployeeDataDocument, options);
}
export type GetEmployersListForVerificationRequestByEmployeeDataQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestByEmployeeDataQuery
>;
export type GetEmployersListForVerificationRequestByEmployeeDataLazyQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestByEmployeeDataLazyQuery
>;
export type GetEmployersListForVerificationRequestByEmployeeDataSuspenseQueryHookResult =
  ReturnType<typeof useGetEmployersListForVerificationRequestByEmployeeDataSuspenseQuery>;
export type GetEmployersListForVerificationRequestByEmployeeDataQueryResult = Apollo.QueryResult<
  GetEmployersListForVerificationRequestByEmployeeDataQuery,
  GetEmployersListForVerificationRequestByEmployeeDataQueryVariables
>;
export const GetEmployersListForVerificationRequestForMyVerifyDocument = gql`
    query GetEmployersListForVerificationRequestForMyVerify {
  getEmployersListForVerificationRequestForMyVerify {
    employers {
      ...EmployerListItemForVerificationRequestInfo
    }
  }
}
    ${EmployerListItemForVerificationRequestInfoFragmentDoc}`;

/**
 * __useGetEmployersListForVerificationRequestForMyVerifyQuery__
 *
 * To run a query within a React component, call `useGetEmployersListForVerificationRequestForMyVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersListForVerificationRequestForMyVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersListForVerificationRequestForMyVerifyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployersListForVerificationRequestForMyVerifyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployersListForVerificationRequestForMyVerifyQuery,
    GetEmployersListForVerificationRequestForMyVerifyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployersListForVerificationRequestForMyVerifyQuery,
    GetEmployersListForVerificationRequestForMyVerifyQueryVariables
  >(GetEmployersListForVerificationRequestForMyVerifyDocument, options);
}
export function useGetEmployersListForVerificationRequestForMyVerifyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployersListForVerificationRequestForMyVerifyQuery,
    GetEmployersListForVerificationRequestForMyVerifyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployersListForVerificationRequestForMyVerifyQuery,
    GetEmployersListForVerificationRequestForMyVerifyQueryVariables
  >(GetEmployersListForVerificationRequestForMyVerifyDocument, options);
}
// @ts-ignore
export function useGetEmployersListForVerificationRequestForMyVerifySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployersListForVerificationRequestForMyVerifyQuery,
    GetEmployersListForVerificationRequestForMyVerifyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForVerificationRequestForMyVerifyQuery,
  GetEmployersListForVerificationRequestForMyVerifyQueryVariables
>;
export function useGetEmployersListForVerificationRequestForMyVerifySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForVerificationRequestForMyVerifyQuery,
        GetEmployersListForVerificationRequestForMyVerifyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForVerificationRequestForMyVerifyQuery | undefined,
  GetEmployersListForVerificationRequestForMyVerifyQueryVariables
>;
export function useGetEmployersListForVerificationRequestForMyVerifySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForVerificationRequestForMyVerifyQuery,
        GetEmployersListForVerificationRequestForMyVerifyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployersListForVerificationRequestForMyVerifyQuery,
    GetEmployersListForVerificationRequestForMyVerifyQueryVariables
  >(GetEmployersListForVerificationRequestForMyVerifyDocument, options);
}
export type GetEmployersListForVerificationRequestForMyVerifyQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestForMyVerifyQuery
>;
export type GetEmployersListForVerificationRequestForMyVerifyLazyQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestForMyVerifyLazyQuery
>;
export type GetEmployersListForVerificationRequestForMyVerifySuspenseQueryHookResult = ReturnType<
  typeof useGetEmployersListForVerificationRequestForMyVerifySuspenseQuery
>;
export type GetEmployersListForVerificationRequestForMyVerifyQueryResult = Apollo.QueryResult<
  GetEmployersListForVerificationRequestForMyVerifyQuery,
  GetEmployersListForVerificationRequestForMyVerifyQueryVariables
>;
export const GetEmployersListForWorkLetterDocument = gql`
    query GetEmployersListForWorkLetter {
  getEmployersListForWorkLetter {
    employers {
      ...EmployerListItemForVerificationRequestInfo
    }
  }
}
    ${EmployerListItemForVerificationRequestInfoFragmentDoc}`;

/**
 * __useGetEmployersListForWorkLetterQuery__
 *
 * To run a query within a React component, call `useGetEmployersListForWorkLetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersListForWorkLetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersListForWorkLetterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployersListForWorkLetterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployersListForWorkLetterQuery,
    GetEmployersListForWorkLetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployersListForWorkLetterQuery,
    GetEmployersListForWorkLetterQueryVariables
  >(GetEmployersListForWorkLetterDocument, options);
}
export function useGetEmployersListForWorkLetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployersListForWorkLetterQuery,
    GetEmployersListForWorkLetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployersListForWorkLetterQuery,
    GetEmployersListForWorkLetterQueryVariables
  >(GetEmployersListForWorkLetterDocument, options);
}
// @ts-ignore
export function useGetEmployersListForWorkLetterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployersListForWorkLetterQuery,
    GetEmployersListForWorkLetterQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForWorkLetterQuery,
  GetEmployersListForWorkLetterQueryVariables
>;
export function useGetEmployersListForWorkLetterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForWorkLetterQuery,
        GetEmployersListForWorkLetterQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForWorkLetterQuery | undefined,
  GetEmployersListForWorkLetterQueryVariables
>;
export function useGetEmployersListForWorkLetterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForWorkLetterQuery,
        GetEmployersListForWorkLetterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployersListForWorkLetterQuery,
    GetEmployersListForWorkLetterQueryVariables
  >(GetEmployersListForWorkLetterDocument, options);
}
export type GetEmployersListForWorkLetterQueryHookResult = ReturnType<
  typeof useGetEmployersListForWorkLetterQuery
>;
export type GetEmployersListForWorkLetterLazyQueryHookResult = ReturnType<
  typeof useGetEmployersListForWorkLetterLazyQuery
>;
export type GetEmployersListForWorkLetterSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployersListForWorkLetterSuspenseQuery
>;
export type GetEmployersListForWorkLetterQueryResult = Apollo.QueryResult<
  GetEmployersListForWorkLetterQuery,
  GetEmployersListForWorkLetterQueryVariables
>;
export const GetEmployersListForWorkLetterForAdminDocument = gql`
    query GetEmployersListForWorkLetterForAdmin($employeeSsnEncrypted: String!) {
  getEmployersListForWorkLetterForAdmin(
    employeeSsnEncrypted: $employeeSsnEncrypted
  ) {
    employers {
      ...EmployerListItemForVerificationRequestInfo
    }
  }
}
    ${EmployerListItemForVerificationRequestInfoFragmentDoc}`;

/**
 * __useGetEmployersListForWorkLetterForAdminQuery__
 *
 * To run a query within a React component, call `useGetEmployersListForWorkLetterForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersListForWorkLetterForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersListForWorkLetterForAdminQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *   },
 * });
 */
export function useGetEmployersListForWorkLetterForAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployersListForWorkLetterForAdminQuery,
    GetEmployersListForWorkLetterForAdminQueryVariables
  > &
    (
      | { variables: GetEmployersListForWorkLetterForAdminQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployersListForWorkLetterForAdminQuery,
    GetEmployersListForWorkLetterForAdminQueryVariables
  >(GetEmployersListForWorkLetterForAdminDocument, options);
}
export function useGetEmployersListForWorkLetterForAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployersListForWorkLetterForAdminQuery,
    GetEmployersListForWorkLetterForAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployersListForWorkLetterForAdminQuery,
    GetEmployersListForWorkLetterForAdminQueryVariables
  >(GetEmployersListForWorkLetterForAdminDocument, options);
}
// @ts-ignore
export function useGetEmployersListForWorkLetterForAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployersListForWorkLetterForAdminQuery,
    GetEmployersListForWorkLetterForAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForWorkLetterForAdminQuery,
  GetEmployersListForWorkLetterForAdminQueryVariables
>;
export function useGetEmployersListForWorkLetterForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForWorkLetterForAdminQuery,
        GetEmployersListForWorkLetterForAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployersListForWorkLetterForAdminQuery | undefined,
  GetEmployersListForWorkLetterForAdminQueryVariables
>;
export function useGetEmployersListForWorkLetterForAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployersListForWorkLetterForAdminQuery,
        GetEmployersListForWorkLetterForAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployersListForWorkLetterForAdminQuery,
    GetEmployersListForWorkLetterForAdminQueryVariables
  >(GetEmployersListForWorkLetterForAdminDocument, options);
}
export type GetEmployersListForWorkLetterForAdminQueryHookResult = ReturnType<
  typeof useGetEmployersListForWorkLetterForAdminQuery
>;
export type GetEmployersListForWorkLetterForAdminLazyQueryHookResult = ReturnType<
  typeof useGetEmployersListForWorkLetterForAdminLazyQuery
>;
export type GetEmployersListForWorkLetterForAdminSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployersListForWorkLetterForAdminSuspenseQuery
>;
export type GetEmployersListForWorkLetterForAdminQueryResult = Apollo.QueryResult<
  GetEmployersListForWorkLetterForAdminQuery,
  GetEmployersListForWorkLetterForAdminQueryVariables
>;
export const SendInvitesToEmployersByPeoStaffDocument = gql`
    mutation sendInvitesToEmployersByPeoStaff($input: SendInvitesToEmployersByPeoStaffInput!) {
  sendInvitesToEmployersByPeoStaff(input: $input) {
    success
  }
}
    `;
export type SendInvitesToEmployersByPeoStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToEmployersByPeoStaffMutation,
  SendInvitesToEmployersByPeoStaffMutationVariables
>;

/**
 * __useSendInvitesToEmployersByPeoStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToEmployersByPeoStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToEmployersByPeoStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToEmployersByPeoStaffMutation, { data, loading, error }] = useSendInvitesToEmployersByPeoStaffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitesToEmployersByPeoStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToEmployersByPeoStaffMutation,
    SendInvitesToEmployersByPeoStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToEmployersByPeoStaffMutation,
    SendInvitesToEmployersByPeoStaffMutationVariables
  >(SendInvitesToEmployersByPeoStaffDocument, options);
}
export type SendInvitesToEmployersByPeoStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToEmployersByPeoStaffMutation
>;
export type SendInvitesToEmployersByPeoStaffMutationResult =
  Apollo.MutationResult<SendInvitesToEmployersByPeoStaffMutation>;
export type SendInvitesToEmployersByPeoStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToEmployersByPeoStaffMutation,
  SendInvitesToEmployersByPeoStaffMutationVariables
>;
export const EmployerLogoDocument = gql`
    query EmployerLogo($id: ID!) {
  employer(where: {id: $id}) {
    id
    logo {
      ...FileInfo
    }
  }
}
    ${FileInfoFragmentDoc}`;

/**
 * __useEmployerLogoQuery__
 *
 * To run a query within a React component, call `useEmployerLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerLogoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployerLogoQuery(
  baseOptions: Apollo.QueryHookOptions<EmployerLogoQuery, EmployerLogoQueryVariables> &
    ({ variables: EmployerLogoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployerLogoQuery, EmployerLogoQueryVariables>(
    EmployerLogoDocument,
    options,
  );
}
export function useEmployerLogoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployerLogoQuery, EmployerLogoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployerLogoQuery, EmployerLogoQueryVariables>(
    EmployerLogoDocument,
    options,
  );
}
// @ts-ignore
export function useEmployerLogoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EmployerLogoQuery, EmployerLogoQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployerLogoQuery, EmployerLogoQueryVariables>;
export function useEmployerLogoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerLogoQuery, EmployerLogoQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployerLogoQuery | undefined, EmployerLogoQueryVariables>;
export function useEmployerLogoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerLogoQuery, EmployerLogoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployerLogoQuery, EmployerLogoQueryVariables>(
    EmployerLogoDocument,
    options,
  );
}
export type EmployerLogoQueryHookResult = ReturnType<typeof useEmployerLogoQuery>;
export type EmployerLogoLazyQueryHookResult = ReturnType<typeof useEmployerLogoLazyQuery>;
export type EmployerLogoSuspenseQueryHookResult = ReturnType<typeof useEmployerLogoSuspenseQuery>;
export type EmployerLogoQueryResult = Apollo.QueryResult<
  EmployerLogoQuery,
  EmployerLogoQueryVariables
>;
export const EmployersCountDocument = gql`
    query EmployersCount($filter: EmployerWhere) {
  employerCount(where: $filter)
}
    `;

/**
 * __useEmployersCountQuery__
 *
 * To run a query within a React component, call `useEmployersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployersCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmployersCountQuery(
  baseOptions?: Apollo.QueryHookOptions<EmployersCountQuery, EmployersCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployersCountQuery, EmployersCountQueryVariables>(
    EmployersCountDocument,
    options,
  );
}
export function useEmployersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployersCountQuery, EmployersCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployersCountQuery, EmployersCountQueryVariables>(
    EmployersCountDocument,
    options,
  );
}
// @ts-ignore
export function useEmployersCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EmployersCountQuery, EmployersCountQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployersCountQuery, EmployersCountQueryVariables>;
export function useEmployersCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployersCountQuery, EmployersCountQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployersCountQuery | undefined, EmployersCountQueryVariables>;
export function useEmployersCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployersCountQuery, EmployersCountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployersCountQuery, EmployersCountQueryVariables>(
    EmployersCountDocument,
    options,
  );
}
export type EmployersCountQueryHookResult = ReturnType<typeof useEmployersCountQuery>;
export type EmployersCountLazyQueryHookResult = ReturnType<typeof useEmployersCountLazyQuery>;
export type EmployersCountSuspenseQueryHookResult = ReturnType<
  typeof useEmployersCountSuspenseQuery
>;
export type EmployersCountQueryResult = Apollo.QueryResult<
  EmployersCountQuery,
  EmployersCountQueryVariables
>;
export const EmployerStaffsListDocument = gql`
    query EmployerStaffsList($filter: EmployerStaffWhere, $orderBy: [EmployerStaffOrderBy!], $first: Int, $skip: Int) {
  employerStaffCount(where: $filter)
  employerStaffList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...EmployerStaffInfo
  }
}
    ${EmployerStaffInfoFragmentDoc}`;

/**
 * __useEmployerStaffsListQuery__
 *
 * To run a query within a React component, call `useEmployerStaffsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerStaffsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerStaffsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useEmployerStaffsListQuery(
  baseOptions?: Apollo.QueryHookOptions<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>(
    EmployerStaffsListDocument,
    options,
  );
}
export function useEmployerStaffsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployerStaffsListQuery,
    EmployerStaffsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>(
    EmployerStaffsListDocument,
    options,
  );
}
// @ts-ignore
export function useEmployerStaffsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployerStaffsListQuery,
    EmployerStaffsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>;
export function useEmployerStaffsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EmployerStaffsListQuery | undefined,
  EmployerStaffsListQueryVariables
>;
export function useEmployerStaffsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployerStaffsListQuery, EmployerStaffsListQueryVariables>(
    EmployerStaffsListDocument,
    options,
  );
}
export type EmployerStaffsListQueryHookResult = ReturnType<typeof useEmployerStaffsListQuery>;
export type EmployerStaffsListLazyQueryHookResult = ReturnType<
  typeof useEmployerStaffsListLazyQuery
>;
export type EmployerStaffsListSuspenseQueryHookResult = ReturnType<
  typeof useEmployerStaffsListSuspenseQuery
>;
export type EmployerStaffsListQueryResult = Apollo.QueryResult<
  EmployerStaffsListQuery,
  EmployerStaffsListQueryVariables
>;
export const EmployerStaffDocument = gql`
    query EmployerStaff($id: ID!) {
  employerStaff(where: {id: $id}) {
    ...EmployerStaffInfo
  }
}
    ${EmployerStaffInfoFragmentDoc}`;

/**
 * __useEmployerStaffQuery__
 *
 * To run a query within a React component, call `useEmployerStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerStaffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployerStaffQuery(
  baseOptions: Apollo.QueryHookOptions<EmployerStaffQuery, EmployerStaffQueryVariables> &
    ({ variables: EmployerStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployerStaffQuery, EmployerStaffQueryVariables>(
    EmployerStaffDocument,
    options,
  );
}
export function useEmployerStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployerStaffQuery, EmployerStaffQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployerStaffQuery, EmployerStaffQueryVariables>(
    EmployerStaffDocument,
    options,
  );
}
// @ts-ignore
export function useEmployerStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EmployerStaffQuery, EmployerStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployerStaffQuery, EmployerStaffQueryVariables>;
export function useEmployerStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerStaffQuery, EmployerStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployerStaffQuery | undefined, EmployerStaffQueryVariables>;
export function useEmployerStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployerStaffQuery, EmployerStaffQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployerStaffQuery, EmployerStaffQueryVariables>(
    EmployerStaffDocument,
    options,
  );
}
export type EmployerStaffQueryHookResult = ReturnType<typeof useEmployerStaffQuery>;
export type EmployerStaffLazyQueryHookResult = ReturnType<typeof useEmployerStaffLazyQuery>;
export type EmployerStaffSuspenseQueryHookResult = ReturnType<typeof useEmployerStaffSuspenseQuery>;
export type EmployerStaffQueryResult = Apollo.QueryResult<
  EmployerStaffQuery,
  EmployerStaffQueryVariables
>;
export const EmployerStaffUpdateDocument = gql`
    mutation EmployerStaffUpdate($data: EmployerStaffUpdate!, $where: EmployerStaffWhereUnique!) {
  employerStaffUpdate(data: $data, where: $where) {
    ...EmployerStaffInfo
  }
}
    ${EmployerStaffInfoFragmentDoc}`;
export type EmployerStaffUpdateMutationFn = Apollo.MutationFunction<
  EmployerStaffUpdateMutation,
  EmployerStaffUpdateMutationVariables
>;

/**
 * __useEmployerStaffUpdateMutation__
 *
 * To run a mutation, you first call `useEmployerStaffUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerStaffUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerStaffUpdateMutation, { data, loading, error }] = useEmployerStaffUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEmployerStaffUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployerStaffUpdateMutation,
    EmployerStaffUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmployerStaffUpdateMutation, EmployerStaffUpdateMutationVariables>(
    EmployerStaffUpdateDocument,
    options,
  );
}
export type EmployerStaffUpdateMutationHookResult = ReturnType<
  typeof useEmployerStaffUpdateMutation
>;
export type EmployerStaffUpdateMutationResult = Apollo.MutationResult<EmployerStaffUpdateMutation>;
export type EmployerStaffUpdateMutationOptions = Apollo.BaseMutationOptions<
  EmployerStaffUpdateMutation,
  EmployerStaffUpdateMutationVariables
>;
export const EmployerStaffInviteDocument = gql`
    mutation EmployerStaffInvite($employerStaffList: [InvitedEmployerStaff!]!, $employerId: ID!) {
  sendInvitesToEmployerStaffs(
    employerStaffList: $employerStaffList
    employerId: $employerId
  ) {
    success
  }
}
    `;
export type EmployerStaffInviteMutationFn = Apollo.MutationFunction<
  EmployerStaffInviteMutation,
  EmployerStaffInviteMutationVariables
>;

/**
 * __useEmployerStaffInviteMutation__
 *
 * To run a mutation, you first call `useEmployerStaffInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerStaffInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerStaffInviteMutation, { data, loading, error }] = useEmployerStaffInviteMutation({
 *   variables: {
 *      employerStaffList: // value for 'employerStaffList'
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useEmployerStaffInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployerStaffInviteMutation,
    EmployerStaffInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmployerStaffInviteMutation, EmployerStaffInviteMutationVariables>(
    EmployerStaffInviteDocument,
    options,
  );
}
export type EmployerStaffInviteMutationHookResult = ReturnType<
  typeof useEmployerStaffInviteMutation
>;
export type EmployerStaffInviteMutationResult = Apollo.MutationResult<EmployerStaffInviteMutation>;
export type EmployerStaffInviteMutationOptions = Apollo.BaseMutationOptions<
  EmployerStaffInviteMutation,
  EmployerStaffInviteMutationVariables
>;
export const EmployerStaffInviteByEmployerAdminDocument = gql`
    mutation EmployerStaffInviteByEmployerAdmin($employerStaffList: [InvitedEmployerStaff!]!) {
  sendInvitesToEmployerStaffsByEmployerAdmin(
    employerStaffList: $employerStaffList
  ) {
    success
  }
}
    `;
export type EmployerStaffInviteByEmployerAdminMutationFn = Apollo.MutationFunction<
  EmployerStaffInviteByEmployerAdminMutation,
  EmployerStaffInviteByEmployerAdminMutationVariables
>;

/**
 * __useEmployerStaffInviteByEmployerAdminMutation__
 *
 * To run a mutation, you first call `useEmployerStaffInviteByEmployerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerStaffInviteByEmployerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerStaffInviteByEmployerAdminMutation, { data, loading, error }] = useEmployerStaffInviteByEmployerAdminMutation({
 *   variables: {
 *      employerStaffList: // value for 'employerStaffList'
 *   },
 * });
 */
export function useEmployerStaffInviteByEmployerAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployerStaffInviteByEmployerAdminMutation,
    EmployerStaffInviteByEmployerAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EmployerStaffInviteByEmployerAdminMutation,
    EmployerStaffInviteByEmployerAdminMutationVariables
  >(EmployerStaffInviteByEmployerAdminDocument, options);
}
export type EmployerStaffInviteByEmployerAdminMutationHookResult = ReturnType<
  typeof useEmployerStaffInviteByEmployerAdminMutation
>;
export type EmployerStaffInviteByEmployerAdminMutationResult =
  Apollo.MutationResult<EmployerStaffInviteByEmployerAdminMutation>;
export type EmployerStaffInviteByEmployerAdminMutationOptions = Apollo.BaseMutationOptions<
  EmployerStaffInviteByEmployerAdminMutation,
  EmployerStaffInviteByEmployerAdminMutationVariables
>;
export const EmployerStaffBillingInfoDocument = gql`
    query EmployerStaffBillingInfo($id: ID!) {
  employerStaff(where: {id: $id}) {
    id
    employer {
      id
      revenueShareSetting {
        id
        revenueShareType
        revenueShareFlat
        revenueSharePercents
      }
    }
  }
}
    `;

/**
 * __useEmployerStaffBillingInfoQuery__
 *
 * To run a query within a React component, call `useEmployerStaffBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerStaffBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerStaffBillingInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployerStaffBillingInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    EmployerStaffBillingInfoQuery,
    EmployerStaffBillingInfoQueryVariables
  > &
    ({ variables: EmployerStaffBillingInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployerStaffBillingInfoQuery, EmployerStaffBillingInfoQueryVariables>(
    EmployerStaffBillingInfoDocument,
    options,
  );
}
export function useEmployerStaffBillingInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployerStaffBillingInfoQuery,
    EmployerStaffBillingInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployerStaffBillingInfoQuery, EmployerStaffBillingInfoQueryVariables>(
    EmployerStaffBillingInfoDocument,
    options,
  );
}
// @ts-ignore
export function useEmployerStaffBillingInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployerStaffBillingInfoQuery,
    EmployerStaffBillingInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EmployerStaffBillingInfoQuery,
  EmployerStaffBillingInfoQueryVariables
>;
export function useEmployerStaffBillingInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EmployerStaffBillingInfoQuery,
        EmployerStaffBillingInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EmployerStaffBillingInfoQuery | undefined,
  EmployerStaffBillingInfoQueryVariables
>;
export function useEmployerStaffBillingInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EmployerStaffBillingInfoQuery,
        EmployerStaffBillingInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EmployerStaffBillingInfoQuery,
    EmployerStaffBillingInfoQueryVariables
  >(EmployerStaffBillingInfoDocument, options);
}
export type EmployerStaffBillingInfoQueryHookResult = ReturnType<
  typeof useEmployerStaffBillingInfoQuery
>;
export type EmployerStaffBillingInfoLazyQueryHookResult = ReturnType<
  typeof useEmployerStaffBillingInfoLazyQuery
>;
export type EmployerStaffBillingInfoSuspenseQueryHookResult = ReturnType<
  typeof useEmployerStaffBillingInfoSuspenseQuery
>;
export type EmployerStaffBillingInfoQueryResult = Apollo.QueryResult<
  EmployerStaffBillingInfoQuery,
  EmployerStaffBillingInfoQueryVariables
>;
export const DeleteEmployerStaffDocument = gql`
    mutation DeleteEmployerStaff($employerStaffId: ID!) {
  deleteEmployerStaff(employerStaffId: $employerStaffId) {
    success
  }
}
    `;
export type DeleteEmployerStaffMutationFn = Apollo.MutationFunction<
  DeleteEmployerStaffMutation,
  DeleteEmployerStaffMutationVariables
>;

/**
 * __useDeleteEmployerStaffMutation__
 *
 * To run a mutation, you first call `useDeleteEmployerStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployerStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployerStaffMutation, { data, loading, error }] = useDeleteEmployerStaffMutation({
 *   variables: {
 *      employerStaffId: // value for 'employerStaffId'
 *   },
 * });
 */
export function useDeleteEmployerStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEmployerStaffMutation,
    DeleteEmployerStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployerStaffMutation, DeleteEmployerStaffMutationVariables>(
    DeleteEmployerStaffDocument,
    options,
  );
}
export type DeleteEmployerStaffMutationHookResult = ReturnType<
  typeof useDeleteEmployerStaffMutation
>;
export type DeleteEmployerStaffMutationResult = Apollo.MutationResult<DeleteEmployerStaffMutation>;
export type DeleteEmployerStaffMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployerStaffMutation,
  DeleteEmployerStaffMutationVariables
>;
export const CheckDeletionEmployerStaffDocument = gql`
    query CheckDeletionEmployerStaff($employerStaffId: ID!) {
  checkDeletionEmployerStaff(employerStaffId: $employerStaffId) {
    valid
    errors
  }
}
    `;

/**
 * __useCheckDeletionEmployerStaffQuery__
 *
 * To run a query within a React component, call `useCheckDeletionEmployerStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDeletionEmployerStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDeletionEmployerStaffQuery({
 *   variables: {
 *      employerStaffId: // value for 'employerStaffId'
 *   },
 * });
 */
export function useCheckDeletionEmployerStaffQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckDeletionEmployerStaffQuery,
    CheckDeletionEmployerStaffQueryVariables
  > &
    ({ variables: CheckDeletionEmployerStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckDeletionEmployerStaffQuery, CheckDeletionEmployerStaffQueryVariables>(
    CheckDeletionEmployerStaffDocument,
    options,
  );
}
export function useCheckDeletionEmployerStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckDeletionEmployerStaffQuery,
    CheckDeletionEmployerStaffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckDeletionEmployerStaffQuery,
    CheckDeletionEmployerStaffQueryVariables
  >(CheckDeletionEmployerStaffDocument, options);
}
// @ts-ignore
export function useCheckDeletionEmployerStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckDeletionEmployerStaffQuery,
    CheckDeletionEmployerStaffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionEmployerStaffQuery,
  CheckDeletionEmployerStaffQueryVariables
>;
export function useCheckDeletionEmployerStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionEmployerStaffQuery,
        CheckDeletionEmployerStaffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionEmployerStaffQuery | undefined,
  CheckDeletionEmployerStaffQueryVariables
>;
export function useCheckDeletionEmployerStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionEmployerStaffQuery,
        CheckDeletionEmployerStaffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckDeletionEmployerStaffQuery,
    CheckDeletionEmployerStaffQueryVariables
  >(CheckDeletionEmployerStaffDocument, options);
}
export type CheckDeletionEmployerStaffQueryHookResult = ReturnType<
  typeof useCheckDeletionEmployerStaffQuery
>;
export type CheckDeletionEmployerStaffLazyQueryHookResult = ReturnType<
  typeof useCheckDeletionEmployerStaffLazyQuery
>;
export type CheckDeletionEmployerStaffSuspenseQueryHookResult = ReturnType<
  typeof useCheckDeletionEmployerStaffSuspenseQuery
>;
export type CheckDeletionEmployerStaffQueryResult = Apollo.QueryResult<
  CheckDeletionEmployerStaffQuery,
  CheckDeletionEmployerStaffQueryVariables
>;
export const GetEmploymentDataOnEmployeeSignupDocument = gql`
    query GetEmploymentDataOnEmployeeSignup($employeeSignupToken: String!, $companyId: ID!) {
  getEmploymentDataOnEmployeeSignup(
    employeeSignupToken: $employeeSignupToken
    companyId: $companyId
  ) {
    ...EmploymentDataInfo
  }
}
    ${EmploymentDataInfoFragmentDoc}`;

/**
 * __useGetEmploymentDataOnEmployeeSignupQuery__
 *
 * To run a query within a React component, call `useGetEmploymentDataOnEmployeeSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmploymentDataOnEmployeeSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmploymentDataOnEmployeeSignupQuery({
 *   variables: {
 *      employeeSignupToken: // value for 'employeeSignupToken'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmploymentDataOnEmployeeSignupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmploymentDataOnEmployeeSignupQuery,
    GetEmploymentDataOnEmployeeSignupQueryVariables
  > &
    (
      | { variables: GetEmploymentDataOnEmployeeSignupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmploymentDataOnEmployeeSignupQuery,
    GetEmploymentDataOnEmployeeSignupQueryVariables
  >(GetEmploymentDataOnEmployeeSignupDocument, options);
}
export function useGetEmploymentDataOnEmployeeSignupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmploymentDataOnEmployeeSignupQuery,
    GetEmploymentDataOnEmployeeSignupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmploymentDataOnEmployeeSignupQuery,
    GetEmploymentDataOnEmployeeSignupQueryVariables
  >(GetEmploymentDataOnEmployeeSignupDocument, options);
}
// @ts-ignore
export function useGetEmploymentDataOnEmployeeSignupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmploymentDataOnEmployeeSignupQuery,
    GetEmploymentDataOnEmployeeSignupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataOnEmployeeSignupQuery,
  GetEmploymentDataOnEmployeeSignupQueryVariables
>;
export function useGetEmploymentDataOnEmployeeSignupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataOnEmployeeSignupQuery,
        GetEmploymentDataOnEmployeeSignupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataOnEmployeeSignupQuery | undefined,
  GetEmploymentDataOnEmployeeSignupQueryVariables
>;
export function useGetEmploymentDataOnEmployeeSignupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataOnEmployeeSignupQuery,
        GetEmploymentDataOnEmployeeSignupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmploymentDataOnEmployeeSignupQuery,
    GetEmploymentDataOnEmployeeSignupQueryVariables
  >(GetEmploymentDataOnEmployeeSignupDocument, options);
}
export type GetEmploymentDataOnEmployeeSignupQueryHookResult = ReturnType<
  typeof useGetEmploymentDataOnEmployeeSignupQuery
>;
export type GetEmploymentDataOnEmployeeSignupLazyQueryHookResult = ReturnType<
  typeof useGetEmploymentDataOnEmployeeSignupLazyQuery
>;
export type GetEmploymentDataOnEmployeeSignupSuspenseQueryHookResult = ReturnType<
  typeof useGetEmploymentDataOnEmployeeSignupSuspenseQuery
>;
export type GetEmploymentDataOnEmployeeSignupQueryResult = Apollo.QueryResult<
  GetEmploymentDataOnEmployeeSignupQuery,
  GetEmploymentDataOnEmployeeSignupQueryVariables
>;
export const GetEmploymentDataOnEmployeeSignupByInviteDocument = gql`
    query GetEmploymentDataOnEmployeeSignupByInvite($inviteId: ID!, $companyId: ID!) {
  getEmploymentDataOnEmployeeSignupByInvite(
    inviteId: $inviteId
    companyId: $companyId
  ) {
    ...EmploymentDataInfo
  }
}
    ${EmploymentDataInfoFragmentDoc}`;

/**
 * __useGetEmploymentDataOnEmployeeSignupByInviteQuery__
 *
 * To run a query within a React component, call `useGetEmploymentDataOnEmployeeSignupByInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmploymentDataOnEmployeeSignupByInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmploymentDataOnEmployeeSignupByInviteQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmploymentDataOnEmployeeSignupByInviteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmploymentDataOnEmployeeSignupByInviteQuery,
    GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
  > &
    (
      | { variables: GetEmploymentDataOnEmployeeSignupByInviteQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmploymentDataOnEmployeeSignupByInviteQuery,
    GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
  >(GetEmploymentDataOnEmployeeSignupByInviteDocument, options);
}
export function useGetEmploymentDataOnEmployeeSignupByInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmploymentDataOnEmployeeSignupByInviteQuery,
    GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmploymentDataOnEmployeeSignupByInviteQuery,
    GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
  >(GetEmploymentDataOnEmployeeSignupByInviteDocument, options);
}
// @ts-ignore
export function useGetEmploymentDataOnEmployeeSignupByInviteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmploymentDataOnEmployeeSignupByInviteQuery,
    GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataOnEmployeeSignupByInviteQuery,
  GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
>;
export function useGetEmploymentDataOnEmployeeSignupByInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataOnEmployeeSignupByInviteQuery,
        GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataOnEmployeeSignupByInviteQuery | undefined,
  GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
>;
export function useGetEmploymentDataOnEmployeeSignupByInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataOnEmployeeSignupByInviteQuery,
        GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmploymentDataOnEmployeeSignupByInviteQuery,
    GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
  >(GetEmploymentDataOnEmployeeSignupByInviteDocument, options);
}
export type GetEmploymentDataOnEmployeeSignupByInviteQueryHookResult = ReturnType<
  typeof useGetEmploymentDataOnEmployeeSignupByInviteQuery
>;
export type GetEmploymentDataOnEmployeeSignupByInviteLazyQueryHookResult = ReturnType<
  typeof useGetEmploymentDataOnEmployeeSignupByInviteLazyQuery
>;
export type GetEmploymentDataOnEmployeeSignupByInviteSuspenseQueryHookResult = ReturnType<
  typeof useGetEmploymentDataOnEmployeeSignupByInviteSuspenseQuery
>;
export type GetEmploymentDataOnEmployeeSignupByInviteQueryResult = Apollo.QueryResult<
  GetEmploymentDataOnEmployeeSignupByInviteQuery,
  GetEmploymentDataOnEmployeeSignupByInviteQueryVariables
>;
export const GetEmploymentDataForEmployeeMyDataDocument = gql`
    query GetEmploymentDataForEmployeeMyData($companyId: ID!) {
  getEmploymentDataForEmployeeMyData(companyId: $companyId) {
    ...EmploymentDataInfo
  }
}
    ${EmploymentDataInfoFragmentDoc}`;

/**
 * __useGetEmploymentDataForEmployeeMyDataQuery__
 *
 * To run a query within a React component, call `useGetEmploymentDataForEmployeeMyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmploymentDataForEmployeeMyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmploymentDataForEmployeeMyDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmploymentDataForEmployeeMyDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmploymentDataForEmployeeMyDataQuery,
    GetEmploymentDataForEmployeeMyDataQueryVariables
  > &
    (
      | { variables: GetEmploymentDataForEmployeeMyDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmploymentDataForEmployeeMyDataQuery,
    GetEmploymentDataForEmployeeMyDataQueryVariables
  >(GetEmploymentDataForEmployeeMyDataDocument, options);
}
export function useGetEmploymentDataForEmployeeMyDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmploymentDataForEmployeeMyDataQuery,
    GetEmploymentDataForEmployeeMyDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmploymentDataForEmployeeMyDataQuery,
    GetEmploymentDataForEmployeeMyDataQueryVariables
  >(GetEmploymentDataForEmployeeMyDataDocument, options);
}
// @ts-ignore
export function useGetEmploymentDataForEmployeeMyDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmploymentDataForEmployeeMyDataQuery,
    GetEmploymentDataForEmployeeMyDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataForEmployeeMyDataQuery,
  GetEmploymentDataForEmployeeMyDataQueryVariables
>;
export function useGetEmploymentDataForEmployeeMyDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataForEmployeeMyDataQuery,
        GetEmploymentDataForEmployeeMyDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataForEmployeeMyDataQuery | undefined,
  GetEmploymentDataForEmployeeMyDataQueryVariables
>;
export function useGetEmploymentDataForEmployeeMyDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataForEmployeeMyDataQuery,
        GetEmploymentDataForEmployeeMyDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmploymentDataForEmployeeMyDataQuery,
    GetEmploymentDataForEmployeeMyDataQueryVariables
  >(GetEmploymentDataForEmployeeMyDataDocument, options);
}
export type GetEmploymentDataForEmployeeMyDataQueryHookResult = ReturnType<
  typeof useGetEmploymentDataForEmployeeMyDataQuery
>;
export type GetEmploymentDataForEmployeeMyDataLazyQueryHookResult = ReturnType<
  typeof useGetEmploymentDataForEmployeeMyDataLazyQuery
>;
export type GetEmploymentDataForEmployeeMyDataSuspenseQueryHookResult = ReturnType<
  typeof useGetEmploymentDataForEmployeeMyDataSuspenseQuery
>;
export type GetEmploymentDataForEmployeeMyDataQueryResult = Apollo.QueryResult<
  GetEmploymentDataForEmployeeMyDataQuery,
  GetEmploymentDataForEmployeeMyDataQueryVariables
>;
export const GetEmploymentDataForSearchedEmployeeDocument = gql`
    query GetEmploymentDataForSearchedEmployee($employeeSsnEncrypted: String!, $companyId: ID!) {
  getEmploymentDataForSearchedEmployee(
    employeeSsnEncrypted: $employeeSsnEncrypted
    companyId: $companyId
  ) {
    ...EmploymentDataInfo
  }
}
    ${EmploymentDataInfoFragmentDoc}`;

/**
 * __useGetEmploymentDataForSearchedEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmploymentDataForSearchedEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmploymentDataForSearchedEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmploymentDataForSearchedEmployeeQuery({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmploymentDataForSearchedEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmploymentDataForSearchedEmployeeQuery,
    GetEmploymentDataForSearchedEmployeeQueryVariables
  > &
    (
      | { variables: GetEmploymentDataForSearchedEmployeeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmploymentDataForSearchedEmployeeQuery,
    GetEmploymentDataForSearchedEmployeeQueryVariables
  >(GetEmploymentDataForSearchedEmployeeDocument, options);
}
export function useGetEmploymentDataForSearchedEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmploymentDataForSearchedEmployeeQuery,
    GetEmploymentDataForSearchedEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmploymentDataForSearchedEmployeeQuery,
    GetEmploymentDataForSearchedEmployeeQueryVariables
  >(GetEmploymentDataForSearchedEmployeeDocument, options);
}
// @ts-ignore
export function useGetEmploymentDataForSearchedEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmploymentDataForSearchedEmployeeQuery,
    GetEmploymentDataForSearchedEmployeeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataForSearchedEmployeeQuery,
  GetEmploymentDataForSearchedEmployeeQueryVariables
>;
export function useGetEmploymentDataForSearchedEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataForSearchedEmployeeQuery,
        GetEmploymentDataForSearchedEmployeeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmploymentDataForSearchedEmployeeQuery | undefined,
  GetEmploymentDataForSearchedEmployeeQueryVariables
>;
export function useGetEmploymentDataForSearchedEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmploymentDataForSearchedEmployeeQuery,
        GetEmploymentDataForSearchedEmployeeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmploymentDataForSearchedEmployeeQuery,
    GetEmploymentDataForSearchedEmployeeQueryVariables
  >(GetEmploymentDataForSearchedEmployeeDocument, options);
}
export type GetEmploymentDataForSearchedEmployeeQueryHookResult = ReturnType<
  typeof useGetEmploymentDataForSearchedEmployeeQuery
>;
export type GetEmploymentDataForSearchedEmployeeLazyQueryHookResult = ReturnType<
  typeof useGetEmploymentDataForSearchedEmployeeLazyQuery
>;
export type GetEmploymentDataForSearchedEmployeeSuspenseQueryHookResult = ReturnType<
  typeof useGetEmploymentDataForSearchedEmployeeSuspenseQuery
>;
export type GetEmploymentDataForSearchedEmployeeQueryResult = Apollo.QueryResult<
  GetEmploymentDataForSearchedEmployeeQuery,
  GetEmploymentDataForSearchedEmployeeQueryVariables
>;
export const UploadFileDocument = gql`
    mutation UploadFile($file: FileUpload!, $public: Boolean!) {
  uploadFile(file: $file, public: $public) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type UploadFileMutationFn = Apollo.MutationFunction<
  UploadFileMutation,
  UploadFileMutationVariables
>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useUploadFileMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(
    UploadFileDocument,
    options,
  );
}
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<
  UploadFileMutation,
  UploadFileMutationVariables
>;
export const GeneratedReportsMetaDocument = gql`
    query GeneratedReportsMeta($inboxItemId: ID!) {
  getGeneratedReportsMeta(inboxItemId: $inboxItemId) {
    ...GeneratedReportMetaInfo
  }
}
    ${GeneratedReportMetaInfoFragmentDoc}`;

/**
 * __useGeneratedReportsMetaQuery__
 *
 * To run a query within a React component, call `useGeneratedReportsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratedReportsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratedReportsMetaQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useGeneratedReportsMetaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GeneratedReportsMetaQuery,
    GeneratedReportsMetaQueryVariables
  > &
    ({ variables: GeneratedReportsMetaQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GeneratedReportsMetaQuery, GeneratedReportsMetaQueryVariables>(
    GeneratedReportsMetaDocument,
    options,
  );
}
export function useGeneratedReportsMetaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeneratedReportsMetaQuery,
    GeneratedReportsMetaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GeneratedReportsMetaQuery, GeneratedReportsMetaQueryVariables>(
    GeneratedReportsMetaDocument,
    options,
  );
}
// @ts-ignore
export function useGeneratedReportsMetaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GeneratedReportsMetaQuery,
    GeneratedReportsMetaQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GeneratedReportsMetaQuery, GeneratedReportsMetaQueryVariables>;
export function useGeneratedReportsMetaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GeneratedReportsMetaQuery,
        GeneratedReportsMetaQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GeneratedReportsMetaQuery | undefined,
  GeneratedReportsMetaQueryVariables
>;
export function useGeneratedReportsMetaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GeneratedReportsMetaQuery,
        GeneratedReportsMetaQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GeneratedReportsMetaQuery, GeneratedReportsMetaQueryVariables>(
    GeneratedReportsMetaDocument,
    options,
  );
}
export type GeneratedReportsMetaQueryHookResult = ReturnType<typeof useGeneratedReportsMetaQuery>;
export type GeneratedReportsMetaLazyQueryHookResult = ReturnType<
  typeof useGeneratedReportsMetaLazyQuery
>;
export type GeneratedReportsMetaSuspenseQueryHookResult = ReturnType<
  typeof useGeneratedReportsMetaSuspenseQuery
>;
export type GeneratedReportsMetaQueryResult = Apollo.QueryResult<
  GeneratedReportsMetaQuery,
  GeneratedReportsMetaQueryVariables
>;
export const DownloadGeneratedReportFilesDocument = gql`
    mutation DownloadGeneratedReportFiles($inboxItemId: ID!, $fileIdList: [ID!]!, $action: PiiDataAccessActionType!) {
  downloadGeneratedReportFiles(
    inboxItemId: $inboxItemId
    fileIdList: $fileIdList
    action: $action
  ) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type DownloadGeneratedReportFilesMutationFn = Apollo.MutationFunction<
  DownloadGeneratedReportFilesMutation,
  DownloadGeneratedReportFilesMutationVariables
>;

/**
 * __useDownloadGeneratedReportFilesMutation__
 *
 * To run a mutation, you first call `useDownloadGeneratedReportFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGeneratedReportFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGeneratedReportFilesMutation, { data, loading, error }] = useDownloadGeneratedReportFilesMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      fileIdList: // value for 'fileIdList'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useDownloadGeneratedReportFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadGeneratedReportFilesMutation,
    DownloadGeneratedReportFilesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DownloadGeneratedReportFilesMutation,
    DownloadGeneratedReportFilesMutationVariables
  >(DownloadGeneratedReportFilesDocument, options);
}
export type DownloadGeneratedReportFilesMutationHookResult = ReturnType<
  typeof useDownloadGeneratedReportFilesMutation
>;
export type DownloadGeneratedReportFilesMutationResult =
  Apollo.MutationResult<DownloadGeneratedReportFilesMutation>;
export type DownloadGeneratedReportFilesMutationOptions = Apollo.BaseMutationOptions<
  DownloadGeneratedReportFilesMutation,
  DownloadGeneratedReportFilesMutationVariables
>;
export const DownloadGeneratedReportFilesArchiveDocument = gql`
    mutation DownloadGeneratedReportFilesArchive($inboxItemId: ID!, $fileIdList: [ID!]!) {
  downloadGeneratedReportFilesArchive(
    inboxItemId: $inboxItemId
    fileIdList: $fileIdList
  ) {
    downloadUrl
    filename
  }
}
    `;
export type DownloadGeneratedReportFilesArchiveMutationFn = Apollo.MutationFunction<
  DownloadGeneratedReportFilesArchiveMutation,
  DownloadGeneratedReportFilesArchiveMutationVariables
>;

/**
 * __useDownloadGeneratedReportFilesArchiveMutation__
 *
 * To run a mutation, you first call `useDownloadGeneratedReportFilesArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGeneratedReportFilesArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGeneratedReportFilesArchiveMutation, { data, loading, error }] = useDownloadGeneratedReportFilesArchiveMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      fileIdList: // value for 'fileIdList'
 *   },
 * });
 */
export function useDownloadGeneratedReportFilesArchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadGeneratedReportFilesArchiveMutation,
    DownloadGeneratedReportFilesArchiveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DownloadGeneratedReportFilesArchiveMutation,
    DownloadGeneratedReportFilesArchiveMutationVariables
  >(DownloadGeneratedReportFilesArchiveDocument, options);
}
export type DownloadGeneratedReportFilesArchiveMutationHookResult = ReturnType<
  typeof useDownloadGeneratedReportFilesArchiveMutation
>;
export type DownloadGeneratedReportFilesArchiveMutationResult =
  Apollo.MutationResult<DownloadGeneratedReportFilesArchiveMutation>;
export type DownloadGeneratedReportFilesArchiveMutationOptions = Apollo.BaseMutationOptions<
  DownloadGeneratedReportFilesArchiveMutation,
  DownloadGeneratedReportFilesArchiveMutationVariables
>;
export const SendGetHelpToClearVerifyStaffDocument = gql`
    mutation sendGetHelpToClearVerifyStaff($data: GetHelpToClearVerifyStaffData!) {
  sendGetHelpToClearVerifyStaff(data: $data) {
    success
  }
}
    `;
export type SendGetHelpToClearVerifyStaffMutationFn = Apollo.MutationFunction<
  SendGetHelpToClearVerifyStaffMutation,
  SendGetHelpToClearVerifyStaffMutationVariables
>;

/**
 * __useSendGetHelpToClearVerifyStaffMutation__
 *
 * To run a mutation, you first call `useSendGetHelpToClearVerifyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGetHelpToClearVerifyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGetHelpToClearVerifyStaffMutation, { data, loading, error }] = useSendGetHelpToClearVerifyStaffMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendGetHelpToClearVerifyStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendGetHelpToClearVerifyStaffMutation,
    SendGetHelpToClearVerifyStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendGetHelpToClearVerifyStaffMutation,
    SendGetHelpToClearVerifyStaffMutationVariables
  >(SendGetHelpToClearVerifyStaffDocument, options);
}
export type SendGetHelpToClearVerifyStaffMutationHookResult = ReturnType<
  typeof useSendGetHelpToClearVerifyStaffMutation
>;
export type SendGetHelpToClearVerifyStaffMutationResult =
  Apollo.MutationResult<SendGetHelpToClearVerifyStaffMutation>;
export type SendGetHelpToClearVerifyStaffMutationOptions = Apollo.BaseMutationOptions<
  SendGetHelpToClearVerifyStaffMutation,
  SendGetHelpToClearVerifyStaffMutationVariables
>;
export const InboxItemsScrollableListDocument = gql`
    query InboxItemsScrollableList($where: InboxItemsListWhere, $skip: Int, $take: Int, $cursorId: ID) {
  getInboxListItemsCount(where: $where)
  getInboxItemsList(where: $where, take: $take, skip: $skip, cursorId: $cursorId) {
    ...InboxListItemInfo
  }
}
    ${InboxListItemInfoFragmentDoc}`;

/**
 * __useInboxItemsScrollableListQuery__
 *
 * To run a query within a React component, call `useInboxItemsScrollableListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxItemsScrollableListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxItemsScrollableListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      cursorId: // value for 'cursorId'
 *   },
 * });
 */
export function useInboxItemsScrollableListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxItemsScrollableListQuery,
    InboxItemsScrollableListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxItemsScrollableListQuery, InboxItemsScrollableListQueryVariables>(
    InboxItemsScrollableListDocument,
    options,
  );
}
export function useInboxItemsScrollableListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxItemsScrollableListQuery,
    InboxItemsScrollableListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxItemsScrollableListQuery, InboxItemsScrollableListQueryVariables>(
    InboxItemsScrollableListDocument,
    options,
  );
}
// @ts-ignore
export function useInboxItemsScrollableListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InboxItemsScrollableListQuery,
    InboxItemsScrollableListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InboxItemsScrollableListQuery,
  InboxItemsScrollableListQueryVariables
>;
export function useInboxItemsScrollableListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxItemsScrollableListQuery,
        InboxItemsScrollableListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InboxItemsScrollableListQuery | undefined,
  InboxItemsScrollableListQueryVariables
>;
export function useInboxItemsScrollableListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxItemsScrollableListQuery,
        InboxItemsScrollableListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InboxItemsScrollableListQuery,
    InboxItemsScrollableListQueryVariables
  >(InboxItemsScrollableListDocument, options);
}
export type InboxItemsScrollableListQueryHookResult = ReturnType<
  typeof useInboxItemsScrollableListQuery
>;
export type InboxItemsScrollableListLazyQueryHookResult = ReturnType<
  typeof useInboxItemsScrollableListLazyQuery
>;
export type InboxItemsScrollableListSuspenseQueryHookResult = ReturnType<
  typeof useInboxItemsScrollableListSuspenseQuery
>;
export type InboxItemsScrollableListQueryResult = Apollo.QueryResult<
  InboxItemsScrollableListQuery,
  InboxItemsScrollableListQueryVariables
>;
export const InboxItemDocument = gql`
    query InboxItem($id: ID!) {
  inboxItem(where: {id: $id}) {
    ...InboxItemInfo
  }
}
    ${InboxItemInfoFragmentDoc}`;

/**
 * __useInboxItemQuery__
 *
 * To run a query within a React component, call `useInboxItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInboxItemQuery(
  baseOptions: Apollo.QueryHookOptions<InboxItemQuery, InboxItemQueryVariables> &
    ({ variables: InboxItemQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxItemQuery, InboxItemQueryVariables>(InboxItemDocument, options);
}
export function useInboxItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InboxItemQuery, InboxItemQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxItemQuery, InboxItemQueryVariables>(InboxItemDocument, options);
}
// @ts-ignore
export function useInboxItemSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InboxItemQuery, InboxItemQueryVariables>,
): Apollo.UseSuspenseQueryResult<InboxItemQuery, InboxItemQueryVariables>;
export function useInboxItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InboxItemQuery, InboxItemQueryVariables>,
): Apollo.UseSuspenseQueryResult<InboxItemQuery | undefined, InboxItemQueryVariables>;
export function useInboxItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InboxItemQuery, InboxItemQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InboxItemQuery, InboxItemQueryVariables>(
    InboxItemDocument,
    options,
  );
}
export type InboxItemQueryHookResult = ReturnType<typeof useInboxItemQuery>;
export type InboxItemLazyQueryHookResult = ReturnType<typeof useInboxItemLazyQuery>;
export type InboxItemSuspenseQueryHookResult = ReturnType<typeof useInboxItemSuspenseQuery>;
export type InboxItemQueryResult = Apollo.QueryResult<InboxItemQuery, InboxItemQueryVariables>;
export const InboxItemsRequestsListDocument = gql`
    query InboxItemsRequestsList($searchValue: String, $orderBy: [InboxItemOrderBy!], $first: Int, $skip: Int) {
  getInboxItemsRequests(
    searchValue: $searchValue
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    count
    items {
      ...InboxItemRequestItem
    }
  }
}
    ${InboxItemRequestItemFragmentDoc}`;

/**
 * __useInboxItemsRequestsListQuery__
 *
 * To run a query within a React component, call `useInboxItemsRequestsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxItemsRequestsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxItemsRequestsListQuery({
 *   variables: {
 *      searchValue: // value for 'searchValue'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useInboxItemsRequestsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxItemsRequestsListQuery,
    InboxItemsRequestsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxItemsRequestsListQuery, InboxItemsRequestsListQueryVariables>(
    InboxItemsRequestsListDocument,
    options,
  );
}
export function useInboxItemsRequestsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxItemsRequestsListQuery,
    InboxItemsRequestsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxItemsRequestsListQuery, InboxItemsRequestsListQueryVariables>(
    InboxItemsRequestsListDocument,
    options,
  );
}
// @ts-ignore
export function useInboxItemsRequestsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InboxItemsRequestsListQuery,
    InboxItemsRequestsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InboxItemsRequestsListQuery, InboxItemsRequestsListQueryVariables>;
export function useInboxItemsRequestsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxItemsRequestsListQuery,
        InboxItemsRequestsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InboxItemsRequestsListQuery | undefined,
  InboxItemsRequestsListQueryVariables
>;
export function useInboxItemsRequestsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxItemsRequestsListQuery,
        InboxItemsRequestsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InboxItemsRequestsListQuery, InboxItemsRequestsListQueryVariables>(
    InboxItemsRequestsListDocument,
    options,
  );
}
export type InboxItemsRequestsListQueryHookResult = ReturnType<
  typeof useInboxItemsRequestsListQuery
>;
export type InboxItemsRequestsListLazyQueryHookResult = ReturnType<
  typeof useInboxItemsRequestsListLazyQuery
>;
export type InboxItemsRequestsListSuspenseQueryHookResult = ReturnType<
  typeof useInboxItemsRequestsListSuspenseQuery
>;
export type InboxItemsRequestsListQueryResult = Apollo.QueryResult<
  InboxItemsRequestsListQuery,
  InboxItemsRequestsListQueryVariables
>;
export const InboxItemUnreadStatusesUpdateDocument = gql`
    mutation InboxItemUnreadStatusesUpdate($input: UpdateInboxItemUnreadStatusesInput!) {
  updateInboxItemUnreadStatuses(input: $input) {
    success
  }
}
    `;
export type InboxItemUnreadStatusesUpdateMutationFn = Apollo.MutationFunction<
  InboxItemUnreadStatusesUpdateMutation,
  InboxItemUnreadStatusesUpdateMutationVariables
>;

/**
 * __useInboxItemUnreadStatusesUpdateMutation__
 *
 * To run a mutation, you first call `useInboxItemUnreadStatusesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInboxItemUnreadStatusesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inboxItemUnreadStatusesUpdateMutation, { data, loading, error }] = useInboxItemUnreadStatusesUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxItemUnreadStatusesUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InboxItemUnreadStatusesUpdateMutation,
    InboxItemUnreadStatusesUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InboxItemUnreadStatusesUpdateMutation,
    InboxItemUnreadStatusesUpdateMutationVariables
  >(InboxItemUnreadStatusesUpdateDocument, options);
}
export type InboxItemUnreadStatusesUpdateMutationHookResult = ReturnType<
  typeof useInboxItemUnreadStatusesUpdateMutation
>;
export type InboxItemUnreadStatusesUpdateMutationResult =
  Apollo.MutationResult<InboxItemUnreadStatusesUpdateMutation>;
export type InboxItemUnreadStatusesUpdateMutationOptions = Apollo.BaseMutationOptions<
  InboxItemUnreadStatusesUpdateMutation,
  InboxItemUnreadStatusesUpdateMutationVariables
>;
export const UpdateInboxItemUnreadStatusDocument = gql`
    mutation UpdateInboxItemUnreadStatus($inboxItemId: ID!) {
  updateInboxItemUnreadStatus(inboxItemId: $inboxItemId) {
    success
  }
}
    `;
export type UpdateInboxItemUnreadStatusMutationFn = Apollo.MutationFunction<
  UpdateInboxItemUnreadStatusMutation,
  UpdateInboxItemUnreadStatusMutationVariables
>;

/**
 * __useUpdateInboxItemUnreadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateInboxItemUnreadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInboxItemUnreadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInboxItemUnreadStatusMutation, { data, loading, error }] = useUpdateInboxItemUnreadStatusMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useUpdateInboxItemUnreadStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateInboxItemUnreadStatusMutation,
    UpdateInboxItemUnreadStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateInboxItemUnreadStatusMutation,
    UpdateInboxItemUnreadStatusMutationVariables
  >(UpdateInboxItemUnreadStatusDocument, options);
}
export type UpdateInboxItemUnreadStatusMutationHookResult = ReturnType<
  typeof useUpdateInboxItemUnreadStatusMutation
>;
export type UpdateInboxItemUnreadStatusMutationResult =
  Apollo.MutationResult<UpdateInboxItemUnreadStatusMutation>;
export type UpdateInboxItemUnreadStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateInboxItemUnreadStatusMutation,
  UpdateInboxItemUnreadStatusMutationVariables
>;
export const LeaveCommentForInboxItemDocument = gql`
    mutation LeaveCommentForInboxItem($inboxItemId: ID!, $comment: String!, $file: FileUpload, $visibleFor: [ActivityLogVisibleFor!]) {
  leaveCommentForInboxItem(
    inboxItemId: $inboxItemId
    comment: $comment
    file: $file
    visibleFor: $visibleFor
  ) {
    success
  }
}
    `;
export type LeaveCommentForInboxItemMutationFn = Apollo.MutationFunction<
  LeaveCommentForInboxItemMutation,
  LeaveCommentForInboxItemMutationVariables
>;

/**
 * __useLeaveCommentForInboxItemMutation__
 *
 * To run a mutation, you first call `useLeaveCommentForInboxItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCommentForInboxItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCommentForInboxItemMutation, { data, loading, error }] = useLeaveCommentForInboxItemMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      comment: // value for 'comment'
 *      file: // value for 'file'
 *      visibleFor: // value for 'visibleFor'
 *   },
 * });
 */
export function useLeaveCommentForInboxItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveCommentForInboxItemMutation,
    LeaveCommentForInboxItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveCommentForInboxItemMutation,
    LeaveCommentForInboxItemMutationVariables
  >(LeaveCommentForInboxItemDocument, options);
}
export type LeaveCommentForInboxItemMutationHookResult = ReturnType<
  typeof useLeaveCommentForInboxItemMutation
>;
export type LeaveCommentForInboxItemMutationResult =
  Apollo.MutationResult<LeaveCommentForInboxItemMutation>;
export type LeaveCommentForInboxItemMutationOptions = Apollo.BaseMutationOptions<
  LeaveCommentForInboxItemMutation,
  LeaveCommentForInboxItemMutationVariables
>;
export const IntegrationsListDocument = gql`
    query IntegrationsList($filter: IntegrationWhere, $orderBy: [IntegrationOrderBy!], $first: Int, $skip: Int) {
  integrationList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...IntegrationInfo
  }
  integrationCount(where: $filter)
}
    ${IntegrationInfoFragmentDoc}`;

/**
 * __useIntegrationsListQuery__
 *
 * To run a query within a React component, call `useIntegrationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useIntegrationsListQuery(
  baseOptions?: Apollo.QueryHookOptions<IntegrationsListQuery, IntegrationsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(
    IntegrationsListDocument,
    options,
  );
}
export function useIntegrationsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsListQuery, IntegrationsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(
    IntegrationsListDocument,
    options,
  );
}
// @ts-ignore
export function useIntegrationsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IntegrationsListQuery,
    IntegrationsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IntegrationsListQuery, IntegrationsListQueryVariables>;
export function useIntegrationsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationsListQuery, IntegrationsListQueryVariables>,
): Apollo.UseSuspenseQueryResult<IntegrationsListQuery | undefined, IntegrationsListQueryVariables>;
export function useIntegrationsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationsListQuery, IntegrationsListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationsListQuery, IntegrationsListQueryVariables>(
    IntegrationsListDocument,
    options,
  );
}
export type IntegrationsListQueryHookResult = ReturnType<typeof useIntegrationsListQuery>;
export type IntegrationsListLazyQueryHookResult = ReturnType<typeof useIntegrationsListLazyQuery>;
export type IntegrationsListSuspenseQueryHookResult = ReturnType<
  typeof useIntegrationsListSuspenseQuery
>;
export type IntegrationsListQueryResult = Apollo.QueryResult<
  IntegrationsListQuery,
  IntegrationsListQueryVariables
>;
export const IntegrationCreateDocument = gql`
    mutation IntegrationCreate($name: String!, $scope: [IntegrationScope!]!, $ipLimitAttempts: Int!, $ipLimitWindow: Int!, $credentialsLimitAttempts: Int!, $credentialsLimitWindow: Int!, $verifierLimitAttempts: Int!, $verifierLimitWindow: Int!, $verifierId: ID) {
  integrationCreateCustom(
    name: $name
    scope: $scope
    ipLimitAttempts: $ipLimitAttempts
    ipLimitWindow: $ipLimitWindow
    credentialsLimitAttempts: $credentialsLimitAttempts
    credentialsLimitWindow: $credentialsLimitWindow
    verifierLimitAttempts: $verifierLimitAttempts
    verifierLimitWindow: $verifierLimitWindow
    verifierId: $verifierId
  ) {
    clientId
    clientSecret
  }
}
    `;
export type IntegrationCreateMutationFn = Apollo.MutationFunction<
  IntegrationCreateMutation,
  IntegrationCreateMutationVariables
>;

/**
 * __useIntegrationCreateMutation__
 *
 * To run a mutation, you first call `useIntegrationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationCreateMutation, { data, loading, error }] = useIntegrationCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      scope: // value for 'scope'
 *      ipLimitAttempts: // value for 'ipLimitAttempts'
 *      ipLimitWindow: // value for 'ipLimitWindow'
 *      credentialsLimitAttempts: // value for 'credentialsLimitAttempts'
 *      credentialsLimitWindow: // value for 'credentialsLimitWindow'
 *      verifierLimitAttempts: // value for 'verifierLimitAttempts'
 *      verifierLimitWindow: // value for 'verifierLimitWindow'
 *      verifierId: // value for 'verifierId'
 *   },
 * });
 */
export function useIntegrationCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IntegrationCreateMutation,
    IntegrationCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IntegrationCreateMutation, IntegrationCreateMutationVariables>(
    IntegrationCreateDocument,
    options,
  );
}
export type IntegrationCreateMutationHookResult = ReturnType<typeof useIntegrationCreateMutation>;
export type IntegrationCreateMutationResult = Apollo.MutationResult<IntegrationCreateMutation>;
export type IntegrationCreateMutationOptions = Apollo.BaseMutationOptions<
  IntegrationCreateMutation,
  IntegrationCreateMutationVariables
>;
export const IntegrationUpdateDocument = gql`
    mutation IntegrationUpdate($id: ID!, $name: String!, $scope: [IntegrationScope!]!, $status: ActiveInactive!, $ipLimitAttempts: Int!, $ipLimitWindow: Int!, $credentialsLimitAttempts: Int!, $credentialsLimitWindow: Int!, $verifierLimitAttempts: Int!, $verifierLimitWindow: Int!) {
  integrationUpdateCustom(
    id: $id
    name: $name
    scope: $scope
    status: $status
    ipLimitAttempts: $ipLimitAttempts
    ipLimitWindow: $ipLimitWindow
    credentialsLimitAttempts: $credentialsLimitAttempts
    credentialsLimitWindow: $credentialsLimitWindow
    verifierLimitAttempts: $verifierLimitAttempts
    verifierLimitWindow: $verifierLimitWindow
  ) {
    ...IntegrationInfo
  }
}
    ${IntegrationInfoFragmentDoc}`;
export type IntegrationUpdateMutationFn = Apollo.MutationFunction<
  IntegrationUpdateMutation,
  IntegrationUpdateMutationVariables
>;

/**
 * __useIntegrationUpdateMutation__
 *
 * To run a mutation, you first call `useIntegrationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationUpdateMutation, { data, loading, error }] = useIntegrationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      scope: // value for 'scope'
 *      status: // value for 'status'
 *      ipLimitAttempts: // value for 'ipLimitAttempts'
 *      ipLimitWindow: // value for 'ipLimitWindow'
 *      credentialsLimitAttempts: // value for 'credentialsLimitAttempts'
 *      credentialsLimitWindow: // value for 'credentialsLimitWindow'
 *      verifierLimitAttempts: // value for 'verifierLimitAttempts'
 *      verifierLimitWindow: // value for 'verifierLimitWindow'
 *   },
 * });
 */
export function useIntegrationUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IntegrationUpdateMutation,
    IntegrationUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IntegrationUpdateMutation, IntegrationUpdateMutationVariables>(
    IntegrationUpdateDocument,
    options,
  );
}
export type IntegrationUpdateMutationHookResult = ReturnType<typeof useIntegrationUpdateMutation>;
export type IntegrationUpdateMutationResult = Apollo.MutationResult<IntegrationUpdateMutation>;
export type IntegrationUpdateMutationOptions = Apollo.BaseMutationOptions<
  IntegrationUpdateMutation,
  IntegrationUpdateMutationVariables
>;
export const IntegrationRegenerateCredentialsDocument = gql`
    mutation IntegrationRegenerateCredentials($id: ID!) {
  integrationRegenerateCredentials(id: $id) {
    clientId
    clientSecret
  }
}
    `;
export type IntegrationRegenerateCredentialsMutationFn = Apollo.MutationFunction<
  IntegrationRegenerateCredentialsMutation,
  IntegrationRegenerateCredentialsMutationVariables
>;

/**
 * __useIntegrationRegenerateCredentialsMutation__
 *
 * To run a mutation, you first call `useIntegrationRegenerateCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationRegenerateCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationRegenerateCredentialsMutation, { data, loading, error }] = useIntegrationRegenerateCredentialsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationRegenerateCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IntegrationRegenerateCredentialsMutation,
    IntegrationRegenerateCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IntegrationRegenerateCredentialsMutation,
    IntegrationRegenerateCredentialsMutationVariables
  >(IntegrationRegenerateCredentialsDocument, options);
}
export type IntegrationRegenerateCredentialsMutationHookResult = ReturnType<
  typeof useIntegrationRegenerateCredentialsMutation
>;
export type IntegrationRegenerateCredentialsMutationResult =
  Apollo.MutationResult<IntegrationRegenerateCredentialsMutation>;
export type IntegrationRegenerateCredentialsMutationOptions = Apollo.BaseMutationOptions<
  IntegrationRegenerateCredentialsMutation,
  IntegrationRegenerateCredentialsMutationVariables
>;
export const IntegrationUsageLogsListDocument = gql`
    query IntegrationUsageLogsList($filter: IntegrationUsageLogWhere, $orderBy: [IntegrationUsageLogOrderBy!], $first: Int, $skip: Int) {
  integrationUsageLogList(
    where: $filter
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    ...IntegrationUsageLogInfo
  }
  integrationUsageLogCount(where: $filter)
}
    ${IntegrationUsageLogInfoFragmentDoc}`;

/**
 * __useIntegrationUsageLogsListQuery__
 *
 * To run a query within a React component, call `useIntegrationUsageLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUsageLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationUsageLogsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useIntegrationUsageLogsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IntegrationUsageLogsListQuery,
    IntegrationUsageLogsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationUsageLogsListQuery, IntegrationUsageLogsListQueryVariables>(
    IntegrationUsageLogsListDocument,
    options,
  );
}
export function useIntegrationUsageLogsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IntegrationUsageLogsListQuery,
    IntegrationUsageLogsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationUsageLogsListQuery, IntegrationUsageLogsListQueryVariables>(
    IntegrationUsageLogsListDocument,
    options,
  );
}
// @ts-ignore
export function useIntegrationUsageLogsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IntegrationUsageLogsListQuery,
    IntegrationUsageLogsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IntegrationUsageLogsListQuery,
  IntegrationUsageLogsListQueryVariables
>;
export function useIntegrationUsageLogsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IntegrationUsageLogsListQuery,
        IntegrationUsageLogsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IntegrationUsageLogsListQuery | undefined,
  IntegrationUsageLogsListQueryVariables
>;
export function useIntegrationUsageLogsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IntegrationUsageLogsListQuery,
        IntegrationUsageLogsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IntegrationUsageLogsListQuery,
    IntegrationUsageLogsListQueryVariables
  >(IntegrationUsageLogsListDocument, options);
}
export type IntegrationUsageLogsListQueryHookResult = ReturnType<
  typeof useIntegrationUsageLogsListQuery
>;
export type IntegrationUsageLogsListLazyQueryHookResult = ReturnType<
  typeof useIntegrationUsageLogsListLazyQuery
>;
export type IntegrationUsageLogsListSuspenseQueryHookResult = ReturnType<
  typeof useIntegrationUsageLogsListSuspenseQuery
>;
export type IntegrationUsageLogsListQueryResult = Apollo.QueryResult<
  IntegrationUsageLogsListQuery,
  IntegrationUsageLogsListQueryVariables
>;
export const IntegrationUsageLogStatsDocument = gql`
    query IntegrationUsageLogStats($filter: IntegrationUsageLogWhere) {
  getIntegrationUsageLogStats(where: $filter) {
    total
    matched
    noMatch
    failed
  }
}
    `;

/**
 * __useIntegrationUsageLogStatsQuery__
 *
 * To run a query within a React component, call `useIntegrationUsageLogStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUsageLogStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationUsageLogStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationUsageLogStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IntegrationUsageLogStatsQuery,
    IntegrationUsageLogStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationUsageLogStatsQuery, IntegrationUsageLogStatsQueryVariables>(
    IntegrationUsageLogStatsDocument,
    options,
  );
}
export function useIntegrationUsageLogStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IntegrationUsageLogStatsQuery,
    IntegrationUsageLogStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationUsageLogStatsQuery, IntegrationUsageLogStatsQueryVariables>(
    IntegrationUsageLogStatsDocument,
    options,
  );
}
// @ts-ignore
export function useIntegrationUsageLogStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IntegrationUsageLogStatsQuery,
    IntegrationUsageLogStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IntegrationUsageLogStatsQuery,
  IntegrationUsageLogStatsQueryVariables
>;
export function useIntegrationUsageLogStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IntegrationUsageLogStatsQuery,
        IntegrationUsageLogStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IntegrationUsageLogStatsQuery | undefined,
  IntegrationUsageLogStatsQueryVariables
>;
export function useIntegrationUsageLogStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IntegrationUsageLogStatsQuery,
        IntegrationUsageLogStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IntegrationUsageLogStatsQuery,
    IntegrationUsageLogStatsQueryVariables
  >(IntegrationUsageLogStatsDocument, options);
}
export type IntegrationUsageLogStatsQueryHookResult = ReturnType<
  typeof useIntegrationUsageLogStatsQuery
>;
export type IntegrationUsageLogStatsLazyQueryHookResult = ReturnType<
  typeof useIntegrationUsageLogStatsLazyQuery
>;
export type IntegrationUsageLogStatsSuspenseQueryHookResult = ReturnType<
  typeof useIntegrationUsageLogStatsSuspenseQuery
>;
export type IntegrationUsageLogStatsQueryResult = Apollo.QueryResult<
  IntegrationUsageLogStatsQuery,
  IntegrationUsageLogStatsQueryVariables
>;
export const IntegrationDetailDocument = gql`
    query IntegrationDetail($id: ID!) {
  integration(where: {id: $id}) {
    ...IntegrationInfo
  }
}
    ${IntegrationInfoFragmentDoc}`;

/**
 * __useIntegrationDetailQuery__
 *
 * To run a query within a React component, call `useIntegrationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationDetailQuery(
  baseOptions: Apollo.QueryHookOptions<IntegrationDetailQuery, IntegrationDetailQueryVariables> &
    ({ variables: IntegrationDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IntegrationDetailQuery, IntegrationDetailQueryVariables>(
    IntegrationDetailDocument,
    options,
  );
}
export function useIntegrationDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IntegrationDetailQuery,
    IntegrationDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IntegrationDetailQuery, IntegrationDetailQueryVariables>(
    IntegrationDetailDocument,
    options,
  );
}
// @ts-ignore
export function useIntegrationDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IntegrationDetailQuery,
    IntegrationDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IntegrationDetailQuery, IntegrationDetailQueryVariables>;
export function useIntegrationDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationDetailQuery, IntegrationDetailQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  IntegrationDetailQuery | undefined,
  IntegrationDetailQueryVariables
>;
export function useIntegrationDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IntegrationDetailQuery, IntegrationDetailQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IntegrationDetailQuery, IntegrationDetailQueryVariables>(
    IntegrationDetailDocument,
    options,
  );
}
export type IntegrationDetailQueryHookResult = ReturnType<typeof useIntegrationDetailQuery>;
export type IntegrationDetailLazyQueryHookResult = ReturnType<typeof useIntegrationDetailLazyQuery>;
export type IntegrationDetailSuspenseQueryHookResult = ReturnType<
  typeof useIntegrationDetailSuspenseQuery
>;
export type IntegrationDetailQueryResult = Apollo.QueryResult<
  IntegrationDetailQuery,
  IntegrationDetailQueryVariables
>;
export const ExportIntegrationUsageLogsDocument = gql`
    query ExportIntegrationUsageLogs($input: ExportIntegrationUsageLogInput!) {
  exportIntegrationUsageLogs(input: $input)
}
    `;

/**
 * __useExportIntegrationUsageLogsQuery__
 *
 * To run a query within a React component, call `useExportIntegrationUsageLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportIntegrationUsageLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportIntegrationUsageLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportIntegrationUsageLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportIntegrationUsageLogsQuery,
    ExportIntegrationUsageLogsQueryVariables
  > &
    ({ variables: ExportIntegrationUsageLogsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportIntegrationUsageLogsQuery, ExportIntegrationUsageLogsQueryVariables>(
    ExportIntegrationUsageLogsDocument,
    options,
  );
}
export function useExportIntegrationUsageLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportIntegrationUsageLogsQuery,
    ExportIntegrationUsageLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportIntegrationUsageLogsQuery,
    ExportIntegrationUsageLogsQueryVariables
  >(ExportIntegrationUsageLogsDocument, options);
}
// @ts-ignore
export function useExportIntegrationUsageLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportIntegrationUsageLogsQuery,
    ExportIntegrationUsageLogsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportIntegrationUsageLogsQuery,
  ExportIntegrationUsageLogsQueryVariables
>;
export function useExportIntegrationUsageLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportIntegrationUsageLogsQuery,
        ExportIntegrationUsageLogsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportIntegrationUsageLogsQuery | undefined,
  ExportIntegrationUsageLogsQueryVariables
>;
export function useExportIntegrationUsageLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportIntegrationUsageLogsQuery,
        ExportIntegrationUsageLogsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportIntegrationUsageLogsQuery,
    ExportIntegrationUsageLogsQueryVariables
  >(ExportIntegrationUsageLogsDocument, options);
}
export type ExportIntegrationUsageLogsQueryHookResult = ReturnType<
  typeof useExportIntegrationUsageLogsQuery
>;
export type ExportIntegrationUsageLogsLazyQueryHookResult = ReturnType<
  typeof useExportIntegrationUsageLogsLazyQuery
>;
export type ExportIntegrationUsageLogsSuspenseQueryHookResult = ReturnType<
  typeof useExportIntegrationUsageLogsSuspenseQuery
>;
export type ExportIntegrationUsageLogsQueryResult = Apollo.QueryResult<
  ExportIntegrationUsageLogsQuery,
  ExportIntegrationUsageLogsQueryVariables
>;
export const InviteDocument = gql`
    query Invite($id: ID!) {
  getInvite(id: $id) {
    id
    email
    role
    isAdditionalStaff
    isEmployerUnderPeo
    isPeoUnderPeoPayrollProvider
    predefinedSignUpMethod
    isBulkUploaded
    from
  }
}
    `;

/**
 * __useInviteQuery__
 *
 * To run a query within a React component, call `useInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteQuery(
  baseOptions: Apollo.QueryHookOptions<InviteQuery, InviteQueryVariables> &
    ({ variables: InviteQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
}
export function useInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
}
// @ts-ignore
export function useInviteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>,
): Apollo.UseSuspenseQueryResult<InviteQuery, InviteQueryVariables>;
export function useInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>,
): Apollo.UseSuspenseQueryResult<InviteQuery | undefined, InviteQueryVariables>;
export function useInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
}
export type InviteQueryHookResult = ReturnType<typeof useInviteQuery>;
export type InviteLazyQueryHookResult = ReturnType<typeof useInviteLazyQuery>;
export type InviteSuspenseQueryHookResult = ReturnType<typeof useInviteSuspenseQuery>;
export type InviteQueryResult = Apollo.QueryResult<InviteQuery, InviteQueryVariables>;
export const SendInvitesToEmployersAdminsByCvAdminDocument = gql`
    mutation sendInvitesToEmployersAdminsByCVAdmin($employers: [InvitedEmployerAdminByCVAdminData!]!, $peoId: ID, $peoPayrollProviderId: ID) {
  sendInvitesToEmployersAdminsByCVAdmin(
    employers: $employers
    peoId: $peoId
    peoPayrollProviderId: $peoPayrollProviderId
  ) {
    success
  }
}
    `;
export type SendInvitesToEmployersAdminsByCvAdminMutationFn = Apollo.MutationFunction<
  SendInvitesToEmployersAdminsByCvAdminMutation,
  SendInvitesToEmployersAdminsByCvAdminMutationVariables
>;

/**
 * __useSendInvitesToEmployersAdminsByCvAdminMutation__
 *
 * To run a mutation, you first call `useSendInvitesToEmployersAdminsByCvAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToEmployersAdminsByCvAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToEmployersAdminsByCvAdminMutation, { data, loading, error }] = useSendInvitesToEmployersAdminsByCvAdminMutation({
 *   variables: {
 *      employers: // value for 'employers'
 *      peoId: // value for 'peoId'
 *      peoPayrollProviderId: // value for 'peoPayrollProviderId'
 *   },
 * });
 */
export function useSendInvitesToEmployersAdminsByCvAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToEmployersAdminsByCvAdminMutation,
    SendInvitesToEmployersAdminsByCvAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToEmployersAdminsByCvAdminMutation,
    SendInvitesToEmployersAdminsByCvAdminMutationVariables
  >(SendInvitesToEmployersAdminsByCvAdminDocument, options);
}
export type SendInvitesToEmployersAdminsByCvAdminMutationHookResult = ReturnType<
  typeof useSendInvitesToEmployersAdminsByCvAdminMutation
>;
export type SendInvitesToEmployersAdminsByCvAdminMutationResult =
  Apollo.MutationResult<SendInvitesToEmployersAdminsByCvAdminMutation>;
export type SendInvitesToEmployersAdminsByCvAdminMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToEmployersAdminsByCvAdminMutation,
  SendInvitesToEmployersAdminsByCvAdminMutationVariables
>;
export const SendInvitesToVerifiersAdminsByCvAdminDocument = gql`
    mutation sendInvitesToVerifiersAdminsByCVAdmin($verifierAdmin: InvitedVerifierAdminByCVAdminData!) {
  sendInvitesToVerifiersAdminsByCVAdmin(verifierAdmin: $verifierAdmin) {
    success
  }
}
    `;
export type SendInvitesToVerifiersAdminsByCvAdminMutationFn = Apollo.MutationFunction<
  SendInvitesToVerifiersAdminsByCvAdminMutation,
  SendInvitesToVerifiersAdminsByCvAdminMutationVariables
>;

/**
 * __useSendInvitesToVerifiersAdminsByCvAdminMutation__
 *
 * To run a mutation, you first call `useSendInvitesToVerifiersAdminsByCvAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToVerifiersAdminsByCvAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToVerifiersAdminsByCvAdminMutation, { data, loading, error }] = useSendInvitesToVerifiersAdminsByCvAdminMutation({
 *   variables: {
 *      verifierAdmin: // value for 'verifierAdmin'
 *   },
 * });
 */
export function useSendInvitesToVerifiersAdminsByCvAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToVerifiersAdminsByCvAdminMutation,
    SendInvitesToVerifiersAdminsByCvAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToVerifiersAdminsByCvAdminMutation,
    SendInvitesToVerifiersAdminsByCvAdminMutationVariables
  >(SendInvitesToVerifiersAdminsByCvAdminDocument, options);
}
export type SendInvitesToVerifiersAdminsByCvAdminMutationHookResult = ReturnType<
  typeof useSendInvitesToVerifiersAdminsByCvAdminMutation
>;
export type SendInvitesToVerifiersAdminsByCvAdminMutationResult =
  Apollo.MutationResult<SendInvitesToVerifiersAdminsByCvAdminMutation>;
export type SendInvitesToVerifiersAdminsByCvAdminMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToVerifiersAdminsByCvAdminMutation,
  SendInvitesToVerifiersAdminsByCvAdminMutationVariables
>;
export const SendInvitesToPeoStaffByPeoAdminDocument = gql`
    mutation sendInvitesToPeoStaffByPeoAdmin($staff: [InvitedPeoStaffData!]!) {
  sendInvitesToPeoStaffByPeoAdmin(staff: $staff) {
    success
  }
}
    `;
export type SendInvitesToPeoStaffByPeoAdminMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoStaffByPeoAdminMutation,
  SendInvitesToPeoStaffByPeoAdminMutationVariables
>;

/**
 * __useSendInvitesToPeoStaffByPeoAdminMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoStaffByPeoAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoStaffByPeoAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoStaffByPeoAdminMutation, { data, loading, error }] = useSendInvitesToPeoStaffByPeoAdminMutation({
 *   variables: {
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useSendInvitesToPeoStaffByPeoAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoStaffByPeoAdminMutation,
    SendInvitesToPeoStaffByPeoAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoStaffByPeoAdminMutation,
    SendInvitesToPeoStaffByPeoAdminMutationVariables
  >(SendInvitesToPeoStaffByPeoAdminDocument, options);
}
export type SendInvitesToPeoStaffByPeoAdminMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoStaffByPeoAdminMutation
>;
export type SendInvitesToPeoStaffByPeoAdminMutationResult =
  Apollo.MutationResult<SendInvitesToPeoStaffByPeoAdminMutation>;
export type SendInvitesToPeoStaffByPeoAdminMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToPeoStaffByPeoAdminMutation,
  SendInvitesToPeoStaffByPeoAdminMutationVariables
>;
export const SendInvitesToVerifiersStaffDocument = gql`
    mutation sendInvitesToVerifiersStaff($verifierId: ID, $verifierStaff: [InvitedVerifierStaffData!]!) {
  sendInvitesToVerifiersStaff(
    verifierId: $verifierId
    verifierStaff: $verifierStaff
  ) {
    success
  }
}
    `;
export type SendInvitesToVerifiersStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToVerifiersStaffMutation,
  SendInvitesToVerifiersStaffMutationVariables
>;

/**
 * __useSendInvitesToVerifiersStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToVerifiersStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToVerifiersStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToVerifiersStaffMutation, { data, loading, error }] = useSendInvitesToVerifiersStaffMutation({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *      verifierStaff: // value for 'verifierStaff'
 *   },
 * });
 */
export function useSendInvitesToVerifiersStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToVerifiersStaffMutation,
    SendInvitesToVerifiersStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToVerifiersStaffMutation,
    SendInvitesToVerifiersStaffMutationVariables
  >(SendInvitesToVerifiersStaffDocument, options);
}
export type SendInvitesToVerifiersStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToVerifiersStaffMutation
>;
export type SendInvitesToVerifiersStaffMutationResult =
  Apollo.MutationResult<SendInvitesToVerifiersStaffMutation>;
export type SendInvitesToVerifiersStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToVerifiersStaffMutation,
  SendInvitesToVerifiersStaffMutationVariables
>;
export const SendInvitesToClearVerifyStaffDocument = gql`
    mutation sendInvitesToClearVerifyStaff($managers: [PlatformStaffInviteItem!]!) {
  sendInvitesToClearVerifyStaff(managers: $managers) {
    success
  }
}
    `;
export type SendInvitesToClearVerifyStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToClearVerifyStaffMutation,
  SendInvitesToClearVerifyStaffMutationVariables
>;

/**
 * __useSendInvitesToClearVerifyStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToClearVerifyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToClearVerifyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToClearVerifyStaffMutation, { data, loading, error }] = useSendInvitesToClearVerifyStaffMutation({
 *   variables: {
 *      managers: // value for 'managers'
 *   },
 * });
 */
export function useSendInvitesToClearVerifyStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToClearVerifyStaffMutation,
    SendInvitesToClearVerifyStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToClearVerifyStaffMutation,
    SendInvitesToClearVerifyStaffMutationVariables
  >(SendInvitesToClearVerifyStaffDocument, options);
}
export type SendInvitesToClearVerifyStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToClearVerifyStaffMutation
>;
export type SendInvitesToClearVerifyStaffMutationResult =
  Apollo.MutationResult<SendInvitesToClearVerifyStaffMutation>;
export type SendInvitesToClearVerifyStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToClearVerifyStaffMutation,
  SendInvitesToClearVerifyStaffMutationVariables
>;
export const UserRegistrationByInviteDocument = gql`
    mutation UserRegistrationByInvite($inviteId: ID!, $user: InvitedSignedUserData!, $verifier: InvitedSignedVerifierData, $employer: InvitedSignedEmployerData, $peo: InvitedSignedPEOData, $consumer: InvitedSignedConsumerData, $peoPayrollProvider: InvitedSignedPEOPayrollProviderData) {
  userRegistrationByInvite(
    inviteId: $inviteId
    user: $user
    verifier: $verifier
    employer: $employer
    peo: $peo
    consumer: $consumer
    peoPayrollProvider: $peoPayrollProvider
  ) {
    idToken
    accessToken
  }
}
    `;
export type UserRegistrationByInviteMutationFn = Apollo.MutationFunction<
  UserRegistrationByInviteMutation,
  UserRegistrationByInviteMutationVariables
>;

/**
 * __useUserRegistrationByInviteMutation__
 *
 * To run a mutation, you first call `useUserRegistrationByInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationByInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRegistrationByInviteMutation, { data, loading, error }] = useUserRegistrationByInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      user: // value for 'user'
 *      verifier: // value for 'verifier'
 *      employer: // value for 'employer'
 *      peo: // value for 'peo'
 *      consumer: // value for 'consumer'
 *      peoPayrollProvider: // value for 'peoPayrollProvider'
 *   },
 * });
 */
export function useUserRegistrationByInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserRegistrationByInviteMutation,
    UserRegistrationByInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserRegistrationByInviteMutation,
    UserRegistrationByInviteMutationVariables
  >(UserRegistrationByInviteDocument, options);
}
export type UserRegistrationByInviteMutationHookResult = ReturnType<
  typeof useUserRegistrationByInviteMutation
>;
export type UserRegistrationByInviteMutationResult =
  Apollo.MutationResult<UserRegistrationByInviteMutation>;
export type UserRegistrationByInviteMutationOptions = Apollo.BaseMutationOptions<
  UserRegistrationByInviteMutation,
  UserRegistrationByInviteMutationVariables
>;
export const SendInvitesToVerifiersAdminsByVerifierAdminDocument = gql`
    mutation sendInvitesToVerifiersAdminsByVerifierAdmin($verifiersAdmins: [InvitedVerifierAdminByVerifierAdminData!]!) {
  sendInvitesToVerifiersAdminsByVerifierAdmin(verifiersAdmins: $verifiersAdmins) {
    success
  }
}
    `;
export type SendInvitesToVerifiersAdminsByVerifierAdminMutationFn = Apollo.MutationFunction<
  SendInvitesToVerifiersAdminsByVerifierAdminMutation,
  SendInvitesToVerifiersAdminsByVerifierAdminMutationVariables
>;

/**
 * __useSendInvitesToVerifiersAdminsByVerifierAdminMutation__
 *
 * To run a mutation, you first call `useSendInvitesToVerifiersAdminsByVerifierAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToVerifiersAdminsByVerifierAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToVerifiersAdminsByVerifierAdminMutation, { data, loading, error }] = useSendInvitesToVerifiersAdminsByVerifierAdminMutation({
 *   variables: {
 *      verifiersAdmins: // value for 'verifiersAdmins'
 *   },
 * });
 */
export function useSendInvitesToVerifiersAdminsByVerifierAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToVerifiersAdminsByVerifierAdminMutation,
    SendInvitesToVerifiersAdminsByVerifierAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToVerifiersAdminsByVerifierAdminMutation,
    SendInvitesToVerifiersAdminsByVerifierAdminMutationVariables
  >(SendInvitesToVerifiersAdminsByVerifierAdminDocument, options);
}
export type SendInvitesToVerifiersAdminsByVerifierAdminMutationHookResult = ReturnType<
  typeof useSendInvitesToVerifiersAdminsByVerifierAdminMutation
>;
export type SendInvitesToVerifiersAdminsByVerifierAdminMutationResult =
  Apollo.MutationResult<SendInvitesToVerifiersAdminsByVerifierAdminMutation>;
export type SendInvitesToVerifiersAdminsByVerifierAdminMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToVerifiersAdminsByVerifierAdminMutation,
  SendInvitesToVerifiersAdminsByVerifierAdminMutationVariables
>;
export const SendInvitesToConsumersByEmployerDocument = gql`
    mutation sendInvitesToConsumersByEmployer($employeeIds: [ID!]!, $inviteEmail: String) {
  sendInvitesToConsumersByEmployer(
    employeeIds: $employeeIds
    inviteEmail: $inviteEmail
  ) {
    success
  }
}
    `;
export type SendInvitesToConsumersByEmployerMutationFn = Apollo.MutationFunction<
  SendInvitesToConsumersByEmployerMutation,
  SendInvitesToConsumersByEmployerMutationVariables
>;

/**
 * __useSendInvitesToConsumersByEmployerMutation__
 *
 * To run a mutation, you first call `useSendInvitesToConsumersByEmployerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToConsumersByEmployerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToConsumersByEmployerMutation, { data, loading, error }] = useSendInvitesToConsumersByEmployerMutation({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      inviteEmail: // value for 'inviteEmail'
 *   },
 * });
 */
export function useSendInvitesToConsumersByEmployerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToConsumersByEmployerMutation,
    SendInvitesToConsumersByEmployerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToConsumersByEmployerMutation,
    SendInvitesToConsumersByEmployerMutationVariables
  >(SendInvitesToConsumersByEmployerDocument, options);
}
export type SendInvitesToConsumersByEmployerMutationHookResult = ReturnType<
  typeof useSendInvitesToConsumersByEmployerMutation
>;
export type SendInvitesToConsumersByEmployerMutationResult =
  Apollo.MutationResult<SendInvitesToConsumersByEmployerMutation>;
export type SendInvitesToConsumersByEmployerMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToConsumersByEmployerMutation,
  SendInvitesToConsumersByEmployerMutationVariables
>;
export const SendInvitesToConsumersByPeoDocument = gql`
    mutation sendInvitesToConsumersByPeo($employeeIds: [ID!]!, $inviteEmail: String) {
  sendInvitesToConsumersByPeo(
    employeeIds: $employeeIds
    inviteEmail: $inviteEmail
  ) {
    success
  }
}
    `;
export type SendInvitesToConsumersByPeoMutationFn = Apollo.MutationFunction<
  SendInvitesToConsumersByPeoMutation,
  SendInvitesToConsumersByPeoMutationVariables
>;

/**
 * __useSendInvitesToConsumersByPeoMutation__
 *
 * To run a mutation, you first call `useSendInvitesToConsumersByPeoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToConsumersByPeoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToConsumersByPeoMutation, { data, loading, error }] = useSendInvitesToConsumersByPeoMutation({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      inviteEmail: // value for 'inviteEmail'
 *   },
 * });
 */
export function useSendInvitesToConsumersByPeoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToConsumersByPeoMutation,
    SendInvitesToConsumersByPeoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToConsumersByPeoMutation,
    SendInvitesToConsumersByPeoMutationVariables
  >(SendInvitesToConsumersByPeoDocument, options);
}
export type SendInvitesToConsumersByPeoMutationHookResult = ReturnType<
  typeof useSendInvitesToConsumersByPeoMutation
>;
export type SendInvitesToConsumersByPeoMutationResult =
  Apollo.MutationResult<SendInvitesToConsumersByPeoMutation>;
export type SendInvitesToConsumersByPeoMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToConsumersByPeoMutation,
  SendInvitesToConsumersByPeoMutationVariables
>;
export const CreateEmployeeInviteLinkByCvStaffDocument = gql`
    mutation createEmployeeInviteLinkByCVStaff($employeeId: ID!) {
  createEmployeeInviteLinkByCVStaff(employeeId: $employeeId) {
    success
    inviteLinkUrl
  }
}
    `;
export type CreateEmployeeInviteLinkByCvStaffMutationFn = Apollo.MutationFunction<
  CreateEmployeeInviteLinkByCvStaffMutation,
  CreateEmployeeInviteLinkByCvStaffMutationVariables
>;

/**
 * __useCreateEmployeeInviteLinkByCvStaffMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeInviteLinkByCvStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeInviteLinkByCvStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeInviteLinkByCvStaffMutation, { data, loading, error }] = useCreateEmployeeInviteLinkByCvStaffMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useCreateEmployeeInviteLinkByCvStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEmployeeInviteLinkByCvStaffMutation,
    CreateEmployeeInviteLinkByCvStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEmployeeInviteLinkByCvStaffMutation,
    CreateEmployeeInviteLinkByCvStaffMutationVariables
  >(CreateEmployeeInviteLinkByCvStaffDocument, options);
}
export type CreateEmployeeInviteLinkByCvStaffMutationHookResult = ReturnType<
  typeof useCreateEmployeeInviteLinkByCvStaffMutation
>;
export type CreateEmployeeInviteLinkByCvStaffMutationResult =
  Apollo.MutationResult<CreateEmployeeInviteLinkByCvStaffMutation>;
export type CreateEmployeeInviteLinkByCvStaffMutationOptions = Apollo.BaseMutationOptions<
  CreateEmployeeInviteLinkByCvStaffMutation,
  CreateEmployeeInviteLinkByCvStaffMutationVariables
>;
export const SendInvitesToConsumersByCvStaffDocument = gql`
    mutation sendInvitesToConsumersByCVStaff($employeeIds: [ID!]!, $inviteScopeEntityId: ID, $inviteScopeParamKey: String, $inviteEmail: String) {
  sendInvitesToConsumersByCVStaff(
    employeeIds: $employeeIds
    inviteScopeEntityId: $inviteScopeEntityId
    inviteScopeParamKey: $inviteScopeParamKey
    inviteEmail: $inviteEmail
  ) {
    success
  }
}
    `;
export type SendInvitesToConsumersByCvStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToConsumersByCvStaffMutation,
  SendInvitesToConsumersByCvStaffMutationVariables
>;

/**
 * __useSendInvitesToConsumersByCvStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToConsumersByCvStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToConsumersByCvStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToConsumersByCvStaffMutation, { data, loading, error }] = useSendInvitesToConsumersByCvStaffMutation({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      inviteScopeEntityId: // value for 'inviteScopeEntityId'
 *      inviteScopeParamKey: // value for 'inviteScopeParamKey'
 *      inviteEmail: // value for 'inviteEmail'
 *   },
 * });
 */
export function useSendInvitesToConsumersByCvStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToConsumersByCvStaffMutation,
    SendInvitesToConsumersByCvStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToConsumersByCvStaffMutation,
    SendInvitesToConsumersByCvStaffMutationVariables
  >(SendInvitesToConsumersByCvStaffDocument, options);
}
export type SendInvitesToConsumersByCvStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToConsumersByCvStaffMutation
>;
export type SendInvitesToConsumersByCvStaffMutationResult =
  Apollo.MutationResult<SendInvitesToConsumersByCvStaffMutation>;
export type SendInvitesToConsumersByCvStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToConsumersByCvStaffMutation,
  SendInvitesToConsumersByCvStaffMutationVariables
>;
export const SendInvitesToPeoByCvStaffDocument = gql`
    mutation sendInvitesToPeoByCVStaff($peos: [InvitedByCVStaffPeoData!]!, $peoPayrollProviderId: ID) {
  sendInvitesToPeoByCVStaff(
    peos: $peos
    peoPayrollProviderId: $peoPayrollProviderId
  ) {
    success
  }
}
    `;
export type SendInvitesToPeoByCvStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoByCvStaffMutation,
  SendInvitesToPeoByCvStaffMutationVariables
>;

/**
 * __useSendInvitesToPeoByCvStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoByCvStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoByCvStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoByCvStaffMutation, { data, loading, error }] = useSendInvitesToPeoByCvStaffMutation({
 *   variables: {
 *      peos: // value for 'peos'
 *      peoPayrollProviderId: // value for 'peoPayrollProviderId'
 *   },
 * });
 */
export function useSendInvitesToPeoByCvStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoByCvStaffMutation,
    SendInvitesToPeoByCvStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoByCvStaffMutation,
    SendInvitesToPeoByCvStaffMutationVariables
  >(SendInvitesToPeoByCvStaffDocument, options);
}
export type SendInvitesToPeoByCvStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoByCvStaffMutation
>;
export type SendInvitesToPeoByCvStaffMutationResult =
  Apollo.MutationResult<SendInvitesToPeoByCvStaffMutation>;
export type SendInvitesToPeoByCvStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToPeoByCvStaffMutation,
  SendInvitesToPeoByCvStaffMutationVariables
>;
export const SendInvitesToPeoPayrollProviderByCvStaffDocument = gql`
    mutation sendInvitesToPeoPayrollProviderByCVStaff($peoPayrollProviders: [InvitedByCVStaffPeoPayrollProviderData!]!) {
  sendInvitesToPeoPayrollProviderByCVStaff(
    peoPayrollProviders: $peoPayrollProviders
  ) {
    success
  }
}
    `;
export type SendInvitesToPeoPayrollProviderByCvStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoPayrollProviderByCvStaffMutation,
  SendInvitesToPeoPayrollProviderByCvStaffMutationVariables
>;

/**
 * __useSendInvitesToPeoPayrollProviderByCvStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoPayrollProviderByCvStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoPayrollProviderByCvStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoPayrollProviderByCvStaffMutation, { data, loading, error }] = useSendInvitesToPeoPayrollProviderByCvStaffMutation({
 *   variables: {
 *      peoPayrollProviders: // value for 'peoPayrollProviders'
 *   },
 * });
 */
export function useSendInvitesToPeoPayrollProviderByCvStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoPayrollProviderByCvStaffMutation,
    SendInvitesToPeoPayrollProviderByCvStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoPayrollProviderByCvStaffMutation,
    SendInvitesToPeoPayrollProviderByCvStaffMutationVariables
  >(SendInvitesToPeoPayrollProviderByCvStaffDocument, options);
}
export type SendInvitesToPeoPayrollProviderByCvStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoPayrollProviderByCvStaffMutation
>;
export type SendInvitesToPeoPayrollProviderByCvStaffMutationResult =
  Apollo.MutationResult<SendInvitesToPeoPayrollProviderByCvStaffMutation>;
export type SendInvitesToPeoPayrollProviderByCvStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToPeoPayrollProviderByCvStaffMutation,
  SendInvitesToPeoPayrollProviderByCvStaffMutationVariables
>;
export const SendInvitesToPeoStaffByCvStaffDocument = gql`
    mutation sendInvitesToPeoStaffByCVStaff($peoId: String!, $staff: [InvitedPeoStaffData!]!) {
  sendInvitesToPeoStaffByCVStaff(peoId: $peoId, staff: $staff) {
    success
  }
}
    `;
export type SendInvitesToPeoStaffByCvStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoStaffByCvStaffMutation,
  SendInvitesToPeoStaffByCvStaffMutationVariables
>;

/**
 * __useSendInvitesToPeoStaffByCvStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoStaffByCvStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoStaffByCvStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoStaffByCvStaffMutation, { data, loading, error }] = useSendInvitesToPeoStaffByCvStaffMutation({
 *   variables: {
 *      peoId: // value for 'peoId'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useSendInvitesToPeoStaffByCvStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoStaffByCvStaffMutation,
    SendInvitesToPeoStaffByCvStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoStaffByCvStaffMutation,
    SendInvitesToPeoStaffByCvStaffMutationVariables
  >(SendInvitesToPeoStaffByCvStaffDocument, options);
}
export type SendInvitesToPeoStaffByCvStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoStaffByCvStaffMutation
>;
export type SendInvitesToPeoStaffByCvStaffMutationResult =
  Apollo.MutationResult<SendInvitesToPeoStaffByCvStaffMutation>;
export type SendInvitesToPeoStaffByCvStaffMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToPeoStaffByCvStaffMutation,
  SendInvitesToPeoStaffByCvStaffMutationVariables
>;
export const SendInvitesToPeoStaffByPeoPayrollProviderStaffDocument = gql`
    mutation sendInvitesToPeoStaffByPeoPayrollProviderStaff($peoId: String!, $staff: [InvitedPeoStaffData!]!) {
  sendInvitesToPeoStaffByPeoPayrollProviderStaff(peoId: $peoId, staff: $staff) {
    success
  }
}
    `;
export type SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoStaffByPeoPayrollProviderStaffMutation,
  SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationVariables
>;

/**
 * __useSendInvitesToPeoStaffByPeoPayrollProviderStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoStaffByPeoPayrollProviderStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoStaffByPeoPayrollProviderStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoStaffByPeoPayrollProviderStaffMutation, { data, loading, error }] = useSendInvitesToPeoStaffByPeoPayrollProviderStaffMutation({
 *   variables: {
 *      peoId: // value for 'peoId'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useSendInvitesToPeoStaffByPeoPayrollProviderStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoStaffByPeoPayrollProviderStaffMutation,
    SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoStaffByPeoPayrollProviderStaffMutation,
    SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationVariables
  >(SendInvitesToPeoStaffByPeoPayrollProviderStaffDocument, options);
}
export type SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoStaffByPeoPayrollProviderStaffMutation
>;
export type SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationResult =
  Apollo.MutationResult<SendInvitesToPeoStaffByPeoPayrollProviderStaffMutation>;
export type SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationOptions =
  Apollo.BaseMutationOptions<
    SendInvitesToPeoStaffByPeoPayrollProviderStaffMutation,
    SendInvitesToPeoStaffByPeoPayrollProviderStaffMutationVariables
  >;
export const SendInvitesToEmployersUnderPeoDocument = gql`
    mutation sendInvitesToEmployersUnderPeo($input: SendInvitesToEmployersUnderPeoInput!) {
  sendInvitesToEmployersUnderPeo(input: $input) {
    success
  }
}
    `;
export type SendInvitesToEmployersUnderPeoMutationFn = Apollo.MutationFunction<
  SendInvitesToEmployersUnderPeoMutation,
  SendInvitesToEmployersUnderPeoMutationVariables
>;

/**
 * __useSendInvitesToEmployersUnderPeoMutation__
 *
 * To run a mutation, you first call `useSendInvitesToEmployersUnderPeoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToEmployersUnderPeoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToEmployersUnderPeoMutation, { data, loading, error }] = useSendInvitesToEmployersUnderPeoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitesToEmployersUnderPeoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToEmployersUnderPeoMutation,
    SendInvitesToEmployersUnderPeoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToEmployersUnderPeoMutation,
    SendInvitesToEmployersUnderPeoMutationVariables
  >(SendInvitesToEmployersUnderPeoDocument, options);
}
export type SendInvitesToEmployersUnderPeoMutationHookResult = ReturnType<
  typeof useSendInvitesToEmployersUnderPeoMutation
>;
export type SendInvitesToEmployersUnderPeoMutationResult =
  Apollo.MutationResult<SendInvitesToEmployersUnderPeoMutation>;
export type SendInvitesToEmployersUnderPeoMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToEmployersUnderPeoMutation,
  SendInvitesToEmployersUnderPeoMutationVariables
>;
export const SendInvitesToPeoByPeoPpDocument = gql`
    mutation sendInvitesToPeoByPeoPp($input: SendInvitesToPeoByPeoPpInput!) {
  sendInvitesToPeoByPeoPp(input: $input) {
    success
  }
}
    `;
export type SendInvitesToPeoByPeoPpMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoByPeoPpMutation,
  SendInvitesToPeoByPeoPpMutationVariables
>;

/**
 * __useSendInvitesToPeoByPeoPpMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoByPeoPpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoByPeoPpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoByPeoPpMutation, { data, loading, error }] = useSendInvitesToPeoByPeoPpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitesToPeoByPeoPpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoByPeoPpMutation,
    SendInvitesToPeoByPeoPpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoByPeoPpMutation,
    SendInvitesToPeoByPeoPpMutationVariables
  >(SendInvitesToPeoByPeoPpDocument, options);
}
export type SendInvitesToPeoByPeoPpMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoByPeoPpMutation
>;
export type SendInvitesToPeoByPeoPpMutationResult =
  Apollo.MutationResult<SendInvitesToPeoByPeoPpMutation>;
export type SendInvitesToPeoByPeoPpMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToPeoByPeoPpMutation,
  SendInvitesToPeoByPeoPpMutationVariables
>;
export const SendInvitesToEmployersByPeoPpDocument = gql`
    mutation sendInvitesToEmployersByPeoPp($input: SendInvitesToEmployersByPeoPpInput!) {
  sendInvitesToEmployersByPeoPp(input: $input) {
    success
  }
}
    `;
export type SendInvitesToEmployersByPeoPpMutationFn = Apollo.MutationFunction<
  SendInvitesToEmployersByPeoPpMutation,
  SendInvitesToEmployersByPeoPpMutationVariables
>;

/**
 * __useSendInvitesToEmployersByPeoPpMutation__
 *
 * To run a mutation, you first call `useSendInvitesToEmployersByPeoPpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToEmployersByPeoPpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToEmployersByPeoPpMutation, { data, loading, error }] = useSendInvitesToEmployersByPeoPpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitesToEmployersByPeoPpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToEmployersByPeoPpMutation,
    SendInvitesToEmployersByPeoPpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToEmployersByPeoPpMutation,
    SendInvitesToEmployersByPeoPpMutationVariables
  >(SendInvitesToEmployersByPeoPpDocument, options);
}
export type SendInvitesToEmployersByPeoPpMutationHookResult = ReturnType<
  typeof useSendInvitesToEmployersByPeoPpMutation
>;
export type SendInvitesToEmployersByPeoPpMutationResult =
  Apollo.MutationResult<SendInvitesToEmployersByPeoPpMutation>;
export type SendInvitesToEmployersByPeoPpMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToEmployersByPeoPpMutation,
  SendInvitesToEmployersByPeoPpMutationVariables
>;
export const SendInvitesToConsumersByPeoPayrollProviderDocument = gql`
    mutation sendInvitesToConsumersByPeoPayrollProvider($employeeIds: [ID!]!, $inviteEmail: String) {
  sendInvitesToConsumersByPeoPayrollProvider(
    employeeIds: $employeeIds
    inviteEmail: $inviteEmail
  ) {
    success
  }
}
    `;
export type SendInvitesToConsumersByPeoPayrollProviderMutationFn = Apollo.MutationFunction<
  SendInvitesToConsumersByPeoPayrollProviderMutation,
  SendInvitesToConsumersByPeoPayrollProviderMutationVariables
>;

/**
 * __useSendInvitesToConsumersByPeoPayrollProviderMutation__
 *
 * To run a mutation, you first call `useSendInvitesToConsumersByPeoPayrollProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToConsumersByPeoPayrollProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToConsumersByPeoPayrollProviderMutation, { data, loading, error }] = useSendInvitesToConsumersByPeoPayrollProviderMutation({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      inviteEmail: // value for 'inviteEmail'
 *   },
 * });
 */
export function useSendInvitesToConsumersByPeoPayrollProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToConsumersByPeoPayrollProviderMutation,
    SendInvitesToConsumersByPeoPayrollProviderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToConsumersByPeoPayrollProviderMutation,
    SendInvitesToConsumersByPeoPayrollProviderMutationVariables
  >(SendInvitesToConsumersByPeoPayrollProviderDocument, options);
}
export type SendInvitesToConsumersByPeoPayrollProviderMutationHookResult = ReturnType<
  typeof useSendInvitesToConsumersByPeoPayrollProviderMutation
>;
export type SendInvitesToConsumersByPeoPayrollProviderMutationResult =
  Apollo.MutationResult<SendInvitesToConsumersByPeoPayrollProviderMutation>;
export type SendInvitesToConsumersByPeoPayrollProviderMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToConsumersByPeoPayrollProviderMutation,
  SendInvitesToConsumersByPeoPayrollProviderMutationVariables
>;
export const ResendInviteToEmployerStaffDocument = gql`
    mutation ResendInviteToEmployerStaff($employerStaffId: ID!) {
  resendInviteToEmployerStaff(employerStaffId: $employerStaffId) {
    success
    inviteLinkUrl
  }
}
    `;
export type ResendInviteToEmployerStaffMutationFn = Apollo.MutationFunction<
  ResendInviteToEmployerStaffMutation,
  ResendInviteToEmployerStaffMutationVariables
>;

/**
 * __useResendInviteToEmployerStaffMutation__
 *
 * To run a mutation, you first call `useResendInviteToEmployerStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteToEmployerStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteToEmployerStaffMutation, { data, loading, error }] = useResendInviteToEmployerStaffMutation({
 *   variables: {
 *      employerStaffId: // value for 'employerStaffId'
 *   },
 * });
 */
export function useResendInviteToEmployerStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInviteToEmployerStaffMutation,
    ResendInviteToEmployerStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendInviteToEmployerStaffMutation,
    ResendInviteToEmployerStaffMutationVariables
  >(ResendInviteToEmployerStaffDocument, options);
}
export type ResendInviteToEmployerStaffMutationHookResult = ReturnType<
  typeof useResendInviteToEmployerStaffMutation
>;
export type ResendInviteToEmployerStaffMutationResult =
  Apollo.MutationResult<ResendInviteToEmployerStaffMutation>;
export type ResendInviteToEmployerStaffMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteToEmployerStaffMutation,
  ResendInviteToEmployerStaffMutationVariables
>;
export const ResendInviteToPeoStaffDocument = gql`
    mutation ResendInviteToPeoStaff($peoStaffId: ID!) {
  resendInviteToPeoStaff(peoStaffId: $peoStaffId) {
    success
    inviteLinkUrl
  }
}
    `;
export type ResendInviteToPeoStaffMutationFn = Apollo.MutationFunction<
  ResendInviteToPeoStaffMutation,
  ResendInviteToPeoStaffMutationVariables
>;

/**
 * __useResendInviteToPeoStaffMutation__
 *
 * To run a mutation, you first call `useResendInviteToPeoStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteToPeoStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteToPeoStaffMutation, { data, loading, error }] = useResendInviteToPeoStaffMutation({
 *   variables: {
 *      peoStaffId: // value for 'peoStaffId'
 *   },
 * });
 */
export function useResendInviteToPeoStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInviteToPeoStaffMutation,
    ResendInviteToPeoStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendInviteToPeoStaffMutation,
    ResendInviteToPeoStaffMutationVariables
  >(ResendInviteToPeoStaffDocument, options);
}
export type ResendInviteToPeoStaffMutationHookResult = ReturnType<
  typeof useResendInviteToPeoStaffMutation
>;
export type ResendInviteToPeoStaffMutationResult =
  Apollo.MutationResult<ResendInviteToPeoStaffMutation>;
export type ResendInviteToPeoStaffMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteToPeoStaffMutation,
  ResendInviteToPeoStaffMutationVariables
>;
export const ResendInviteToPlatformStaffDocument = gql`
    mutation ResendInviteToPlatformStaff($platformStaffId: ID!) {
  resendInviteToPlatformStaff(platformStaffId: $platformStaffId) {
    success
    inviteLinkUrl
  }
}
    `;
export type ResendInviteToPlatformStaffMutationFn = Apollo.MutationFunction<
  ResendInviteToPlatformStaffMutation,
  ResendInviteToPlatformStaffMutationVariables
>;

/**
 * __useResendInviteToPlatformStaffMutation__
 *
 * To run a mutation, you first call `useResendInviteToPlatformStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteToPlatformStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteToPlatformStaffMutation, { data, loading, error }] = useResendInviteToPlatformStaffMutation({
 *   variables: {
 *      platformStaffId: // value for 'platformStaffId'
 *   },
 * });
 */
export function useResendInviteToPlatformStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInviteToPlatformStaffMutation,
    ResendInviteToPlatformStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendInviteToPlatformStaffMutation,
    ResendInviteToPlatformStaffMutationVariables
  >(ResendInviteToPlatformStaffDocument, options);
}
export type ResendInviteToPlatformStaffMutationHookResult = ReturnType<
  typeof useResendInviteToPlatformStaffMutation
>;
export type ResendInviteToPlatformStaffMutationResult =
  Apollo.MutationResult<ResendInviteToPlatformStaffMutation>;
export type ResendInviteToPlatformStaffMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteToPlatformStaffMutation,
  ResendInviteToPlatformStaffMutationVariables
>;
export const ResendInviteToVerifierStaffDocument = gql`
    mutation ResendInviteToVerifierStaff($verifierStaffId: ID!) {
  resendInviteToVerifierStaff(verifierStaffId: $verifierStaffId) {
    success
    inviteLinkUrl
  }
}
    `;
export type ResendInviteToVerifierStaffMutationFn = Apollo.MutationFunction<
  ResendInviteToVerifierStaffMutation,
  ResendInviteToVerifierStaffMutationVariables
>;

/**
 * __useResendInviteToVerifierStaffMutation__
 *
 * To run a mutation, you first call `useResendInviteToVerifierStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteToVerifierStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteToVerifierStaffMutation, { data, loading, error }] = useResendInviteToVerifierStaffMutation({
 *   variables: {
 *      verifierStaffId: // value for 'verifierStaffId'
 *   },
 * });
 */
export function useResendInviteToVerifierStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInviteToVerifierStaffMutation,
    ResendInviteToVerifierStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendInviteToVerifierStaffMutation,
    ResendInviteToVerifierStaffMutationVariables
  >(ResendInviteToVerifierStaffDocument, options);
}
export type ResendInviteToVerifierStaffMutationHookResult = ReturnType<
  typeof useResendInviteToVerifierStaffMutation
>;
export type ResendInviteToVerifierStaffMutationResult =
  Apollo.MutationResult<ResendInviteToVerifierStaffMutation>;
export type ResendInviteToVerifierStaffMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteToVerifierStaffMutation,
  ResendInviteToVerifierStaffMutationVariables
>;
export const GetMaintenanceStatusDocument = gql`
    query getMaintenanceStatus {
  getMaintenanceStatus {
    isMaintenanceEnabled
  }
}
    `;

/**
 * __useGetMaintenanceStatusQuery__
 *
 * To run a query within a React component, call `useGetMaintenanceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenanceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenanceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaintenanceStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMaintenanceStatusQuery,
    GetMaintenanceStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>(
    GetMaintenanceStatusDocument,
    options,
  );
}
export function useGetMaintenanceStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMaintenanceStatusQuery,
    GetMaintenanceStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>(
    GetMaintenanceStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetMaintenanceStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMaintenanceStatusQuery,
    GetMaintenanceStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>;
export function useGetMaintenanceStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMaintenanceStatusQuery,
        GetMaintenanceStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMaintenanceStatusQuery | undefined,
  GetMaintenanceStatusQueryVariables
>;
export function useGetMaintenanceStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMaintenanceStatusQuery,
        GetMaintenanceStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>(
    GetMaintenanceStatusDocument,
    options,
  );
}
export type GetMaintenanceStatusQueryHookResult = ReturnType<typeof useGetMaintenanceStatusQuery>;
export type GetMaintenanceStatusLazyQueryHookResult = ReturnType<
  typeof useGetMaintenanceStatusLazyQuery
>;
export type GetMaintenanceStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetMaintenanceStatusSuspenseQuery
>;
export type GetMaintenanceStatusQueryResult = Apollo.QueryResult<
  GetMaintenanceStatusQuery,
  GetMaintenanceStatusQueryVariables
>;
export const MiddeskCreateBusinessForVerifierDocument = gql`
    mutation middeskCreateBusinessForVerifier($verifierId: ID!, $businessFields: BusinessFields!) {
  middeskCreateBusinessForVerifier(
    verifierId: $verifierId
    businessFields: $businessFields
  ) {
    middeskBusinessId
  }
}
    `;
export type MiddeskCreateBusinessForVerifierMutationFn = Apollo.MutationFunction<
  MiddeskCreateBusinessForVerifierMutation,
  MiddeskCreateBusinessForVerifierMutationVariables
>;

/**
 * __useMiddeskCreateBusinessForVerifierMutation__
 *
 * To run a mutation, you first call `useMiddeskCreateBusinessForVerifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMiddeskCreateBusinessForVerifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [middeskCreateBusinessForVerifierMutation, { data, loading, error }] = useMiddeskCreateBusinessForVerifierMutation({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *      businessFields: // value for 'businessFields'
 *   },
 * });
 */
export function useMiddeskCreateBusinessForVerifierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MiddeskCreateBusinessForVerifierMutation,
    MiddeskCreateBusinessForVerifierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MiddeskCreateBusinessForVerifierMutation,
    MiddeskCreateBusinessForVerifierMutationVariables
  >(MiddeskCreateBusinessForVerifierDocument, options);
}
export type MiddeskCreateBusinessForVerifierMutationHookResult = ReturnType<
  typeof useMiddeskCreateBusinessForVerifierMutation
>;
export type MiddeskCreateBusinessForVerifierMutationResult =
  Apollo.MutationResult<MiddeskCreateBusinessForVerifierMutation>;
export type MiddeskCreateBusinessForVerifierMutationOptions = Apollo.BaseMutationOptions<
  MiddeskCreateBusinessForVerifierMutation,
  MiddeskCreateBusinessForVerifierMutationVariables
>;
export const GetMiddeskStatusDocument = gql`
    query getMiddeskStatus {
  getMiddeskStatus {
    isMiddeskEnabled
  }
}
    `;

/**
 * __useGetMiddeskStatusQuery__
 *
 * To run a query within a React component, call `useGetMiddeskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiddeskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiddeskStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMiddeskStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>(
    GetMiddeskStatusDocument,
    options,
  );
}
export function useGetMiddeskStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>(
    GetMiddeskStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetMiddeskStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMiddeskStatusQuery,
    GetMiddeskStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>;
export function useGetMiddeskStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMiddeskStatusQuery | undefined, GetMiddeskStatusQueryVariables>;
export function useGetMiddeskStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMiddeskStatusQuery, GetMiddeskStatusQueryVariables>(
    GetMiddeskStatusDocument,
    options,
  );
}
export type GetMiddeskStatusQueryHookResult = ReturnType<typeof useGetMiddeskStatusQuery>;
export type GetMiddeskStatusLazyQueryHookResult = ReturnType<typeof useGetMiddeskStatusLazyQuery>;
export type GetMiddeskStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetMiddeskStatusSuspenseQuery
>;
export type GetMiddeskStatusQueryResult = Apollo.QueryResult<
  GetMiddeskStatusQuery,
  GetMiddeskStatusQueryVariables
>;
export const GetPartnershipsDocument = gql`
    query GetPartnerships($where: GetPartnershipsWhere, $take: Int, $skip: Int) {
  getPartnerships(where: $where, take: $take, skip: $skip) {
    count
    items {
      ...PartnershipInfo
    }
  }
}
    ${PartnershipInfoFragmentDoc}`;

/**
 * __useGetPartnershipsQuery__
 *
 * To run a query within a React component, call `useGetPartnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnershipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPartnershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPartnershipsQuery, GetPartnershipsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPartnershipsQuery, GetPartnershipsQueryVariables>(
    GetPartnershipsDocument,
    options,
  );
}
export function useGetPartnershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPartnershipsQuery, GetPartnershipsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPartnershipsQuery, GetPartnershipsQueryVariables>(
    GetPartnershipsDocument,
    options,
  );
}
// @ts-ignore
export function useGetPartnershipsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPartnershipsQuery,
    GetPartnershipsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPartnershipsQuery, GetPartnershipsQueryVariables>;
export function useGetPartnershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPartnershipsQuery, GetPartnershipsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPartnershipsQuery | undefined, GetPartnershipsQueryVariables>;
export function useGetPartnershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPartnershipsQuery, GetPartnershipsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPartnershipsQuery, GetPartnershipsQueryVariables>(
    GetPartnershipsDocument,
    options,
  );
}
export type GetPartnershipsQueryHookResult = ReturnType<typeof useGetPartnershipsQuery>;
export type GetPartnershipsLazyQueryHookResult = ReturnType<typeof useGetPartnershipsLazyQuery>;
export type GetPartnershipsSuspenseQueryHookResult = ReturnType<
  typeof useGetPartnershipsSuspenseQuery
>;
export type GetPartnershipsQueryResult = Apollo.QueryResult<
  GetPartnershipsQuery,
  GetPartnershipsQueryVariables
>;
export const SendInviteToPartnershipDocument = gql`
    mutation SendInviteToPartnership($companyType: CompanyType!, $staffEmail: String!) {
  sendInviteToPartnership(companyType: $companyType, staffEmail: $staffEmail) {
    success
  }
}
    `;
export type SendInviteToPartnershipMutationFn = Apollo.MutationFunction<
  SendInviteToPartnershipMutation,
  SendInviteToPartnershipMutationVariables
>;

/**
 * __useSendInviteToPartnershipMutation__
 *
 * To run a mutation, you first call `useSendInviteToPartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteToPartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteToPartnershipMutation, { data, loading, error }] = useSendInviteToPartnershipMutation({
 *   variables: {
 *      companyType: // value for 'companyType'
 *      staffEmail: // value for 'staffEmail'
 *   },
 * });
 */
export function useSendInviteToPartnershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInviteToPartnershipMutation,
    SendInviteToPartnershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInviteToPartnershipMutation,
    SendInviteToPartnershipMutationVariables
  >(SendInviteToPartnershipDocument, options);
}
export type SendInviteToPartnershipMutationHookResult = ReturnType<
  typeof useSendInviteToPartnershipMutation
>;
export type SendInviteToPartnershipMutationResult =
  Apollo.MutationResult<SendInviteToPartnershipMutation>;
export type SendInviteToPartnershipMutationOptions = Apollo.BaseMutationOptions<
  SendInviteToPartnershipMutation,
  SendInviteToPartnershipMutationVariables
>;
export const GenerateWorkLetterDocument = gql`
    mutation GenerateWorkLetter($company: VerificationRequestCompanyData!, $letterType: EmployeeWorkLetterType!) {
  generateWorkLetterPdf(company: $company, letterType: $letterType) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateWorkLetterMutationFn = Apollo.MutationFunction<
  GenerateWorkLetterMutation,
  GenerateWorkLetterMutationVariables
>;

/**
 * __useGenerateWorkLetterMutation__
 *
 * To run a mutation, you first call `useGenerateWorkLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkLetterMutation, { data, loading, error }] = useGenerateWorkLetterMutation({
 *   variables: {
 *      company: // value for 'company'
 *      letterType: // value for 'letterType'
 *   },
 * });
 */
export function useGenerateWorkLetterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateWorkLetterMutation,
    GenerateWorkLetterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateWorkLetterMutation, GenerateWorkLetterMutationVariables>(
    GenerateWorkLetterDocument,
    options,
  );
}
export type GenerateWorkLetterMutationHookResult = ReturnType<typeof useGenerateWorkLetterMutation>;
export type GenerateWorkLetterMutationResult = Apollo.MutationResult<GenerateWorkLetterMutation>;
export type GenerateWorkLetterMutationOptions = Apollo.BaseMutationOptions<
  GenerateWorkLetterMutation,
  GenerateWorkLetterMutationVariables
>;
export const GenerateWorkLetterForAdminDocument = gql`
    mutation GenerateWorkLetterForAdmin($employeeSsnEncrypted: String!, $company: VerificationRequestCompanyData!, $letterType: EmployeeWorkLetterType!) {
  generateWorkLetterPdfForAdmin(
    employeeSsnEncrypted: $employeeSsnEncrypted
    company: $company
    letterType: $letterType
  ) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateWorkLetterForAdminMutationFn = Apollo.MutationFunction<
  GenerateWorkLetterForAdminMutation,
  GenerateWorkLetterForAdminMutationVariables
>;

/**
 * __useGenerateWorkLetterForAdminMutation__
 *
 * To run a mutation, you first call `useGenerateWorkLetterForAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkLetterForAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkLetterForAdminMutation, { data, loading, error }] = useGenerateWorkLetterForAdminMutation({
 *   variables: {
 *      employeeSsnEncrypted: // value for 'employeeSsnEncrypted'
 *      company: // value for 'company'
 *      letterType: // value for 'letterType'
 *   },
 * });
 */
export function useGenerateWorkLetterForAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateWorkLetterForAdminMutation,
    GenerateWorkLetterForAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateWorkLetterForAdminMutation,
    GenerateWorkLetterForAdminMutationVariables
  >(GenerateWorkLetterForAdminDocument, options);
}
export type GenerateWorkLetterForAdminMutationHookResult = ReturnType<
  typeof useGenerateWorkLetterForAdminMutation
>;
export type GenerateWorkLetterForAdminMutationResult =
  Apollo.MutationResult<GenerateWorkLetterForAdminMutation>;
export type GenerateWorkLetterForAdminMutationOptions = Apollo.BaseMutationOptions<
  GenerateWorkLetterForAdminMutation,
  GenerateWorkLetterForAdminMutationVariables
>;
export const GenerateMyDataPdfDocument = gql`
    mutation GenerateMyDataPdf {
  generateMyDataPdf {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateMyDataPdfMutationFn = Apollo.MutationFunction<
  GenerateMyDataPdfMutation,
  GenerateMyDataPdfMutationVariables
>;

/**
 * __useGenerateMyDataPdfMutation__
 *
 * To run a mutation, you first call `useGenerateMyDataPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyDataPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyDataPdfMutation, { data, loading, error }] = useGenerateMyDataPdfMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateMyDataPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateMyDataPdfMutation,
    GenerateMyDataPdfMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateMyDataPdfMutation, GenerateMyDataPdfMutationVariables>(
    GenerateMyDataPdfDocument,
    options,
  );
}
export type GenerateMyDataPdfMutationHookResult = ReturnType<typeof useGenerateMyDataPdfMutation>;
export type GenerateMyDataPdfMutationResult = Apollo.MutationResult<GenerateMyDataPdfMutation>;
export type GenerateMyDataPdfMutationOptions = Apollo.BaseMutationOptions<
  GenerateMyDataPdfMutation,
  GenerateMyDataPdfMutationVariables
>;
export const PeoDocument = gql`
    query Peo($id: ID!) {
  peo(where: {id: $id}) {
    ...PeoInfo
  }
}
    ${PeoInfoFragmentDoc}`;

/**
 * __usePeoQuery__
 *
 * To run a query within a React component, call `usePeoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeoQuery(
  baseOptions: Apollo.QueryHookOptions<PeoQuery, PeoQueryVariables> &
    ({ variables: PeoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoQuery, PeoQueryVariables>(PeoDocument, options);
}
export function usePeoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeoQuery, PeoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoQuery, PeoQueryVariables>(PeoDocument, options);
}
// @ts-ignore
export function usePeoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PeoQuery, PeoQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoQuery, PeoQueryVariables>;
export function usePeoSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeoQuery, PeoQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoQuery | undefined, PeoQueryVariables>;
export function usePeoSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeoQuery, PeoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeoQuery, PeoQueryVariables>(PeoDocument, options);
}
export type PeoQueryHookResult = ReturnType<typeof usePeoQuery>;
export type PeoLazyQueryHookResult = ReturnType<typeof usePeoLazyQuery>;
export type PeoSuspenseQueryHookResult = ReturnType<typeof usePeoSuspenseQuery>;
export type PeoQueryResult = Apollo.QueryResult<PeoQuery, PeoQueryVariables>;
export const PeosListDocument = gql`
    query PeosList($filter: PeoWhere, $orderBy: [PeoOrderBy!], $first: Int, $skip: Int) {
  peoCount(where: $filter)
  peoList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...PeoInfo
  }
}
    ${PeoInfoFragmentDoc}`;

/**
 * __usePeosListQuery__
 *
 * To run a query within a React component, call `usePeosListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeosListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeosListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeosListQuery(
  baseOptions?: Apollo.QueryHookOptions<PeosListQuery, PeosListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeosListQuery, PeosListQueryVariables>(PeosListDocument, options);
}
export function usePeosListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeosListQuery, PeosListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeosListQuery, PeosListQueryVariables>(PeosListDocument, options);
}
// @ts-ignore
export function usePeosListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PeosListQuery, PeosListQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeosListQuery, PeosListQueryVariables>;
export function usePeosListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeosListQuery, PeosListQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeosListQuery | undefined, PeosListQueryVariables>;
export function usePeosListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeosListQuery, PeosListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeosListQuery, PeosListQueryVariables>(PeosListDocument, options);
}
export type PeosListQueryHookResult = ReturnType<typeof usePeosListQuery>;
export type PeosListLazyQueryHookResult = ReturnType<typeof usePeosListLazyQuery>;
export type PeosListSuspenseQueryHookResult = ReturnType<typeof usePeosListSuspenseQuery>;
export type PeosListQueryResult = Apollo.QueryResult<PeosListQuery, PeosListQueryVariables>;
export const PeosSimpleListDocument = gql`
    query PeosSimpleList($filter: PeoWhere, $orderBy: [PeoOrderBy!], $first: Int, $skip: Int) {
  peoCount(where: $filter)
  peoList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...PeoSimpleInfo
  }
}
    ${PeoSimpleInfoFragmentDoc}`;

/**
 * __usePeosSimpleListQuery__
 *
 * To run a query within a React component, call `usePeosSimpleListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeosSimpleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeosSimpleListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeosSimpleListQuery(
  baseOptions?: Apollo.QueryHookOptions<PeosSimpleListQuery, PeosSimpleListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeosSimpleListQuery, PeosSimpleListQueryVariables>(
    PeosSimpleListDocument,
    options,
  );
}
export function usePeosSimpleListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeosSimpleListQuery, PeosSimpleListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeosSimpleListQuery, PeosSimpleListQueryVariables>(
    PeosSimpleListDocument,
    options,
  );
}
// @ts-ignore
export function usePeosSimpleListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PeosSimpleListQuery, PeosSimpleListQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeosSimpleListQuery, PeosSimpleListQueryVariables>;
export function usePeosSimpleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeosSimpleListQuery, PeosSimpleListQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeosSimpleListQuery | undefined, PeosSimpleListQueryVariables>;
export function usePeosSimpleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeosSimpleListQuery, PeosSimpleListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeosSimpleListQuery, PeosSimpleListQueryVariables>(
    PeosSimpleListDocument,
    options,
  );
}
export type PeosSimpleListQueryHookResult = ReturnType<typeof usePeosSimpleListQuery>;
export type PeosSimpleListLazyQueryHookResult = ReturnType<typeof usePeosSimpleListLazyQuery>;
export type PeosSimpleListSuspenseQueryHookResult = ReturnType<
  typeof usePeosSimpleListSuspenseQuery
>;
export type PeosSimpleListQueryResult = Apollo.QueryResult<
  PeosSimpleListQuery,
  PeosSimpleListQueryVariables
>;
export const PeoUpdateDocument = gql`
    mutation PeoUpdate($data: PeoUpdate!, $where: PeoWhereUnique!) {
  peoUpdate(data: $data, where: $where) {
    ...PeoInfo
  }
}
    ${PeoInfoFragmentDoc}`;
export type PeoUpdateMutationFn = Apollo.MutationFunction<
  PeoUpdateMutation,
  PeoUpdateMutationVariables
>;

/**
 * __usePeoUpdateMutation__
 *
 * To run a mutation, you first call `usePeoUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoUpdateMutation, { data, loading, error }] = usePeoUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeoUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<PeoUpdateMutation, PeoUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PeoUpdateMutation, PeoUpdateMutationVariables>(
    PeoUpdateDocument,
    options,
  );
}
export type PeoUpdateMutationHookResult = ReturnType<typeof usePeoUpdateMutation>;
export type PeoUpdateMutationResult = Apollo.MutationResult<PeoUpdateMutation>;
export type PeoUpdateMutationOptions = Apollo.BaseMutationOptions<
  PeoUpdateMutation,
  PeoUpdateMutationVariables
>;
export const PeoUpdateWithEmployersDocument = gql`
    mutation PeoUpdateWithEmployers($id: ID!, $data: PeoUpdate, $employersUpdateManyData: [EmployerUpdateMany!], $employersUpdateManyWhere: [EmployerWhere!]) {
  updatePeoWithEmployers(
    id: $id
    data: $data
    employersUpdateManyData: $employersUpdateManyData
    employersUpdateManyWhere: $employersUpdateManyWhere
  ) {
    success
  }
}
    `;
export type PeoUpdateWithEmployersMutationFn = Apollo.MutationFunction<
  PeoUpdateWithEmployersMutation,
  PeoUpdateWithEmployersMutationVariables
>;

/**
 * __usePeoUpdateWithEmployersMutation__
 *
 * To run a mutation, you first call `usePeoUpdateWithEmployersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoUpdateWithEmployersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoUpdateWithEmployersMutation, { data, loading, error }] = usePeoUpdateWithEmployersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      employersUpdateManyData: // value for 'employersUpdateManyData'
 *      employersUpdateManyWhere: // value for 'employersUpdateManyWhere'
 *   },
 * });
 */
export function usePeoUpdateWithEmployersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PeoUpdateWithEmployersMutation,
    PeoUpdateWithEmployersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PeoUpdateWithEmployersMutation,
    PeoUpdateWithEmployersMutationVariables
  >(PeoUpdateWithEmployersDocument, options);
}
export type PeoUpdateWithEmployersMutationHookResult = ReturnType<
  typeof usePeoUpdateWithEmployersMutation
>;
export type PeoUpdateWithEmployersMutationResult =
  Apollo.MutationResult<PeoUpdateWithEmployersMutation>;
export type PeoUpdateWithEmployersMutationOptions = Apollo.BaseMutationOptions<
  PeoUpdateWithEmployersMutation,
  PeoUpdateWithEmployersMutationVariables
>;
export const PeoRevenueShareDocument = gql`
    query PeoRevenueShare($where: PeoWhereUnique!) {
  peo(where: $where) {
    ...PeoRevenueShareInfo
  }
}
    ${PeoRevenueShareInfoFragmentDoc}`;

/**
 * __usePeoRevenueShareQuery__
 *
 * To run a query within a React component, call `usePeoRevenueShareQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoRevenueShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoRevenueShareQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeoRevenueShareQuery(
  baseOptions: Apollo.QueryHookOptions<PeoRevenueShareQuery, PeoRevenueShareQueryVariables> &
    ({ variables: PeoRevenueShareQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>(
    PeoRevenueShareDocument,
    options,
  );
}
export function usePeoRevenueShareLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>(
    PeoRevenueShareDocument,
    options,
  );
}
// @ts-ignore
export function usePeoRevenueShareSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoRevenueShareQuery,
    PeoRevenueShareQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>;
export function usePeoRevenueShareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoRevenueShareQuery | undefined, PeoRevenueShareQueryVariables>;
export function usePeoRevenueShareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeoRevenueShareQuery, PeoRevenueShareQueryVariables>(
    PeoRevenueShareDocument,
    options,
  );
}
export type PeoRevenueShareQueryHookResult = ReturnType<typeof usePeoRevenueShareQuery>;
export type PeoRevenueShareLazyQueryHookResult = ReturnType<typeof usePeoRevenueShareLazyQuery>;
export type PeoRevenueShareSuspenseQueryHookResult = ReturnType<
  typeof usePeoRevenueShareSuspenseQuery
>;
export type PeoRevenueShareQueryResult = Apollo.QueryResult<
  PeoRevenueShareQuery,
  PeoRevenueShareQueryVariables
>;
export const PeoRevenueShareUpdateDocument = gql`
    mutation PeoRevenueShareUpdate($where: PeoWhereUnique!, $data: PeoUpdate!) {
  peoUpdate(where: $where, data: $data) {
    ...PeoRevenueShareInfo
  }
}
    ${PeoRevenueShareInfoFragmentDoc}`;
export type PeoRevenueShareUpdateMutationFn = Apollo.MutationFunction<
  PeoRevenueShareUpdateMutation,
  PeoRevenueShareUpdateMutationVariables
>;

/**
 * __usePeoRevenueShareUpdateMutation__
 *
 * To run a mutation, you first call `usePeoRevenueShareUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoRevenueShareUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoRevenueShareUpdateMutation, { data, loading, error }] = usePeoRevenueShareUpdateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePeoRevenueShareUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PeoRevenueShareUpdateMutation,
    PeoRevenueShareUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PeoRevenueShareUpdateMutation, PeoRevenueShareUpdateMutationVariables>(
    PeoRevenueShareUpdateDocument,
    options,
  );
}
export type PeoRevenueShareUpdateMutationHookResult = ReturnType<
  typeof usePeoRevenueShareUpdateMutation
>;
export type PeoRevenueShareUpdateMutationResult =
  Apollo.MutationResult<PeoRevenueShareUpdateMutation>;
export type PeoRevenueShareUpdateMutationOptions = Apollo.BaseMutationOptions<
  PeoRevenueShareUpdateMutation,
  PeoRevenueShareUpdateMutationVariables
>;
export const GetPeoBasicInfoDocument = gql`
    query GetPeoBasicInfo($id: ID!) {
  getPeoBasicInfo(id: $id) {
    ...PeoBasicInfo
  }
}
    ${PeoBasicInfoFragmentDoc}`;

/**
 * __useGetPeoBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetPeoBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeoBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeoBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPeoBasicInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables> &
    ({ variables: GetPeoBasicInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>(
    GetPeoBasicInfoDocument,
    options,
  );
}
export function useGetPeoBasicInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>(
    GetPeoBasicInfoDocument,
    options,
  );
}
// @ts-ignore
export function useGetPeoBasicInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPeoBasicInfoQuery,
    GetPeoBasicInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>;
export function useGetPeoBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPeoBasicInfoQuery | undefined, GetPeoBasicInfoQueryVariables>;
export function useGetPeoBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPeoBasicInfoQuery, GetPeoBasicInfoQueryVariables>(
    GetPeoBasicInfoDocument,
    options,
  );
}
export type GetPeoBasicInfoQueryHookResult = ReturnType<typeof useGetPeoBasicInfoQuery>;
export type GetPeoBasicInfoLazyQueryHookResult = ReturnType<typeof useGetPeoBasicInfoLazyQuery>;
export type GetPeoBasicInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetPeoBasicInfoSuspenseQuery
>;
export type GetPeoBasicInfoQueryResult = Apollo.QueryResult<
  GetPeoBasicInfoQuery,
  GetPeoBasicInfoQueryVariables
>;
export const PeoPayrollProvidersListDocument = gql`
    query PeoPayrollProvidersList($filter: PeoPayrollProviderWhere, $orderBy: [PeoPayrollProviderOrderBy!], $first: Int, $skip: Int) {
  peoPayrollProviderCount(where: $filter)
  peoPayrollProviderList(
    where: $filter
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    ...PeoPayrollProviderInfo
  }
}
    ${PeoPayrollProviderInfoFragmentDoc}`;

/**
 * __usePeoPayrollProvidersListQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProvidersListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProvidersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProvidersListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeoPayrollProvidersListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PeoPayrollProvidersListQuery,
    PeoPayrollProvidersListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoPayrollProvidersListQuery, PeoPayrollProvidersListQueryVariables>(
    PeoPayrollProvidersListDocument,
    options,
  );
}
export function usePeoPayrollProvidersListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProvidersListQuery,
    PeoPayrollProvidersListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoPayrollProvidersListQuery, PeoPayrollProvidersListQueryVariables>(
    PeoPayrollProvidersListDocument,
    options,
  );
}
// @ts-ignore
export function usePeoPayrollProvidersListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProvidersListQuery,
    PeoPayrollProvidersListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProvidersListQuery,
  PeoPayrollProvidersListQueryVariables
>;
export function usePeoPayrollProvidersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProvidersListQuery,
        PeoPayrollProvidersListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProvidersListQuery | undefined,
  PeoPayrollProvidersListQueryVariables
>;
export function usePeoPayrollProvidersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProvidersListQuery,
        PeoPayrollProvidersListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PeoPayrollProvidersListQuery,
    PeoPayrollProvidersListQueryVariables
  >(PeoPayrollProvidersListDocument, options);
}
export type PeoPayrollProvidersListQueryHookResult = ReturnType<
  typeof usePeoPayrollProvidersListQuery
>;
export type PeoPayrollProvidersListLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProvidersListLazyQuery
>;
export type PeoPayrollProvidersListSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProvidersListSuspenseQuery
>;
export type PeoPayrollProvidersListQueryResult = Apollo.QueryResult<
  PeoPayrollProvidersListQuery,
  PeoPayrollProvidersListQueryVariables
>;
export const PeoPayrollProvidersSimpleListDocument = gql`
    query PeoPayrollProvidersSimpleList($filter: PeoPayrollProviderWhere, $orderBy: [PeoPayrollProviderOrderBy!], $first: Int, $skip: Int) {
  peoPayrollProviderList(
    where: $filter
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    ...PeoPayrollProviderMinimalInfo
  }
}
    ${PeoPayrollProviderMinimalInfoFragmentDoc}`;

/**
 * __usePeoPayrollProvidersSimpleListQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProvidersSimpleListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProvidersSimpleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProvidersSimpleListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeoPayrollProvidersSimpleListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  >(PeoPayrollProvidersSimpleListDocument, options);
}
export function usePeoPayrollProvidersSimpleListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  >(PeoPayrollProvidersSimpleListDocument, options);
}
// @ts-ignore
export function usePeoPayrollProvidersSimpleListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProvidersSimpleListQuery,
  PeoPayrollProvidersSimpleListQueryVariables
>;
export function usePeoPayrollProvidersSimpleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProvidersSimpleListQuery,
        PeoPayrollProvidersSimpleListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProvidersSimpleListQuery | undefined,
  PeoPayrollProvidersSimpleListQueryVariables
>;
export function usePeoPayrollProvidersSimpleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProvidersSimpleListQuery,
        PeoPayrollProvidersSimpleListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PeoPayrollProvidersSimpleListQuery,
    PeoPayrollProvidersSimpleListQueryVariables
  >(PeoPayrollProvidersSimpleListDocument, options);
}
export type PeoPayrollProvidersSimpleListQueryHookResult = ReturnType<
  typeof usePeoPayrollProvidersSimpleListQuery
>;
export type PeoPayrollProvidersSimpleListLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProvidersSimpleListLazyQuery
>;
export type PeoPayrollProvidersSimpleListSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProvidersSimpleListSuspenseQuery
>;
export type PeoPayrollProvidersSimpleListQueryResult = Apollo.QueryResult<
  PeoPayrollProvidersSimpleListQuery,
  PeoPayrollProvidersSimpleListQueryVariables
>;
export const PeoPayrollProviderByIdDocument = gql`
    query PeoPayrollProviderById($id: ID!) {
  peoPayrollProvider(where: {id: $id}) {
    ...PeoPayrollProviderInfo
  }
}
    ${PeoPayrollProviderInfoFragmentDoc}`;

/**
 * __usePeoPayrollProviderByIdQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProviderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProviderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeoPayrollProviderByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PeoPayrollProviderByIdQuery,
    PeoPayrollProviderByIdQueryVariables
  > &
    ({ variables: PeoPayrollProviderByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoPayrollProviderByIdQuery, PeoPayrollProviderByIdQueryVariables>(
    PeoPayrollProviderByIdDocument,
    options,
  );
}
export function usePeoPayrollProviderByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProviderByIdQuery,
    PeoPayrollProviderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoPayrollProviderByIdQuery, PeoPayrollProviderByIdQueryVariables>(
    PeoPayrollProviderByIdDocument,
    options,
  );
}
// @ts-ignore
export function usePeoPayrollProviderByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProviderByIdQuery,
    PeoPayrollProviderByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PeoPayrollProviderByIdQuery, PeoPayrollProviderByIdQueryVariables>;
export function usePeoPayrollProviderByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderByIdQuery,
        PeoPayrollProviderByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderByIdQuery | undefined,
  PeoPayrollProviderByIdQueryVariables
>;
export function usePeoPayrollProviderByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderByIdQuery,
        PeoPayrollProviderByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeoPayrollProviderByIdQuery, PeoPayrollProviderByIdQueryVariables>(
    PeoPayrollProviderByIdDocument,
    options,
  );
}
export type PeoPayrollProviderByIdQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderByIdQuery
>;
export type PeoPayrollProviderByIdLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderByIdLazyQuery
>;
export type PeoPayrollProviderByIdSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderByIdSuspenseQuery
>;
export type PeoPayrollProviderByIdQueryResult = Apollo.QueryResult<
  PeoPayrollProviderByIdQuery,
  PeoPayrollProviderByIdQueryVariables
>;
export const PeoPayrollProviderEmployersByIdDocument = gql`
    query PeoPayrollProviderEmployersById($id: ID!) {
  peoPayrollProvider(where: {id: $id}) {
    id
    peosList {
      id
      displayName
      logo {
        ...FileInfo
      }
      employersList {
        id
        displayName
        setLiveAt
        logo {
          ...FileInfo
        }
      }
    }
    employersList {
      id
      displayName
      setLiveAt
      logo {
        ...FileInfo
      }
    }
  }
}
    ${FileInfoFragmentDoc}`;

/**
 * __usePeoPayrollProviderEmployersByIdQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProviderEmployersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderEmployersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProviderEmployersByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeoPayrollProviderEmployersByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PeoPayrollProviderEmployersByIdQuery,
    PeoPayrollProviderEmployersByIdQueryVariables
  > &
    (
      | { variables: PeoPayrollProviderEmployersByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PeoPayrollProviderEmployersByIdQuery,
    PeoPayrollProviderEmployersByIdQueryVariables
  >(PeoPayrollProviderEmployersByIdDocument, options);
}
export function usePeoPayrollProviderEmployersByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProviderEmployersByIdQuery,
    PeoPayrollProviderEmployersByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PeoPayrollProviderEmployersByIdQuery,
    PeoPayrollProviderEmployersByIdQueryVariables
  >(PeoPayrollProviderEmployersByIdDocument, options);
}
// @ts-ignore
export function usePeoPayrollProviderEmployersByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProviderEmployersByIdQuery,
    PeoPayrollProviderEmployersByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderEmployersByIdQuery,
  PeoPayrollProviderEmployersByIdQueryVariables
>;
export function usePeoPayrollProviderEmployersByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderEmployersByIdQuery,
        PeoPayrollProviderEmployersByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderEmployersByIdQuery | undefined,
  PeoPayrollProviderEmployersByIdQueryVariables
>;
export function usePeoPayrollProviderEmployersByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderEmployersByIdQuery,
        PeoPayrollProviderEmployersByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PeoPayrollProviderEmployersByIdQuery,
    PeoPayrollProviderEmployersByIdQueryVariables
  >(PeoPayrollProviderEmployersByIdDocument, options);
}
export type PeoPayrollProviderEmployersByIdQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderEmployersByIdQuery
>;
export type PeoPayrollProviderEmployersByIdLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderEmployersByIdLazyQuery
>;
export type PeoPayrollProviderEmployersByIdSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderEmployersByIdSuspenseQuery
>;
export type PeoPayrollProviderEmployersByIdQueryResult = Apollo.QueryResult<
  PeoPayrollProviderEmployersByIdQuery,
  PeoPayrollProviderEmployersByIdQueryVariables
>;
export const PeoPayrollProviderUpdateDocument = gql`
    mutation PeoPayrollProviderUpdate($data: PeoPayrollProviderUpdate!, $where: PeoPayrollProviderWhereUnique!) {
  peoPayrollProviderUpdate(data: $data, where: $where) {
    ...PeoPayrollProviderInfo
  }
}
    ${PeoPayrollProviderInfoFragmentDoc}`;
export type PeoPayrollProviderUpdateMutationFn = Apollo.MutationFunction<
  PeoPayrollProviderUpdateMutation,
  PeoPayrollProviderUpdateMutationVariables
>;

/**
 * __usePeoPayrollProviderUpdateMutation__
 *
 * To run a mutation, you first call `usePeoPayrollProviderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoPayrollProviderUpdateMutation, { data, loading, error }] = usePeoPayrollProviderUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeoPayrollProviderUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PeoPayrollProviderUpdateMutation,
    PeoPayrollProviderUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PeoPayrollProviderUpdateMutation,
    PeoPayrollProviderUpdateMutationVariables
  >(PeoPayrollProviderUpdateDocument, options);
}
export type PeoPayrollProviderUpdateMutationHookResult = ReturnType<
  typeof usePeoPayrollProviderUpdateMutation
>;
export type PeoPayrollProviderUpdateMutationResult =
  Apollo.MutationResult<PeoPayrollProviderUpdateMutation>;
export type PeoPayrollProviderUpdateMutationOptions = Apollo.BaseMutationOptions<
  PeoPayrollProviderUpdateMutation,
  PeoPayrollProviderUpdateMutationVariables
>;
export const PeoPayrollProviderRevenueShareDocument = gql`
    query PeoPayrollProviderRevenueShare($where: PeoPayrollProviderWhereUnique!) {
  peoPayrollProvider(where: $where) {
    ...PeoPayrollProviderRevenueShareInfo
  }
}
    ${PeoPayrollProviderRevenueShareInfoFragmentDoc}`;

/**
 * __usePeoPayrollProviderRevenueShareQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProviderRevenueShareQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderRevenueShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProviderRevenueShareQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeoPayrollProviderRevenueShareQuery(
  baseOptions: Apollo.QueryHookOptions<
    PeoPayrollProviderRevenueShareQuery,
    PeoPayrollProviderRevenueShareQueryVariables
  > &
    (
      | { variables: PeoPayrollProviderRevenueShareQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PeoPayrollProviderRevenueShareQuery,
    PeoPayrollProviderRevenueShareQueryVariables
  >(PeoPayrollProviderRevenueShareDocument, options);
}
export function usePeoPayrollProviderRevenueShareLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProviderRevenueShareQuery,
    PeoPayrollProviderRevenueShareQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PeoPayrollProviderRevenueShareQuery,
    PeoPayrollProviderRevenueShareQueryVariables
  >(PeoPayrollProviderRevenueShareDocument, options);
}
// @ts-ignore
export function usePeoPayrollProviderRevenueShareSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProviderRevenueShareQuery,
    PeoPayrollProviderRevenueShareQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderRevenueShareQuery,
  PeoPayrollProviderRevenueShareQueryVariables
>;
export function usePeoPayrollProviderRevenueShareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderRevenueShareQuery,
        PeoPayrollProviderRevenueShareQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderRevenueShareQuery | undefined,
  PeoPayrollProviderRevenueShareQueryVariables
>;
export function usePeoPayrollProviderRevenueShareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderRevenueShareQuery,
        PeoPayrollProviderRevenueShareQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PeoPayrollProviderRevenueShareQuery,
    PeoPayrollProviderRevenueShareQueryVariables
  >(PeoPayrollProviderRevenueShareDocument, options);
}
export type PeoPayrollProviderRevenueShareQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderRevenueShareQuery
>;
export type PeoPayrollProviderRevenueShareLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderRevenueShareLazyQuery
>;
export type PeoPayrollProviderRevenueShareSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderRevenueShareSuspenseQuery
>;
export type PeoPayrollProviderRevenueShareQueryResult = Apollo.QueryResult<
  PeoPayrollProviderRevenueShareQuery,
  PeoPayrollProviderRevenueShareQueryVariables
>;
export const PeoPayrollProviderRevenueShareUpdateDocument = gql`
    mutation PeoPayrollProviderRevenueShareUpdate($where: PeoPayrollProviderWhereUnique!, $data: PeoPayrollProviderUpdate!) {
  peoPayrollProviderUpdate(where: $where, data: $data) {
    ...PeoPayrollProviderRevenueShareInfo
  }
}
    ${PeoPayrollProviderRevenueShareInfoFragmentDoc}`;
export type PeoPayrollProviderRevenueShareUpdateMutationFn = Apollo.MutationFunction<
  PeoPayrollProviderRevenueShareUpdateMutation,
  PeoPayrollProviderRevenueShareUpdateMutationVariables
>;

/**
 * __usePeoPayrollProviderRevenueShareUpdateMutation__
 *
 * To run a mutation, you first call `usePeoPayrollProviderRevenueShareUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderRevenueShareUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoPayrollProviderRevenueShareUpdateMutation, { data, loading, error }] = usePeoPayrollProviderRevenueShareUpdateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePeoPayrollProviderRevenueShareUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PeoPayrollProviderRevenueShareUpdateMutation,
    PeoPayrollProviderRevenueShareUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PeoPayrollProviderRevenueShareUpdateMutation,
    PeoPayrollProviderRevenueShareUpdateMutationVariables
  >(PeoPayrollProviderRevenueShareUpdateDocument, options);
}
export type PeoPayrollProviderRevenueShareUpdateMutationHookResult = ReturnType<
  typeof usePeoPayrollProviderRevenueShareUpdateMutation
>;
export type PeoPayrollProviderRevenueShareUpdateMutationResult =
  Apollo.MutationResult<PeoPayrollProviderRevenueShareUpdateMutation>;
export type PeoPayrollProviderRevenueShareUpdateMutationOptions = Apollo.BaseMutationOptions<
  PeoPayrollProviderRevenueShareUpdateMutation,
  PeoPayrollProviderRevenueShareUpdateMutationVariables
>;
export const GetPeoPayrollProviderBasicInfoDocument = gql`
    query GetPeoPayrollProviderBasicInfo($id: ID!) {
  getPeoPayrollProviderBasicInfo(id: $id) {
    ...PeoPayrollProviderBasicInfo
  }
}
    ${PeoPayrollProviderBasicInfoFragmentDoc}`;

/**
 * __useGetPeoPayrollProviderBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetPeoPayrollProviderBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeoPayrollProviderBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeoPayrollProviderBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPeoPayrollProviderBasicInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPeoPayrollProviderBasicInfoQuery,
    GetPeoPayrollProviderBasicInfoQueryVariables
  > &
    (
      | { variables: GetPeoPayrollProviderBasicInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPeoPayrollProviderBasicInfoQuery,
    GetPeoPayrollProviderBasicInfoQueryVariables
  >(GetPeoPayrollProviderBasicInfoDocument, options);
}
export function useGetPeoPayrollProviderBasicInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPeoPayrollProviderBasicInfoQuery,
    GetPeoPayrollProviderBasicInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPeoPayrollProviderBasicInfoQuery,
    GetPeoPayrollProviderBasicInfoQueryVariables
  >(GetPeoPayrollProviderBasicInfoDocument, options);
}
// @ts-ignore
export function useGetPeoPayrollProviderBasicInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPeoPayrollProviderBasicInfoQuery,
    GetPeoPayrollProviderBasicInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPeoPayrollProviderBasicInfoQuery,
  GetPeoPayrollProviderBasicInfoQueryVariables
>;
export function useGetPeoPayrollProviderBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPeoPayrollProviderBasicInfoQuery,
        GetPeoPayrollProviderBasicInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPeoPayrollProviderBasicInfoQuery | undefined,
  GetPeoPayrollProviderBasicInfoQueryVariables
>;
export function useGetPeoPayrollProviderBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPeoPayrollProviderBasicInfoQuery,
        GetPeoPayrollProviderBasicInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPeoPayrollProviderBasicInfoQuery,
    GetPeoPayrollProviderBasicInfoQueryVariables
  >(GetPeoPayrollProviderBasicInfoDocument, options);
}
export type GetPeoPayrollProviderBasicInfoQueryHookResult = ReturnType<
  typeof useGetPeoPayrollProviderBasicInfoQuery
>;
export type GetPeoPayrollProviderBasicInfoLazyQueryHookResult = ReturnType<
  typeof useGetPeoPayrollProviderBasicInfoLazyQuery
>;
export type GetPeoPayrollProviderBasicInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetPeoPayrollProviderBasicInfoSuspenseQuery
>;
export type GetPeoPayrollProviderBasicInfoQueryResult = Apollo.QueryResult<
  GetPeoPayrollProviderBasicInfoQuery,
  GetPeoPayrollProviderBasicInfoQueryVariables
>;
export const PeoPayrollProviderStaffDocument = gql`
    query PeoPayrollProviderStaff($id: ID!) {
  peoPayrollProviderStaff(where: {id: $id}) {
    ...PeoPayrollProviderStaffInfo
  }
}
    ${PeoPayrollProviderStaffInfoFragmentDoc}`;

/**
 * __usePeoPayrollProviderStaffQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProviderStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProviderStaffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeoPayrollProviderStaffQuery(
  baseOptions: Apollo.QueryHookOptions<
    PeoPayrollProviderStaffQuery,
    PeoPayrollProviderStaffQueryVariables
  > &
    ({ variables: PeoPayrollProviderStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoPayrollProviderStaffQuery, PeoPayrollProviderStaffQueryVariables>(
    PeoPayrollProviderStaffDocument,
    options,
  );
}
export function usePeoPayrollProviderStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProviderStaffQuery,
    PeoPayrollProviderStaffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoPayrollProviderStaffQuery, PeoPayrollProviderStaffQueryVariables>(
    PeoPayrollProviderStaffDocument,
    options,
  );
}
// @ts-ignore
export function usePeoPayrollProviderStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProviderStaffQuery,
    PeoPayrollProviderStaffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderStaffQuery,
  PeoPayrollProviderStaffQueryVariables
>;
export function usePeoPayrollProviderStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderStaffQuery,
        PeoPayrollProviderStaffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderStaffQuery | undefined,
  PeoPayrollProviderStaffQueryVariables
>;
export function usePeoPayrollProviderStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderStaffQuery,
        PeoPayrollProviderStaffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PeoPayrollProviderStaffQuery,
    PeoPayrollProviderStaffQueryVariables
  >(PeoPayrollProviderStaffDocument, options);
}
export type PeoPayrollProviderStaffQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffQuery
>;
export type PeoPayrollProviderStaffLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffLazyQuery
>;
export type PeoPayrollProviderStaffSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffSuspenseQuery
>;
export type PeoPayrollProviderStaffQueryResult = Apollo.QueryResult<
  PeoPayrollProviderStaffQuery,
  PeoPayrollProviderStaffQueryVariables
>;
export const PeoPayrollProviderStaffsListDocument = gql`
    query PeoPayrollProviderStaffsList($filter: PeoPayrollProviderStaffWhere, $orderBy: [PeoPayrollProviderStaffOrderBy!], $first: Int, $skip: Int) {
  peoPayrollProviderStaffList(
    where: $filter
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    ...PeoPayrollProviderStaffInfo
  }
  peoPayrollProviderStaffCount(where: $filter)
}
    ${PeoPayrollProviderStaffInfoFragmentDoc}`;

/**
 * __usePeoPayrollProviderStaffsListQuery__
 *
 * To run a query within a React component, call `usePeoPayrollProviderStaffsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderStaffsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoPayrollProviderStaffsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeoPayrollProviderStaffsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PeoPayrollProviderStaffsListQuery,
    PeoPayrollProviderStaffsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PeoPayrollProviderStaffsListQuery,
    PeoPayrollProviderStaffsListQueryVariables
  >(PeoPayrollProviderStaffsListDocument, options);
}
export function usePeoPayrollProviderStaffsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoPayrollProviderStaffsListQuery,
    PeoPayrollProviderStaffsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PeoPayrollProviderStaffsListQuery,
    PeoPayrollProviderStaffsListQueryVariables
  >(PeoPayrollProviderStaffsListDocument, options);
}
// @ts-ignore
export function usePeoPayrollProviderStaffsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoPayrollProviderStaffsListQuery,
    PeoPayrollProviderStaffsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderStaffsListQuery,
  PeoPayrollProviderStaffsListQueryVariables
>;
export function usePeoPayrollProviderStaffsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderStaffsListQuery,
        PeoPayrollProviderStaffsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PeoPayrollProviderStaffsListQuery | undefined,
  PeoPayrollProviderStaffsListQueryVariables
>;
export function usePeoPayrollProviderStaffsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PeoPayrollProviderStaffsListQuery,
        PeoPayrollProviderStaffsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PeoPayrollProviderStaffsListQuery,
    PeoPayrollProviderStaffsListQueryVariables
  >(PeoPayrollProviderStaffsListDocument, options);
}
export type PeoPayrollProviderStaffsListQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffsListQuery
>;
export type PeoPayrollProviderStaffsListLazyQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffsListLazyQuery
>;
export type PeoPayrollProviderStaffsListSuspenseQueryHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffsListSuspenseQuery
>;
export type PeoPayrollProviderStaffsListQueryResult = Apollo.QueryResult<
  PeoPayrollProviderStaffsListQuery,
  PeoPayrollProviderStaffsListQueryVariables
>;
export const PeoPayrollProviderStaffUpdateDocument = gql`
    mutation PeoPayrollProviderStaffUpdate($data: PeoPayrollProviderStaffUpdate!, $where: PeoPayrollProviderStaffWhereUnique!) {
  peoPayrollProviderStaffUpdate(data: $data, where: $where) {
    ...PeoPayrollProviderStaffInfo
  }
}
    ${PeoPayrollProviderStaffInfoFragmentDoc}`;
export type PeoPayrollProviderStaffUpdateMutationFn = Apollo.MutationFunction<
  PeoPayrollProviderStaffUpdateMutation,
  PeoPayrollProviderStaffUpdateMutationVariables
>;

/**
 * __usePeoPayrollProviderStaffUpdateMutation__
 *
 * To run a mutation, you first call `usePeoPayrollProviderStaffUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoPayrollProviderStaffUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoPayrollProviderStaffUpdateMutation, { data, loading, error }] = usePeoPayrollProviderStaffUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeoPayrollProviderStaffUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PeoPayrollProviderStaffUpdateMutation,
    PeoPayrollProviderStaffUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PeoPayrollProviderStaffUpdateMutation,
    PeoPayrollProviderStaffUpdateMutationVariables
  >(PeoPayrollProviderStaffUpdateDocument, options);
}
export type PeoPayrollProviderStaffUpdateMutationHookResult = ReturnType<
  typeof usePeoPayrollProviderStaffUpdateMutation
>;
export type PeoPayrollProviderStaffUpdateMutationResult =
  Apollo.MutationResult<PeoPayrollProviderStaffUpdateMutation>;
export type PeoPayrollProviderStaffUpdateMutationOptions = Apollo.BaseMutationOptions<
  PeoPayrollProviderStaffUpdateMutation,
  PeoPayrollProviderStaffUpdateMutationVariables
>;
export const SendInvitesToPeoPayrollProviderStaffsDocument = gql`
    mutation sendInvitesToPeoPayrollProviderStaffs($staff: [InvitedPeoPayrollProviderStaff!]!) {
  sendInvitesToPeoPayrollProviderStaffs(staff: $staff) {
    success
  }
}
    `;
export type SendInvitesToPeoPayrollProviderStaffsMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoPayrollProviderStaffsMutation,
  SendInvitesToPeoPayrollProviderStaffsMutationVariables
>;

/**
 * __useSendInvitesToPeoPayrollProviderStaffsMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoPayrollProviderStaffsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoPayrollProviderStaffsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoPayrollProviderStaffsMutation, { data, loading, error }] = useSendInvitesToPeoPayrollProviderStaffsMutation({
 *   variables: {
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useSendInvitesToPeoPayrollProviderStaffsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoPayrollProviderStaffsMutation,
    SendInvitesToPeoPayrollProviderStaffsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoPayrollProviderStaffsMutation,
    SendInvitesToPeoPayrollProviderStaffsMutationVariables
  >(SendInvitesToPeoPayrollProviderStaffsDocument, options);
}
export type SendInvitesToPeoPayrollProviderStaffsMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoPayrollProviderStaffsMutation
>;
export type SendInvitesToPeoPayrollProviderStaffsMutationResult =
  Apollo.MutationResult<SendInvitesToPeoPayrollProviderStaffsMutation>;
export type SendInvitesToPeoPayrollProviderStaffsMutationOptions = Apollo.BaseMutationOptions<
  SendInvitesToPeoPayrollProviderStaffsMutation,
  SendInvitesToPeoPayrollProviderStaffsMutationVariables
>;
export const SendInvitesToPeoPayrollProviderStaffByCvStaffDocument = gql`
    mutation sendInvitesToPeoPayrollProviderStaffByCVStaff($peoPayrollProviderId: String!, $staff: [InvitedPeoPayrollProviderStaff!]!) {
  sendInvitesToPeoPayrollProviderStaffByCVStaff(
    peoPayrollProviderId: $peoPayrollProviderId
    staff: $staff
  ) {
    success
  }
}
    `;
export type SendInvitesToPeoPayrollProviderStaffByCvStaffMutationFn = Apollo.MutationFunction<
  SendInvitesToPeoPayrollProviderStaffByCvStaffMutation,
  SendInvitesToPeoPayrollProviderStaffByCvStaffMutationVariables
>;

/**
 * __useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation__
 *
 * To run a mutation, you first call `useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitesToPeoPayrollProviderStaffByCvStaffMutation, { data, loading, error }] = useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation({
 *   variables: {
 *      peoPayrollProviderId: // value for 'peoPayrollProviderId'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendInvitesToPeoPayrollProviderStaffByCvStaffMutation,
    SendInvitesToPeoPayrollProviderStaffByCvStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendInvitesToPeoPayrollProviderStaffByCvStaffMutation,
    SendInvitesToPeoPayrollProviderStaffByCvStaffMutationVariables
  >(SendInvitesToPeoPayrollProviderStaffByCvStaffDocument, options);
}
export type SendInvitesToPeoPayrollProviderStaffByCvStaffMutationHookResult = ReturnType<
  typeof useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation
>;
export type SendInvitesToPeoPayrollProviderStaffByCvStaffMutationResult =
  Apollo.MutationResult<SendInvitesToPeoPayrollProviderStaffByCvStaffMutation>;
export type SendInvitesToPeoPayrollProviderStaffByCvStaffMutationOptions =
  Apollo.BaseMutationOptions<
    SendInvitesToPeoPayrollProviderStaffByCvStaffMutation,
    SendInvitesToPeoPayrollProviderStaffByCvStaffMutationVariables
  >;
export const PeoStaffDocument = gql`
    query PeoStaff($id: ID!) {
  peoStaff(where: {id: $id}) {
    ...PeoStaffInfo
  }
}
    ${PeoStaffInfoFragmentDoc}`;

/**
 * __usePeoStaffQuery__
 *
 * To run a query within a React component, call `usePeoStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoStaffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeoStaffQuery(
  baseOptions: Apollo.QueryHookOptions<PeoStaffQuery, PeoStaffQueryVariables> &
    ({ variables: PeoStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoStaffQuery, PeoStaffQueryVariables>(PeoStaffDocument, options);
}
export function usePeoStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeoStaffQuery, PeoStaffQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoStaffQuery, PeoStaffQueryVariables>(PeoStaffDocument, options);
}
// @ts-ignore
export function usePeoStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PeoStaffQuery, PeoStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoStaffQuery, PeoStaffQueryVariables>;
export function usePeoStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoStaffQuery, PeoStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoStaffQuery | undefined, PeoStaffQueryVariables>;
export function usePeoStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoStaffQuery, PeoStaffQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeoStaffQuery, PeoStaffQueryVariables>(PeoStaffDocument, options);
}
export type PeoStaffQueryHookResult = ReturnType<typeof usePeoStaffQuery>;
export type PeoStaffLazyQueryHookResult = ReturnType<typeof usePeoStaffLazyQuery>;
export type PeoStaffSuspenseQueryHookResult = ReturnType<typeof usePeoStaffSuspenseQuery>;
export type PeoStaffQueryResult = Apollo.QueryResult<PeoStaffQuery, PeoStaffQueryVariables>;
export const PeoStaffListDocument = gql`
    query PeoStaffList($filter: PeoStaffWhere, $orderBy: [PeoStaffOrderBy!], $first: Int, $skip: Int) {
  peoStaffCount(where: $filter)
  peoStaffList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...PeoStaffInfo
  }
}
    ${PeoStaffInfoFragmentDoc}`;

/**
 * __usePeoStaffListQuery__
 *
 * To run a query within a React component, call `usePeoStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoStaffListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeoStaffListQuery(
  baseOptions?: Apollo.QueryHookOptions<PeoStaffListQuery, PeoStaffListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoStaffListQuery, PeoStaffListQueryVariables>(
    PeoStaffListDocument,
    options,
  );
}
export function usePeoStaffListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeoStaffListQuery, PeoStaffListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoStaffListQuery, PeoStaffListQueryVariables>(
    PeoStaffListDocument,
    options,
  );
}
// @ts-ignore
export function usePeoStaffListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PeoStaffListQuery, PeoStaffListQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoStaffListQuery, PeoStaffListQueryVariables>;
export function usePeoStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoStaffListQuery, PeoStaffListQueryVariables>,
): Apollo.UseSuspenseQueryResult<PeoStaffListQuery | undefined, PeoStaffListQueryVariables>;
export function usePeoStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoStaffListQuery, PeoStaffListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeoStaffListQuery, PeoStaffListQueryVariables>(
    PeoStaffListDocument,
    options,
  );
}
export type PeoStaffListQueryHookResult = ReturnType<typeof usePeoStaffListQuery>;
export type PeoStaffListLazyQueryHookResult = ReturnType<typeof usePeoStaffListLazyQuery>;
export type PeoStaffListSuspenseQueryHookResult = ReturnType<typeof usePeoStaffListSuspenseQuery>;
export type PeoStaffListQueryResult = Apollo.QueryResult<
  PeoStaffListQuery,
  PeoStaffListQueryVariables
>;
export const PeoStaffMinimalListDocument = gql`
    query PeoStaffMinimalList($filter: PeoStaffWhere, $orderBy: [PeoStaffOrderBy!], $first: Int, $skip: Int) {
  peoStaffCount(where: $filter)
  peoStaffList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...PeoStaffMinimalInfo
  }
}
    ${PeoStaffMinimalInfoFragmentDoc}`;

/**
 * __usePeoStaffMinimalListQuery__
 *
 * To run a query within a React component, call `usePeoStaffMinimalListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoStaffMinimalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoStaffMinimalListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeoStaffMinimalListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PeoStaffMinimalListQuery,
    PeoStaffMinimalListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeoStaffMinimalListQuery, PeoStaffMinimalListQueryVariables>(
    PeoStaffMinimalListDocument,
    options,
  );
}
export function usePeoStaffMinimalListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PeoStaffMinimalListQuery,
    PeoStaffMinimalListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeoStaffMinimalListQuery, PeoStaffMinimalListQueryVariables>(
    PeoStaffMinimalListDocument,
    options,
  );
}
// @ts-ignore
export function usePeoStaffMinimalListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PeoStaffMinimalListQuery,
    PeoStaffMinimalListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PeoStaffMinimalListQuery, PeoStaffMinimalListQueryVariables>;
export function usePeoStaffMinimalListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoStaffMinimalListQuery, PeoStaffMinimalListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PeoStaffMinimalListQuery | undefined,
  PeoStaffMinimalListQueryVariables
>;
export function usePeoStaffMinimalListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeoStaffMinimalListQuery, PeoStaffMinimalListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeoStaffMinimalListQuery, PeoStaffMinimalListQueryVariables>(
    PeoStaffMinimalListDocument,
    options,
  );
}
export type PeoStaffMinimalListQueryHookResult = ReturnType<typeof usePeoStaffMinimalListQuery>;
export type PeoStaffMinimalListLazyQueryHookResult = ReturnType<
  typeof usePeoStaffMinimalListLazyQuery
>;
export type PeoStaffMinimalListSuspenseQueryHookResult = ReturnType<
  typeof usePeoStaffMinimalListSuspenseQuery
>;
export type PeoStaffMinimalListQueryResult = Apollo.QueryResult<
  PeoStaffMinimalListQuery,
  PeoStaffMinimalListQueryVariables
>;
export const GetPeoStaffAccessInfoDocument = gql`
    query GetPeoStaffAccessInfo($id: ID!) {
  getPeoStaffAccessInfo(id: $id) {
    ...PeoStaffAccessInfoItem
  }
}
    ${PeoStaffAccessInfoItemFragmentDoc}`;

/**
 * __useGetPeoStaffAccessInfoQuery__
 *
 * To run a query within a React component, call `useGetPeoStaffAccessInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeoStaffAccessInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeoStaffAccessInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPeoStaffAccessInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPeoStaffAccessInfoQuery,
    GetPeoStaffAccessInfoQueryVariables
  > &
    ({ variables: GetPeoStaffAccessInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPeoStaffAccessInfoQuery, GetPeoStaffAccessInfoQueryVariables>(
    GetPeoStaffAccessInfoDocument,
    options,
  );
}
export function useGetPeoStaffAccessInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPeoStaffAccessInfoQuery,
    GetPeoStaffAccessInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPeoStaffAccessInfoQuery, GetPeoStaffAccessInfoQueryVariables>(
    GetPeoStaffAccessInfoDocument,
    options,
  );
}
// @ts-ignore
export function useGetPeoStaffAccessInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPeoStaffAccessInfoQuery,
    GetPeoStaffAccessInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPeoStaffAccessInfoQuery, GetPeoStaffAccessInfoQueryVariables>;
export function useGetPeoStaffAccessInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPeoStaffAccessInfoQuery,
        GetPeoStaffAccessInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPeoStaffAccessInfoQuery | undefined,
  GetPeoStaffAccessInfoQueryVariables
>;
export function useGetPeoStaffAccessInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPeoStaffAccessInfoQuery,
        GetPeoStaffAccessInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPeoStaffAccessInfoQuery, GetPeoStaffAccessInfoQueryVariables>(
    GetPeoStaffAccessInfoDocument,
    options,
  );
}
export type GetPeoStaffAccessInfoQueryHookResult = ReturnType<typeof useGetPeoStaffAccessInfoQuery>;
export type GetPeoStaffAccessInfoLazyQueryHookResult = ReturnType<
  typeof useGetPeoStaffAccessInfoLazyQuery
>;
export type GetPeoStaffAccessInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetPeoStaffAccessInfoSuspenseQuery
>;
export type GetPeoStaffAccessInfoQueryResult = Apollo.QueryResult<
  GetPeoStaffAccessInfoQuery,
  GetPeoStaffAccessInfoQueryVariables
>;
export const PeoStaffUpdateDocument = gql`
    mutation PeoStaffUpdate($data: PeoStaffUpdate!, $where: PeoStaffWhereUnique!) {
  peoStaffUpdate(data: $data, where: $where) {
    ...PeoStaffInfo
  }
}
    ${PeoStaffInfoFragmentDoc}`;
export type PeoStaffUpdateMutationFn = Apollo.MutationFunction<
  PeoStaffUpdateMutation,
  PeoStaffUpdateMutationVariables
>;

/**
 * __usePeoStaffUpdateMutation__
 *
 * To run a mutation, you first call `usePeoStaffUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeoStaffUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peoStaffUpdateMutation, { data, loading, error }] = usePeoStaffUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePeoStaffUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<PeoStaffUpdateMutation, PeoStaffUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PeoStaffUpdateMutation, PeoStaffUpdateMutationVariables>(
    PeoStaffUpdateDocument,
    options,
  );
}
export type PeoStaffUpdateMutationHookResult = ReturnType<typeof usePeoStaffUpdateMutation>;
export type PeoStaffUpdateMutationResult = Apollo.MutationResult<PeoStaffUpdateMutation>;
export type PeoStaffUpdateMutationOptions = Apollo.BaseMutationOptions<
  PeoStaffUpdateMutation,
  PeoStaffUpdateMutationVariables
>;
export const UpdatePeoStaffDetailsDocument = gql`
    mutation UpdatePeoStaffDetails($peoStaffId: ID!, $data: UpdatePeoStaffDetailsInput!) {
  updatePeoStaffDetails(peoStaffId: $peoStaffId, data: $data) {
    success
  }
}
    `;
export type UpdatePeoStaffDetailsMutationFn = Apollo.MutationFunction<
  UpdatePeoStaffDetailsMutation,
  UpdatePeoStaffDetailsMutationVariables
>;

/**
 * __useUpdatePeoStaffDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePeoStaffDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeoStaffDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeoStaffDetailsMutation, { data, loading, error }] = useUpdatePeoStaffDetailsMutation({
 *   variables: {
 *      peoStaffId: // value for 'peoStaffId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePeoStaffDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePeoStaffDetailsMutation,
    UpdatePeoStaffDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePeoStaffDetailsMutation, UpdatePeoStaffDetailsMutationVariables>(
    UpdatePeoStaffDetailsDocument,
    options,
  );
}
export type UpdatePeoStaffDetailsMutationHookResult = ReturnType<
  typeof useUpdatePeoStaffDetailsMutation
>;
export type UpdatePeoStaffDetailsMutationResult =
  Apollo.MutationResult<UpdatePeoStaffDetailsMutation>;
export type UpdatePeoStaffDetailsMutationOptions = Apollo.BaseMutationOptions<
  UpdatePeoStaffDetailsMutation,
  UpdatePeoStaffDetailsMutationVariables
>;
export const DeletePeoStaffDocument = gql`
    mutation DeletePeoStaff($peoStaffId: ID!) {
  deletePeoStaff(peoStaffId: $peoStaffId) {
    success
  }
}
    `;
export type DeletePeoStaffMutationFn = Apollo.MutationFunction<
  DeletePeoStaffMutation,
  DeletePeoStaffMutationVariables
>;

/**
 * __useDeletePeoStaffMutation__
 *
 * To run a mutation, you first call `useDeletePeoStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePeoStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePeoStaffMutation, { data, loading, error }] = useDeletePeoStaffMutation({
 *   variables: {
 *      peoStaffId: // value for 'peoStaffId'
 *   },
 * });
 */
export function useDeletePeoStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePeoStaffMutation, DeletePeoStaffMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePeoStaffMutation, DeletePeoStaffMutationVariables>(
    DeletePeoStaffDocument,
    options,
  );
}
export type DeletePeoStaffMutationHookResult = ReturnType<typeof useDeletePeoStaffMutation>;
export type DeletePeoStaffMutationResult = Apollo.MutationResult<DeletePeoStaffMutation>;
export type DeletePeoStaffMutationOptions = Apollo.BaseMutationOptions<
  DeletePeoStaffMutation,
  DeletePeoStaffMutationVariables
>;
export const CheckDeletionPeoStaffDocument = gql`
    query CheckDeletionPeoStaff($peoStaffId: ID!) {
  checkDeletionPeoStaff(peoStaffId: $peoStaffId) {
    valid
    errors
  }
}
    `;

/**
 * __useCheckDeletionPeoStaffQuery__
 *
 * To run a query within a React component, call `useCheckDeletionPeoStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDeletionPeoStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDeletionPeoStaffQuery({
 *   variables: {
 *      peoStaffId: // value for 'peoStaffId'
 *   },
 * });
 */
export function useCheckDeletionPeoStaffQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckDeletionPeoStaffQuery,
    CheckDeletionPeoStaffQueryVariables
  > &
    ({ variables: CheckDeletionPeoStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckDeletionPeoStaffQuery, CheckDeletionPeoStaffQueryVariables>(
    CheckDeletionPeoStaffDocument,
    options,
  );
}
export function useCheckDeletionPeoStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckDeletionPeoStaffQuery,
    CheckDeletionPeoStaffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckDeletionPeoStaffQuery, CheckDeletionPeoStaffQueryVariables>(
    CheckDeletionPeoStaffDocument,
    options,
  );
}
// @ts-ignore
export function useCheckDeletionPeoStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckDeletionPeoStaffQuery,
    CheckDeletionPeoStaffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckDeletionPeoStaffQuery, CheckDeletionPeoStaffQueryVariables>;
export function useCheckDeletionPeoStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionPeoStaffQuery,
        CheckDeletionPeoStaffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionPeoStaffQuery | undefined,
  CheckDeletionPeoStaffQueryVariables
>;
export function useCheckDeletionPeoStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionPeoStaffQuery,
        CheckDeletionPeoStaffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckDeletionPeoStaffQuery, CheckDeletionPeoStaffQueryVariables>(
    CheckDeletionPeoStaffDocument,
    options,
  );
}
export type CheckDeletionPeoStaffQueryHookResult = ReturnType<typeof useCheckDeletionPeoStaffQuery>;
export type CheckDeletionPeoStaffLazyQueryHookResult = ReturnType<
  typeof useCheckDeletionPeoStaffLazyQuery
>;
export type CheckDeletionPeoStaffSuspenseQueryHookResult = ReturnType<
  typeof useCheckDeletionPeoStaffSuspenseQuery
>;
export type CheckDeletionPeoStaffQueryResult = Apollo.QueryResult<
  CheckDeletionPeoStaffQuery,
  CheckDeletionPeoStaffQueryVariables
>;
export const PermissiblePurposeReferencesListDocument = gql`
    query PermissiblePurposeReferencesList($filter: PermissiblePurposeReferenceWhere) {
  permissiblePurposeReferenceCount(where: $filter)
  permissiblePurposeReferenceList(where: $filter) {
    ...PermissiblePurposeReferenceItem
  }
}
    ${PermissiblePurposeReferenceItemFragmentDoc}`;

/**
 * __usePermissiblePurposeReferencesListQuery__
 *
 * To run a query within a React component, call `usePermissiblePurposeReferencesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposeReferencesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissiblePurposeReferencesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePermissiblePurposeReferencesListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PermissiblePurposeReferencesListQuery,
    PermissiblePurposeReferencesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PermissiblePurposeReferencesListQuery,
    PermissiblePurposeReferencesListQueryVariables
  >(PermissiblePurposeReferencesListDocument, options);
}
export function usePermissiblePurposeReferencesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissiblePurposeReferencesListQuery,
    PermissiblePurposeReferencesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PermissiblePurposeReferencesListQuery,
    PermissiblePurposeReferencesListQueryVariables
  >(PermissiblePurposeReferencesListDocument, options);
}
// @ts-ignore
export function usePermissiblePurposeReferencesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissiblePurposeReferencesListQuery,
    PermissiblePurposeReferencesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeReferencesListQuery,
  PermissiblePurposeReferencesListQueryVariables
>;
export function usePermissiblePurposeReferencesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposeReferencesListQuery,
        PermissiblePurposeReferencesListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeReferencesListQuery | undefined,
  PermissiblePurposeReferencesListQueryVariables
>;
export function usePermissiblePurposeReferencesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposeReferencesListQuery,
        PermissiblePurposeReferencesListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PermissiblePurposeReferencesListQuery,
    PermissiblePurposeReferencesListQueryVariables
  >(PermissiblePurposeReferencesListDocument, options);
}
export type PermissiblePurposeReferencesListQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListQuery
>;
export type PermissiblePurposeReferencesListLazyQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListLazyQuery
>;
export type PermissiblePurposeReferencesListSuspenseQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListSuspenseQuery
>;
export type PermissiblePurposeReferencesListQueryResult = Apollo.QueryResult<
  PermissiblePurposeReferencesListQuery,
  PermissiblePurposeReferencesListQueryVariables
>;
export const PermissiblePurposeReferencesListWithPermissiblePurposesDocument = gql`
    query PermissiblePurposeReferencesListWithPermissiblePurposes($filter: PermissiblePurposeReferenceWhere, $permissiblePurposeFilter: PermissiblePurposeWhere) {
  permissiblePurposeReferenceCount(where: $filter)
  permissiblePurposeReferenceList(where: $filter) {
    ...PermissiblePurposeReferenceItem
    permissiblePurposesCount(where: $permissiblePurposeFilter)
    permissiblePurposesList(where: $permissiblePurposeFilter) {
      ...PermissiblePurposeByReferenceItem
    }
  }
}
    ${PermissiblePurposeReferenceItemFragmentDoc}
${PermissiblePurposeByReferenceItemFragmentDoc}`;

/**
 * __usePermissiblePurposeReferencesListWithPermissiblePurposesQuery__
 *
 * To run a query within a React component, call `usePermissiblePurposeReferencesListWithPermissiblePurposesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposeReferencesListWithPermissiblePurposesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissiblePurposeReferencesListWithPermissiblePurposesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      permissiblePurposeFilter: // value for 'permissiblePurposeFilter'
 *   },
 * });
 */
export function usePermissiblePurposeReferencesListWithPermissiblePurposesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
    PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
    PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
  >(PermissiblePurposeReferencesListWithPermissiblePurposesDocument, options);
}
export function usePermissiblePurposeReferencesListWithPermissiblePurposesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
    PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
    PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
  >(PermissiblePurposeReferencesListWithPermissiblePurposesDocument, options);
}
// @ts-ignore
export function usePermissiblePurposeReferencesListWithPermissiblePurposesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
    PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
  PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
>;
export function usePermissiblePurposeReferencesListWithPermissiblePurposesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
        PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeReferencesListWithPermissiblePurposesQuery | undefined,
  PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
>;
export function usePermissiblePurposeReferencesListWithPermissiblePurposesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
        PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
    PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
  >(PermissiblePurposeReferencesListWithPermissiblePurposesDocument, options);
}
export type PermissiblePurposeReferencesListWithPermissiblePurposesQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListWithPermissiblePurposesQuery
>;
export type PermissiblePurposeReferencesListWithPermissiblePurposesLazyQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListWithPermissiblePurposesLazyQuery
>;
export type PermissiblePurposeReferencesListWithPermissiblePurposesSuspenseQueryHookResult =
  ReturnType<typeof usePermissiblePurposeReferencesListWithPermissiblePurposesSuspenseQuery>;
export type PermissiblePurposeReferencesListWithPermissiblePurposesQueryResult = Apollo.QueryResult<
  PermissiblePurposeReferencesListWithPermissiblePurposesQuery,
  PermissiblePurposeReferencesListWithPermissiblePurposesQueryVariables
>;
export const PermissiblePurposeReferencesListDashboardVerifiersTabDocument = gql`
    query PermissiblePurposeReferencesListDashboardVerifiersTab($permissiblePurposeFilter: PermissiblePurposeWhere) {
  permissiblePurposeReferenceList {
    id
    label
    verifierType
    permissiblePurposesCount(where: $permissiblePurposeFilter)
  }
}
    `;

/**
 * __usePermissiblePurposeReferencesListDashboardVerifiersTabQuery__
 *
 * To run a query within a React component, call `usePermissiblePurposeReferencesListDashboardVerifiersTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposeReferencesListDashboardVerifiersTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissiblePurposeReferencesListDashboardVerifiersTabQuery({
 *   variables: {
 *      permissiblePurposeFilter: // value for 'permissiblePurposeFilter'
 *   },
 * });
 */
export function usePermissiblePurposeReferencesListDashboardVerifiersTabQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
    PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
    PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
  >(PermissiblePurposeReferencesListDashboardVerifiersTabDocument, options);
}
export function usePermissiblePurposeReferencesListDashboardVerifiersTabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
    PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
    PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
  >(PermissiblePurposeReferencesListDashboardVerifiersTabDocument, options);
}
// @ts-ignore
export function usePermissiblePurposeReferencesListDashboardVerifiersTabSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
    PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
  PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
>;
export function usePermissiblePurposeReferencesListDashboardVerifiersTabSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
        PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeReferencesListDashboardVerifiersTabQuery | undefined,
  PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
>;
export function usePermissiblePurposeReferencesListDashboardVerifiersTabSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
        PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
    PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
  >(PermissiblePurposeReferencesListDashboardVerifiersTabDocument, options);
}
export type PermissiblePurposeReferencesListDashboardVerifiersTabQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListDashboardVerifiersTabQuery
>;
export type PermissiblePurposeReferencesListDashboardVerifiersTabLazyQueryHookResult = ReturnType<
  typeof usePermissiblePurposeReferencesListDashboardVerifiersTabLazyQuery
>;
export type PermissiblePurposeReferencesListDashboardVerifiersTabSuspenseQueryHookResult =
  ReturnType<typeof usePermissiblePurposeReferencesListDashboardVerifiersTabSuspenseQuery>;
export type PermissiblePurposeReferencesListDashboardVerifiersTabQueryResult = Apollo.QueryResult<
  PermissiblePurposeReferencesListDashboardVerifiersTabQuery,
  PermissiblePurposeReferencesListDashboardVerifiersTabQueryVariables
>;
export const PermissiblePurposeDocument = gql`
    query PermissiblePurpose($filter: PermissiblePurposeWhereUnique!) {
  permissiblePurpose(where: $filter) {
    ...PermissiblePurposesItem
  }
}
    ${PermissiblePurposesItemFragmentDoc}`;

/**
 * __usePermissiblePurposeQuery__
 *
 * To run a query within a React component, call `usePermissiblePurposeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissiblePurposeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePermissiblePurposeQuery(
  baseOptions: Apollo.QueryHookOptions<PermissiblePurposeQuery, PermissiblePurposeQueryVariables> &
    ({ variables: PermissiblePurposeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PermissiblePurposeQuery, PermissiblePurposeQueryVariables>(
    PermissiblePurposeDocument,
    options,
  );
}
export function usePermissiblePurposeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissiblePurposeQuery,
    PermissiblePurposeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PermissiblePurposeQuery, PermissiblePurposeQueryVariables>(
    PermissiblePurposeDocument,
    options,
  );
}
// @ts-ignore
export function usePermissiblePurposeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissiblePurposeQuery,
    PermissiblePurposeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PermissiblePurposeQuery, PermissiblePurposeQueryVariables>;
export function usePermissiblePurposeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PermissiblePurposeQuery, PermissiblePurposeQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposeQuery | undefined,
  PermissiblePurposeQueryVariables
>;
export function usePermissiblePurposeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PermissiblePurposeQuery, PermissiblePurposeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PermissiblePurposeQuery, PermissiblePurposeQueryVariables>(
    PermissiblePurposeDocument,
    options,
  );
}
export type PermissiblePurposeQueryHookResult = ReturnType<typeof usePermissiblePurposeQuery>;
export type PermissiblePurposeLazyQueryHookResult = ReturnType<
  typeof usePermissiblePurposeLazyQuery
>;
export type PermissiblePurposeSuspenseQueryHookResult = ReturnType<
  typeof usePermissiblePurposeSuspenseQuery
>;
export type PermissiblePurposeQueryResult = Apollo.QueryResult<
  PermissiblePurposeQuery,
  PermissiblePurposeQueryVariables
>;
export const PermissiblePurposesListDocument = gql`
    query PermissiblePurposesList($filter: PermissiblePurposeWhere, $orderBy: [PermissiblePurposeOrderBy!], $first: Int, $skip: Int) {
  permissiblePurposeCount(where: $filter)
  permissiblePurposeList(
    where: $filter
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    ...PermissiblePurposesItem
  }
}
    ${PermissiblePurposesItemFragmentDoc}`;

/**
 * __usePermissiblePurposesListQuery__
 *
 * To run a query within a React component, call `usePermissiblePurposesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissiblePurposesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePermissiblePurposesListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PermissiblePurposesListQuery,
    PermissiblePurposesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PermissiblePurposesListQuery, PermissiblePurposesListQueryVariables>(
    PermissiblePurposesListDocument,
    options,
  );
}
export function usePermissiblePurposesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissiblePurposesListQuery,
    PermissiblePurposesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PermissiblePurposesListQuery, PermissiblePurposesListQueryVariables>(
    PermissiblePurposesListDocument,
    options,
  );
}
// @ts-ignore
export function usePermissiblePurposesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissiblePurposesListQuery,
    PermissiblePurposesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposesListQuery,
  PermissiblePurposesListQueryVariables
>;
export function usePermissiblePurposesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposesListQuery,
        PermissiblePurposesListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PermissiblePurposesListQuery | undefined,
  PermissiblePurposesListQueryVariables
>;
export function usePermissiblePurposesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissiblePurposesListQuery,
        PermissiblePurposesListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PermissiblePurposesListQuery,
    PermissiblePurposesListQueryVariables
  >(PermissiblePurposesListDocument, options);
}
export type PermissiblePurposesListQueryHookResult = ReturnType<
  typeof usePermissiblePurposesListQuery
>;
export type PermissiblePurposesListLazyQueryHookResult = ReturnType<
  typeof usePermissiblePurposesListLazyQuery
>;
export type PermissiblePurposesListSuspenseQueryHookResult = ReturnType<
  typeof usePermissiblePurposesListSuspenseQuery
>;
export type PermissiblePurposesListQueryResult = Apollo.QueryResult<
  PermissiblePurposesListQuery,
  PermissiblePurposesListQueryVariables
>;
export const PermissiblePurposeCreateDocument = gql`
    mutation PermissiblePurposeCreate($data: PermissiblePurposeCreate!) {
  createPermissiblePurpose(data: $data) {
    id
  }
}
    `;
export type PermissiblePurposeCreateMutationFn = Apollo.MutationFunction<
  PermissiblePurposeCreateMutation,
  PermissiblePurposeCreateMutationVariables
>;

/**
 * __usePermissiblePurposeCreateMutation__
 *
 * To run a mutation, you first call `usePermissiblePurposeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissiblePurposeCreateMutation, { data, loading, error }] = usePermissiblePurposeCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePermissiblePurposeCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PermissiblePurposeCreateMutation,
    PermissiblePurposeCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PermissiblePurposeCreateMutation,
    PermissiblePurposeCreateMutationVariables
  >(PermissiblePurposeCreateDocument, options);
}
export type PermissiblePurposeCreateMutationHookResult = ReturnType<
  typeof usePermissiblePurposeCreateMutation
>;
export type PermissiblePurposeCreateMutationResult =
  Apollo.MutationResult<PermissiblePurposeCreateMutation>;
export type PermissiblePurposeCreateMutationOptions = Apollo.BaseMutationOptions<
  PermissiblePurposeCreateMutation,
  PermissiblePurposeCreateMutationVariables
>;
export const PermissiblePurposeUpdateDocument = gql`
    mutation PermissiblePurposeUpdate($id: ID!, $data: PermissiblePurposeUpdate!) {
  updatePermissiblePurpose(id: $id, data: $data) {
    ...PermissiblePurposesItem
  }
}
    ${PermissiblePurposesItemFragmentDoc}`;
export type PermissiblePurposeUpdateMutationFn = Apollo.MutationFunction<
  PermissiblePurposeUpdateMutation,
  PermissiblePurposeUpdateMutationVariables
>;

/**
 * __usePermissiblePurposeUpdateMutation__
 *
 * To run a mutation, you first call `usePermissiblePurposeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissiblePurposeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissiblePurposeUpdateMutation, { data, loading, error }] = usePermissiblePurposeUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePermissiblePurposeUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PermissiblePurposeUpdateMutation,
    PermissiblePurposeUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PermissiblePurposeUpdateMutation,
    PermissiblePurposeUpdateMutationVariables
  >(PermissiblePurposeUpdateDocument, options);
}
export type PermissiblePurposeUpdateMutationHookResult = ReturnType<
  typeof usePermissiblePurposeUpdateMutation
>;
export type PermissiblePurposeUpdateMutationResult =
  Apollo.MutationResult<PermissiblePurposeUpdateMutation>;
export type PermissiblePurposeUpdateMutationOptions = Apollo.BaseMutationOptions<
  PermissiblePurposeUpdateMutation,
  PermissiblePurposeUpdateMutationVariables
>;
export const PlatformStaffListDocument = gql`
    query PlatformStaffList($filter: PlatformStaffWhere, $orderBy: [PlatformStaffOrderBy!], $first: Int, $skip: Int) {
  platformStaffCount(where: $filter)
  platformStaffList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...PlatformStaffItem
  }
}
    ${PlatformStaffItemFragmentDoc}`;

/**
 * __usePlatformStaffListQuery__
 *
 * To run a query within a React component, call `usePlatformStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformStaffListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePlatformStaffListQuery(
  baseOptions?: Apollo.QueryHookOptions<PlatformStaffListQuery, PlatformStaffListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlatformStaffListQuery, PlatformStaffListQueryVariables>(
    PlatformStaffListDocument,
    options,
  );
}
export function usePlatformStaffListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlatformStaffListQuery,
    PlatformStaffListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlatformStaffListQuery, PlatformStaffListQueryVariables>(
    PlatformStaffListDocument,
    options,
  );
}
// @ts-ignore
export function usePlatformStaffListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PlatformStaffListQuery,
    PlatformStaffListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PlatformStaffListQuery, PlatformStaffListQueryVariables>;
export function usePlatformStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PlatformStaffListQuery, PlatformStaffListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PlatformStaffListQuery | undefined,
  PlatformStaffListQueryVariables
>;
export function usePlatformStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PlatformStaffListQuery, PlatformStaffListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PlatformStaffListQuery, PlatformStaffListQueryVariables>(
    PlatformStaffListDocument,
    options,
  );
}
export type PlatformStaffListQueryHookResult = ReturnType<typeof usePlatformStaffListQuery>;
export type PlatformStaffListLazyQueryHookResult = ReturnType<typeof usePlatformStaffListLazyQuery>;
export type PlatformStaffListSuspenseQueryHookResult = ReturnType<
  typeof usePlatformStaffListSuspenseQuery
>;
export type PlatformStaffListQueryResult = Apollo.QueryResult<
  PlatformStaffListQuery,
  PlatformStaffListQueryVariables
>;
export const PlatformStaffDocument = gql`
    query PlatformStaff($where: PlatformStaffWhereUnique!) {
  platformStaff(where: $where) {
    ...PlatformStaffItem
  }
}
    ${PlatformStaffItemFragmentDoc}`;

/**
 * __usePlatformStaffQuery__
 *
 * To run a query within a React component, call `usePlatformStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformStaffQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePlatformStaffQuery(
  baseOptions: Apollo.QueryHookOptions<PlatformStaffQuery, PlatformStaffQueryVariables> &
    ({ variables: PlatformStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlatformStaffQuery, PlatformStaffQueryVariables>(
    PlatformStaffDocument,
    options,
  );
}
export function usePlatformStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PlatformStaffQuery, PlatformStaffQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlatformStaffQuery, PlatformStaffQueryVariables>(
    PlatformStaffDocument,
    options,
  );
}
// @ts-ignore
export function usePlatformStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformStaffQuery, PlatformStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<PlatformStaffQuery, PlatformStaffQueryVariables>;
export function usePlatformStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PlatformStaffQuery, PlatformStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<PlatformStaffQuery | undefined, PlatformStaffQueryVariables>;
export function usePlatformStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PlatformStaffQuery, PlatformStaffQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PlatformStaffQuery, PlatformStaffQueryVariables>(
    PlatformStaffDocument,
    options,
  );
}
export type PlatformStaffQueryHookResult = ReturnType<typeof usePlatformStaffQuery>;
export type PlatformStaffLazyQueryHookResult = ReturnType<typeof usePlatformStaffLazyQuery>;
export type PlatformStaffSuspenseQueryHookResult = ReturnType<typeof usePlatformStaffSuspenseQuery>;
export type PlatformStaffQueryResult = Apollo.QueryResult<
  PlatformStaffQuery,
  PlatformStaffQueryVariables
>;
export const CheckDeletionClearVerifyStaffDocument = gql`
    query CheckDeletionClearVerifyStaff($platformStaffId: ID!) {
  checkDeletionClearVerifyStaff(platformStaffId: $platformStaffId) {
    valid
    errors
  }
}
    `;

/**
 * __useCheckDeletionClearVerifyStaffQuery__
 *
 * To run a query within a React component, call `useCheckDeletionClearVerifyStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDeletionClearVerifyStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDeletionClearVerifyStaffQuery({
 *   variables: {
 *      platformStaffId: // value for 'platformStaffId'
 *   },
 * });
 */
export function useCheckDeletionClearVerifyStaffQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckDeletionClearVerifyStaffQuery,
    CheckDeletionClearVerifyStaffQueryVariables
  > &
    (
      | { variables: CheckDeletionClearVerifyStaffQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckDeletionClearVerifyStaffQuery,
    CheckDeletionClearVerifyStaffQueryVariables
  >(CheckDeletionClearVerifyStaffDocument, options);
}
export function useCheckDeletionClearVerifyStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckDeletionClearVerifyStaffQuery,
    CheckDeletionClearVerifyStaffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckDeletionClearVerifyStaffQuery,
    CheckDeletionClearVerifyStaffQueryVariables
  >(CheckDeletionClearVerifyStaffDocument, options);
}
// @ts-ignore
export function useCheckDeletionClearVerifyStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckDeletionClearVerifyStaffQuery,
    CheckDeletionClearVerifyStaffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionClearVerifyStaffQuery,
  CheckDeletionClearVerifyStaffQueryVariables
>;
export function useCheckDeletionClearVerifyStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionClearVerifyStaffQuery,
        CheckDeletionClearVerifyStaffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionClearVerifyStaffQuery | undefined,
  CheckDeletionClearVerifyStaffQueryVariables
>;
export function useCheckDeletionClearVerifyStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionClearVerifyStaffQuery,
        CheckDeletionClearVerifyStaffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckDeletionClearVerifyStaffQuery,
    CheckDeletionClearVerifyStaffQueryVariables
  >(CheckDeletionClearVerifyStaffDocument, options);
}
export type CheckDeletionClearVerifyStaffQueryHookResult = ReturnType<
  typeof useCheckDeletionClearVerifyStaffQuery
>;
export type CheckDeletionClearVerifyStaffLazyQueryHookResult = ReturnType<
  typeof useCheckDeletionClearVerifyStaffLazyQuery
>;
export type CheckDeletionClearVerifyStaffSuspenseQueryHookResult = ReturnType<
  typeof useCheckDeletionClearVerifyStaffSuspenseQuery
>;
export type CheckDeletionClearVerifyStaffQueryResult = Apollo.QueryResult<
  CheckDeletionClearVerifyStaffQuery,
  CheckDeletionClearVerifyStaffQueryVariables
>;
export const DeleteClearVerifyStaffDocument = gql`
    mutation DeleteClearVerifyStaff($platformStaffId: ID!) {
  deleteClearVerifyStaff(platformStaffId: $platformStaffId) {
    success
  }
}
    `;
export type DeleteClearVerifyStaffMutationFn = Apollo.MutationFunction<
  DeleteClearVerifyStaffMutation,
  DeleteClearVerifyStaffMutationVariables
>;

/**
 * __useDeleteClearVerifyStaffMutation__
 *
 * To run a mutation, you first call `useDeleteClearVerifyStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClearVerifyStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClearVerifyStaffMutation, { data, loading, error }] = useDeleteClearVerifyStaffMutation({
 *   variables: {
 *      platformStaffId: // value for 'platformStaffId'
 *   },
 * });
 */
export function useDeleteClearVerifyStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClearVerifyStaffMutation,
    DeleteClearVerifyStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClearVerifyStaffMutation,
    DeleteClearVerifyStaffMutationVariables
  >(DeleteClearVerifyStaffDocument, options);
}
export type DeleteClearVerifyStaffMutationHookResult = ReturnType<
  typeof useDeleteClearVerifyStaffMutation
>;
export type DeleteClearVerifyStaffMutationResult =
  Apollo.MutationResult<DeleteClearVerifyStaffMutation>;
export type DeleteClearVerifyStaffMutationOptions = Apollo.BaseMutationOptions<
  DeleteClearVerifyStaffMutation,
  DeleteClearVerifyStaffMutationVariables
>;
export const UpdatePlatformStaffDocument = gql`
    mutation UpdatePlatformStaff($where: PlatformStaffWhereUnique!, $data: PlatformStaffUpdate!) {
  platformStaffUpdate(where: $where, data: $data) {
    ...PlatformStaffItem
  }
}
    ${PlatformStaffItemFragmentDoc}`;
export type UpdatePlatformStaffMutationFn = Apollo.MutationFunction<
  UpdatePlatformStaffMutation,
  UpdatePlatformStaffMutationVariables
>;

/**
 * __useUpdatePlatformStaffMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformStaffMutation, { data, loading, error }] = useUpdatePlatformStaffMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePlatformStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlatformStaffMutation,
    UpdatePlatformStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePlatformStaffMutation, UpdatePlatformStaffMutationVariables>(
    UpdatePlatformStaffDocument,
    options,
  );
}
export type UpdatePlatformStaffMutationHookResult = ReturnType<
  typeof useUpdatePlatformStaffMutation
>;
export type UpdatePlatformStaffMutationResult = Apollo.MutationResult<UpdatePlatformStaffMutation>;
export type UpdatePlatformStaffMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlatformStaffMutation,
  UpdatePlatformStaffMutationVariables
>;
export const ResourceListDocument = gql`
    query ResourceList($filter: ResourceWhere, $orderBy: [ResourceOrderBy!]) {
  resourceCount(where: $filter)
  resourceList(where: $filter, orderBy: $orderBy) {
    ...ResourceInfo
  }
}
    ${ResourceInfoFragmentDoc}`;

/**
 * __useResourceListQuery__
 *
 * To run a query within a React component, call `useResourceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useResourceListQuery(
  baseOptions?: Apollo.QueryHookOptions<ResourceListQuery, ResourceListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResourceListQuery, ResourceListQueryVariables>(
    ResourceListDocument,
    options,
  );
}
export function useResourceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ResourceListQuery, ResourceListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ResourceListQuery, ResourceListQueryVariables>(
    ResourceListDocument,
    options,
  );
}
// @ts-ignore
export function useResourceListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ResourceListQuery, ResourceListQueryVariables>,
): Apollo.UseSuspenseQueryResult<ResourceListQuery, ResourceListQueryVariables>;
export function useResourceListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResourceListQuery, ResourceListQueryVariables>,
): Apollo.UseSuspenseQueryResult<ResourceListQuery | undefined, ResourceListQueryVariables>;
export function useResourceListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResourceListQuery, ResourceListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ResourceListQuery, ResourceListQueryVariables>(
    ResourceListDocument,
    options,
  );
}
export type ResourceListQueryHookResult = ReturnType<typeof useResourceListQuery>;
export type ResourceListLazyQueryHookResult = ReturnType<typeof useResourceListLazyQuery>;
export type ResourceListSuspenseQueryHookResult = ReturnType<typeof useResourceListSuspenseQuery>;
export type ResourceListQueryResult = Apollo.QueryResult<
  ResourceListQuery,
  ResourceListQueryVariables
>;
export const GenerateRevenueShareReportDocument = gql`
    mutation GenerateRevenueShareReport($startDate: Date!, $endDate: Date!, $companyId: ID, $companyType: CompanyType) {
  generateRevenueShareReport(
    startDate: $startDate
    endDate: $endDate
    companyId: $companyId
    companyType: $companyType
  ) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateRevenueShareReportMutationFn = Apollo.MutationFunction<
  GenerateRevenueShareReportMutation,
  GenerateRevenueShareReportMutationVariables
>;

/**
 * __useGenerateRevenueShareReportMutation__
 *
 * To run a mutation, you first call `useGenerateRevenueShareReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRevenueShareReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRevenueShareReportMutation, { data, loading, error }] = useGenerateRevenueShareReportMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      companyId: // value for 'companyId'
 *      companyType: // value for 'companyType'
 *   },
 * });
 */
export function useGenerateRevenueShareReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateRevenueShareReportMutation,
    GenerateRevenueShareReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateRevenueShareReportMutation,
    GenerateRevenueShareReportMutationVariables
  >(GenerateRevenueShareReportDocument, options);
}
export type GenerateRevenueShareReportMutationHookResult = ReturnType<
  typeof useGenerateRevenueShareReportMutation
>;
export type GenerateRevenueShareReportMutationResult =
  Apollo.MutationResult<GenerateRevenueShareReportMutation>;
export type GenerateRevenueShareReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateRevenueShareReportMutation,
  GenerateRevenueShareReportMutationVariables
>;
export const GetDashboardRevenueShareAccountsCountDocument = gql`
    query GetDashboardRevenueShareAccountsCount($asOfDate: Date!) {
  getDashboardRevenueShareAccountsCount(asOfDate: $asOfDate)
}
    `;

/**
 * __useGetDashboardRevenueShareAccountsCountQuery__
 *
 * To run a query within a React component, call `useGetDashboardRevenueShareAccountsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardRevenueShareAccountsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardRevenueShareAccountsCountQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetDashboardRevenueShareAccountsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDashboardRevenueShareAccountsCountQuery,
    GetDashboardRevenueShareAccountsCountQueryVariables
  > &
    (
      | { variables: GetDashboardRevenueShareAccountsCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardRevenueShareAccountsCountQuery,
    GetDashboardRevenueShareAccountsCountQueryVariables
  >(GetDashboardRevenueShareAccountsCountDocument, options);
}
export function useGetDashboardRevenueShareAccountsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardRevenueShareAccountsCountQuery,
    GetDashboardRevenueShareAccountsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardRevenueShareAccountsCountQuery,
    GetDashboardRevenueShareAccountsCountQueryVariables
  >(GetDashboardRevenueShareAccountsCountDocument, options);
}
// @ts-ignore
export function useGetDashboardRevenueShareAccountsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardRevenueShareAccountsCountQuery,
    GetDashboardRevenueShareAccountsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardRevenueShareAccountsCountQuery,
  GetDashboardRevenueShareAccountsCountQueryVariables
>;
export function useGetDashboardRevenueShareAccountsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardRevenueShareAccountsCountQuery,
        GetDashboardRevenueShareAccountsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDashboardRevenueShareAccountsCountQuery | undefined,
  GetDashboardRevenueShareAccountsCountQueryVariables
>;
export function useGetDashboardRevenueShareAccountsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardRevenueShareAccountsCountQuery,
        GetDashboardRevenueShareAccountsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardRevenueShareAccountsCountQuery,
    GetDashboardRevenueShareAccountsCountQueryVariables
  >(GetDashboardRevenueShareAccountsCountDocument, options);
}
export type GetDashboardRevenueShareAccountsCountQueryHookResult = ReturnType<
  typeof useGetDashboardRevenueShareAccountsCountQuery
>;
export type GetDashboardRevenueShareAccountsCountLazyQueryHookResult = ReturnType<
  typeof useGetDashboardRevenueShareAccountsCountLazyQuery
>;
export type GetDashboardRevenueShareAccountsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardRevenueShareAccountsCountSuspenseQuery
>;
export type GetDashboardRevenueShareAccountsCountQueryResult = Apollo.QueryResult<
  GetDashboardRevenueShareAccountsCountQuery,
  GetDashboardRevenueShareAccountsCountQueryVariables
>;
export const ValidateSignupEmployeeDataDocument = gql`
    query ValidateSignupEmployeeData($inviteId: ID, $employeeSignupToken: String, $employeeSsn: String!, $email: String!) {
  validateSignupEmployeeData(
    inviteId: $inviteId
    employeeSignupToken: $employeeSignupToken
    employeeSsn: $employeeSsn
    email: $email
  ) {
    employeeSignupToken
  }
}
    `;

/**
 * __useValidateSignupEmployeeDataQuery__
 *
 * To run a query within a React component, call `useValidateSignupEmployeeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSignupEmployeeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSignupEmployeeDataQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      employeeSignupToken: // value for 'employeeSignupToken'
 *      employeeSsn: // value for 'employeeSsn'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateSignupEmployeeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateSignupEmployeeDataQuery,
    ValidateSignupEmployeeDataQueryVariables
  > &
    ({ variables: ValidateSignupEmployeeDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateSignupEmployeeDataQuery, ValidateSignupEmployeeDataQueryVariables>(
    ValidateSignupEmployeeDataDocument,
    options,
  );
}
export function useValidateSignupEmployeeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateSignupEmployeeDataQuery,
    ValidateSignupEmployeeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValidateSignupEmployeeDataQuery,
    ValidateSignupEmployeeDataQueryVariables
  >(ValidateSignupEmployeeDataDocument, options);
}
// @ts-ignore
export function useValidateSignupEmployeeDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidateSignupEmployeeDataQuery,
    ValidateSignupEmployeeDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ValidateSignupEmployeeDataQuery,
  ValidateSignupEmployeeDataQueryVariables
>;
export function useValidateSignupEmployeeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateSignupEmployeeDataQuery,
        ValidateSignupEmployeeDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ValidateSignupEmployeeDataQuery | undefined,
  ValidateSignupEmployeeDataQueryVariables
>;
export function useValidateSignupEmployeeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateSignupEmployeeDataQuery,
        ValidateSignupEmployeeDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ValidateSignupEmployeeDataQuery,
    ValidateSignupEmployeeDataQueryVariables
  >(ValidateSignupEmployeeDataDocument, options);
}
export type ValidateSignupEmployeeDataQueryHookResult = ReturnType<
  typeof useValidateSignupEmployeeDataQuery
>;
export type ValidateSignupEmployeeDataLazyQueryHookResult = ReturnType<
  typeof useValidateSignupEmployeeDataLazyQuery
>;
export type ValidateSignupEmployeeDataSuspenseQueryHookResult = ReturnType<
  typeof useValidateSignupEmployeeDataSuspenseQuery
>;
export type ValidateSignupEmployeeDataQueryResult = Apollo.QueryResult<
  ValidateSignupEmployeeDataQuery,
  ValidateSignupEmployeeDataQueryVariables
>;
export const ValidateSignupEmployeePinOrSsnDocument = gql`
    query ValidateSignupEmployeePinOrSsn($pinOrSsn: String!, $companyType: CompanyType!, $companyId: ID!) {
  validateSignupEmployeePinOrSsn(
    pinOrSsn: $pinOrSsn
    companyType: $companyType
    companyId: $companyId
  ) {
    employeeSignupToken
  }
}
    `;

/**
 * __useValidateSignupEmployeePinOrSsnQuery__
 *
 * To run a query within a React component, call `useValidateSignupEmployeePinOrSsnQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSignupEmployeePinOrSsnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSignupEmployeePinOrSsnQuery({
 *   variables: {
 *      pinOrSsn: // value for 'pinOrSsn'
 *      companyType: // value for 'companyType'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useValidateSignupEmployeePinOrSsnQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateSignupEmployeePinOrSsnQuery,
    ValidateSignupEmployeePinOrSsnQueryVariables
  > &
    (
      | { variables: ValidateSignupEmployeePinOrSsnQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ValidateSignupEmployeePinOrSsnQuery,
    ValidateSignupEmployeePinOrSsnQueryVariables
  >(ValidateSignupEmployeePinOrSsnDocument, options);
}
export function useValidateSignupEmployeePinOrSsnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateSignupEmployeePinOrSsnQuery,
    ValidateSignupEmployeePinOrSsnQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValidateSignupEmployeePinOrSsnQuery,
    ValidateSignupEmployeePinOrSsnQueryVariables
  >(ValidateSignupEmployeePinOrSsnDocument, options);
}
// @ts-ignore
export function useValidateSignupEmployeePinOrSsnSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidateSignupEmployeePinOrSsnQuery,
    ValidateSignupEmployeePinOrSsnQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ValidateSignupEmployeePinOrSsnQuery,
  ValidateSignupEmployeePinOrSsnQueryVariables
>;
export function useValidateSignupEmployeePinOrSsnSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateSignupEmployeePinOrSsnQuery,
        ValidateSignupEmployeePinOrSsnQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ValidateSignupEmployeePinOrSsnQuery | undefined,
  ValidateSignupEmployeePinOrSsnQueryVariables
>;
export function useValidateSignupEmployeePinOrSsnSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateSignupEmployeePinOrSsnQuery,
        ValidateSignupEmployeePinOrSsnQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ValidateSignupEmployeePinOrSsnQuery,
    ValidateSignupEmployeePinOrSsnQueryVariables
  >(ValidateSignupEmployeePinOrSsnDocument, options);
}
export type ValidateSignupEmployeePinOrSsnQueryHookResult = ReturnType<
  typeof useValidateSignupEmployeePinOrSsnQuery
>;
export type ValidateSignupEmployeePinOrSsnLazyQueryHookResult = ReturnType<
  typeof useValidateSignupEmployeePinOrSsnLazyQuery
>;
export type ValidateSignupEmployeePinOrSsnSuspenseQueryHookResult = ReturnType<
  typeof useValidateSignupEmployeePinOrSsnSuspenseQuery
>;
export type ValidateSignupEmployeePinOrSsnQueryResult = Apollo.QueryResult<
  ValidateSignupEmployeePinOrSsnQuery,
  ValidateSignupEmployeePinOrSsnQueryVariables
>;
export const StatesListDocument = gql`
    query StatesList($filter: StateWhere) {
  stateList(where: $filter) {
    ...StatesItem
  }
}
    ${StatesItemFragmentDoc}`;

/**
 * __useStatesListQuery__
 *
 * To run a query within a React component, call `useStatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStatesListQuery(
  baseOptions?: Apollo.QueryHookOptions<StatesListQuery, StatesListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StatesListQuery, StatesListQueryVariables>(StatesListDocument, options);
}
export function useStatesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StatesListQuery, StatesListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StatesListQuery, StatesListQueryVariables>(
    StatesListDocument,
    options,
  );
}
// @ts-ignore
export function useStatesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<StatesListQuery, StatesListQueryVariables>,
): Apollo.UseSuspenseQueryResult<StatesListQuery, StatesListQueryVariables>;
export function useStatesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StatesListQuery, StatesListQueryVariables>,
): Apollo.UseSuspenseQueryResult<StatesListQuery | undefined, StatesListQueryVariables>;
export function useStatesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StatesListQuery, StatesListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StatesListQuery, StatesListQueryVariables>(
    StatesListDocument,
    options,
  );
}
export type StatesListQueryHookResult = ReturnType<typeof useStatesListQuery>;
export type StatesListLazyQueryHookResult = ReturnType<typeof useStatesListLazyQuery>;
export type StatesListSuspenseQueryHookResult = ReturnType<typeof useStatesListSuspenseQuery>;
export type StatesListQueryResult = Apollo.QueryResult<StatesListQuery, StatesListQueryVariables>;
export const StripeGetAccountInfoDocument = gql`
    query StripeGetAccountInfo($stripeAccountId: String) {
  stripeGetAccountInfo(stripeAccountId: $stripeAccountId) {
    status
  }
}
    `;

/**
 * __useStripeGetAccountInfoQuery__
 *
 * To run a query within a React component, call `useStripeGetAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetAccountInfoQuery({
 *   variables: {
 *      stripeAccountId: // value for 'stripeAccountId'
 *   },
 * });
 */
export function useStripeGetAccountInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StripeGetAccountInfoQuery,
    StripeGetAccountInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StripeGetAccountInfoQuery, StripeGetAccountInfoQueryVariables>(
    StripeGetAccountInfoDocument,
    options,
  );
}
export function useStripeGetAccountInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeGetAccountInfoQuery,
    StripeGetAccountInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StripeGetAccountInfoQuery, StripeGetAccountInfoQueryVariables>(
    StripeGetAccountInfoDocument,
    options,
  );
}
// @ts-ignore
export function useStripeGetAccountInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StripeGetAccountInfoQuery,
    StripeGetAccountInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<StripeGetAccountInfoQuery, StripeGetAccountInfoQueryVariables>;
export function useStripeGetAccountInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetAccountInfoQuery,
        StripeGetAccountInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StripeGetAccountInfoQuery | undefined,
  StripeGetAccountInfoQueryVariables
>;
export function useStripeGetAccountInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetAccountInfoQuery,
        StripeGetAccountInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StripeGetAccountInfoQuery, StripeGetAccountInfoQueryVariables>(
    StripeGetAccountInfoDocument,
    options,
  );
}
export type StripeGetAccountInfoQueryHookResult = ReturnType<typeof useStripeGetAccountInfoQuery>;
export type StripeGetAccountInfoLazyQueryHookResult = ReturnType<
  typeof useStripeGetAccountInfoLazyQuery
>;
export type StripeGetAccountInfoSuspenseQueryHookResult = ReturnType<
  typeof useStripeGetAccountInfoSuspenseQuery
>;
export type StripeGetAccountInfoQueryResult = Apollo.QueryResult<
  StripeGetAccountInfoQuery,
  StripeGetAccountInfoQueryVariables
>;
export const StripeCreatePaymentIntentForVerifierDocument = gql`
    mutation StripeCreatePaymentIntentForVerifier($verifierId: ID!, $amount: Float!, $metadata: Json) {
  stripeCreatePaymentIntentForVerifier(
    verifierId: $verifierId
    amount: $amount
    metadata: $metadata
  ) {
    customerId
    paymentIntent
  }
}
    `;
export type StripeCreatePaymentIntentForVerifierMutationFn = Apollo.MutationFunction<
  StripeCreatePaymentIntentForVerifierMutation,
  StripeCreatePaymentIntentForVerifierMutationVariables
>;

/**
 * __useStripeCreatePaymentIntentForVerifierMutation__
 *
 * To run a mutation, you first call `useStripeCreatePaymentIntentForVerifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreatePaymentIntentForVerifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreatePaymentIntentForVerifierMutation, { data, loading, error }] = useStripeCreatePaymentIntentForVerifierMutation({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *      amount: // value for 'amount'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useStripeCreatePaymentIntentForVerifierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeCreatePaymentIntentForVerifierMutation,
    StripeCreatePaymentIntentForVerifierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeCreatePaymentIntentForVerifierMutation,
    StripeCreatePaymentIntentForVerifierMutationVariables
  >(StripeCreatePaymentIntentForVerifierDocument, options);
}
export type StripeCreatePaymentIntentForVerifierMutationHookResult = ReturnType<
  typeof useStripeCreatePaymentIntentForVerifierMutation
>;
export type StripeCreatePaymentIntentForVerifierMutationResult =
  Apollo.MutationResult<StripeCreatePaymentIntentForVerifierMutation>;
export type StripeCreatePaymentIntentForVerifierMutationOptions = Apollo.BaseMutationOptions<
  StripeCreatePaymentIntentForVerifierMutation,
  StripeCreatePaymentIntentForVerifierMutationVariables
>;
export const StripeCreatePaymentIntentForVerifierStaffDocument = gql`
    mutation StripeCreatePaymentIntentForVerifierStaff($verifierStaffId: ID!, $amount: Float!, $metadata: Json) {
  stripeCreatePaymentIntentForVerifierStaff(
    verifierStaffId: $verifierStaffId
    amount: $amount
    metadata: $metadata
  ) {
    customerId
    paymentIntent
  }
}
    `;
export type StripeCreatePaymentIntentForVerifierStaffMutationFn = Apollo.MutationFunction<
  StripeCreatePaymentIntentForVerifierStaffMutation,
  StripeCreatePaymentIntentForVerifierStaffMutationVariables
>;

/**
 * __useStripeCreatePaymentIntentForVerifierStaffMutation__
 *
 * To run a mutation, you first call `useStripeCreatePaymentIntentForVerifierStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreatePaymentIntentForVerifierStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreatePaymentIntentForVerifierStaffMutation, { data, loading, error }] = useStripeCreatePaymentIntentForVerifierStaffMutation({
 *   variables: {
 *      verifierStaffId: // value for 'verifierStaffId'
 *      amount: // value for 'amount'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useStripeCreatePaymentIntentForVerifierStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeCreatePaymentIntentForVerifierStaffMutation,
    StripeCreatePaymentIntentForVerifierStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeCreatePaymentIntentForVerifierStaffMutation,
    StripeCreatePaymentIntentForVerifierStaffMutationVariables
  >(StripeCreatePaymentIntentForVerifierStaffDocument, options);
}
export type StripeCreatePaymentIntentForVerifierStaffMutationHookResult = ReturnType<
  typeof useStripeCreatePaymentIntentForVerifierStaffMutation
>;
export type StripeCreatePaymentIntentForVerifierStaffMutationResult =
  Apollo.MutationResult<StripeCreatePaymentIntentForVerifierStaffMutation>;
export type StripeCreatePaymentIntentForVerifierStaffMutationOptions = Apollo.BaseMutationOptions<
  StripeCreatePaymentIntentForVerifierStaffMutation,
  StripeCreatePaymentIntentForVerifierStaffMutationVariables
>;
export const StripeGetCustomerPaymentMethodsDocument = gql`
    query StripeGetCustomerPaymentMethods($stripeCustomerId: String, $stripeAccountId: String) {
  stripeGetCustomerPaymentMethods(
    stripeCustomerId: $stripeCustomerId
    stripeAccountId: $stripeAccountId
  ) {
    defaultPaymentMethodId
    cardPaymentMethods
    achPaymentMethods
  }
}
    `;

/**
 * __useStripeGetCustomerPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useStripeGetCustomerPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetCustomerPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetCustomerPaymentMethodsQuery({
 *   variables: {
 *      stripeCustomerId: // value for 'stripeCustomerId'
 *      stripeAccountId: // value for 'stripeAccountId'
 *   },
 * });
 */
export function useStripeGetCustomerPaymentMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StripeGetCustomerPaymentMethodsQuery,
    StripeGetCustomerPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StripeGetCustomerPaymentMethodsQuery,
    StripeGetCustomerPaymentMethodsQueryVariables
  >(StripeGetCustomerPaymentMethodsDocument, options);
}
export function useStripeGetCustomerPaymentMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeGetCustomerPaymentMethodsQuery,
    StripeGetCustomerPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StripeGetCustomerPaymentMethodsQuery,
    StripeGetCustomerPaymentMethodsQueryVariables
  >(StripeGetCustomerPaymentMethodsDocument, options);
}
// @ts-ignore
export function useStripeGetCustomerPaymentMethodsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StripeGetCustomerPaymentMethodsQuery,
    StripeGetCustomerPaymentMethodsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  StripeGetCustomerPaymentMethodsQuery,
  StripeGetCustomerPaymentMethodsQueryVariables
>;
export function useStripeGetCustomerPaymentMethodsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetCustomerPaymentMethodsQuery,
        StripeGetCustomerPaymentMethodsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StripeGetCustomerPaymentMethodsQuery | undefined,
  StripeGetCustomerPaymentMethodsQueryVariables
>;
export function useStripeGetCustomerPaymentMethodsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetCustomerPaymentMethodsQuery,
        StripeGetCustomerPaymentMethodsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StripeGetCustomerPaymentMethodsQuery,
    StripeGetCustomerPaymentMethodsQueryVariables
  >(StripeGetCustomerPaymentMethodsDocument, options);
}
export type StripeGetCustomerPaymentMethodsQueryHookResult = ReturnType<
  typeof useStripeGetCustomerPaymentMethodsQuery
>;
export type StripeGetCustomerPaymentMethodsLazyQueryHookResult = ReturnType<
  typeof useStripeGetCustomerPaymentMethodsLazyQuery
>;
export type StripeGetCustomerPaymentMethodsSuspenseQueryHookResult = ReturnType<
  typeof useStripeGetCustomerPaymentMethodsSuspenseQuery
>;
export type StripeGetCustomerPaymentMethodsQueryResult = Apollo.QueryResult<
  StripeGetCustomerPaymentMethodsQuery,
  StripeGetCustomerPaymentMethodsQueryVariables
>;
export const StripeCreateSetupIntentDocument = gql`
    mutation StripeCreateSetupIntent {
  stripeCreateSetupIntent {
    clientSecret
  }
}
    `;
export type StripeCreateSetupIntentMutationFn = Apollo.MutationFunction<
  StripeCreateSetupIntentMutation,
  StripeCreateSetupIntentMutationVariables
>;

/**
 * __useStripeCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useStripeCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreateSetupIntentMutation, { data, loading, error }] = useStripeCreateSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useStripeCreateSetupIntentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeCreateSetupIntentMutation,
    StripeCreateSetupIntentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeCreateSetupIntentMutation,
    StripeCreateSetupIntentMutationVariables
  >(StripeCreateSetupIntentDocument, options);
}
export type StripeCreateSetupIntentMutationHookResult = ReturnType<
  typeof useStripeCreateSetupIntentMutation
>;
export type StripeCreateSetupIntentMutationResult =
  Apollo.MutationResult<StripeCreateSetupIntentMutation>;
export type StripeCreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<
  StripeCreateSetupIntentMutation,
  StripeCreateSetupIntentMutationVariables
>;
export const StripeUpdateCustomerDefaultPaymentMethodDocument = gql`
    mutation StripeUpdateCustomerDefaultPaymentMethod($customerId: String!, $defaultPaymentMethodId: String!, $connectedStripeAccountId: String) {
  stripeUpdateCustomerDefaultPaymentMethod(
    customerId: $customerId
    defaultPaymentMethodId: $defaultPaymentMethodId
    connectedStripeAccountId: $connectedStripeAccountId
  ) {
    defaultPaymentMethodId
    success
  }
}
    `;
export type StripeUpdateCustomerDefaultPaymentMethodMutationFn = Apollo.MutationFunction<
  StripeUpdateCustomerDefaultPaymentMethodMutation,
  StripeUpdateCustomerDefaultPaymentMethodMutationVariables
>;

/**
 * __useStripeUpdateCustomerDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useStripeUpdateCustomerDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeUpdateCustomerDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeUpdateCustomerDefaultPaymentMethodMutation, { data, loading, error }] = useStripeUpdateCustomerDefaultPaymentMethodMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      defaultPaymentMethodId: // value for 'defaultPaymentMethodId'
 *      connectedStripeAccountId: // value for 'connectedStripeAccountId'
 *   },
 * });
 */
export function useStripeUpdateCustomerDefaultPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeUpdateCustomerDefaultPaymentMethodMutation,
    StripeUpdateCustomerDefaultPaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeUpdateCustomerDefaultPaymentMethodMutation,
    StripeUpdateCustomerDefaultPaymentMethodMutationVariables
  >(StripeUpdateCustomerDefaultPaymentMethodDocument, options);
}
export type StripeUpdateCustomerDefaultPaymentMethodMutationHookResult = ReturnType<
  typeof useStripeUpdateCustomerDefaultPaymentMethodMutation
>;
export type StripeUpdateCustomerDefaultPaymentMethodMutationResult =
  Apollo.MutationResult<StripeUpdateCustomerDefaultPaymentMethodMutation>;
export type StripeUpdateCustomerDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  StripeUpdateCustomerDefaultPaymentMethodMutation,
  StripeUpdateCustomerDefaultPaymentMethodMutationVariables
>;
export const StripeDetachPaymentMethodDocument = gql`
    mutation StripeDetachPaymentMethod($paymentMethodId: String!, $connectedStripeAccountId: String) {
  stripeDetachPaymentMethod(
    paymentMethodId: $paymentMethodId
    connectedStripeAccountId: $connectedStripeAccountId
  ) {
    success
  }
}
    `;
export type StripeDetachPaymentMethodMutationFn = Apollo.MutationFunction<
  StripeDetachPaymentMethodMutation,
  StripeDetachPaymentMethodMutationVariables
>;

/**
 * __useStripeDetachPaymentMethodMutation__
 *
 * To run a mutation, you first call `useStripeDetachPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeDetachPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeDetachPaymentMethodMutation, { data, loading, error }] = useStripeDetachPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      connectedStripeAccountId: // value for 'connectedStripeAccountId'
 *   },
 * });
 */
export function useStripeDetachPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeDetachPaymentMethodMutation,
    StripeDetachPaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeDetachPaymentMethodMutation,
    StripeDetachPaymentMethodMutationVariables
  >(StripeDetachPaymentMethodDocument, options);
}
export type StripeDetachPaymentMethodMutationHookResult = ReturnType<
  typeof useStripeDetachPaymentMethodMutation
>;
export type StripeDetachPaymentMethodMutationResult =
  Apollo.MutationResult<StripeDetachPaymentMethodMutation>;
export type StripeDetachPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  StripeDetachPaymentMethodMutation,
  StripeDetachPaymentMethodMutationVariables
>;
export const StripeGetPaymentHistoryDocument = gql`
    query StripeGetPaymentHistory($verifierId: ID, $limit: Int, $pageId: String) {
  stripeGetPaymentHistory(verifierId: $verifierId, limit: $limit, pageId: $pageId) {
    paymentHistoryCharges {
      ...StripeBillingTransactionInfo
    }
    nextPageId
  }
}
    ${StripeBillingTransactionInfoFragmentDoc}`;

/**
 * __useStripeGetPaymentHistoryQuery__
 *
 * To run a query within a React component, call `useStripeGetPaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetPaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetPaymentHistoryQuery({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *      limit: // value for 'limit'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useStripeGetPaymentHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StripeGetPaymentHistoryQuery,
    StripeGetPaymentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StripeGetPaymentHistoryQuery, StripeGetPaymentHistoryQueryVariables>(
    StripeGetPaymentHistoryDocument,
    options,
  );
}
export function useStripeGetPaymentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeGetPaymentHistoryQuery,
    StripeGetPaymentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StripeGetPaymentHistoryQuery, StripeGetPaymentHistoryQueryVariables>(
    StripeGetPaymentHistoryDocument,
    options,
  );
}
// @ts-ignore
export function useStripeGetPaymentHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StripeGetPaymentHistoryQuery,
    StripeGetPaymentHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  StripeGetPaymentHistoryQuery,
  StripeGetPaymentHistoryQueryVariables
>;
export function useStripeGetPaymentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetPaymentHistoryQuery,
        StripeGetPaymentHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StripeGetPaymentHistoryQuery | undefined,
  StripeGetPaymentHistoryQueryVariables
>;
export function useStripeGetPaymentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetPaymentHistoryQuery,
        StripeGetPaymentHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StripeGetPaymentHistoryQuery,
    StripeGetPaymentHistoryQueryVariables
  >(StripeGetPaymentHistoryDocument, options);
}
export type StripeGetPaymentHistoryQueryHookResult = ReturnType<
  typeof useStripeGetPaymentHistoryQuery
>;
export type StripeGetPaymentHistoryLazyQueryHookResult = ReturnType<
  typeof useStripeGetPaymentHistoryLazyQuery
>;
export type StripeGetPaymentHistorySuspenseQueryHookResult = ReturnType<
  typeof useStripeGetPaymentHistorySuspenseQuery
>;
export type StripeGetPaymentHistoryQueryResult = Apollo.QueryResult<
  StripeGetPaymentHistoryQuery,
  StripeGetPaymentHistoryQueryVariables
>;
export const StripeGetPaymentIntentForVerificationRequestDocument = gql`
    query StripeGetPaymentIntentForVerificationRequest($inboxItemId: ID!) {
  stripeGetPaymentIntentForVerificationRequest(inboxItemId: $inboxItemId) {
    paymentIntentId
    paymentMethod
  }
}
    `;

/**
 * __useStripeGetPaymentIntentForVerificationRequestQuery__
 *
 * To run a query within a React component, call `useStripeGetPaymentIntentForVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetPaymentIntentForVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetPaymentIntentForVerificationRequestQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useStripeGetPaymentIntentForVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    StripeGetPaymentIntentForVerificationRequestQuery,
    StripeGetPaymentIntentForVerificationRequestQueryVariables
  > &
    (
      | { variables: StripeGetPaymentIntentForVerificationRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StripeGetPaymentIntentForVerificationRequestQuery,
    StripeGetPaymentIntentForVerificationRequestQueryVariables
  >(StripeGetPaymentIntentForVerificationRequestDocument, options);
}
export function useStripeGetPaymentIntentForVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeGetPaymentIntentForVerificationRequestQuery,
    StripeGetPaymentIntentForVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StripeGetPaymentIntentForVerificationRequestQuery,
    StripeGetPaymentIntentForVerificationRequestQueryVariables
  >(StripeGetPaymentIntentForVerificationRequestDocument, options);
}
// @ts-ignore
export function useStripeGetPaymentIntentForVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StripeGetPaymentIntentForVerificationRequestQuery,
    StripeGetPaymentIntentForVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  StripeGetPaymentIntentForVerificationRequestQuery,
  StripeGetPaymentIntentForVerificationRequestQueryVariables
>;
export function useStripeGetPaymentIntentForVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetPaymentIntentForVerificationRequestQuery,
        StripeGetPaymentIntentForVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StripeGetPaymentIntentForVerificationRequestQuery | undefined,
  StripeGetPaymentIntentForVerificationRequestQueryVariables
>;
export function useStripeGetPaymentIntentForVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeGetPaymentIntentForVerificationRequestQuery,
        StripeGetPaymentIntentForVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StripeGetPaymentIntentForVerificationRequestQuery,
    StripeGetPaymentIntentForVerificationRequestQueryVariables
  >(StripeGetPaymentIntentForVerificationRequestDocument, options);
}
export type StripeGetPaymentIntentForVerificationRequestQueryHookResult = ReturnType<
  typeof useStripeGetPaymentIntentForVerificationRequestQuery
>;
export type StripeGetPaymentIntentForVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useStripeGetPaymentIntentForVerificationRequestLazyQuery
>;
export type StripeGetPaymentIntentForVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useStripeGetPaymentIntentForVerificationRequestSuspenseQuery
>;
export type StripeGetPaymentIntentForVerificationRequestQueryResult = Apollo.QueryResult<
  StripeGetPaymentIntentForVerificationRequestQuery,
  StripeGetPaymentIntentForVerificationRequestQueryVariables
>;
export const StripeUpdatePaymentMethodForVerificationRequestDocument = gql`
    mutation StripeUpdatePaymentMethodForVerificationRequest($inboxItemId: ID!, $paymentMethodId: String!) {
  stripeUpdatePaymentMethodForVerificationRequest(
    inboxItemId: $inboxItemId
    paymentMethodId: $paymentMethodId
  ) {
    success
    redirectUrl
  }
}
    `;
export type StripeUpdatePaymentMethodForVerificationRequestMutationFn = Apollo.MutationFunction<
  StripeUpdatePaymentMethodForVerificationRequestMutation,
  StripeUpdatePaymentMethodForVerificationRequestMutationVariables
>;

/**
 * __useStripeUpdatePaymentMethodForVerificationRequestMutation__
 *
 * To run a mutation, you first call `useStripeUpdatePaymentMethodForVerificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeUpdatePaymentMethodForVerificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeUpdatePaymentMethodForVerificationRequestMutation, { data, loading, error }] = useStripeUpdatePaymentMethodForVerificationRequestMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStripeUpdatePaymentMethodForVerificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeUpdatePaymentMethodForVerificationRequestMutation,
    StripeUpdatePaymentMethodForVerificationRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeUpdatePaymentMethodForVerificationRequestMutation,
    StripeUpdatePaymentMethodForVerificationRequestMutationVariables
  >(StripeUpdatePaymentMethodForVerificationRequestDocument, options);
}
export type StripeUpdatePaymentMethodForVerificationRequestMutationHookResult = ReturnType<
  typeof useStripeUpdatePaymentMethodForVerificationRequestMutation
>;
export type StripeUpdatePaymentMethodForVerificationRequestMutationResult =
  Apollo.MutationResult<StripeUpdatePaymentMethodForVerificationRequestMutation>;
export type StripeUpdatePaymentMethodForVerificationRequestMutationOptions =
  Apollo.BaseMutationOptions<
    StripeUpdatePaymentMethodForVerificationRequestMutation,
    StripeUpdatePaymentMethodForVerificationRequestMutationVariables
  >;
export const StripeRefundChargeDocument = gql`
    mutation StripeRefundCharge($stripeChargeId: String!) {
  stripeRefundCharge(stripeChargeId: $stripeChargeId) {
    success
  }
}
    `;
export type StripeRefundChargeMutationFn = Apollo.MutationFunction<
  StripeRefundChargeMutation,
  StripeRefundChargeMutationVariables
>;

/**
 * __useStripeRefundChargeMutation__
 *
 * To run a mutation, you first call `useStripeRefundChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeRefundChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeRefundChargeMutation, { data, loading, error }] = useStripeRefundChargeMutation({
 *   variables: {
 *      stripeChargeId: // value for 'stripeChargeId'
 *   },
 * });
 */
export function useStripeRefundChargeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeRefundChargeMutation,
    StripeRefundChargeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StripeRefundChargeMutation, StripeRefundChargeMutationVariables>(
    StripeRefundChargeDocument,
    options,
  );
}
export type StripeRefundChargeMutationHookResult = ReturnType<typeof useStripeRefundChargeMutation>;
export type StripeRefundChargeMutationResult = Apollo.MutationResult<StripeRefundChargeMutation>;
export type StripeRefundChargeMutationOptions = Apollo.BaseMutationOptions<
  StripeRefundChargeMutation,
  StripeRefundChargeMutationVariables
>;
export const StripeRefundVerificationRequestChargeDocument = gql`
    mutation StripeRefundVerificationRequestCharge($inboxItemId: ID!) {
  stripeRefundVerificationRequestCharge(inboxItemId: $inboxItemId) {
    success
  }
}
    `;
export type StripeRefundVerificationRequestChargeMutationFn = Apollo.MutationFunction<
  StripeRefundVerificationRequestChargeMutation,
  StripeRefundVerificationRequestChargeMutationVariables
>;

/**
 * __useStripeRefundVerificationRequestChargeMutation__
 *
 * To run a mutation, you first call `useStripeRefundVerificationRequestChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeRefundVerificationRequestChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeRefundVerificationRequestChargeMutation, { data, loading, error }] = useStripeRefundVerificationRequestChargeMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useStripeRefundVerificationRequestChargeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StripeRefundVerificationRequestChargeMutation,
    StripeRefundVerificationRequestChargeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StripeRefundVerificationRequestChargeMutation,
    StripeRefundVerificationRequestChargeMutationVariables
  >(StripeRefundVerificationRequestChargeDocument, options);
}
export type StripeRefundVerificationRequestChargeMutationHookResult = ReturnType<
  typeof useStripeRefundVerificationRequestChargeMutation
>;
export type StripeRefundVerificationRequestChargeMutationResult =
  Apollo.MutationResult<StripeRefundVerificationRequestChargeMutation>;
export type StripeRefundVerificationRequestChargeMutationOptions = Apollo.BaseMutationOptions<
  StripeRefundVerificationRequestChargeMutation,
  StripeRefundVerificationRequestChargeMutationVariables
>;
export const CreateTestVerificationRequestDocument = gql`
    mutation CreateTestVerificationRequest($ssn: String!, $employeeFirstName: String, $employeeLastName: String, $employeeBirthDate: Date!, $requestType: [VerificationRequestType!]!, $companies: [VerificationRequestCompanyData!]!) {
  createTestVerificationRequest(
    ssn: $ssn
    employeeFirstName: $employeeFirstName
    employeeLastName: $employeeLastName
    employeeBirthDate: $employeeBirthDate
    requestType: $requestType
    companies: $companies
  ) {
    success
    inboxItemId
  }
}
    `;
export type CreateTestVerificationRequestMutationFn = Apollo.MutationFunction<
  CreateTestVerificationRequestMutation,
  CreateTestVerificationRequestMutationVariables
>;

/**
 * __useCreateTestVerificationRequestMutation__
 *
 * To run a mutation, you first call `useCreateTestVerificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestVerificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestVerificationRequestMutation, { data, loading, error }] = useCreateTestVerificationRequestMutation({
 *   variables: {
 *      ssn: // value for 'ssn'
 *      employeeFirstName: // value for 'employeeFirstName'
 *      employeeLastName: // value for 'employeeLastName'
 *      employeeBirthDate: // value for 'employeeBirthDate'
 *      requestType: // value for 'requestType'
 *      companies: // value for 'companies'
 *   },
 * });
 */
export function useCreateTestVerificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTestVerificationRequestMutation,
    CreateTestVerificationRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTestVerificationRequestMutation,
    CreateTestVerificationRequestMutationVariables
  >(CreateTestVerificationRequestDocument, options);
}
export type CreateTestVerificationRequestMutationHookResult = ReturnType<
  typeof useCreateTestVerificationRequestMutation
>;
export type CreateTestVerificationRequestMutationResult =
  Apollo.MutationResult<CreateTestVerificationRequestMutation>;
export type CreateTestVerificationRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateTestVerificationRequestMutation,
  CreateTestVerificationRequestMutationVariables
>;
export const TestVerificationRequestDocument = gql`
    query TestVerificationRequest($inboxItemId: ID!) {
  testVerificationRequest(where: {inboxItemId: $inboxItemId}) {
    ...TestVerificationRequestInfo
  }
}
    ${TestVerificationRequestInfoFragmentDoc}`;

/**
 * __useTestVerificationRequestQuery__
 *
 * To run a query within a React component, call `useTestVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestVerificationRequestQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useTestVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    TestVerificationRequestQuery,
    TestVerificationRequestQueryVariables
  > &
    ({ variables: TestVerificationRequestQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestVerificationRequestQuery, TestVerificationRequestQueryVariables>(
    TestVerificationRequestDocument,
    options,
  );
}
export function useTestVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestVerificationRequestQuery,
    TestVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestVerificationRequestQuery, TestVerificationRequestQueryVariables>(
    TestVerificationRequestDocument,
    options,
  );
}
// @ts-ignore
export function useTestVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TestVerificationRequestQuery,
    TestVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TestVerificationRequestQuery,
  TestVerificationRequestQueryVariables
>;
export function useTestVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestVerificationRequestQuery,
        TestVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TestVerificationRequestQuery | undefined,
  TestVerificationRequestQueryVariables
>;
export function useTestVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestVerificationRequestQuery,
        TestVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TestVerificationRequestQuery,
    TestVerificationRequestQueryVariables
  >(TestVerificationRequestDocument, options);
}
export type TestVerificationRequestQueryHookResult = ReturnType<
  typeof useTestVerificationRequestQuery
>;
export type TestVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useTestVerificationRequestLazyQuery
>;
export type TestVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useTestVerificationRequestSuspenseQuery
>;
export type TestVerificationRequestQueryResult = Apollo.QueryResult<
  TestVerificationRequestQuery,
  TestVerificationRequestQueryVariables
>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...CurrentUserBaseInfo
  }
}
    ${CurrentUserBaseInfoFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<
  CurrentUserQuery,
  CurrentUserQueryVariables
>;
export const UserByIdDocument = gql`
    query UserById($id: ID!) {
  user(where: {id: $id}) {
    ...UserItem
  }
}
    ${UserItemFragmentDoc}`;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables> &
    ({ variables: UserByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
}
export function useUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
}
// @ts-ignore
export function useUserByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserByIdQuery, UserByIdQueryVariables>;
export function useUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserByIdQuery | undefined, UserByIdQueryVariables>;
export function useUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
}
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdSuspenseQueryHookResult = ReturnType<typeof useUserByIdSuspenseQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const EmployeeInviteIdDocument = gql`
    query EmployeeInviteId($userId: ID!) {
  getEmployeeInviteId(userId: $userId)
}
    `;

/**
 * __useEmployeeInviteIdQuery__
 *
 * To run a query within a React component, call `useEmployeeInviteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeInviteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeInviteIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEmployeeInviteIdQuery(
  baseOptions: Apollo.QueryHookOptions<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables> &
    ({ variables: EmployeeInviteIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>(
    EmployeeInviteIdDocument,
    options,
  );
}
export function useEmployeeInviteIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>(
    EmployeeInviteIdDocument,
    options,
  );
}
// @ts-ignore
export function useEmployeeInviteIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EmployeeInviteIdQuery,
    EmployeeInviteIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>;
export function useEmployeeInviteIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<EmployeeInviteIdQuery | undefined, EmployeeInviteIdQueryVariables>;
export function useEmployeeInviteIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EmployeeInviteIdQuery, EmployeeInviteIdQueryVariables>(
    EmployeeInviteIdDocument,
    options,
  );
}
export type EmployeeInviteIdQueryHookResult = ReturnType<typeof useEmployeeInviteIdQuery>;
export type EmployeeInviteIdLazyQueryHookResult = ReturnType<typeof useEmployeeInviteIdLazyQuery>;
export type EmployeeInviteIdSuspenseQueryHookResult = ReturnType<
  typeof useEmployeeInviteIdSuspenseQuery
>;
export type EmployeeInviteIdQueryResult = Apollo.QueryResult<
  EmployeeInviteIdQuery,
  EmployeeInviteIdQueryVariables
>;
export const UserAvatarDocument = gql`
    query UserAvatar($id: ID!) {
  user(where: {id: $id}) {
    id
    avatar {
      ...FileInfo
    }
  }
}
    ${FileInfoFragmentDoc}`;

/**
 * __useUserAvatarQuery__
 *
 * To run a query within a React component, call `useUserAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvatarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserAvatarQuery(
  baseOptions: Apollo.QueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables> &
    ({ variables: UserAvatarQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserAvatarQuery, UserAvatarQueryVariables>(UserAvatarDocument, options);
}
export function useUserAvatarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserAvatarQuery, UserAvatarQueryVariables>(
    UserAvatarDocument,
    options,
  );
}
// @ts-ignore
export function useUserAvatarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserAvatarQuery, UserAvatarQueryVariables>;
export function useUserAvatarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserAvatarQuery | undefined, UserAvatarQueryVariables>;
export function useUserAvatarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserAvatarQuery, UserAvatarQueryVariables>(
    UserAvatarDocument,
    options,
  );
}
export type UserAvatarQueryHookResult = ReturnType<typeof useUserAvatarQuery>;
export type UserAvatarLazyQueryHookResult = ReturnType<typeof useUserAvatarLazyQuery>;
export type UserAvatarSuspenseQueryHookResult = ReturnType<typeof useUserAvatarSuspenseQuery>;
export type UserAvatarQueryResult = Apollo.QueryResult<UserAvatarQuery, UserAvatarQueryVariables>;
export const UserNotificationSettingsDocument = gql`
    query UserNotificationSettings($where: UserWhereUnique!) {
  user(where: $where) {
    id
    notificationSettings
  }
}
    `;

/**
 * __useUserNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useUserNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationSettingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserNotificationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserNotificationSettingsQuery,
    UserNotificationSettingsQueryVariables
  > &
    ({ variables: UserNotificationSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserNotificationSettingsQuery, UserNotificationSettingsQueryVariables>(
    UserNotificationSettingsDocument,
    options,
  );
}
export function useUserNotificationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserNotificationSettingsQuery,
    UserNotificationSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserNotificationSettingsQuery, UserNotificationSettingsQueryVariables>(
    UserNotificationSettingsDocument,
    options,
  );
}
// @ts-ignore
export function useUserNotificationSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserNotificationSettingsQuery,
    UserNotificationSettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserNotificationSettingsQuery,
  UserNotificationSettingsQueryVariables
>;
export function useUserNotificationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserNotificationSettingsQuery,
        UserNotificationSettingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserNotificationSettingsQuery | undefined,
  UserNotificationSettingsQueryVariables
>;
export function useUserNotificationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserNotificationSettingsQuery,
        UserNotificationSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserNotificationSettingsQuery,
    UserNotificationSettingsQueryVariables
  >(UserNotificationSettingsDocument, options);
}
export type UserNotificationSettingsQueryHookResult = ReturnType<
  typeof useUserNotificationSettingsQuery
>;
export type UserNotificationSettingsLazyQueryHookResult = ReturnType<
  typeof useUserNotificationSettingsLazyQuery
>;
export type UserNotificationSettingsSuspenseQueryHookResult = ReturnType<
  typeof useUserNotificationSettingsSuspenseQuery
>;
export type UserNotificationSettingsQueryResult = Apollo.QueryResult<
  UserNotificationSettingsQuery,
  UserNotificationSettingsQueryVariables
>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($data: UserUpdate!, $where: UserWhereUnique!) {
  userUpdate(data: $data, where: $where) {
    id
    status
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const UpdateUserNotificationSettingsDocument = gql`
    mutation UpdateUserNotificationSettings($data: UserUpdate!, $where: UserWhereUnique!) {
  userUpdate(data: $data, where: $where) {
    id
    notificationSettings
  }
}
    `;
export type UpdateUserNotificationSettingsMutationFn = Apollo.MutationFunction<
  UpdateUserNotificationSettingsMutation,
  UpdateUserNotificationSettingsMutationVariables
>;

/**
 * __useUpdateUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationSettingsMutation, { data, loading, error }] = useUpdateUserNotificationSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateUserNotificationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserNotificationSettingsMutation,
    UpdateUserNotificationSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserNotificationSettingsMutation,
    UpdateUserNotificationSettingsMutationVariables
  >(UpdateUserNotificationSettingsDocument, options);
}
export type UpdateUserNotificationSettingsMutationHookResult = ReturnType<
  typeof useUpdateUserNotificationSettingsMutation
>;
export type UpdateUserNotificationSettingsMutationResult =
  Apollo.MutationResult<UpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserNotificationSettingsMutation,
  UpdateUserNotificationSettingsMutationVariables
>;
export const CreateUserPasswordChangeRequestDocument = gql`
    mutation CreateUserPasswordChangeRequest {
  createUserPasswordChangeRequest {
    success
  }
}
    `;
export type CreateUserPasswordChangeRequestMutationFn = Apollo.MutationFunction<
  CreateUserPasswordChangeRequestMutation,
  CreateUserPasswordChangeRequestMutationVariables
>;

/**
 * __useCreateUserPasswordChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateUserPasswordChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPasswordChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPasswordChangeRequestMutation, { data, loading, error }] = useCreateUserPasswordChangeRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateUserPasswordChangeRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserPasswordChangeRequestMutation,
    CreateUserPasswordChangeRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserPasswordChangeRequestMutation,
    CreateUserPasswordChangeRequestMutationVariables
  >(CreateUserPasswordChangeRequestDocument, options);
}
export type CreateUserPasswordChangeRequestMutationHookResult = ReturnType<
  typeof useCreateUserPasswordChangeRequestMutation
>;
export type CreateUserPasswordChangeRequestMutationResult =
  Apollo.MutationResult<CreateUserPasswordChangeRequestMutation>;
export type CreateUserPasswordChangeRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateUserPasswordChangeRequestMutation,
  CreateUserPasswordChangeRequestMutationVariables
>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($currentPassword: String!, $newPassword: String!, $mfaSession: String, $mfaCode: String, $userPasswordChangeRequestId: ID!) {
  changeUserPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
    mfaSession: $mfaSession
    mfaCode: $mfaCode
    userPasswordChangeRequestId: $userPasswordChangeRequestId
  ) {
    success
    mfaSession
  }
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<
  ChangeUserPasswordMutation,
  ChangeUserPasswordMutationVariables
>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *      mfaSession: // value for 'mfaSession'
 *      mfaCode: // value for 'mfaCode'
 *      userPasswordChangeRequestId: // value for 'userPasswordChangeRequestId'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeUserPasswordMutation,
    ChangeUserPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(
    ChangeUserPasswordDocument,
    options,
  );
}
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangeUserPasswordMutation,
  ChangeUserPasswordMutationVariables
>;
export const CreateUserPasswordResetRequestDocument = gql`
    mutation CreateUserPasswordResetRequest($email: String!) {
  createUserPasswordResetRequest(email: $email) {
    success
  }
}
    `;
export type CreateUserPasswordResetRequestMutationFn = Apollo.MutationFunction<
  CreateUserPasswordResetRequestMutation,
  CreateUserPasswordResetRequestMutationVariables
>;

/**
 * __useCreateUserPasswordResetRequestMutation__
 *
 * To run a mutation, you first call `useCreateUserPasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPasswordResetRequestMutation, { data, loading, error }] = useCreateUserPasswordResetRequestMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateUserPasswordResetRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserPasswordResetRequestMutation,
    CreateUserPasswordResetRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserPasswordResetRequestMutation,
    CreateUserPasswordResetRequestMutationVariables
  >(CreateUserPasswordResetRequestDocument, options);
}
export type CreateUserPasswordResetRequestMutationHookResult = ReturnType<
  typeof useCreateUserPasswordResetRequestMutation
>;
export type CreateUserPasswordResetRequestMutationResult =
  Apollo.MutationResult<CreateUserPasswordResetRequestMutation>;
export type CreateUserPasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateUserPasswordResetRequestMutation,
  CreateUserPasswordResetRequestMutationVariables
>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($newPassword: String!, $userPasswordResetRequestId: ID!) {
  resetUserPassword(
    newPassword: $newPassword
    userPasswordResetRequestId: $userPasswordResetRequestId
  ) {
    success
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      userPasswordResetRequestId: // value for 'userPasswordResetRequestId'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(
    ResetUserPasswordDocument,
    options,
  );
}
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const CheckPasswordRequestExistDocument = gql`
    query CheckPasswordRequestExist($requestId: ID!, $requestType: PasswordRequestType!) {
  checkPasswordRequestExist(requestId: $requestId, requestType: $requestType) {
    success
  }
}
    `;

/**
 * __useCheckPasswordRequestExistQuery__
 *
 * To run a query within a React component, call `useCheckPasswordRequestExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPasswordRequestExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPasswordRequestExistQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      requestType: // value for 'requestType'
 *   },
 * });
 */
export function useCheckPasswordRequestExistQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckPasswordRequestExistQuery,
    CheckPasswordRequestExistQueryVariables
  > &
    ({ variables: CheckPasswordRequestExistQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckPasswordRequestExistQuery, CheckPasswordRequestExistQueryVariables>(
    CheckPasswordRequestExistDocument,
    options,
  );
}
export function useCheckPasswordRequestExistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckPasswordRequestExistQuery,
    CheckPasswordRequestExistQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckPasswordRequestExistQuery,
    CheckPasswordRequestExistQueryVariables
  >(CheckPasswordRequestExistDocument, options);
}
// @ts-ignore
export function useCheckPasswordRequestExistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckPasswordRequestExistQuery,
    CheckPasswordRequestExistQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckPasswordRequestExistQuery,
  CheckPasswordRequestExistQueryVariables
>;
export function useCheckPasswordRequestExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckPasswordRequestExistQuery,
        CheckPasswordRequestExistQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckPasswordRequestExistQuery | undefined,
  CheckPasswordRequestExistQueryVariables
>;
export function useCheckPasswordRequestExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckPasswordRequestExistQuery,
        CheckPasswordRequestExistQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckPasswordRequestExistQuery,
    CheckPasswordRequestExistQueryVariables
  >(CheckPasswordRequestExistDocument, options);
}
export type CheckPasswordRequestExistQueryHookResult = ReturnType<
  typeof useCheckPasswordRequestExistQuery
>;
export type CheckPasswordRequestExistLazyQueryHookResult = ReturnType<
  typeof useCheckPasswordRequestExistLazyQuery
>;
export type CheckPasswordRequestExistSuspenseQueryHookResult = ReturnType<
  typeof useCheckPasswordRequestExistSuspenseQuery
>;
export type CheckPasswordRequestExistQueryResult = Apollo.QueryResult<
  CheckPasswordRequestExistQuery,
  CheckPasswordRequestExistQueryVariables
>;
export const UserRegistrationVerifierAdminDocument = gql`
    mutation UserRegistrationVerifierAdmin($user: VerifierAdminUserData!, $verifier: VerifierAdminVerifierData!, $emailConfirmationCode: String!) {
  userRegistrationVerifierAdmin(
    user: $user
    verifier: $verifier
    emailConfirmationCode: $emailConfirmationCode
  ) {
    idToken
    accessToken
  }
}
    `;
export type UserRegistrationVerifierAdminMutationFn = Apollo.MutationFunction<
  UserRegistrationVerifierAdminMutation,
  UserRegistrationVerifierAdminMutationVariables
>;

/**
 * __useUserRegistrationVerifierAdminMutation__
 *
 * To run a mutation, you first call `useUserRegistrationVerifierAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationVerifierAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRegistrationVerifierAdminMutation, { data, loading, error }] = useUserRegistrationVerifierAdminMutation({
 *   variables: {
 *      user: // value for 'user'
 *      verifier: // value for 'verifier'
 *      emailConfirmationCode: // value for 'emailConfirmationCode'
 *   },
 * });
 */
export function useUserRegistrationVerifierAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserRegistrationVerifierAdminMutation,
    UserRegistrationVerifierAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserRegistrationVerifierAdminMutation,
    UserRegistrationVerifierAdminMutationVariables
  >(UserRegistrationVerifierAdminDocument, options);
}
export type UserRegistrationVerifierAdminMutationHookResult = ReturnType<
  typeof useUserRegistrationVerifierAdminMutation
>;
export type UserRegistrationVerifierAdminMutationResult =
  Apollo.MutationResult<UserRegistrationVerifierAdminMutation>;
export type UserRegistrationVerifierAdminMutationOptions = Apollo.BaseMutationOptions<
  UserRegistrationVerifierAdminMutation,
  UserRegistrationVerifierAdminMutationVariables
>;
export const UserRegistrationVerifierManagerDocument = gql`
    mutation UserRegistrationVerifierManager($verifierId: ID!, $user: VerifierManagerUserData!, $emailConfirmationCode: String!) {
  userRegistrationVerifierManager(
    verifierId: $verifierId
    user: $user
    emailConfirmationCode: $emailConfirmationCode
  ) {
    idToken
    accessToken
  }
}
    `;
export type UserRegistrationVerifierManagerMutationFn = Apollo.MutationFunction<
  UserRegistrationVerifierManagerMutation,
  UserRegistrationVerifierManagerMutationVariables
>;

/**
 * __useUserRegistrationVerifierManagerMutation__
 *
 * To run a mutation, you first call `useUserRegistrationVerifierManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationVerifierManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRegistrationVerifierManagerMutation, { data, loading, error }] = useUserRegistrationVerifierManagerMutation({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *      user: // value for 'user'
 *      emailConfirmationCode: // value for 'emailConfirmationCode'
 *   },
 * });
 */
export function useUserRegistrationVerifierManagerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserRegistrationVerifierManagerMutation,
    UserRegistrationVerifierManagerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserRegistrationVerifierManagerMutation,
    UserRegistrationVerifierManagerMutationVariables
  >(UserRegistrationVerifierManagerDocument, options);
}
export type UserRegistrationVerifierManagerMutationHookResult = ReturnType<
  typeof useUserRegistrationVerifierManagerMutation
>;
export type UserRegistrationVerifierManagerMutationResult =
  Apollo.MutationResult<UserRegistrationVerifierManagerMutation>;
export type UserRegistrationVerifierManagerMutationOptions = Apollo.BaseMutationOptions<
  UserRegistrationVerifierManagerMutation,
  UserRegistrationVerifierManagerMutationVariables
>;
export const SendRequestAccountIsFrozenDocument = gql`
    mutation SendRequestAccountIsFrozen($employeeId: ID!) {
  sendRequestAccountIsFrozen(employeeId: $employeeId) {
    success
  }
}
    `;
export type SendRequestAccountIsFrozenMutationFn = Apollo.MutationFunction<
  SendRequestAccountIsFrozenMutation,
  SendRequestAccountIsFrozenMutationVariables
>;

/**
 * __useSendRequestAccountIsFrozenMutation__
 *
 * To run a mutation, you first call `useSendRequestAccountIsFrozenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRequestAccountIsFrozenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRequestAccountIsFrozenMutation, { data, loading, error }] = useSendRequestAccountIsFrozenMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useSendRequestAccountIsFrozenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendRequestAccountIsFrozenMutation,
    SendRequestAccountIsFrozenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendRequestAccountIsFrozenMutation,
    SendRequestAccountIsFrozenMutationVariables
  >(SendRequestAccountIsFrozenDocument, options);
}
export type SendRequestAccountIsFrozenMutationHookResult = ReturnType<
  typeof useSendRequestAccountIsFrozenMutation
>;
export type SendRequestAccountIsFrozenMutationResult =
  Apollo.MutationResult<SendRequestAccountIsFrozenMutation>;
export type SendRequestAccountIsFrozenMutationOptions = Apollo.BaseMutationOptions<
  SendRequestAccountIsFrozenMutation,
  SendRequestAccountIsFrozenMutationVariables
>;
export const SendDeleteMyDataRequestDocument = gql`
    mutation SendDeleteMyDataRequest {
  sendDeleteMyDataRequest {
    success
  }
}
    `;
export type SendDeleteMyDataRequestMutationFn = Apollo.MutationFunction<
  SendDeleteMyDataRequestMutation,
  SendDeleteMyDataRequestMutationVariables
>;

/**
 * __useSendDeleteMyDataRequestMutation__
 *
 * To run a mutation, you first call `useSendDeleteMyDataRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDeleteMyDataRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDeleteMyDataRequestMutation, { data, loading, error }] = useSendDeleteMyDataRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendDeleteMyDataRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendDeleteMyDataRequestMutation,
    SendDeleteMyDataRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendDeleteMyDataRequestMutation,
    SendDeleteMyDataRequestMutationVariables
  >(SendDeleteMyDataRequestDocument, options);
}
export type SendDeleteMyDataRequestMutationHookResult = ReturnType<
  typeof useSendDeleteMyDataRequestMutation
>;
export type SendDeleteMyDataRequestMutationResult =
  Apollo.MutationResult<SendDeleteMyDataRequestMutation>;
export type SendDeleteMyDataRequestMutationOptions = Apollo.BaseMutationOptions<
  SendDeleteMyDataRequestMutation,
  SendDeleteMyDataRequestMutationVariables
>;
export const ChangeUserStatusDocument = gql`
    mutation ChangeUserStatus($userId: ID!, $newStatus: UserStatus!) {
  changeUserStatus(userId: $userId, newStatus: $newStatus) {
    id
    status
  }
}
    `;
export type ChangeUserStatusMutationFn = Apollo.MutationFunction<
  ChangeUserStatusMutation,
  ChangeUserStatusMutationVariables
>;

/**
 * __useChangeUserStatusMutation__
 *
 * To run a mutation, you first call `useChangeUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserStatusMutation, { data, loading, error }] = useChangeUserStatusMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useChangeUserStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeUserStatusMutation,
    ChangeUserStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>(
    ChangeUserStatusDocument,
    options,
  );
}
export type ChangeUserStatusMutationHookResult = ReturnType<typeof useChangeUserStatusMutation>;
export type ChangeUserStatusMutationResult = Apollo.MutationResult<ChangeUserStatusMutation>;
export type ChangeUserStatusMutationOptions = Apollo.BaseMutationOptions<
  ChangeUserStatusMutation,
  ChangeUserStatusMutationVariables
>;
export const ChangeEmployeeUserEmailByPlatformAdminDocument = gql`
    mutation ChangeEmployeeUserEmailByPlatformAdmin($userId: ID!, $newEmail: String!) {
  changeEmployeeUserEmailByPlatformAdmin(userId: $userId, newEmail: $newEmail) {
    success
  }
}
    `;
export type ChangeEmployeeUserEmailByPlatformAdminMutationFn = Apollo.MutationFunction<
  ChangeEmployeeUserEmailByPlatformAdminMutation,
  ChangeEmployeeUserEmailByPlatformAdminMutationVariables
>;

/**
 * __useChangeEmployeeUserEmailByPlatformAdminMutation__
 *
 * To run a mutation, you first call `useChangeEmployeeUserEmailByPlatformAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmployeeUserEmailByPlatformAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmployeeUserEmailByPlatformAdminMutation, { data, loading, error }] = useChangeEmployeeUserEmailByPlatformAdminMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useChangeEmployeeUserEmailByPlatformAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeEmployeeUserEmailByPlatformAdminMutation,
    ChangeEmployeeUserEmailByPlatformAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeEmployeeUserEmailByPlatformAdminMutation,
    ChangeEmployeeUserEmailByPlatformAdminMutationVariables
  >(ChangeEmployeeUserEmailByPlatformAdminDocument, options);
}
export type ChangeEmployeeUserEmailByPlatformAdminMutationHookResult = ReturnType<
  typeof useChangeEmployeeUserEmailByPlatformAdminMutation
>;
export type ChangeEmployeeUserEmailByPlatformAdminMutationResult =
  Apollo.MutationResult<ChangeEmployeeUserEmailByPlatformAdminMutation>;
export type ChangeEmployeeUserEmailByPlatformAdminMutationOptions = Apollo.BaseMutationOptions<
  ChangeEmployeeUserEmailByPlatformAdminMutation,
  ChangeEmployeeUserEmailByPlatformAdminMutationVariables
>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($userId: ID!, $data: UpdateUserRoleInput!) {
  updateUserRole(userId: $userId, input: $data) {
    success
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<
  UpdateUserRoleMutation,
  UpdateUserRoleMutationVariables
>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(
    UpdateUserRoleDocument,
    options,
  );
}
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserRoleMutation,
  UpdateUserRoleMutationVariables
>;
export const CreateUserEmailChangeRequestDocument = gql`
    mutation CreateUserEmailChangeRequest($newEmail: String!) {
  createUserEmailChangeRequest(newEmail: $newEmail) {
    success
  }
}
    `;
export type CreateUserEmailChangeRequestMutationFn = Apollo.MutationFunction<
  CreateUserEmailChangeRequestMutation,
  CreateUserEmailChangeRequestMutationVariables
>;

/**
 * __useCreateUserEmailChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateUserEmailChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserEmailChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserEmailChangeRequestMutation, { data, loading, error }] = useCreateUserEmailChangeRequestMutation({
 *   variables: {
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useCreateUserEmailChangeRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserEmailChangeRequestMutation,
    CreateUserEmailChangeRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserEmailChangeRequestMutation,
    CreateUserEmailChangeRequestMutationVariables
  >(CreateUserEmailChangeRequestDocument, options);
}
export type CreateUserEmailChangeRequestMutationHookResult = ReturnType<
  typeof useCreateUserEmailChangeRequestMutation
>;
export type CreateUserEmailChangeRequestMutationResult =
  Apollo.MutationResult<CreateUserEmailChangeRequestMutation>;
export type CreateUserEmailChangeRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateUserEmailChangeRequestMutation,
  CreateUserEmailChangeRequestMutationVariables
>;
export const ConfirmUserEmailDocument = gql`
    mutation ConfirmUserEmail($userEmailChangeRequestId: ID!) {
  confirmUserEmail(userEmailChangeRequestId: $userEmailChangeRequestId) {
    success
  }
}
    `;
export type ConfirmUserEmailMutationFn = Apollo.MutationFunction<
  ConfirmUserEmailMutation,
  ConfirmUserEmailMutationVariables
>;

/**
 * __useConfirmUserEmailMutation__
 *
 * To run a mutation, you first call `useConfirmUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUserEmailMutation, { data, loading, error }] = useConfirmUserEmailMutation({
 *   variables: {
 *      userEmailChangeRequestId: // value for 'userEmailChangeRequestId'
 *   },
 * });
 */
export function useConfirmUserEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmUserEmailMutation,
    ConfirmUserEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>(
    ConfirmUserEmailDocument,
    options,
  );
}
export type ConfirmUserEmailMutationHookResult = ReturnType<typeof useConfirmUserEmailMutation>;
export type ConfirmUserEmailMutationResult = Apollo.MutationResult<ConfirmUserEmailMutation>;
export type ConfirmUserEmailMutationOptions = Apollo.BaseMutationOptions<
  ConfirmUserEmailMutation,
  ConfirmUserEmailMutationVariables
>;
export const CheckIfUserEmailChangeExistDocument = gql`
    query CheckIfUserEmailChangeExist {
  checkIfUserEmailChangeExist {
    success
  }
}
    `;

/**
 * __useCheckIfUserEmailChangeExistQuery__
 *
 * To run a query within a React component, call `useCheckIfUserEmailChangeExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfUserEmailChangeExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfUserEmailChangeExistQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckIfUserEmailChangeExistQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckIfUserEmailChangeExistQuery,
    CheckIfUserEmailChangeExistQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckIfUserEmailChangeExistQuery,
    CheckIfUserEmailChangeExistQueryVariables
  >(CheckIfUserEmailChangeExistDocument, options);
}
export function useCheckIfUserEmailChangeExistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckIfUserEmailChangeExistQuery,
    CheckIfUserEmailChangeExistQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckIfUserEmailChangeExistQuery,
    CheckIfUserEmailChangeExistQueryVariables
  >(CheckIfUserEmailChangeExistDocument, options);
}
// @ts-ignore
export function useCheckIfUserEmailChangeExistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckIfUserEmailChangeExistQuery,
    CheckIfUserEmailChangeExistQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckIfUserEmailChangeExistQuery,
  CheckIfUserEmailChangeExistQueryVariables
>;
export function useCheckIfUserEmailChangeExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckIfUserEmailChangeExistQuery,
        CheckIfUserEmailChangeExistQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckIfUserEmailChangeExistQuery | undefined,
  CheckIfUserEmailChangeExistQueryVariables
>;
export function useCheckIfUserEmailChangeExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckIfUserEmailChangeExistQuery,
        CheckIfUserEmailChangeExistQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckIfUserEmailChangeExistQuery,
    CheckIfUserEmailChangeExistQueryVariables
  >(CheckIfUserEmailChangeExistDocument, options);
}
export type CheckIfUserEmailChangeExistQueryHookResult = ReturnType<
  typeof useCheckIfUserEmailChangeExistQuery
>;
export type CheckIfUserEmailChangeExistLazyQueryHookResult = ReturnType<
  typeof useCheckIfUserEmailChangeExistLazyQuery
>;
export type CheckIfUserEmailChangeExistSuspenseQueryHookResult = ReturnType<
  typeof useCheckIfUserEmailChangeExistSuspenseQuery
>;
export type CheckIfUserEmailChangeExistQueryResult = Apollo.QueryResult<
  CheckIfUserEmailChangeExistQuery,
  CheckIfUserEmailChangeExistQueryVariables
>;
export const VerificationRequestTotalChargeDocument = gql`
    query VerificationRequestTotalCharge($employeeId: ID, $employeeSsn: String, $requestType: VerificationRequestType!, $permissiblePurposeId: ID!, $companies: [VerificationRequestCompanyData!]!) {
  getVerificationRequestTotalCharge(
    employeeId: $employeeId
    employeeSsn: $employeeSsn
    requestType: $requestType
    permissiblePurposeId: $permissiblePurposeId
    companies: $companies
  ) {
    totalCharge
    isReverification
    isOutstandingRequest
  }
}
    `;

/**
 * __useVerificationRequestTotalChargeQuery__
 *
 * To run a query within a React component, call `useVerificationRequestTotalChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationRequestTotalChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationRequestTotalChargeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      employeeSsn: // value for 'employeeSsn'
 *      requestType: // value for 'requestType'
 *      permissiblePurposeId: // value for 'permissiblePurposeId'
 *      companies: // value for 'companies'
 *   },
 * });
 */
export function useVerificationRequestTotalChargeQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerificationRequestTotalChargeQuery,
    VerificationRequestTotalChargeQueryVariables
  > &
    (
      | { variables: VerificationRequestTotalChargeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VerificationRequestTotalChargeQuery,
    VerificationRequestTotalChargeQueryVariables
  >(VerificationRequestTotalChargeDocument, options);
}
export function useVerificationRequestTotalChargeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationRequestTotalChargeQuery,
    VerificationRequestTotalChargeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VerificationRequestTotalChargeQuery,
    VerificationRequestTotalChargeQueryVariables
  >(VerificationRequestTotalChargeDocument, options);
}
// @ts-ignore
export function useVerificationRequestTotalChargeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationRequestTotalChargeQuery,
    VerificationRequestTotalChargeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestTotalChargeQuery,
  VerificationRequestTotalChargeQueryVariables
>;
export function useVerificationRequestTotalChargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestTotalChargeQuery,
        VerificationRequestTotalChargeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestTotalChargeQuery | undefined,
  VerificationRequestTotalChargeQueryVariables
>;
export function useVerificationRequestTotalChargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestTotalChargeQuery,
        VerificationRequestTotalChargeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerificationRequestTotalChargeQuery,
    VerificationRequestTotalChargeQueryVariables
  >(VerificationRequestTotalChargeDocument, options);
}
export type VerificationRequestTotalChargeQueryHookResult = ReturnType<
  typeof useVerificationRequestTotalChargeQuery
>;
export type VerificationRequestTotalChargeLazyQueryHookResult = ReturnType<
  typeof useVerificationRequestTotalChargeLazyQuery
>;
export type VerificationRequestTotalChargeSuspenseQueryHookResult = ReturnType<
  typeof useVerificationRequestTotalChargeSuspenseQuery
>;
export type VerificationRequestTotalChargeQueryResult = Apollo.QueryResult<
  VerificationRequestTotalChargeQuery,
  VerificationRequestTotalChargeQueryVariables
>;
export const GetMyVerifyRequestTotalChargeDocument = gql`
    query GetMyVerifyRequestTotalCharge($inboxItemId: ID!, $permissiblePurposeId: ID!, $verificationReportType: VerificationRequestType) {
  getMyVerifyRequestTotalCharge(
    inboxItemId: $inboxItemId
    permissiblePurposeId: $permissiblePurposeId
    verificationReportType: $verificationReportType
  ) {
    totalCharge
    isReverification
    isOutstandingRequest
  }
}
    `;

/**
 * __useGetMyVerifyRequestTotalChargeQuery__
 *
 * To run a query within a React component, call `useGetMyVerifyRequestTotalChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVerifyRequestTotalChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVerifyRequestTotalChargeQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      permissiblePurposeId: // value for 'permissiblePurposeId'
 *      verificationReportType: // value for 'verificationReportType'
 *   },
 * });
 */
export function useGetMyVerifyRequestTotalChargeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMyVerifyRequestTotalChargeQuery,
    GetMyVerifyRequestTotalChargeQueryVariables
  > &
    (
      | { variables: GetMyVerifyRequestTotalChargeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMyVerifyRequestTotalChargeQuery,
    GetMyVerifyRequestTotalChargeQueryVariables
  >(GetMyVerifyRequestTotalChargeDocument, options);
}
export function useGetMyVerifyRequestTotalChargeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyVerifyRequestTotalChargeQuery,
    GetMyVerifyRequestTotalChargeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyVerifyRequestTotalChargeQuery,
    GetMyVerifyRequestTotalChargeQueryVariables
  >(GetMyVerifyRequestTotalChargeDocument, options);
}
// @ts-ignore
export function useGetMyVerifyRequestTotalChargeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyVerifyRequestTotalChargeQuery,
    GetMyVerifyRequestTotalChargeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetMyVerifyRequestTotalChargeQuery,
  GetMyVerifyRequestTotalChargeQueryVariables
>;
export function useGetMyVerifyRequestTotalChargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyVerifyRequestTotalChargeQuery,
        GetMyVerifyRequestTotalChargeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMyVerifyRequestTotalChargeQuery | undefined,
  GetMyVerifyRequestTotalChargeQueryVariables
>;
export function useGetMyVerifyRequestTotalChargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyVerifyRequestTotalChargeQuery,
        GetMyVerifyRequestTotalChargeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMyVerifyRequestTotalChargeQuery,
    GetMyVerifyRequestTotalChargeQueryVariables
  >(GetMyVerifyRequestTotalChargeDocument, options);
}
export type GetMyVerifyRequestTotalChargeQueryHookResult = ReturnType<
  typeof useGetMyVerifyRequestTotalChargeQuery
>;
export type GetMyVerifyRequestTotalChargeLazyQueryHookResult = ReturnType<
  typeof useGetMyVerifyRequestTotalChargeLazyQuery
>;
export type GetMyVerifyRequestTotalChargeSuspenseQueryHookResult = ReturnType<
  typeof useGetMyVerifyRequestTotalChargeSuspenseQuery
>;
export type GetMyVerifyRequestTotalChargeQueryResult = Apollo.QueryResult<
  GetMyVerifyRequestTotalChargeQuery,
  GetMyVerifyRequestTotalChargeQueryVariables
>;
export const GetExistingVerificationRequestTotalChargeDocument = gql`
    query GetExistingVerificationRequestTotalCharge($inboxItemId: ID!, $reason: ExistingVerificationRequestTotalChargeReason!) {
  getExistingVerificationRequestTotalCharge(
    inboxItemId: $inboxItemId
    reason: $reason
  ) {
    totalCharge
  }
}
    `;

/**
 * __useGetExistingVerificationRequestTotalChargeQuery__
 *
 * To run a query within a React component, call `useGetExistingVerificationRequestTotalChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingVerificationRequestTotalChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingVerificationRequestTotalChargeQuery({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useGetExistingVerificationRequestTotalChargeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExistingVerificationRequestTotalChargeQuery,
    GetExistingVerificationRequestTotalChargeQueryVariables
  > &
    (
      | { variables: GetExistingVerificationRequestTotalChargeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetExistingVerificationRequestTotalChargeQuery,
    GetExistingVerificationRequestTotalChargeQueryVariables
  >(GetExistingVerificationRequestTotalChargeDocument, options);
}
export function useGetExistingVerificationRequestTotalChargeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExistingVerificationRequestTotalChargeQuery,
    GetExistingVerificationRequestTotalChargeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetExistingVerificationRequestTotalChargeQuery,
    GetExistingVerificationRequestTotalChargeQueryVariables
  >(GetExistingVerificationRequestTotalChargeDocument, options);
}
// @ts-ignore
export function useGetExistingVerificationRequestTotalChargeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetExistingVerificationRequestTotalChargeQuery,
    GetExistingVerificationRequestTotalChargeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetExistingVerificationRequestTotalChargeQuery,
  GetExistingVerificationRequestTotalChargeQueryVariables
>;
export function useGetExistingVerificationRequestTotalChargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExistingVerificationRequestTotalChargeQuery,
        GetExistingVerificationRequestTotalChargeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetExistingVerificationRequestTotalChargeQuery | undefined,
  GetExistingVerificationRequestTotalChargeQueryVariables
>;
export function useGetExistingVerificationRequestTotalChargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExistingVerificationRequestTotalChargeQuery,
        GetExistingVerificationRequestTotalChargeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetExistingVerificationRequestTotalChargeQuery,
    GetExistingVerificationRequestTotalChargeQueryVariables
  >(GetExistingVerificationRequestTotalChargeDocument, options);
}
export type GetExistingVerificationRequestTotalChargeQueryHookResult = ReturnType<
  typeof useGetExistingVerificationRequestTotalChargeQuery
>;
export type GetExistingVerificationRequestTotalChargeLazyQueryHookResult = ReturnType<
  typeof useGetExistingVerificationRequestTotalChargeLazyQuery
>;
export type GetExistingVerificationRequestTotalChargeSuspenseQueryHookResult = ReturnType<
  typeof useGetExistingVerificationRequestTotalChargeSuspenseQuery
>;
export type GetExistingVerificationRequestTotalChargeQueryResult = Apollo.QueryResult<
  GetExistingVerificationRequestTotalChargeQuery,
  GetExistingVerificationRequestTotalChargeQueryVariables
>;
export const CreateVerificationRequestDocument = gql`
    mutation CreateVerificationRequest($employeeFirstName: String, $employeeLastName: String, $employeeBirthDate: Date!, $noteToEmployee: String, $paymentMethodId: String, $permissiblePurposeId: ID!, $requestType: VerificationRequestType!, $ssn: String!, $companies: [VerificationRequestCompanyData!]!, $verifierId: ID) {
  createVerificationRequest(
    employeeFirstName: $employeeFirstName
    employeeLastName: $employeeLastName
    employeeBirthDate: $employeeBirthDate
    noteToEmployee: $noteToEmployee
    paymentMethodId: $paymentMethodId
    permissiblePurposeId: $permissiblePurposeId
    requestType: $requestType
    ssn: $ssn
    companies: $companies
    verifierId: $verifierId
  ) {
    success
    redirectUrl
    inboxItemId
  }
}
    `;
export type CreateVerificationRequestMutationFn = Apollo.MutationFunction<
  CreateVerificationRequestMutation,
  CreateVerificationRequestMutationVariables
>;

/**
 * __useCreateVerificationRequestMutation__
 *
 * To run a mutation, you first call `useCreateVerificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVerificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVerificationRequestMutation, { data, loading, error }] = useCreateVerificationRequestMutation({
 *   variables: {
 *      employeeFirstName: // value for 'employeeFirstName'
 *      employeeLastName: // value for 'employeeLastName'
 *      employeeBirthDate: // value for 'employeeBirthDate'
 *      noteToEmployee: // value for 'noteToEmployee'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      permissiblePurposeId: // value for 'permissiblePurposeId'
 *      requestType: // value for 'requestType'
 *      ssn: // value for 'ssn'
 *      companies: // value for 'companies'
 *      verifierId: // value for 'verifierId'
 *   },
 * });
 */
export function useCreateVerificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVerificationRequestMutation,
    CreateVerificationRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateVerificationRequestMutation,
    CreateVerificationRequestMutationVariables
  >(CreateVerificationRequestDocument, options);
}
export type CreateVerificationRequestMutationHookResult = ReturnType<
  typeof useCreateVerificationRequestMutation
>;
export type CreateVerificationRequestMutationResult =
  Apollo.MutationResult<CreateVerificationRequestMutation>;
export type CreateVerificationRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateVerificationRequestMutation,
  CreateVerificationRequestMutationVariables
>;
export const CreateVerificationRequestByEmployeeDocument = gql`
    mutation CreateVerificationRequestByEmployee($companyName: String!, $firstName: String!, $lastName: String!, $contactEmail: String!, $companies: [VerificationRequestCompanyData!]!, $noteToRecipient: String) {
  createVerificationRequestByEmployee(
    companyName: $companyName
    firstName: $firstName
    lastName: $lastName
    contactEmail: $contactEmail
    companies: $companies
    noteToRecipient: $noteToRecipient
  ) {
    success
  }
}
    `;
export type CreateVerificationRequestByEmployeeMutationFn = Apollo.MutationFunction<
  CreateVerificationRequestByEmployeeMutation,
  CreateVerificationRequestByEmployeeMutationVariables
>;

/**
 * __useCreateVerificationRequestByEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateVerificationRequestByEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVerificationRequestByEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVerificationRequestByEmployeeMutation, { data, loading, error }] = useCreateVerificationRequestByEmployeeMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      contactEmail: // value for 'contactEmail'
 *      companies: // value for 'companies'
 *      noteToRecipient: // value for 'noteToRecipient'
 *   },
 * });
 */
export function useCreateVerificationRequestByEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVerificationRequestByEmployeeMutation,
    CreateVerificationRequestByEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateVerificationRequestByEmployeeMutation,
    CreateVerificationRequestByEmployeeMutationVariables
  >(CreateVerificationRequestByEmployeeDocument, options);
}
export type CreateVerificationRequestByEmployeeMutationHookResult = ReturnType<
  typeof useCreateVerificationRequestByEmployeeMutation
>;
export type CreateVerificationRequestByEmployeeMutationResult =
  Apollo.MutationResult<CreateVerificationRequestByEmployeeMutation>;
export type CreateVerificationRequestByEmployeeMutationOptions = Apollo.BaseMutationOptions<
  CreateVerificationRequestByEmployeeMutation,
  CreateVerificationRequestByEmployeeMutationVariables
>;
export const CreateReverificationRequestDocument = gql`
    mutation CreateReverificationRequest($inboxItemId: ID!, $paymentMethodId: String) {
  createReverificationRequest(
    inboxItemId: $inboxItemId
    paymentMethodId: $paymentMethodId
  ) {
    success
    redirectUrl
    inboxItemId
  }
}
    `;
export type CreateReverificationRequestMutationFn = Apollo.MutationFunction<
  CreateReverificationRequestMutation,
  CreateReverificationRequestMutationVariables
>;

/**
 * __useCreateReverificationRequestMutation__
 *
 * To run a mutation, you first call `useCreateReverificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReverificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReverificationRequestMutation, { data, loading, error }] = useCreateReverificationRequestMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCreateReverificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReverificationRequestMutation,
    CreateReverificationRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReverificationRequestMutation,
    CreateReverificationRequestMutationVariables
  >(CreateReverificationRequestDocument, options);
}
export type CreateReverificationRequestMutationHookResult = ReturnType<
  typeof useCreateReverificationRequestMutation
>;
export type CreateReverificationRequestMutationResult =
  Apollo.MutationResult<CreateReverificationRequestMutation>;
export type CreateReverificationRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateReverificationRequestMutation,
  CreateReverificationRequestMutationVariables
>;
export const VerificationRequestDocument = gql`
    query VerificationRequest($filter: VerificationRequestWhereUnique!) {
  verificationRequest(where: $filter) {
    ...VerificationRequestListItem
  }
}
    ${VerificationRequestListItemFragmentDoc}`;

/**
 * __useVerificationRequestQuery__
 *
 * To run a query within a React component, call `useVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationRequestQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerificationRequestQuery,
    VerificationRequestQueryVariables
  > &
    ({ variables: VerificationRequestQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerificationRequestQuery, VerificationRequestQueryVariables>(
    VerificationRequestDocument,
    options,
  );
}
export function useVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationRequestQuery,
    VerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerificationRequestQuery, VerificationRequestQueryVariables>(
    VerificationRequestDocument,
    options,
  );
}
// @ts-ignore
export function useVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationRequestQuery,
    VerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerificationRequestQuery, VerificationRequestQueryVariables>;
export function useVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerificationRequestQuery, VerificationRequestQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestQuery | undefined,
  VerificationRequestQueryVariables
>;
export function useVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerificationRequestQuery, VerificationRequestQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerificationRequestQuery, VerificationRequestQueryVariables>(
    VerificationRequestDocument,
    options,
  );
}
export type VerificationRequestQueryHookResult = ReturnType<typeof useVerificationRequestQuery>;
export type VerificationRequestLazyQueryHookResult = ReturnType<
  typeof useVerificationRequestLazyQuery
>;
export type VerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useVerificationRequestSuspenseQuery
>;
export type VerificationRequestQueryResult = Apollo.QueryResult<
  VerificationRequestQuery,
  VerificationRequestQueryVariables
>;
export const VerificationRequestPaymentInfoDocument = gql`
    query VerificationRequestPaymentInfo($where: VerificationRequestWhereUnique!) {
  verificationRequest(where: $where) {
    ...VerificationRequestPaymentInfo
  }
}
    ${VerificationRequestPaymentInfoFragmentDoc}`;

/**
 * __useVerificationRequestPaymentInfoQuery__
 *
 * To run a query within a React component, call `useVerificationRequestPaymentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationRequestPaymentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationRequestPaymentInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVerificationRequestPaymentInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerificationRequestPaymentInfoQuery,
    VerificationRequestPaymentInfoQueryVariables
  > &
    (
      | { variables: VerificationRequestPaymentInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VerificationRequestPaymentInfoQuery,
    VerificationRequestPaymentInfoQueryVariables
  >(VerificationRequestPaymentInfoDocument, options);
}
export function useVerificationRequestPaymentInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationRequestPaymentInfoQuery,
    VerificationRequestPaymentInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VerificationRequestPaymentInfoQuery,
    VerificationRequestPaymentInfoQueryVariables
  >(VerificationRequestPaymentInfoDocument, options);
}
// @ts-ignore
export function useVerificationRequestPaymentInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationRequestPaymentInfoQuery,
    VerificationRequestPaymentInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestPaymentInfoQuery,
  VerificationRequestPaymentInfoQueryVariables
>;
export function useVerificationRequestPaymentInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestPaymentInfoQuery,
        VerificationRequestPaymentInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestPaymentInfoQuery | undefined,
  VerificationRequestPaymentInfoQueryVariables
>;
export function useVerificationRequestPaymentInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestPaymentInfoQuery,
        VerificationRequestPaymentInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerificationRequestPaymentInfoQuery,
    VerificationRequestPaymentInfoQueryVariables
  >(VerificationRequestPaymentInfoDocument, options);
}
export type VerificationRequestPaymentInfoQueryHookResult = ReturnType<
  typeof useVerificationRequestPaymentInfoQuery
>;
export type VerificationRequestPaymentInfoLazyQueryHookResult = ReturnType<
  typeof useVerificationRequestPaymentInfoLazyQuery
>;
export type VerificationRequestPaymentInfoSuspenseQueryHookResult = ReturnType<
  typeof useVerificationRequestPaymentInfoSuspenseQuery
>;
export type VerificationRequestPaymentInfoQueryResult = Apollo.QueryResult<
  VerificationRequestPaymentInfoQuery,
  VerificationRequestPaymentInfoQueryVariables
>;
export const VerificationRequestsListDocument = gql`
    query VerificationRequestsList($filter: VerificationRequestWhere) {
  verificationRequestList(where: $filter) {
    id
    createdAt
    inboxItemId
    employee {
      id
      user {
        id
        firstName
        lastName
      }
    }
    verifierStaff {
      id
      verifier {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useVerificationRequestsListQuery__
 *
 * To run a query within a React component, call `useVerificationRequestsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationRequestsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationRequestsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVerificationRequestsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VerificationRequestsListQuery,
    VerificationRequestsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerificationRequestsListQuery, VerificationRequestsListQueryVariables>(
    VerificationRequestsListDocument,
    options,
  );
}
export function useVerificationRequestsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationRequestsListQuery,
    VerificationRequestsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerificationRequestsListQuery, VerificationRequestsListQueryVariables>(
    VerificationRequestsListDocument,
    options,
  );
}
// @ts-ignore
export function useVerificationRequestsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationRequestsListQuery,
    VerificationRequestsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestsListQuery,
  VerificationRequestsListQueryVariables
>;
export function useVerificationRequestsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestsListQuery,
        VerificationRequestsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestsListQuery | undefined,
  VerificationRequestsListQueryVariables
>;
export function useVerificationRequestsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestsListQuery,
        VerificationRequestsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerificationRequestsListQuery,
    VerificationRequestsListQueryVariables
  >(VerificationRequestsListDocument, options);
}
export type VerificationRequestsListQueryHookResult = ReturnType<
  typeof useVerificationRequestsListQuery
>;
export type VerificationRequestsListLazyQueryHookResult = ReturnType<
  typeof useVerificationRequestsListLazyQuery
>;
export type VerificationRequestsListSuspenseQueryHookResult = ReturnType<
  typeof useVerificationRequestsListSuspenseQuery
>;
export type VerificationRequestsListQueryResult = Apollo.QueryResult<
  VerificationRequestsListQuery,
  VerificationRequestsListQueryVariables
>;
export const VerificationRequestsReportListDocument = gql`
    query VerificationRequestsReportList($filter: VerificationRequestWhere, $orderBy: [VerificationRequestOrderBy!], $first: Int, $skip: Int) {
  verificationRequestCount(where: $filter)
  getVerificationRequestsListForReport(
    where: $filter
    orderBy: $orderBy
    take: $first
    skip: $skip
  ) {
    ...VerificationRequestForReportItem
  }
}
    ${VerificationRequestForReportItemFragmentDoc}`;

/**
 * __useVerificationRequestsReportListQuery__
 *
 * To run a query within a React component, call `useVerificationRequestsReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationRequestsReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationRequestsReportListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useVerificationRequestsReportListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VerificationRequestsReportListQuery,
    VerificationRequestsReportListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VerificationRequestsReportListQuery,
    VerificationRequestsReportListQueryVariables
  >(VerificationRequestsReportListDocument, options);
}
export function useVerificationRequestsReportListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationRequestsReportListQuery,
    VerificationRequestsReportListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VerificationRequestsReportListQuery,
    VerificationRequestsReportListQueryVariables
  >(VerificationRequestsReportListDocument, options);
}
// @ts-ignore
export function useVerificationRequestsReportListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationRequestsReportListQuery,
    VerificationRequestsReportListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestsReportListQuery,
  VerificationRequestsReportListQueryVariables
>;
export function useVerificationRequestsReportListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestsReportListQuery,
        VerificationRequestsReportListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestsReportListQuery | undefined,
  VerificationRequestsReportListQueryVariables
>;
export function useVerificationRequestsReportListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestsReportListQuery,
        VerificationRequestsReportListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerificationRequestsReportListQuery,
    VerificationRequestsReportListQueryVariables
  >(VerificationRequestsReportListDocument, options);
}
export type VerificationRequestsReportListQueryHookResult = ReturnType<
  typeof useVerificationRequestsReportListQuery
>;
export type VerificationRequestsReportListLazyQueryHookResult = ReturnType<
  typeof useVerificationRequestsReportListLazyQuery
>;
export type VerificationRequestsReportListSuspenseQueryHookResult = ReturnType<
  typeof useVerificationRequestsReportListSuspenseQuery
>;
export type VerificationRequestsReportListQueryResult = Apollo.QueryResult<
  VerificationRequestsReportListQuery,
  VerificationRequestsReportListQueryVariables
>;
export const VerificationRequestsCountDocument = gql`
    query VerificationRequestsCount($where: VerificationRequestWhere) {
  verificationRequestCount(where: $where)
}
    `;

/**
 * __useVerificationRequestsCountQuery__
 *
 * To run a query within a React component, call `useVerificationRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationRequestsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVerificationRequestsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VerificationRequestsCountQuery,
    VerificationRequestsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerificationRequestsCountQuery, VerificationRequestsCountQueryVariables>(
    VerificationRequestsCountDocument,
    options,
  );
}
export function useVerificationRequestsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationRequestsCountQuery,
    VerificationRequestsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VerificationRequestsCountQuery,
    VerificationRequestsCountQueryVariables
  >(VerificationRequestsCountDocument, options);
}
// @ts-ignore
export function useVerificationRequestsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationRequestsCountQuery,
    VerificationRequestsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestsCountQuery,
  VerificationRequestsCountQueryVariables
>;
export function useVerificationRequestsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestsCountQuery,
        VerificationRequestsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerificationRequestsCountQuery | undefined,
  VerificationRequestsCountQueryVariables
>;
export function useVerificationRequestsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerificationRequestsCountQuery,
        VerificationRequestsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerificationRequestsCountQuery,
    VerificationRequestsCountQueryVariables
  >(VerificationRequestsCountDocument, options);
}
export type VerificationRequestsCountQueryHookResult = ReturnType<
  typeof useVerificationRequestsCountQuery
>;
export type VerificationRequestsCountLazyQueryHookResult = ReturnType<
  typeof useVerificationRequestsCountLazyQuery
>;
export type VerificationRequestsCountSuspenseQueryHookResult = ReturnType<
  typeof useVerificationRequestsCountSuspenseQuery
>;
export type VerificationRequestsCountQueryResult = Apollo.QueryResult<
  VerificationRequestsCountQuery,
  VerificationRequestsCountQueryVariables
>;
export const GetAnnualFreeReportDataDocument = gql`
    query GetAnnualFreeReportData {
  getAnnualFreeReportData {
    createdAt
    file {
      ...FileResponseInfo
    }
  }
}
    ${FileResponseInfoFragmentDoc}`;

/**
 * __useGetAnnualFreeReportDataQuery__
 *
 * To run a query within a React component, call `useGetAnnualFreeReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnualFreeReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnualFreeReportDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnualFreeReportDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAnnualFreeReportDataQuery,
    GetAnnualFreeReportDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnnualFreeReportDataQuery, GetAnnualFreeReportDataQueryVariables>(
    GetAnnualFreeReportDataDocument,
    options,
  );
}
export function useGetAnnualFreeReportDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnnualFreeReportDataQuery,
    GetAnnualFreeReportDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnnualFreeReportDataQuery, GetAnnualFreeReportDataQueryVariables>(
    GetAnnualFreeReportDataDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnnualFreeReportDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnnualFreeReportDataQuery,
    GetAnnualFreeReportDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAnnualFreeReportDataQuery,
  GetAnnualFreeReportDataQueryVariables
>;
export function useGetAnnualFreeReportDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnnualFreeReportDataQuery,
        GetAnnualFreeReportDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnnualFreeReportDataQuery | undefined,
  GetAnnualFreeReportDataQueryVariables
>;
export function useGetAnnualFreeReportDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnnualFreeReportDataQuery,
        GetAnnualFreeReportDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAnnualFreeReportDataQuery,
    GetAnnualFreeReportDataQueryVariables
  >(GetAnnualFreeReportDataDocument, options);
}
export type GetAnnualFreeReportDataQueryHookResult = ReturnType<
  typeof useGetAnnualFreeReportDataQuery
>;
export type GetAnnualFreeReportDataLazyQueryHookResult = ReturnType<
  typeof useGetAnnualFreeReportDataLazyQuery
>;
export type GetAnnualFreeReportDataSuspenseQueryHookResult = ReturnType<
  typeof useGetAnnualFreeReportDataSuspenseQuery
>;
export type GetAnnualFreeReportDataQueryResult = Apollo.QueryResult<
  GetAnnualFreeReportDataQuery,
  GetAnnualFreeReportDataQueryVariables
>;
export const GenerateVerificationRequestsReportDocument = gql`
    mutation GenerateVerificationRequestsReport($where: VerificationRequestWhere, $orderBy: [VerificationRequestOrderBy!], $format: VerificationRequestsReportFormat!) {
  generateVerificationRequestsReport(
    where: $where
    orderBy: $orderBy
    format: $format
  ) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateVerificationRequestsReportMutationFn = Apollo.MutationFunction<
  GenerateVerificationRequestsReportMutation,
  GenerateVerificationRequestsReportMutationVariables
>;

/**
 * __useGenerateVerificationRequestsReportMutation__
 *
 * To run a mutation, you first call `useGenerateVerificationRequestsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateVerificationRequestsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateVerificationRequestsReportMutation, { data, loading, error }] = useGenerateVerificationRequestsReportMutation({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGenerateVerificationRequestsReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateVerificationRequestsReportMutation,
    GenerateVerificationRequestsReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateVerificationRequestsReportMutation,
    GenerateVerificationRequestsReportMutationVariables
  >(GenerateVerificationRequestsReportDocument, options);
}
export type GenerateVerificationRequestsReportMutationHookResult = ReturnType<
  typeof useGenerateVerificationRequestsReportMutation
>;
export type GenerateVerificationRequestsReportMutationResult =
  Apollo.MutationResult<GenerateVerificationRequestsReportMutation>;
export type GenerateVerificationRequestsReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateVerificationRequestsReportMutation,
  GenerateVerificationRequestsReportMutationVariables
>;
export const ApproveVerificationRequestByVerifierDocument = gql`
    mutation ApproveVerificationRequestByVerifier($inboxItemId: ID!, $verificationRequestType: VerificationRequestType, $permissiblePurposeId: ID!, $paymentMethodId: String) {
  approveVerificationRequestByVerifier(
    inboxItemId: $inboxItemId
    verificationRequestType: $verificationRequestType
    permissiblePurposeId: $permissiblePurposeId
    paymentMethodId: $paymentMethodId
  ) {
    success
    redirectUrl
  }
}
    `;
export type ApproveVerificationRequestByVerifierMutationFn = Apollo.MutationFunction<
  ApproveVerificationRequestByVerifierMutation,
  ApproveVerificationRequestByVerifierMutationVariables
>;

/**
 * __useApproveVerificationRequestByVerifierMutation__
 *
 * To run a mutation, you first call `useApproveVerificationRequestByVerifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveVerificationRequestByVerifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveVerificationRequestByVerifierMutation, { data, loading, error }] = useApproveVerificationRequestByVerifierMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *      verificationRequestType: // value for 'verificationRequestType'
 *      permissiblePurposeId: // value for 'permissiblePurposeId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useApproveVerificationRequestByVerifierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveVerificationRequestByVerifierMutation,
    ApproveVerificationRequestByVerifierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveVerificationRequestByVerifierMutation,
    ApproveVerificationRequestByVerifierMutationVariables
  >(ApproveVerificationRequestByVerifierDocument, options);
}
export type ApproveVerificationRequestByVerifierMutationHookResult = ReturnType<
  typeof useApproveVerificationRequestByVerifierMutation
>;
export type ApproveVerificationRequestByVerifierMutationResult =
  Apollo.MutationResult<ApproveVerificationRequestByVerifierMutation>;
export type ApproveVerificationRequestByVerifierMutationOptions = Apollo.BaseMutationOptions<
  ApproveVerificationRequestByVerifierMutation,
  ApproveVerificationRequestByVerifierMutationVariables
>;
export const ApproveVerificationRequestByEmployeeDocument = gql`
    mutation ApproveVerificationRequestByEmployee($inboxItemId: ID!) {
  approveVerificationRequestByEmployee(inboxItemId: $inboxItemId) {
    success
  }
}
    `;
export type ApproveVerificationRequestByEmployeeMutationFn = Apollo.MutationFunction<
  ApproveVerificationRequestByEmployeeMutation,
  ApproveVerificationRequestByEmployeeMutationVariables
>;

/**
 * __useApproveVerificationRequestByEmployeeMutation__
 *
 * To run a mutation, you first call `useApproveVerificationRequestByEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveVerificationRequestByEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveVerificationRequestByEmployeeMutation, { data, loading, error }] = useApproveVerificationRequestByEmployeeMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useApproveVerificationRequestByEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveVerificationRequestByEmployeeMutation,
    ApproveVerificationRequestByEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveVerificationRequestByEmployeeMutation,
    ApproveVerificationRequestByEmployeeMutationVariables
  >(ApproveVerificationRequestByEmployeeDocument, options);
}
export type ApproveVerificationRequestByEmployeeMutationHookResult = ReturnType<
  typeof useApproveVerificationRequestByEmployeeMutation
>;
export type ApproveVerificationRequestByEmployeeMutationResult =
  Apollo.MutationResult<ApproveVerificationRequestByEmployeeMutation>;
export type ApproveVerificationRequestByEmployeeMutationOptions = Apollo.BaseMutationOptions<
  ApproveVerificationRequestByEmployeeMutation,
  ApproveVerificationRequestByEmployeeMutationVariables
>;
export const DeclineVerificationRequestByVerifierDocument = gql`
    mutation DeclineVerificationRequestByVerifier($inboxItemId: ID!) {
  declineVerificationRequestByVerifier(inboxItemId: $inboxItemId) {
    success
  }
}
    `;
export type DeclineVerificationRequestByVerifierMutationFn = Apollo.MutationFunction<
  DeclineVerificationRequestByVerifierMutation,
  DeclineVerificationRequestByVerifierMutationVariables
>;

/**
 * __useDeclineVerificationRequestByVerifierMutation__
 *
 * To run a mutation, you first call `useDeclineVerificationRequestByVerifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineVerificationRequestByVerifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineVerificationRequestByVerifierMutation, { data, loading, error }] = useDeclineVerificationRequestByVerifierMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useDeclineVerificationRequestByVerifierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineVerificationRequestByVerifierMutation,
    DeclineVerificationRequestByVerifierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeclineVerificationRequestByVerifierMutation,
    DeclineVerificationRequestByVerifierMutationVariables
  >(DeclineVerificationRequestByVerifierDocument, options);
}
export type DeclineVerificationRequestByVerifierMutationHookResult = ReturnType<
  typeof useDeclineVerificationRequestByVerifierMutation
>;
export type DeclineVerificationRequestByVerifierMutationResult =
  Apollo.MutationResult<DeclineVerificationRequestByVerifierMutation>;
export type DeclineVerificationRequestByVerifierMutationOptions = Apollo.BaseMutationOptions<
  DeclineVerificationRequestByVerifierMutation,
  DeclineVerificationRequestByVerifierMutationVariables
>;
export const DeclineVerificationRequestByEmployeeDocument = gql`
    mutation DeclineVerificationRequestByEmployee($inboxItemId: ID!) {
  declineVerificationRequestByEmployee(inboxItemId: $inboxItemId) {
    success
  }
}
    `;
export type DeclineVerificationRequestByEmployeeMutationFn = Apollo.MutationFunction<
  DeclineVerificationRequestByEmployeeMutation,
  DeclineVerificationRequestByEmployeeMutationVariables
>;

/**
 * __useDeclineVerificationRequestByEmployeeMutation__
 *
 * To run a mutation, you first call `useDeclineVerificationRequestByEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineVerificationRequestByEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineVerificationRequestByEmployeeMutation, { data, loading, error }] = useDeclineVerificationRequestByEmployeeMutation({
 *   variables: {
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useDeclineVerificationRequestByEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineVerificationRequestByEmployeeMutation,
    DeclineVerificationRequestByEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeclineVerificationRequestByEmployeeMutation,
    DeclineVerificationRequestByEmployeeMutationVariables
  >(DeclineVerificationRequestByEmployeeDocument, options);
}
export type DeclineVerificationRequestByEmployeeMutationHookResult = ReturnType<
  typeof useDeclineVerificationRequestByEmployeeMutation
>;
export type DeclineVerificationRequestByEmployeeMutationResult =
  Apollo.MutationResult<DeclineVerificationRequestByEmployeeMutation>;
export type DeclineVerificationRequestByEmployeeMutationOptions = Apollo.BaseMutationOptions<
  DeclineVerificationRequestByEmployeeMutation,
  DeclineVerificationRequestByEmployeeMutationVariables
>;
export const GenerateAnnualFreeReportDocument = gql`
    mutation GenerateAnnualFreeReport {
  generateAnnualFreeReport {
    status
    file {
      ...FileResponseInfo
    }
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateAnnualFreeReportMutationFn = Apollo.MutationFunction<
  GenerateAnnualFreeReportMutation,
  GenerateAnnualFreeReportMutationVariables
>;

/**
 * __useGenerateAnnualFreeReportMutation__
 *
 * To run a mutation, you first call `useGenerateAnnualFreeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAnnualFreeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAnnualFreeReportMutation, { data, loading, error }] = useGenerateAnnualFreeReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateAnnualFreeReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAnnualFreeReportMutation,
    GenerateAnnualFreeReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateAnnualFreeReportMutation,
    GenerateAnnualFreeReportMutationVariables
  >(GenerateAnnualFreeReportDocument, options);
}
export type GenerateAnnualFreeReportMutationHookResult = ReturnType<
  typeof useGenerateAnnualFreeReportMutation
>;
export type GenerateAnnualFreeReportMutationResult =
  Apollo.MutationResult<GenerateAnnualFreeReportMutation>;
export type GenerateAnnualFreeReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateAnnualFreeReportMutation,
  GenerateAnnualFreeReportMutationVariables
>;
export const VerifiersListDocument = gql`
    query VerifiersList($filter: VerifierWhere, $orderBy: [VerifierOrderBy!], $first: Int, $skip: Int) {
  verifierList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...VerifierInfo
  }
  verifierCount(where: $filter)
}
    ${VerifierInfoFragmentDoc}`;

/**
 * __useVerifiersListQuery__
 *
 * To run a query within a React component, call `useVerifiersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifiersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiersListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useVerifiersListQuery(
  baseOptions?: Apollo.QueryHookOptions<VerifiersListQuery, VerifiersListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifiersListQuery, VerifiersListQueryVariables>(
    VerifiersListDocument,
    options,
  );
}
export function useVerifiersListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifiersListQuery, VerifiersListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifiersListQuery, VerifiersListQueryVariables>(
    VerifiersListDocument,
    options,
  );
}
// @ts-ignore
export function useVerifiersListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<VerifiersListQuery, VerifiersListQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifiersListQuery, VerifiersListQueryVariables>;
export function useVerifiersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifiersListQuery, VerifiersListQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifiersListQuery | undefined, VerifiersListQueryVariables>;
export function useVerifiersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifiersListQuery, VerifiersListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifiersListQuery, VerifiersListQueryVariables>(
    VerifiersListDocument,
    options,
  );
}
export type VerifiersListQueryHookResult = ReturnType<typeof useVerifiersListQuery>;
export type VerifiersListLazyQueryHookResult = ReturnType<typeof useVerifiersListLazyQuery>;
export type VerifiersListSuspenseQueryHookResult = ReturnType<typeof useVerifiersListSuspenseQuery>;
export type VerifiersListQueryResult = Apollo.QueryResult<
  VerifiersListQuery,
  VerifiersListQueryVariables
>;
export const VerifierDocument = gql`
    query Verifier($id: ID!) {
  verifier(where: {id: $id}) {
    ...VerifierDetailInfo
  }
}
    ${VerifierDetailInfoFragmentDoc}`;

/**
 * __useVerifierQuery__
 *
 * To run a query within a React component, call `useVerifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifierQuery(
  baseOptions: Apollo.QueryHookOptions<VerifierQuery, VerifierQueryVariables> &
    ({ variables: VerifierQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierQuery, VerifierQueryVariables>(VerifierDocument, options);
}
export function useVerifierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifierQuery, VerifierQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierQuery, VerifierQueryVariables>(VerifierDocument, options);
}
// @ts-ignore
export function useVerifierSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<VerifierQuery, VerifierQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifierQuery, VerifierQueryVariables>;
export function useVerifierSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierQuery, VerifierQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifierQuery | undefined, VerifierQueryVariables>;
export function useVerifierSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierQuery, VerifierQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierQuery, VerifierQueryVariables>(VerifierDocument, options);
}
export type VerifierQueryHookResult = ReturnType<typeof useVerifierQuery>;
export type VerifierLazyQueryHookResult = ReturnType<typeof useVerifierLazyQuery>;
export type VerifierSuspenseQueryHookResult = ReturnType<typeof useVerifierSuspenseQuery>;
export type VerifierQueryResult = Apollo.QueryResult<VerifierQuery, VerifierQueryVariables>;
export const CheckIsAdditionalVerifierAdminDocument = gql`
    query CheckIsAdditionalVerifierAdmin($verifierId: ID!) {
  checkIsAdditionalVerifierAdmin(verifierId: $verifierId) {
    isAdditionalVerifierAdmin
  }
}
    `;

/**
 * __useCheckIsAdditionalVerifierAdminQuery__
 *
 * To run a query within a React component, call `useCheckIsAdditionalVerifierAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIsAdditionalVerifierAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIsAdditionalVerifierAdminQuery({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *   },
 * });
 */
export function useCheckIsAdditionalVerifierAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckIsAdditionalVerifierAdminQuery,
    CheckIsAdditionalVerifierAdminQueryVariables
  > &
    (
      | { variables: CheckIsAdditionalVerifierAdminQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckIsAdditionalVerifierAdminQuery,
    CheckIsAdditionalVerifierAdminQueryVariables
  >(CheckIsAdditionalVerifierAdminDocument, options);
}
export function useCheckIsAdditionalVerifierAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckIsAdditionalVerifierAdminQuery,
    CheckIsAdditionalVerifierAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckIsAdditionalVerifierAdminQuery,
    CheckIsAdditionalVerifierAdminQueryVariables
  >(CheckIsAdditionalVerifierAdminDocument, options);
}
// @ts-ignore
export function useCheckIsAdditionalVerifierAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckIsAdditionalVerifierAdminQuery,
    CheckIsAdditionalVerifierAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckIsAdditionalVerifierAdminQuery,
  CheckIsAdditionalVerifierAdminQueryVariables
>;
export function useCheckIsAdditionalVerifierAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckIsAdditionalVerifierAdminQuery,
        CheckIsAdditionalVerifierAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckIsAdditionalVerifierAdminQuery | undefined,
  CheckIsAdditionalVerifierAdminQueryVariables
>;
export function useCheckIsAdditionalVerifierAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckIsAdditionalVerifierAdminQuery,
        CheckIsAdditionalVerifierAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckIsAdditionalVerifierAdminQuery,
    CheckIsAdditionalVerifierAdminQueryVariables
  >(CheckIsAdditionalVerifierAdminDocument, options);
}
export type CheckIsAdditionalVerifierAdminQueryHookResult = ReturnType<
  typeof useCheckIsAdditionalVerifierAdminQuery
>;
export type CheckIsAdditionalVerifierAdminLazyQueryHookResult = ReturnType<
  typeof useCheckIsAdditionalVerifierAdminLazyQuery
>;
export type CheckIsAdditionalVerifierAdminSuspenseQueryHookResult = ReturnType<
  typeof useCheckIsAdditionalVerifierAdminSuspenseQuery
>;
export type CheckIsAdditionalVerifierAdminQueryResult = Apollo.QueryResult<
  CheckIsAdditionalVerifierAdminQuery,
  CheckIsAdditionalVerifierAdminQueryVariables
>;
export const VerifierUpdateDocument = gql`
    mutation VerifierUpdate($id: ID!, $data: VerifierUpdate!) {
  updateVerifier(id: $id, data: $data) {
    ...VerifierDetailInfo
  }
}
    ${VerifierDetailInfoFragmentDoc}`;
export type VerifierUpdateMutationFn = Apollo.MutationFunction<
  VerifierUpdateMutation,
  VerifierUpdateMutationVariables
>;

/**
 * __useVerifierUpdateMutation__
 *
 * To run a mutation, you first call `useVerifierUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifierUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifierUpdateMutation, { data, loading, error }] = useVerifierUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerifierUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifierUpdateMutation, VerifierUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifierUpdateMutation, VerifierUpdateMutationVariables>(
    VerifierUpdateDocument,
    options,
  );
}
export type VerifierUpdateMutationHookResult = ReturnType<typeof useVerifierUpdateMutation>;
export type VerifierUpdateMutationResult = Apollo.MutationResult<VerifierUpdateMutation>;
export type VerifierUpdateMutationOptions = Apollo.BaseMutationOptions<
  VerifierUpdateMutation,
  VerifierUpdateMutationVariables
>;
export const VerifierBillingRulesDocument = gql`
    query VerifierBillingRules($id: ID!) {
  verifier(where: {id: $id}) {
    ...VerifierBillingRulesInfo
  }
}
    ${VerifierBillingRulesInfoFragmentDoc}`;

/**
 * __useVerifierBillingRulesQuery__
 *
 * To run a query within a React component, call `useVerifierBillingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierBillingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierBillingRulesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifierBillingRulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifierBillingRulesQuery,
    VerifierBillingRulesQueryVariables
  > &
    ({ variables: VerifierBillingRulesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierBillingRulesQuery, VerifierBillingRulesQueryVariables>(
    VerifierBillingRulesDocument,
    options,
  );
}
export function useVerifierBillingRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifierBillingRulesQuery,
    VerifierBillingRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierBillingRulesQuery, VerifierBillingRulesQueryVariables>(
    VerifierBillingRulesDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierBillingRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifierBillingRulesQuery,
    VerifierBillingRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerifierBillingRulesQuery, VerifierBillingRulesQueryVariables>;
export function useVerifierBillingRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierBillingRulesQuery,
        VerifierBillingRulesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerifierBillingRulesQuery | undefined,
  VerifierBillingRulesQueryVariables
>;
export function useVerifierBillingRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierBillingRulesQuery,
        VerifierBillingRulesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierBillingRulesQuery, VerifierBillingRulesQueryVariables>(
    VerifierBillingRulesDocument,
    options,
  );
}
export type VerifierBillingRulesQueryHookResult = ReturnType<typeof useVerifierBillingRulesQuery>;
export type VerifierBillingRulesLazyQueryHookResult = ReturnType<
  typeof useVerifierBillingRulesLazyQuery
>;
export type VerifierBillingRulesSuspenseQueryHookResult = ReturnType<
  typeof useVerifierBillingRulesSuspenseQuery
>;
export type VerifierBillingRulesQueryResult = Apollo.QueryResult<
  VerifierBillingRulesQuery,
  VerifierBillingRulesQueryVariables
>;
export const VerifierBillingRulesUpdateDocument = gql`
    mutation VerifierBillingRulesUpdate($id: ID!, $data: VerifierUpdate!) {
  updateVerifier(id: $id, data: $data) {
    ...VerifierBillingRulesInfo
  }
}
    ${VerifierBillingRulesInfoFragmentDoc}`;
export type VerifierBillingRulesUpdateMutationFn = Apollo.MutationFunction<
  VerifierBillingRulesUpdateMutation,
  VerifierBillingRulesUpdateMutationVariables
>;

/**
 * __useVerifierBillingRulesUpdateMutation__
 *
 * To run a mutation, you first call `useVerifierBillingRulesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifierBillingRulesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifierBillingRulesUpdateMutation, { data, loading, error }] = useVerifierBillingRulesUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerifierBillingRulesUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifierBillingRulesUpdateMutation,
    VerifierBillingRulesUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifierBillingRulesUpdateMutation,
    VerifierBillingRulesUpdateMutationVariables
  >(VerifierBillingRulesUpdateDocument, options);
}
export type VerifierBillingRulesUpdateMutationHookResult = ReturnType<
  typeof useVerifierBillingRulesUpdateMutation
>;
export type VerifierBillingRulesUpdateMutationResult =
  Apollo.MutationResult<VerifierBillingRulesUpdateMutation>;
export type VerifierBillingRulesUpdateMutationOptions = Apollo.BaseMutationOptions<
  VerifierBillingRulesUpdateMutation,
  VerifierBillingRulesUpdateMutationVariables
>;
export const GetVerifierByEmailDomainDocument = gql`
    query GetVerifierByEmailDomain($email: String!, $emailConfirmationCode: String!) {
  getVerifierByEmailDomain(
    email: $email
    emailConfirmationCode: $emailConfirmationCode
  ) {
    verifiers {
      id
      logo {
        ...FileResponseInfo
      }
      createdAt
      displayName
      type
      address {
        state
        street
      }
    }
  }
}
    ${FileResponseInfoFragmentDoc}`;

/**
 * __useGetVerifierByEmailDomainQuery__
 *
 * To run a query within a React component, call `useGetVerifierByEmailDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifierByEmailDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifierByEmailDomainQuery({
 *   variables: {
 *      email: // value for 'email'
 *      emailConfirmationCode: // value for 'emailConfirmationCode'
 *   },
 * });
 */
export function useGetVerifierByEmailDomainQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVerifierByEmailDomainQuery,
    GetVerifierByEmailDomainQueryVariables
  > &
    ({ variables: GetVerifierByEmailDomainQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVerifierByEmailDomainQuery, GetVerifierByEmailDomainQueryVariables>(
    GetVerifierByEmailDomainDocument,
    options,
  );
}
export function useGetVerifierByEmailDomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVerifierByEmailDomainQuery,
    GetVerifierByEmailDomainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVerifierByEmailDomainQuery, GetVerifierByEmailDomainQueryVariables>(
    GetVerifierByEmailDomainDocument,
    options,
  );
}
// @ts-ignore
export function useGetVerifierByEmailDomainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVerifierByEmailDomainQuery,
    GetVerifierByEmailDomainQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetVerifierByEmailDomainQuery,
  GetVerifierByEmailDomainQueryVariables
>;
export function useGetVerifierByEmailDomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVerifierByEmailDomainQuery,
        GetVerifierByEmailDomainQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetVerifierByEmailDomainQuery | undefined,
  GetVerifierByEmailDomainQueryVariables
>;
export function useGetVerifierByEmailDomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVerifierByEmailDomainQuery,
        GetVerifierByEmailDomainQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetVerifierByEmailDomainQuery,
    GetVerifierByEmailDomainQueryVariables
  >(GetVerifierByEmailDomainDocument, options);
}
export type GetVerifierByEmailDomainQueryHookResult = ReturnType<
  typeof useGetVerifierByEmailDomainQuery
>;
export type GetVerifierByEmailDomainLazyQueryHookResult = ReturnType<
  typeof useGetVerifierByEmailDomainLazyQuery
>;
export type GetVerifierByEmailDomainSuspenseQueryHookResult = ReturnType<
  typeof useGetVerifierByEmailDomainSuspenseQuery
>;
export type GetVerifierByEmailDomainQueryResult = Apollo.QueryResult<
  GetVerifierByEmailDomainQuery,
  GetVerifierByEmailDomainQueryVariables
>;
export const GetVerifierInfoByVerificationRequestDocument = gql`
    query GetVerifierInfoByVerificationRequest($verificationRequestId: ID!) {
  getVerifierInfoByVerificationRequest(
    verificationRequestId: $verificationRequestId
  ) {
    id
    credentialStatus
    type
    logo {
      ...FileResponseInfo
    }
    displayName
    contactName
    contactEmail
    contactPhone
  }
}
    ${FileResponseInfoFragmentDoc}`;

/**
 * __useGetVerifierInfoByVerificationRequestQuery__
 *
 * To run a query within a React component, call `useGetVerifierInfoByVerificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifierInfoByVerificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifierInfoByVerificationRequestQuery({
 *   variables: {
 *      verificationRequestId: // value for 'verificationRequestId'
 *   },
 * });
 */
export function useGetVerifierInfoByVerificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVerifierInfoByVerificationRequestQuery,
    GetVerifierInfoByVerificationRequestQueryVariables
  > &
    (
      | { variables: GetVerifierInfoByVerificationRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVerifierInfoByVerificationRequestQuery,
    GetVerifierInfoByVerificationRequestQueryVariables
  >(GetVerifierInfoByVerificationRequestDocument, options);
}
export function useGetVerifierInfoByVerificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVerifierInfoByVerificationRequestQuery,
    GetVerifierInfoByVerificationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVerifierInfoByVerificationRequestQuery,
    GetVerifierInfoByVerificationRequestQueryVariables
  >(GetVerifierInfoByVerificationRequestDocument, options);
}
// @ts-ignore
export function useGetVerifierInfoByVerificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVerifierInfoByVerificationRequestQuery,
    GetVerifierInfoByVerificationRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetVerifierInfoByVerificationRequestQuery,
  GetVerifierInfoByVerificationRequestQueryVariables
>;
export function useGetVerifierInfoByVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVerifierInfoByVerificationRequestQuery,
        GetVerifierInfoByVerificationRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetVerifierInfoByVerificationRequestQuery | undefined,
  GetVerifierInfoByVerificationRequestQueryVariables
>;
export function useGetVerifierInfoByVerificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVerifierInfoByVerificationRequestQuery,
        GetVerifierInfoByVerificationRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetVerifierInfoByVerificationRequestQuery,
    GetVerifierInfoByVerificationRequestQueryVariables
  >(GetVerifierInfoByVerificationRequestDocument, options);
}
export type GetVerifierInfoByVerificationRequestQueryHookResult = ReturnType<
  typeof useGetVerifierInfoByVerificationRequestQuery
>;
export type GetVerifierInfoByVerificationRequestLazyQueryHookResult = ReturnType<
  typeof useGetVerifierInfoByVerificationRequestLazyQuery
>;
export type GetVerifierInfoByVerificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useGetVerifierInfoByVerificationRequestSuspenseQuery
>;
export type GetVerifierInfoByVerificationRequestQueryResult = Apollo.QueryResult<
  GetVerifierInfoByVerificationRequestQuery,
  GetVerifierInfoByVerificationRequestQueryVariables
>;
export const VerifierLogoDocument = gql`
    query VerifierLogo($id: ID!) {
  verifier(where: {id: $id}) {
    id
    logo {
      ...FileInfo
    }
  }
}
    ${FileInfoFragmentDoc}`;

/**
 * __useVerifierLogoQuery__
 *
 * To run a query within a React component, call `useVerifierLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierLogoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifierLogoQuery(
  baseOptions: Apollo.QueryHookOptions<VerifierLogoQuery, VerifierLogoQueryVariables> &
    ({ variables: VerifierLogoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierLogoQuery, VerifierLogoQueryVariables>(
    VerifierLogoDocument,
    options,
  );
}
export function useVerifierLogoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifierLogoQuery, VerifierLogoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierLogoQuery, VerifierLogoQueryVariables>(
    VerifierLogoDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierLogoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<VerifierLogoQuery, VerifierLogoQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifierLogoQuery, VerifierLogoQueryVariables>;
export function useVerifierLogoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierLogoQuery, VerifierLogoQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifierLogoQuery | undefined, VerifierLogoQueryVariables>;
export function useVerifierLogoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierLogoQuery, VerifierLogoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierLogoQuery, VerifierLogoQueryVariables>(
    VerifierLogoDocument,
    options,
  );
}
export type VerifierLogoQueryHookResult = ReturnType<typeof useVerifierLogoQuery>;
export type VerifierLogoLazyQueryHookResult = ReturnType<typeof useVerifierLogoLazyQuery>;
export type VerifierLogoSuspenseQueryHookResult = ReturnType<typeof useVerifierLogoSuspenseQuery>;
export type VerifierLogoQueryResult = Apollo.QueryResult<
  VerifierLogoQuery,
  VerifierLogoQueryVariables
>;
export const VerifierCredentialInfoDocument = gql`
    query VerifierCredentialInfo($where: VerifierWhereUnique!) {
  verifier(where: $where) {
    ...VerifierCredentialInfo
  }
}
    ${VerifierCredentialInfoFragmentDoc}`;

/**
 * __useVerifierCredentialInfoQuery__
 *
 * To run a query within a React component, call `useVerifierCredentialInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierCredentialInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierCredentialInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVerifierCredentialInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifierCredentialInfoQuery,
    VerifierCredentialInfoQueryVariables
  > &
    ({ variables: VerifierCredentialInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierCredentialInfoQuery, VerifierCredentialInfoQueryVariables>(
    VerifierCredentialInfoDocument,
    options,
  );
}
export function useVerifierCredentialInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifierCredentialInfoQuery,
    VerifierCredentialInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierCredentialInfoQuery, VerifierCredentialInfoQueryVariables>(
    VerifierCredentialInfoDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierCredentialInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifierCredentialInfoQuery,
    VerifierCredentialInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerifierCredentialInfoQuery, VerifierCredentialInfoQueryVariables>;
export function useVerifierCredentialInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierCredentialInfoQuery,
        VerifierCredentialInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerifierCredentialInfoQuery | undefined,
  VerifierCredentialInfoQueryVariables
>;
export function useVerifierCredentialInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierCredentialInfoQuery,
        VerifierCredentialInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierCredentialInfoQuery, VerifierCredentialInfoQueryVariables>(
    VerifierCredentialInfoDocument,
    options,
  );
}
export type VerifierCredentialInfoQueryHookResult = ReturnType<
  typeof useVerifierCredentialInfoQuery
>;
export type VerifierCredentialInfoLazyQueryHookResult = ReturnType<
  typeof useVerifierCredentialInfoLazyQuery
>;
export type VerifierCredentialInfoSuspenseQueryHookResult = ReturnType<
  typeof useVerifierCredentialInfoSuspenseQuery
>;
export type VerifierCredentialInfoQueryResult = Apollo.QueryResult<
  VerifierCredentialInfoQuery,
  VerifierCredentialInfoQueryVariables
>;
export const VerifiersBasicListDocument = gql`
    query VerifiersBasicList($displayName: String, $first: Int) {
  getVerifiersBasicList(displayName: $displayName, take: $first) {
    ...VerifierBasicItemInfo
  }
}
    ${VerifierBasicItemInfoFragmentDoc}`;

/**
 * __useVerifiersBasicListQuery__
 *
 * To run a query within a React component, call `useVerifiersBasicListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifiersBasicListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiersBasicListQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useVerifiersBasicListQuery(
  baseOptions?: Apollo.QueryHookOptions<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>(
    VerifiersBasicListDocument,
    options,
  );
}
export function useVerifiersBasicListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifiersBasicListQuery,
    VerifiersBasicListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>(
    VerifiersBasicListDocument,
    options,
  );
}
// @ts-ignore
export function useVerifiersBasicListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifiersBasicListQuery,
    VerifiersBasicListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>;
export function useVerifiersBasicListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VerifiersBasicListQuery | undefined,
  VerifiersBasicListQueryVariables
>;
export function useVerifiersBasicListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifiersBasicListQuery, VerifiersBasicListQueryVariables>(
    VerifiersBasicListDocument,
    options,
  );
}
export type VerifiersBasicListQueryHookResult = ReturnType<typeof useVerifiersBasicListQuery>;
export type VerifiersBasicListLazyQueryHookResult = ReturnType<
  typeof useVerifiersBasicListLazyQuery
>;
export type VerifiersBasicListSuspenseQueryHookResult = ReturnType<
  typeof useVerifiersBasicListSuspenseQuery
>;
export type VerifiersBasicListQueryResult = Apollo.QueryResult<
  VerifiersBasicListQuery,
  VerifiersBasicListQueryVariables
>;
export const DeleteVerifierDocument = gql`
    mutation DeleteVerifier($verifierId: ID!) {
  deleteVerifier(verifierId: $verifierId) {
    success
  }
}
    `;
export type DeleteVerifierMutationFn = Apollo.MutationFunction<
  DeleteVerifierMutation,
  DeleteVerifierMutationVariables
>;

/**
 * __useDeleteVerifierMutation__
 *
 * To run a mutation, you first call `useDeleteVerifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVerifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVerifierMutation, { data, loading, error }] = useDeleteVerifierMutation({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *   },
 * });
 */
export function useDeleteVerifierMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteVerifierMutation, DeleteVerifierMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteVerifierMutation, DeleteVerifierMutationVariables>(
    DeleteVerifierDocument,
    options,
  );
}
export type DeleteVerifierMutationHookResult = ReturnType<typeof useDeleteVerifierMutation>;
export type DeleteVerifierMutationResult = Apollo.MutationResult<DeleteVerifierMutation>;
export type DeleteVerifierMutationOptions = Apollo.BaseMutationOptions<
  DeleteVerifierMutation,
  DeleteVerifierMutationVariables
>;
export const CheckDeletionVerifierDocument = gql`
    query CheckDeletionVerifier($verifierId: ID!) {
  checkDeletionVerifier(verifierId: $verifierId) {
    valid
    errors
  }
}
    `;

/**
 * __useCheckDeletionVerifierQuery__
 *
 * To run a query within a React component, call `useCheckDeletionVerifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDeletionVerifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDeletionVerifierQuery({
 *   variables: {
 *      verifierId: // value for 'verifierId'
 *   },
 * });
 */
export function useCheckDeletionVerifierQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckDeletionVerifierQuery,
    CheckDeletionVerifierQueryVariables
  > &
    ({ variables: CheckDeletionVerifierQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckDeletionVerifierQuery, CheckDeletionVerifierQueryVariables>(
    CheckDeletionVerifierDocument,
    options,
  );
}
export function useCheckDeletionVerifierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckDeletionVerifierQuery,
    CheckDeletionVerifierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckDeletionVerifierQuery, CheckDeletionVerifierQueryVariables>(
    CheckDeletionVerifierDocument,
    options,
  );
}
// @ts-ignore
export function useCheckDeletionVerifierSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckDeletionVerifierQuery,
    CheckDeletionVerifierQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckDeletionVerifierQuery, CheckDeletionVerifierQueryVariables>;
export function useCheckDeletionVerifierSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionVerifierQuery,
        CheckDeletionVerifierQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionVerifierQuery | undefined,
  CheckDeletionVerifierQueryVariables
>;
export function useCheckDeletionVerifierSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionVerifierQuery,
        CheckDeletionVerifierQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckDeletionVerifierQuery, CheckDeletionVerifierQueryVariables>(
    CheckDeletionVerifierDocument,
    options,
  );
}
export type CheckDeletionVerifierQueryHookResult = ReturnType<typeof useCheckDeletionVerifierQuery>;
export type CheckDeletionVerifierLazyQueryHookResult = ReturnType<
  typeof useCheckDeletionVerifierLazyQuery
>;
export type CheckDeletionVerifierSuspenseQueryHookResult = ReturnType<
  typeof useCheckDeletionVerifierSuspenseQuery
>;
export type CheckDeletionVerifierQueryResult = Apollo.QueryResult<
  CheckDeletionVerifierQuery,
  CheckDeletionVerifierQueryVariables
>;
export const GenerateRankedVerifiersReportDocument = gql`
    mutation GenerateRankedVerifiersReport($verifierType: VerifierType!) {
  generateRankedVerifiersReport(verifierType: $verifierType) {
    ...FileResponseInfo
  }
}
    ${FileResponseInfoFragmentDoc}`;
export type GenerateRankedVerifiersReportMutationFn = Apollo.MutationFunction<
  GenerateRankedVerifiersReportMutation,
  GenerateRankedVerifiersReportMutationVariables
>;

/**
 * __useGenerateRankedVerifiersReportMutation__
 *
 * To run a mutation, you first call `useGenerateRankedVerifiersReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRankedVerifiersReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRankedVerifiersReportMutation, { data, loading, error }] = useGenerateRankedVerifiersReportMutation({
 *   variables: {
 *      verifierType: // value for 'verifierType'
 *   },
 * });
 */
export function useGenerateRankedVerifiersReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateRankedVerifiersReportMutation,
    GenerateRankedVerifiersReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateRankedVerifiersReportMutation,
    GenerateRankedVerifiersReportMutationVariables
  >(GenerateRankedVerifiersReportDocument, options);
}
export type GenerateRankedVerifiersReportMutationHookResult = ReturnType<
  typeof useGenerateRankedVerifiersReportMutation
>;
export type GenerateRankedVerifiersReportMutationResult =
  Apollo.MutationResult<GenerateRankedVerifiersReportMutation>;
export type GenerateRankedVerifiersReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateRankedVerifiersReportMutation,
  GenerateRankedVerifiersReportMutationVariables
>;
export const VerifierStaffListDocument = gql`
    query VerifierStaffList($filter: VerifierStaffWhere, $orderBy: [VerifierStaffOrderBy!], $first: Int, $skip: Int) {
  verifierStaffCount(where: $filter)
  verifierStaffList(where: $filter, orderBy: $orderBy, take: $first, skip: $skip) {
    ...VerifierStaffItem
  }
}
    ${VerifierStaffItemFragmentDoc}`;

/**
 * __useVerifierStaffListQuery__
 *
 * To run a query within a React component, call `useVerifierStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierStaffListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useVerifierStaffListQuery(
  baseOptions?: Apollo.QueryHookOptions<VerifierStaffListQuery, VerifierStaffListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierStaffListQuery, VerifierStaffListQueryVariables>(
    VerifierStaffListDocument,
    options,
  );
}
export function useVerifierStaffListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifierStaffListQuery,
    VerifierStaffListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierStaffListQuery, VerifierStaffListQueryVariables>(
    VerifierStaffListDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierStaffListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifierStaffListQuery,
    VerifierStaffListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerifierStaffListQuery, VerifierStaffListQueryVariables>;
export function useVerifierStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierStaffListQuery, VerifierStaffListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VerifierStaffListQuery | undefined,
  VerifierStaffListQueryVariables
>;
export function useVerifierStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierStaffListQuery, VerifierStaffListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierStaffListQuery, VerifierStaffListQueryVariables>(
    VerifierStaffListDocument,
    options,
  );
}
export type VerifierStaffListQueryHookResult = ReturnType<typeof useVerifierStaffListQuery>;
export type VerifierStaffListLazyQueryHookResult = ReturnType<typeof useVerifierStaffListLazyQuery>;
export type VerifierStaffListSuspenseQueryHookResult = ReturnType<
  typeof useVerifierStaffListSuspenseQuery
>;
export type VerifierStaffListQueryResult = Apollo.QueryResult<
  VerifierStaffListQuery,
  VerifierStaffListQueryVariables
>;
export const VerifierStaffUpdateDocument = gql`
    mutation VerifierStaffUpdate($data: VerifierStaffUpdate!, $where: VerifierStaffWhereUnique!) {
  verifierStaffUpdate(data: $data, where: $where) {
    ...VerifierStaffItem
  }
}
    ${VerifierStaffItemFragmentDoc}`;
export type VerifierStaffUpdateMutationFn = Apollo.MutationFunction<
  VerifierStaffUpdateMutation,
  VerifierStaffUpdateMutationVariables
>;

/**
 * __useVerifierStaffUpdateMutation__
 *
 * To run a mutation, you first call `useVerifierStaffUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifierStaffUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifierStaffUpdateMutation, { data, loading, error }] = useVerifierStaffUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVerifierStaffUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifierStaffUpdateMutation,
    VerifierStaffUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifierStaffUpdateMutation, VerifierStaffUpdateMutationVariables>(
    VerifierStaffUpdateDocument,
    options,
  );
}
export type VerifierStaffUpdateMutationHookResult = ReturnType<
  typeof useVerifierStaffUpdateMutation
>;
export type VerifierStaffUpdateMutationResult = Apollo.MutationResult<VerifierStaffUpdateMutation>;
export type VerifierStaffUpdateMutationOptions = Apollo.BaseMutationOptions<
  VerifierStaffUpdateMutation,
  VerifierStaffUpdateMutationVariables
>;
export const VerifierStaffDocument = gql`
    query VerifierStaff($id: ID!) {
  verifierStaff(where: {id: $id}) {
    ...VerifierStaffItem
  }
}
    ${VerifierStaffItemFragmentDoc}`;

/**
 * __useVerifierStaffQuery__
 *
 * To run a query within a React component, call `useVerifierStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierStaffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifierStaffQuery(
  baseOptions: Apollo.QueryHookOptions<VerifierStaffQuery, VerifierStaffQueryVariables> &
    ({ variables: VerifierStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierStaffQuery, VerifierStaffQueryVariables>(
    VerifierStaffDocument,
    options,
  );
}
export function useVerifierStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifierStaffQuery, VerifierStaffQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierStaffQuery, VerifierStaffQueryVariables>(
    VerifierStaffDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<VerifierStaffQuery, VerifierStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifierStaffQuery, VerifierStaffQueryVariables>;
export function useVerifierStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierStaffQuery, VerifierStaffQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifierStaffQuery | undefined, VerifierStaffQueryVariables>;
export function useVerifierStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifierStaffQuery, VerifierStaffQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifierStaffQuery, VerifierStaffQueryVariables>(
    VerifierStaffDocument,
    options,
  );
}
export type VerifierStaffQueryHookResult = ReturnType<typeof useVerifierStaffQuery>;
export type VerifierStaffLazyQueryHookResult = ReturnType<typeof useVerifierStaffLazyQuery>;
export type VerifierStaffSuspenseQueryHookResult = ReturnType<typeof useVerifierStaffSuspenseQuery>;
export type VerifierStaffQueryResult = Apollo.QueryResult<
  VerifierStaffQuery,
  VerifierStaffQueryVariables
>;
export const VerifierStaffBillingAccessDocument = gql`
    query VerifierStaffBillingAccess($id: ID!) {
  verifierStaff(where: {id: $id}) {
    verifier {
      type
    }
  }
}
    `;

/**
 * __useVerifierStaffBillingAccessQuery__
 *
 * To run a query within a React component, call `useVerifierStaffBillingAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierStaffBillingAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierStaffBillingAccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifierStaffBillingAccessQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifierStaffBillingAccessQuery,
    VerifierStaffBillingAccessQueryVariables
  > &
    ({ variables: VerifierStaffBillingAccessQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierStaffBillingAccessQuery, VerifierStaffBillingAccessQueryVariables>(
    VerifierStaffBillingAccessDocument,
    options,
  );
}
export function useVerifierStaffBillingAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifierStaffBillingAccessQuery,
    VerifierStaffBillingAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VerifierStaffBillingAccessQuery,
    VerifierStaffBillingAccessQueryVariables
  >(VerifierStaffBillingAccessDocument, options);
}
// @ts-ignore
export function useVerifierStaffBillingAccessSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifierStaffBillingAccessQuery,
    VerifierStaffBillingAccessQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerifierStaffBillingAccessQuery,
  VerifierStaffBillingAccessQueryVariables
>;
export function useVerifierStaffBillingAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierStaffBillingAccessQuery,
        VerifierStaffBillingAccessQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerifierStaffBillingAccessQuery | undefined,
  VerifierStaffBillingAccessQueryVariables
>;
export function useVerifierStaffBillingAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierStaffBillingAccessQuery,
        VerifierStaffBillingAccessQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerifierStaffBillingAccessQuery,
    VerifierStaffBillingAccessQueryVariables
  >(VerifierStaffBillingAccessDocument, options);
}
export type VerifierStaffBillingAccessQueryHookResult = ReturnType<
  typeof useVerifierStaffBillingAccessQuery
>;
export type VerifierStaffBillingAccessLazyQueryHookResult = ReturnType<
  typeof useVerifierStaffBillingAccessLazyQuery
>;
export type VerifierStaffBillingAccessSuspenseQueryHookResult = ReturnType<
  typeof useVerifierStaffBillingAccessSuspenseQuery
>;
export type VerifierStaffBillingAccessQueryResult = Apollo.QueryResult<
  VerifierStaffBillingAccessQuery,
  VerifierStaffBillingAccessQueryVariables
>;
export const VerifierStaffBillingInfoDocument = gql`
    query VerifierStaffBillingInfo($id: ID!) {
  verifierStaff(where: {id: $id}) {
    ...VerifierStaffWithBillingInfo
  }
}
    ${VerifierStaffWithBillingInfoFragmentDoc}`;

/**
 * __useVerifierStaffBillingInfoQuery__
 *
 * To run a query within a React component, call `useVerifierStaffBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifierStaffBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifierStaffBillingInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifierStaffBillingInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifierStaffBillingInfoQuery,
    VerifierStaffBillingInfoQueryVariables
  > &
    ({ variables: VerifierStaffBillingInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifierStaffBillingInfoQuery, VerifierStaffBillingInfoQueryVariables>(
    VerifierStaffBillingInfoDocument,
    options,
  );
}
export function useVerifierStaffBillingInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifierStaffBillingInfoQuery,
    VerifierStaffBillingInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifierStaffBillingInfoQuery, VerifierStaffBillingInfoQueryVariables>(
    VerifierStaffBillingInfoDocument,
    options,
  );
}
// @ts-ignore
export function useVerifierStaffBillingInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifierStaffBillingInfoQuery,
    VerifierStaffBillingInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerifierStaffBillingInfoQuery,
  VerifierStaffBillingInfoQueryVariables
>;
export function useVerifierStaffBillingInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierStaffBillingInfoQuery,
        VerifierStaffBillingInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerifierStaffBillingInfoQuery | undefined,
  VerifierStaffBillingInfoQueryVariables
>;
export function useVerifierStaffBillingInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifierStaffBillingInfoQuery,
        VerifierStaffBillingInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerifierStaffBillingInfoQuery,
    VerifierStaffBillingInfoQueryVariables
  >(VerifierStaffBillingInfoDocument, options);
}
export type VerifierStaffBillingInfoQueryHookResult = ReturnType<
  typeof useVerifierStaffBillingInfoQuery
>;
export type VerifierStaffBillingInfoLazyQueryHookResult = ReturnType<
  typeof useVerifierStaffBillingInfoLazyQuery
>;
export type VerifierStaffBillingInfoSuspenseQueryHookResult = ReturnType<
  typeof useVerifierStaffBillingInfoSuspenseQuery
>;
export type VerifierStaffBillingInfoQueryResult = Apollo.QueryResult<
  VerifierStaffBillingInfoQuery,
  VerifierStaffBillingInfoQueryVariables
>;
export const DeleteVerifierStaffDocument = gql`
    mutation DeleteVerifierStaff($verifierStaffId: ID!) {
  deleteVerifierStaff(verifierStaffId: $verifierStaffId) {
    success
  }
}
    `;
export type DeleteVerifierStaffMutationFn = Apollo.MutationFunction<
  DeleteVerifierStaffMutation,
  DeleteVerifierStaffMutationVariables
>;

/**
 * __useDeleteVerifierStaffMutation__
 *
 * To run a mutation, you first call `useDeleteVerifierStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVerifierStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVerifierStaffMutation, { data, loading, error }] = useDeleteVerifierStaffMutation({
 *   variables: {
 *      verifierStaffId: // value for 'verifierStaffId'
 *   },
 * });
 */
export function useDeleteVerifierStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVerifierStaffMutation,
    DeleteVerifierStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteVerifierStaffMutation, DeleteVerifierStaffMutationVariables>(
    DeleteVerifierStaffDocument,
    options,
  );
}
export type DeleteVerifierStaffMutationHookResult = ReturnType<
  typeof useDeleteVerifierStaffMutation
>;
export type DeleteVerifierStaffMutationResult = Apollo.MutationResult<DeleteVerifierStaffMutation>;
export type DeleteVerifierStaffMutationOptions = Apollo.BaseMutationOptions<
  DeleteVerifierStaffMutation,
  DeleteVerifierStaffMutationVariables
>;
export const CheckDeletionVerifierStaffDocument = gql`
    query CheckDeletionVerifierStaff($verifierStaffId: ID!) {
  checkDeletionVerifierStaff(verifierStaffId: $verifierStaffId) {
    valid
    errors
  }
}
    `;

/**
 * __useCheckDeletionVerifierStaffQuery__
 *
 * To run a query within a React component, call `useCheckDeletionVerifierStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDeletionVerifierStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDeletionVerifierStaffQuery({
 *   variables: {
 *      verifierStaffId: // value for 'verifierStaffId'
 *   },
 * });
 */
export function useCheckDeletionVerifierStaffQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckDeletionVerifierStaffQuery,
    CheckDeletionVerifierStaffQueryVariables
  > &
    ({ variables: CheckDeletionVerifierStaffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckDeletionVerifierStaffQuery, CheckDeletionVerifierStaffQueryVariables>(
    CheckDeletionVerifierStaffDocument,
    options,
  );
}
export function useCheckDeletionVerifierStaffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckDeletionVerifierStaffQuery,
    CheckDeletionVerifierStaffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckDeletionVerifierStaffQuery,
    CheckDeletionVerifierStaffQueryVariables
  >(CheckDeletionVerifierStaffDocument, options);
}
// @ts-ignore
export function useCheckDeletionVerifierStaffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckDeletionVerifierStaffQuery,
    CheckDeletionVerifierStaffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionVerifierStaffQuery,
  CheckDeletionVerifierStaffQueryVariables
>;
export function useCheckDeletionVerifierStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionVerifierStaffQuery,
        CheckDeletionVerifierStaffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckDeletionVerifierStaffQuery | undefined,
  CheckDeletionVerifierStaffQueryVariables
>;
export function useCheckDeletionVerifierStaffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckDeletionVerifierStaffQuery,
        CheckDeletionVerifierStaffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckDeletionVerifierStaffQuery,
    CheckDeletionVerifierStaffQueryVariables
  >(CheckDeletionVerifierStaffDocument, options);
}
export type CheckDeletionVerifierStaffQueryHookResult = ReturnType<
  typeof useCheckDeletionVerifierStaffQuery
>;
export type CheckDeletionVerifierStaffLazyQueryHookResult = ReturnType<
  typeof useCheckDeletionVerifierStaffLazyQuery
>;
export type CheckDeletionVerifierStaffSuspenseQueryHookResult = ReturnType<
  typeof useCheckDeletionVerifierStaffSuspenseQuery
>;
export type CheckDeletionVerifierStaffQueryResult = Apollo.QueryResult<
  CheckDeletionVerifierStaffQuery,
  CheckDeletionVerifierStaffQueryVariables
>;
